
/* V191 · THE SHELF READS THE STORE + THE COLD CASE (see svMergeStore and the last block) */
const COMING_SOON = false;
try{ window.STATION_COMING_SOON = false; }catch(e){};  /* every buy control reads COMING SOON and points to crew alerts; flip to false on drop day */
const PRE_DROP = false; /* the bottles are here \u00b7 $33 is real */
const TEST_CHECKOUT = false; /* live store: only a product that actually exists can be bought */

/* ============ WHAT IS ACTUALLY ABOARD ============
   window.STATION_STOCK is written by the theme layout straight out of
   Shopify at render time: price, availability and units left per colour.
   Everything that sells reads from here, so the site can never offer a
   vessel the warehouse does not have. var + function declarations only —
   these are called from renderers that run long before this line, and a
   const here would be a temporal dead zone. */
var STOCK = (typeof window !== 'undefined' && window.STATION_STOCK) || {};

/* ---------- THE SIGHTING GATE ----------
   The black one is the specimen nobody has confirmed. Selling it before
   anybody has actually seen one would make the whole Impound a story with a
   price on it, so the lot is sealed until the record says otherwise. Set in
   the theme editor and read server-side. This layer stops the site from ever
   offering the lot and stops the cart from taking it. It is not the whole
   lock and should not be treated as one: any client gate can be walked around
   by somebody posting to /cart/add.js by hand. The lock that actually holds is
   keeping the Shopify product in DRAFT until the sighting is confirmed, so
   there is no purchasable variant to post at. Belt here, braces in admin. */
var BLACK = (typeof window !== 'undefined' && window.STATION_BLACK) || {confirmed:false};
/* snapshot the flag at load. BLACK stays around for the record copy, but the
   gate reads a frozen boolean, so flipping window.STATION_BLACK.confirmed in
   the console after the fact moves nothing. */
var BLACK_SEEN = (function(){
  var b = (typeof window !== 'undefined') ? window.STATION_BLACK : null;
  return !!(b && b.sighted === true);
})();
var BLACK_OK = (function(){
  var b = (typeof window !== 'undefined') ? window.STATION_BLACK : null;
  /* both gates, in order: seen, then tested. A sighting alone opens nothing. */
  return !!(b && b.sighted === true && b.verified === true);
})();
function blackSighted(){ return BLACK_SEEN; }
function blackVerified(){ return BLACK_OK; }
function isBlackLot(id){ return id === 'imp-1' || id === 'v-black'; }
function blackSealed(id){ return isBlackLot(id) && !blackVerified(); }
try{ window.STATION_BLACK_SEALED = function(id){ return blackSealed(id); }; }catch(e){}

function stockKey(id){
  var m = String(id || '').match(/^v-(green|pink|red|yellow|blue)$/);
  if(m) return m[1];
  if(id === 'imp-1') return 'black';
  return null;
}
function stockOf(id){ var k = stockKey(id); return k ? (STOCK[k] || null) : null; }
/* no reading at all means "not our call" — never block a line we cannot see */
function soldOut(id){
  var s = stockOf(id);
  if(!s) return false;
  if(s.available === false) return true;
  if(typeof s.left === 'number' && s.left <= 0) return true;
  return false;
}
function leftOf(id){ var s = stockOf(id); return (s && typeof s.left === 'number') ? s.left : null; }
function priceOf(id, fallback){ var s = stockOf(id); return (s && typeof s.price === 'number') ? s.price : fallback; }
function vesselURL(colour){
  var s = STOCK[colour];
  return (s && s.url) ? s.url : ('/products/' + colour + '-alien-618');
}
/* how many were made across the hues Shopify actually knows about */
function heldBack(){
  var n = (typeof window !== 'undefined') ? window.STATION_HELD_BACK : 0;
  n = parseInt(n, 10);
  return (isFinite(n) && n > 0) ? n : 0;
}
/* what was made, minus what the studio kept — the number the board is
   really measuring against, so a vessel on a shelf in Colorado is not
   counted as somebody's purchase */
function runMade(){
  var keys = ['green','pink','red','yellow','blue'], total = 0, seen = 0;
  for(var i=0;i<keys.length;i++){
    var s = STOCK[keys[i]];
    if(!s) continue;
    total += (typeof s.made === 'number') ? s.made : 100;
    seen++;
  }
  if(!seen) return null;
  return Math.max(0, total - heldBack());
}
function runMadeGross(){
  var keys = ['green','pink','red','yellow','blue'], total = 0, seen = 0;
  for(var i=0;i<keys.length;i++){
    var s = STOCK[keys[i]];
    if(!s) continue;
    total += (typeof s.made === 'number') ? s.made : 100;
    seen++;
  }
  return seen ? total : null;
}
try{ window.STATION_HELD = heldBack; }catch(e){}
try{ window.STATION_RUNMADE = runMade; }catch(e){}

/* the honest first-run count: what Shopify still holds across the five */
function runLeft(){
  var keys = ['green','pink','red','yellow','blue'], total = 0, seen = 0;
  for(var i=0;i<keys.length;i++){
    var s = STOCK[keys[i]];
    if(!s) continue;
    if(typeof s.left === 'number'){ total += Math.max(0, s.left); seen++; }
    else if(s.available){ total += 100; seen++; }
  }
  return seen ? total : null;
}
function vesselCapLine(k){
  var s = STOCK[k] || null;
  var left = (s && typeof s.left === 'number') ? s.left : null;
  if(left === 0 || (s && s.available === false))
    return 'GONE FOR GOOD \u00b7 <b>100</b> WERE MADE \u00b7 THIS RUN NEVER REPEATS';
  if(left === null)
    return 'IN STOCK NOW \u00b7 <b>100</b> OF THIS COLOR \u00b7 <b>500</b> IN THE FIRST RUN \u00b7 THIS RUN NEVER REPEATS \u00b7 <b>8,000,000</b> WILL EVER EXIST';
  if(left <= 9)
    return 'ONLY <b>' + left + '</b> OF <b>100</b> LEFT \u00b7 THEN THIS COLOR IS GONE FOR GOOD';
  return 'IN STOCK NOW: <b>' + left + '</b> OF <b>100</b> \u00b7 <b>500</b> IN THE FIRST RUN \u00b7 THIS RUN NEVER REPEATS \u00b7 <b>8,000,000</b> WILL EVER EXIST';
}
try{
  window.STATION_SOLDOUT = soldOut;
  window.STATION_LEFT = leftOf;
  window.STATION_RUNLEFT = runLeft;
}catch(e){}

const activeOnly = arr => arr.filter(p => OG.has((p.id.match(/^[a-z]+-(\w+)/)||[])[1]));
const OG = new Set(['green','pink','red','yellow','blue']);
const OG_IMG = {
  green: 'data:image/webp;base64,UklGRlBTAABXRUJQVlA4WAoAAAAQAAAAUwEALQQAQUxQSL8kAAAB90c2aZPk/9NL54hI/J0TEbcB2LYNANJOg/8/WI1x6hjR/wlAP4IkczyQGo2fox7nyMeg7URwOSVVSWv8bjILIpSZVVqJjlbUFrATsZQJRAGZkFShGv45dCp+GP0KONdRISEeFQmpgAmWHjVAY9s9t/sOMGybY9u+ALTNRVvg1e3ItkMg933GttkpLaMwbtvIkWX3X/Um3yF9I2ICPAck8YAqIUkNQAKiJvAEj60yj6iTzLq6j2SqQv+Q0mNTMp3npuRSoPLcKUEnKrtUd6nsFsVI0iy2nWhkdJLYUeYeMtr2am3tDkCmtp2lAXzG0tOJLvWGbdsxN/v/bcdxps/zsW3btm3bfGXrsW3bdu+mitrUSlIkKYK6vRvUzcxcx/5implJnjY9Hk5ETIC327aWPdG2bcy1H0I8BKJ4IAnuBKcoCAXldvpZLpe7u7u7u+svcHfXT+7uVaexrfUhXJVD9oNta6dGxATYsW3bbSRpH7CqWmtfW7onUHZ7bfXq+U9DB4z/ADBIRoYbEROgt7Zt1ba1p/b9oZgpBCXwK2pFgC5YioCZGX54uxlzrn0+PbjPVERMgC9PEx7csRoJwPTI7/tmA9DhfTUTYDeCu5qjIDut8gDa7ZNLSjuvTa1Dj/zKwl0b0zWj6UrfuRKTI7UlwFyRGUYKDhydu297e5kNxt2c1uNEbXbLpdFJKIqskJzlj3jw3ATrHUL/n9ndpOVk4DQv7lq/5SQllBGyxOJHfu5N8EBI9KCEMIe5Nz53lhJKByU2XX58MwkTPa6gcPp/3lXDIxdMNB5/eYFkFX2pKGx70buiKPJASiw+cYEw0bdhxlsefYoShUCW2Pch9xIh+jrMHn7di2cwlQAlGlffMkUYfR/Oxf9+E0nZZ2BPPDtDEnWoKAw9KlDmOctPXyRM1KSwe57aiyvvll48i4eo0So4/+Ie8l1w79NbwajXKph95goo06C5lSTqV4mtTYgciyAIiTqWgv8kyy0ufrWFUc/mzc8fD2UYfEgzGXVdpf1vCcsv+dyVEPWt+IgpV3YZJ3ZQazp4LCy7YJhaI2KIHA9qXpFlXnd4li3idaZgMcOc+1CdEdzEc0thE9T9BJFbgNeek+FmtWfKsLmdNSd2TWPZ9corNQevvEpkVth//hxRa8HP/J/lFvCtr1RRY1H997eR38Hv/xF15vzun+IZ5m+rNXgHIsdFvYt3H42aizxTE9Vag8gvY9/hWjOO7Zbllqg+c9LrTGn6g0O5Zf7EUy7qXPHyiWR5JR/6RKg3i6mvaKG8ik8+7Ua9y+990C2nzFc+NkTdwRfPJ8so2aeMee1hafmzRD5besMzXlH/ll5+xKtcUuz+AjEIJfvkRiibPm0x2SDA/NxHeyaZn3qTG4NRXP0+txxSDH/dKBoQVOVlZLHFm867MSilxqNe5Y985KODAVqVz2i7ssfiTUfCBghx6smw3FEa/YhgoFZ81Kak3GHxgDRQxOFd5M+5pg8WfOhM9sA5BYM1dJ7cdU0zeKfxvLHYuYoNGHF+PixrYG4Lg1ZMz5K3Yr+5Bk00llHWBNcJBq3bdXJ3jEE8RmTO7YF0m6yVt7ahgRM++NMyPbhYOnJyAKHaLw6W6sEFPdTyAVSVV/z9A4swxSrBINr+MyKkBwtJ4EFi+ggaQLJb3zsO4IakBwAZ4eEA1ejp+Se2hw0gZO97V/3gdCWa3ZC0RjOBEwCNg0ux4+bU+H5ADOy5qcbBHbXj4xXN5qBYS0kiIlg/f2jmxp724RHu6BgDOsBpvn60dnLzzQuH6wBmhqQ1jyTCWb9rsXnxTGN5J+tdEULGIJeQ4TTfGZ3bu6tx8gzNbghpTSIhwgHG9rdWrm09Osf6iBAyjLtECZkZzRdG6uP9c8dv0FwQ0hpCQiTWT+6av2/7ygEzgHCQjLtRSbjRXDt24sym+asnaS4I6f4nEwnAFtt7rs+cWGyx3gMDcVcrJHADqN/Yd25seGEmAAqS7l+ySgCN7dPXdi+fbA2xPiEh7p4lUWiu3Txwaqr/ytkKMJfQfUdWCWDr3tOrqwdHWqxPSOKuXATmAEs3j4yeHzg5D1Ak3UdUCWDzhU/64b/6j0mAhIS4yxeSOUDt/M6R7TMLNSjSYLBKwOTlT/jRv3yHu3u4hMhGIVGApflzGzbtr4OqSjVnVQSMH/+w1W1NICGJDJVEAeojvZuOXAdcumepihTsuvrIkd0NSEgiY4VUoDY7sn1kbw230L3ILAW7n/2qizNAkkQGSypANfqOt5yGErrXSIn2ra/40sdn8JBENkuiwMXhD/Sdx6V7iSyx41O/4IkZPJnIbgmH2Ve/5AolVBuWmH35pZOQVIk8V5hz8H8GGhTVgxxOP7FAchM5HyrVng2vuZBUBxbc+rADJJnI/XA4+2xh6jc50w/fFDJKoKTC9aOkPjNYXbNIohgGnLlKWF9F4+Y+3ERJDGZWpuhfwZF9QqIwWuLKXkJ94owfJ4nyKJjcTPSFRfNYA0SRFNM3G9EHgY5txSiXzSGwnmN5hkTBVEJB9Jbxhd+DWWaA8TlfzaoWVgiS0+AHvhBbRQQ4+RkUUO9M1MhRg5tYb8iu7EQ5gjh+BPWC7M4keWpscesFeO2iK03ki2eS9UA59ToL8jTsSzeFuvbi+XOeKfIrJ8K6tun/M1I17FG6/375eqtSpeIY3q1X/7pQlCrB9KZQl+ZvSVZx+Bjd4vcscoVozfbA33u2OCfodt7jVbLAZbw78upLsWQRTaI7IPHhwdG9iITZ1EBdmvkiLFnEwYNdMla/VOnio8tdgklEvopuBx8urCKVuqaUme5ScBqlS3AL74a8eR5LF7FQhboAVYOMDfFu4pEyHl1qtBNGbJvpinFsEcuX2L6KdQEOtSJfCCbprsjZ6NK7T3uR2lqgUnUDJUxwiuicGNqGJYy42HR1DBTkbLOiQAflPQpNdKfRLDTtqgvGiR3hCSMWj2EdgyNNJ2O8dYhuGqXWulKmVaRSsfGuTBWbLZ1TaqyhlAluVKlTML5AmRXbh1DHiEIDId5NOqIbUWjE9DzqWKOFcsanLnbMODkXZYZgis4fr5ysjS4Y7y6tIpUKzmm8Q8HmYiNWx0IdkW+6hgoNVC06PblQcIiOEbybtIqOOuZRcMI7JKYni43YMos6Ak+PJJUaH/88C3VAvvn1iFKreN3NsE4wMVFynI9peAfg2ESUG4yTM6GNifPmlFvF5lN0AFoUXbfznfGyA5vYuJIdKj3RCbadxsqOdwCGGhTeZSVtLCi7xrkFOlB+2yMU6IgS9Z79po5Y2VGMHkcbEcdGQyUH10U6eElO4W12osX7baoilTYWWPmZxzcgHzpZesSFhbANsPMAVnrGt7Dhpii+ERt7T3oVqOCf/oEoT7/yH1ac4H8Q5dnYeFWVn42Li21XaQpOEZRno/yqAyU4FakteHESF2dD5WnrFBuK8uPtR4yNjhQfpM9Ycnst5rNnUemB1hgb3D5fgoiNvG9SVe2E8kecmmlnZgblz8iiRyvhCwfzBy5jtGw8TPp6tZW2+8KTR9aYRq2JU3dMycOJC+3AUoPkNT1uwdsQM4eI1Ak7tRnRRmmMkrti83VvB+iTK3NcGzDaDXtowCJxwk4ME23J4znhShtZ41HXXG2BVx9rrkIjbzwHooNV3LzmVmjMb15zo5Nye55QkRH2HK6OAFPbKTOwc5KOWxw4klRg5CeXwzoGrA2j4qIYvUY35RMXSwxXRlxdgJhYobzuHw+6a1ycTioq8rlzWJeA5RYqKIpNS3RfPnKVsnq9HeoaxNgQKiZi95TTi8b2o6iQKHadw3qCYLWZCkloC0FvSpyrUAFRNE8j9QjyhaUywuGZEL0bjSnKpziyxellY3VPUulI7cuopwhWGqhoKFpH6HV5Y42yaZyaCfUYxM5xVDIY2eT0vhhZRMVCcegA1geIa2NJhUJuR+nbZYtCAVct+sR85hJWJMTcTrc+gZhsUyYX2vSx2LPXVRyUpq9gfQQ8UIUKg7Algn42n7pGaRTXxt36CmKugYqC054N+r+aRAUhtDKL+s+4PJNUDpLuoQ4V1U1RDu0ooRpAaekgKgTiyGKImhwaijKg2DMb1KVxZiGsBHh7DdWGorFM5J9gXNRouO+kBFxpJdUIFounsdyL2f2Imt02F3mn2LkfUbs3NnnWwWlF7YjmPlC2KZgmqF/5tgtYvnFpPlRDwO6pyDXFlt3UtLg+7Moy+cS9qK6itY9MY20o6gr5/PWIDJMfOeSitsVHbs0wMfUoor5lL3rYIrvc/ulbFDUWNr0Tz67gO/7evMYwGyO7o3rnj4lal7beriK3+Ik/I9UaLN4ms7O3fVkSNb/wP0Re4ZX/pubDzv5GfsnqDuePyO+oPfiZ25Zdqj3xd29TZJa9q/bAyOzFxOtUf5FbsM/c7lZ3yi8aw9S+ZxhRd8be4VB2DcDrlZPbMQBGye9mVXNybc8u+dAnD4VqLXacwzIL8ZbFeoMtY2T4O41aF6darvxqbUV1BhcJclupcZM6Vxo9hrILcWskqcbYeyjPVvZRZ3ay6RkG1qbGkz9MkOPyGlP13FpYhskbK6iuqjj5HaMowwgeEvW92ZwsN+6ZTlZbjZCyTDH3oUNRW9flZLp/9teHaqkRi89gmSbiyb1YDSX/ix8gyPbQd/x55bVj7Hv1FWWc23/9OFE3Ir1xRCLjpX9/B1KdWML+hncFWR8At011YQrOLmIi84PqQItkqgNTYunWTkT+i90f+liLZOo3U2L5wx8iKIIKLn/E422S+sqUWP7wZyZxlQEUwaUPf7yNrG+kxMqHPTVJMlEMLYJLH3aJJPWFLLH0oU9tJpkoihbOifv3kEy9p0Tz3jdPkUwUR4ORt9zTIKnHBNWTz06TTBRJJeaee0xgvWTO8jPncROlUhZceWoJ750qMffCGRxRMuXBuRcXiaonLKgu3NgCRumsgpmnb4Gpe8V54KOO4qKEKjH3xC2ouuRi4cYVHFFIJf+Jn/l8ZCsSfPc1IoyCWsl/+jsJW4kv/Llvwo2y6sG3/ezn0XHjs34MSZRWM9mPfwbWIWwdlVFirWIdnZZhRpk1o7PCyGe7owxSa7KTx1H6GKglGMHI36XzZssJLmFKIPpuoAPYdtlE/oo4gU/hR7eYyOAo61+1nP3pFq9SqCo7ftMm7Bf2lUghef3lui0yvakypRCyi0MC80tfXqEyhNjZYL19ciuJUuT14xiVX70VRjEOeyCE82GVqyCVp2ZcseMyRknedz2Mq9OhklTFowo9HE5JDu1v+fABqSzRcBoVZVmx+DhHd6KiBJu++9Ezw1GY5EMHGwTF+V2UZ3vXH5Un569+qzzBO99VokTX/x8XvyKfxOGb+WQMk9G1lLKU6vq/6/+u/7v+7/q/6/+PH3my8oTaOUvk0+3bJLRZRnX9/zHzLaVSkdpaoIK1Kp/EwnA+QdD1f9f/Xf93/d/1f9f/HztSKbUu8sn09lvp5Db1NKUT3KhIaKcLf0upWi2dAu7sQsnUbsAIlkqx5yjpnLcOliegIvUB/3f93/V/1/9d/3f93w2yUqoklHEpn9xevcHTCf01S6h1RkJLGdX1fxKrSKUCFbsLFG5YSqexuUVCB+/pbyl1A0uoPXOmfDp7joQyo+v/rv+7/u/6v+v/rv8/6q4ySp5RtlBPp17z/1V5Ojm5G2UTrCOjlVIf93REiRpplyexcgJLJ2/u5QP+/7DmiIz6nM/F8mndI1AuNcBn359Kva6OIOO9eCY5MUmI3dMWmbS/csTCJRJ5hjHAehJJxt/cyBrXU2nqF4LTh/KI47JOYGkEA25DD2mscqPXBmJ2yZVEwdi4hpFxsgjGq81iSxNZJGc9twVnPZZENjVMQzB4wSOHODLnRtn5IZRCxm5swtmIZZD89kPoAI7UXRnE/vEWgvFRcuhYw5dTub0xhZwtGGeHKEof2ekh1IKYvCzSN+ib82gh/OxWU/q4HsJo/VGTHskjuzGGWgqf3oWSJxidbQPMyV5jQ720YTqbPl7ro12xoV6UOsGFKaKtA2OK1BFDc652ytIBI3Vd6zHaFa+5UJQ4ssV9RFvhe95NZA7jF+ig+V48dXprRe0pdl01pY3KnV5EJ5fq5K04MNYRMXdOSpxtjdKRcmuT5Y0zSmfFa097JE3YuSGiI+ETbzMljRi8ZOoIZotkrfMBczqsi1jOyC4OKzok+q+4UiaYuoQ6FDa7nUgZY1PldNrZQcrK7/RiHYODdU8Zpo4SHQv2TFpkjMZumzomv/30uiWM2ftxOi/ePWWRLvILQ8QKQCyRr8HABdcKyJZOS+li9GOspOt9Ztkirx1BKyL6r7iyhZHRFQpmT5AvvUtlZdz+vyddnL2sdN5fFaVK2MXDxAqx/zi5IobOulaqG9nifABjpW9sxDJFdmEIrVhsnXclSjB6zmLFMHWYTIGDOCtfNJopKvX1aBXAB1SUJ4yOrIpg7ziZcuSOrwb59c2JYgxirEZjC64kkTeOolUB12SkqYzV6mS0UurDgPd7rAqzVLGDq8PUyBSr71sV1vi0v7bwJDH1/Os1cFshL9Xnvuln5GSp6U++/1NphDpnXtQQL/yZqpCn1qB86w8/0ot3SFGJb/z1P/rdqpCpPc5Xvfbrl6KKjph/2nf96qNf/7uokKxWceWXX/i9WAdk137iHb//qSgK6WrO5/3mT016B8Les5+qohRStlHN/dQ1qR2zO5+PFSNrrfhLPumRtBl+4Z9IXrN/+NUlbw1unjDlDhWHXurRSnDuE0zkb+9S0XLii64j0rcqwy+lsRyXPpMUdn3KN2CT8agvrJcMQvaZc7YtZv5lKuQQ/N3UbVEVYSSR2c9uHT7p+/78G7EcIvjnvuEXh1/zuXlURl+/BZ/b0xBZLOP/3WC6MvJYjPyyDbvOFuUR2D/c2LWnzXgiVfFPN7KX/thxIotE+bsbZGfPVUoiceNRPxPA1pWSQ9K13/50s574yhsogyrb/JnvbxCb/24XkUEN3vfL5rB4TWSwejb9po4UZ83yR3Hjfb/5K3aEJj7+08JKT9Wz5V9p2fzob1tURUfxiEPv8p6qpTjwq+OESo75e/4Bq2i9cXr+DW9MksqMgkuP6qdUtN/41ufBkcpLFPeXD2AVbZvdnvjOvVu2Q6iwVFaunjrZW7yikwpas192YmGUwlp4/78PTdBxBTC8+qNTsmKiynnz2/oB6xgIgp+6TsJABaQq8MxXgbPSxuUnn54ACJUNEYXLb54esZ7Qiq1fW9tzYUQTFE0ZVO9+zm4gWI2Gw+xYvP7zkRUKhdutxZ1veh+F1WvygMYfLxOoPEg4PO0Ni+cxi1UESEr3v+noMSKwshAOl4ff8TYwr1j9Ckaf/uwZCJWDd3Ntf13facwkPihNiT27ll5cdUKAZV/G9sfsWsK84oNXchj7yTXu6FLOSXIb27R9M1RGn5t0e/Zs8/LJKk2vEMoyCVABnvakG1CJOlQAWEx+7gubQoSkvAqneXH64qveTUHUpIxwgBe+gzu6UB4pwDxO1CnHH3usDibqVWHRenLKffHq8ji4lDsKKAB9TzxYwS0wC+7d1eGv3teeJiEpT4SEG1B72fQjLr7rJoCZxL1ZBoTTnBx9w+e2AFzrlBMKN5rPbzvac2A9QAlA3OMlBx47O3Rlx5RYn2S5oCgwz43hmYm+C4AbhLg/CuEwPHX2y7e6YqhJAiTdzSmaChd6Nxzi+hXAHCrusxUkmJly+dTaM0usj9AddDelJolC87UXvew0gDkh7s8Szh33fux4Glrd1uTO4YDs7kaAhHkTcL33jnH7zdtwExL3dWmdEsDM9j2fcjIEYawPhQjdnUhmMgABOnm4el0vzUXBmtEU4DB5sArko2srpOUDLiDCdDchCQcMqI+dv9U37rL68XlwwBSsNSUlXuu+X5zjzv6atJ8iqQXn7m95nVg8cptlHYI1q2xdCEd+YmeSfOzRR9uvKUJ72l5V0R7MWmDq+OAxszuDNQAzE4Yk1sQCOXc+vYjupPTAs776na7UcxSyp5fPX7GlR03yxQMPc9cemSTEGnlH9Isx+vv/WLf8rf/8szdff/uXbR++87ub60XbwwhZSy61r7189d//m73+1d/6T78oXv/pF/7I9c0vd3z3h6/3Njv6ptmlw3gj2683vcj2f/6m9cc3aP/mr3/+9vctHbz9mb/i84w2Y/M7/U//6dX+xd/7by9i//0f892v+Q7efvPr9rajP4j8YkHOXfoGGboYE8sy39HrPaNf/TbZ33ah/V9v3/vJ7SD09md/76/lr//eb7L2/pN/ganhE75c/OyP+Xe//90/+kc9hV7/6R/8h+W//68E+e2ffO9P/waR//2dJr16rcmymMh16Jticg7LdWF7b/VqHUqSRLbe/i8ixHe/j1//hV9n9v7Tf+P6rssNlrXGl/zef/iHv/9H/+n30ZGD3/wC+wVZ+D9/yB+9ZVq/aMjae6tXYbku5Jy+DXbEWK7TYFpr1prWOJBENiQavEbfhfHd7/snrrPlsNrN/Wb7xQt6CL1JicWGNbm3prW01gRNrovY0U/bCHNfO1hzrvl4kbREkq4MG4O9CNGquTcJQggdLq2FBa3F8nHL2XJtuYfRT9SQua9pWPPhgmENRklHiUQiDMNgtCnTCEIIkUjW8tjQBC0ED9cWmpZ7hn5qRsx1zbnWmmYNe7+O55GUbJKcSIQxhrlaS825hogQSe5rsfdalpGP36/Q0rTWcrZcY/TTMTLnMtc15zTnNI879rZRUkovjBZrTVNeHd1ocjY5W65Zzkwfwsho1hqsOWcx17b2gGUilZSSNEg0GHNOp3NGLpFcWmuahiwmy4etdhFLzha0lkbUq0tGs9Zg7kOb+zzvCOasbPumpGSI5GkkuqyFZe/XezQIduS5AzXkHrSWVuiFhWjWmmWuc87SdrBu1x3ZQyVJiiQiDMPAOhKEECKSJqw19p57dnQ8LteaJWeuWVorinpNIWatOYe1p+ur2GgfYYIsSgckp+yG6XSukY8kc28ZLJh8sVFsbx9GCzmbROjlBFGtwdxnZHZZhpj2UYyUSvKiPl1DFiP2URND1iUZOc6cCaFeSdaGwZwzC+ZxWdPIwi7N2Sj30CIY3yuCHPldLtOc7RKW0bSs4wyW5GxBC6qNiCStl3PWMI211jQ0X21aWHJKIkLIdc75f5sz1xCyrLUPWBbWNF9taFpr0YSWUNolKS9zwRpeWmPM85xrDU3LHkqbjW1vU2QzSIiQpxMiJBJvUd7tzdvb7CFrGlrLmeeI1rzRgv0YTOb+0kwvDcuwpvlyH1VKHSSSI7LmsGWtQ3nMY854kkgPpdR8Ol9uWshC8540b8/bDy9znTXGssNcYzRaluXDVMogCQm5goYx79txz+MHQkKSi0J7wrKs0Yi55sgiWrqM/eCsYeY6Y5rrmuemyXJtqUqKJEIIsuYwpx+IbuQMQogkSiOzdrFM0zy3XJvoOBOM/ZCGNQazXpphHdM0ZC0LeWxNSs4QBLmCTjxuPr0JgvhEMmvN47CsZWiajoU07yUIY/vB5HEMNvfBXJug5eNcK0kW1zTMDc/b5Z6vOaShue54XoNprkHuBTnnhz0M1matrWFZky93dJwxi7usOf9KyOOXrot53DFfnpaFVmupxYbZD2OeZ70YxrQMzdmlT5DlLEsOkOO8aw/QF77cA7keOtacy9xvu+zQkDUR4r3cZ/sBRJetGdbLdU3LupAzGlloWUxrxtyzuzxrTx93kY+XNSyjMefclzUt1/dC7PIDH2szDYNlETRNkAmtBQ2y5nKnXnUPH3Yso8Faw2QwTYOxLAhNaj7cD6LjfGVjbR1ozly7oOVsMiHnO/GxdrsvTKY519w31zmb+2pR1kNj37NoJWxtebHsCCHIY5Nry1c7+vCD+XDNdZrHwTDsyOJttSNZfoBxGWZrHpugpUVDq+lgoaPhS7NjWK7T1tBYswbTPLaSz/e9inQeM6xZNEE03q9aBI1FmOZbdWjCWDQYa3u/aAymsbTQiGT5fl+odzOv5tMmiFi9ynUiGFnfLOcygjG5bu8txmCaT1uqND/MeldjGItlaYmLFmuRc8i38pBzrMWaC7NmWSxCpLrse2eMsTmXlr0XBCVkbFmj5xqSlHpXr6xZziKi4/v/atqcY1rj7QxaMyBf/rlGclR40ZrIWdPe37O1pjG8NK3Be0vQWu75POaM5JjVC1rTvBFNa72DtcNgvBJr7wVZmshnMwilWK8WszdBjpbvey/MQ7PEQlaj+ayGKFjM0h6E93yf17K9DeaxV0uW1WT62UKILLP2nscgr7LUK4/TNJZBa62myeTnbYi21hpk0TT5wS7Mc2u0WH72hkZrnsPy47guP7MvPl5+HNulZrEWa7SfPSGxFkvbpf1wMi2EZa5rMtnPmhBarlkY1mQ/gHqpwfuF9yv0wt6bRvsZE6Je4T3s/cL7BW3e2/epNWeL7M2ErV4Zlok+JUGksvdWmHhlrDlb9Mp970YE7xmtV4M1GPTJCDpS0d5rpBeM0V75nkevRO6tteYcayyy9knIGVKqt7O11tzH7D32PWrQIpIm1jDLLGtCxr7wcg1JqXcltJhmxliDesdsk0UoazlnDQbLnCPsGy2MnFkQtORcy7a1bbWlSnrq3CTSag0Lw2BYa66jY99UHSPX1kIQwkJra+umLetDnZsg3gux7GiYc1jW3EfHvoE6Ru4tCzlDO7IY1lAqjz73JJpa7msHO1q21jT3odu+SboNuTetlbUjZy33tWmQED0WtgtSrk3mOuea0WCZ5nFHl30zdNmRxyYLGmk5c800151TefihQZoiTZNhMMx9zbks87yjp31QPV3znGU5W+4hCJmmGZudpR092nMkRDRozrEWMyxDwzIZGtNunegD6IPHJhoyWWjIQmItcjZojHFBnjokQoShOYd1MY35cDFN5jp37oX00cfdoInlw2hyWcjZEMYw5snHIK0PGmTaQ8OcyzTLK8u6IEM0dOG4o50eIPbUw1e75JrrsSx7W5osZ2gPTQbtg+1T9Awfttq75RpN1hCvTLvAZHtvWa/3FkbD7F3qzIvsS00IYfV6L6tXmeDSZG+GlmnMde3VvMpoJeSahfl49ArmPhpM82nQkey60sP0lUyeg/AUQSP3YO+Rj8My12G25jWGiKNFsibnMs19GHrJmjC0Y+lcy3pJD5KvPfZZdITCtMx7CLk3Wc5pmbF2MD+SS65JyEIjWExrrguvt621QfNh7RGClhx2dNydeviwGx1BiNZHOWutvN5Yrq2JBaNhGWbm3F9Ack0WHU2Ta65rrstonie2mCZZQhA00Zm8b5/kMQhChySKyuS5kXXRcp3rNO0Yy+zY2Z+LaWnRIlqEDkYs1jTN45AtTGOKRFdy2DJ2l45rF/SVSPSUUsrQBU3TYjFyHcYaY401r7EJTYLs7XYPy5dHozVMy9wi0RJC0LXct68FIXREooeSitZo5MsLu5zDK4OZ5sczIrXck1LOTGthWROLNY8LUhqS6B5Z874d+l1E0qVpwfLYYjEtC2tN5jrN2ry7KhGiJsTgMFGirF6FZfnynJlzlNK+XQhZgx4myBn6wnupaXJmh3x5WdjeW7asWctFLj+uYYg8ruTMWlrTtJiGLhMjpUUHkYiOgsxd6iboKSLRQ5ImI6bL0MSapjVrmfsGayVF0I8KQuYucmRpsTT5nfaSszIlSaSDIDLm3rlG0EMiSbot93nP73SaxZplmOZcEiE/xqELcg+5BhmNrE+WxaiUkiQNIjToIXIJkUuSpNRiYlmfLKORwVyHuc8SQn6k28OOmdDkzHOI5TqCzDnYnMgQESIIuksQRIjoog+85TmD0cFimOc5p2FDI7T8iIc1g629hz7Ic7u9GQ0ilZSSJJGIEFlz75wRIhJJklISi0EjXrfmeR8Mvd4vNNZCfuznHENbtCzS6EaXxxZLOaEXlgcWizUfz+NoxrLGWuY65CdxzgXH2XJmIdren2jOlJSUZEhkiJCxS7mG6CLSRVJSmubafPqqMSxzrrkeaxj5KZ1zsg6ttVyb6FUmGnpQkkzJiZzQMId9uOcDfSDdJKm5D43J9h7TXNdacy7DmvwEz3PLcm+1TJjQcm9bKO2VtKf2RIQQdOJqEEJEWmlJtZRrc1/DhMnamvuy5jrykz3k2nTREKvlwyaTJImBRAQhyNilXIMQRCQuJGmtV6b5cG0xNNdprkN+8kfuWZZrlrO1LOfijERkysPpJiL55NNlrR2WuS7L3Ee+DcPIY9bxmOXaFAkRcSBkDRlz31xDzpAHIkJY01yX+XSZx5Fvy7Ajj42O5ywGQmQSQoused+cOUPITYQ8LzueR/O4I9+mHYagQaPLPQghZE/GzJPeJR+Ra5oQQnb5cDRoMOQbOWczdoms4aVwIWfQrYN8mjV4y3EDOZzImOMcd7c8d0Ouud+Qez7u9i3fcLJLtJzu6AHz1Tw/5YvdfiZ25nSTrsy9U5cv557fbX62du565/Qu+byH33FPP4+7w9VH+l32yc/9rjx0X/v//u8iHABWUDggai4AAPBYAZ0BKlQBLgQ+bTaWSKQpIqQkMjmZIA2JZ27OnyPwsMbtOd6OwfyCi4b1eQ50xPJyOFI78N+YH9j6zHhz6Z+kMoX5wv1H96/Lf5o/6z/deNh7gX6Xf6D/Df4DsX/tJ+GfwE/WT9qveX/wfqt/zv4S/1X5A/69/dP/V2EP7X+wB+4Hpe/ud8NP9k/5P7c+zf/5dZX9af438k/1s+inxz+U/235LfuV5n/c57tM2nH3vYcHPrfmI+8H3zwS9ae9O43nzr2Bv5//Xv/H6uX/L5qv0T/hewV/Kv65/1fXT9gfoWfq0O0IspZKPHzac0BZIZfn19YeYxaU6a//8Fja9y1cTZakyKb1oJ/fIRZT+sC8/mclCjEUASssBy0E+1SghZo6yuc1JeHf9vljo9Ogqt94tJzMv5UsqAdKoWnvDJrwhNoJkla0E/xDP4/6Sdvq5BBCJSBThsVUFvrA9suhgaa0Rr1SsS4xc2HTjrUbF1zQUPvHU/PwZneGFsYWQTg93Z4w2bd3zQDTJdPfhk0M0qwC2LSv/N5vGUWyfUq9S1bBmXiohd8zk96vVwQSjs6NyJGp90qH1W0wmumsqVCeJ0Sog3cQV31jpU+PHjIqjsw7ieXKbX06UWCyQeo5Abc4am+FKJxXFSDpQZWFt1TNmA7ztPmJcPnAqH5N/+wVydMPcKxsFwl70o6DcduE4D2upI1+YPXEzasYXQ4kLsFzvjbCwRk2WGuKgizO4BkdQY7OfQfg4u1R64wrFS/XyqVK9feXOw4fugrjsxCx1quYVVC8fVLjTYa4qhz5CZNufzZkAvDc5IJHJ1YKVX+76C7Td7sAVUCmNoocU8K01lKqXR67G5gh0eSH6mf+C7Z7QAwQmh21WeU89tPVwZCLP8Ct9PbLJDSXs40EOq+88ChC05dh44OsLvnCr5KNIlv4duiuw/PnZgDnRzr6TGwtJnnxFXFEHFsHXTGi/GPQ+xjLF7//A3FRP7vkPJVeYXyPVT/oIVfrHzt8GS5Yb+fCNlUnPMW9gwYhHOxz+SaXUnUql6NehrkIioM4psC7fpCIS6BhtM4Z1sq7i47CewgdgQvcFOwFh+OIrp144ia07nUbbD1nCFfpwCeoMaFZPz0CRR2ugoICgtNS9NehbNF9kyIQUAWTUTAuJBWQKIWTLe9hYo/RSObts8kUb6a9KFxl8cFV5lLloO4o0kAEjOZextDLzXAkrSeszN3ZjewFoRYTQ5IpPQsNLDKUqYt/Ymcdez7jR3k1Zjcbj1VUE8q8dWXfwExPrVrjiKCK2r6fl/4hG0eE4xFsgyHOczWPi0ntfQEA1w2TGBEMhcrp0ya/leGFDP+iFXHbizbkZYD0qp8550hjL6qexfZjmSBvNSogIRsvXhFEq10+dRXtvTS9MlDI2LNTTTAeAcJpTpszMzWMi7iSOtcCS7jUKOY0UpzO2Hrj4zh1AJISf18mv/+PFa8t3wfNQckDRCl5WHWx01dJKW1zYr12l4k/vny/KIA7TurIfpT+2siYPZZJ2tS8OhygPzUef/Ilg+6FDAaKjzoKxfyLPbNqRKxh+NREKoq8K9Aj8hEPgWFwPFSUExt9PqoNiyJtVuPc0RO6JeDLPXePEoIdPAVsqtGYWPzMPzxh7Dk+O9Q/CKGPDEAuDhsfY8oC7XEB40tkQ4useaBgUaeDRLJc0CjSyYp4cAAfWy3R3+f0avHYlmhxbdE/TcHH1H/H6d23NvnEF95trCM6KC5xtPzop3y449upG4qUELlBgt9TnTHYLm2vA/6RbwnUTXmXeom1j6R/YIEJKTWJbd/eDsdSaayWTOiHrmoZYowpivzwEhy0//N8y23rL8qh1og87U2bbWhQDS7A+4tZXZyNU0oftz1qMJl57HmcocH385Tns8pgOefS5I61xV3kHeQIQfgbIzqkMMEPxEVR+3z9pu8K+EOYJuv2VOo4LfWamueCc71bNSimsNq1XoBB8eKbw6o6NzRjhRhPwDeAFcnBvOSs+jXZ8ACXLzzqxJDqHFtSlIjpN8qQa//9d3N4eIbpWV/6Rbcu25nBxT//UAfANCFaCPPGumb9AodSmCakLOhwCAFQ0e6Ws9dyA1Du4lWzOGdn2DupUwNaZTn30subZe9Y0D2wAC0cAy264dXmgrEUSLKNMarCn4CjgRg6nNTGG88ZJKa5SoFwiBkq3ZGZBD/BiNyKmuTyTFujjnpE9JVpZCexe5K+d7OTSJuFuaGf9iPOsP0raBg5hEOTjvR1SYbOvjB4TXbWzLdirvTOhsYd5X1vUiMt3p+6vBO7Ky/KWCQ049TEz6E3Qx/okD8WOgy4J4yLgXlg2MC04ua1gHQTqfb+FXlmF7Oj3f5ifffb55Z75RXp8zB1CdG1TLBYk2ueT9VerGAoBlSxiadJPNhs36a7Pw3jb6Kt4XY7XgcBSvQCSNFCL3s8BxkcAVxJwH30LbaGHsadDfOf69MpP2XTRb3ZQjgfsxiA5LsWDGaykMlo1OksyRj+030H1Lyv7Bt0vMahJ8Ic2VwVq2qkjkFf/9Ohyi71qrq36HL3GqYpVpcQOSegrUwjIsL1tibjf/Ym9dXhzi3WL39JB1SvBADmAclwXws9J0W5S2HLvAw8H7drUARXGqIsIvrUB/nPYLpvAmRut0vPq9im5YMuAT7geMgps4mdzLc3IYKLvOyok0aaZvJy/McCSw4tbPQDuJA8njYvKUEzI5dg4l0Hdy4qE70IIm94l7IwdcgxnSvx0lhppKbF6MqCNbWyKKQmR9fFbuQFxLotYpmKEAuflifrEqjFts+W8+W33MBs0YzWf4gk13ZL2aTuFtK1RLujWfbI0FO1ftJL/UY33Ee9u4PH/ephtDeH+wlR9i/dSmEw/g6y3I4Lu94Q2mq3eRsXYtYEa5zCle5lLxh1ze5rbIxMHKL+w+devuXIUXm9qKOEKbpHVoySvosxN49XOtdd797Tn+EoS1dRWt4fgtqwsNel3CjhXBPV+I7ZsY73z487cjHnQ/m8hpEYatlXRcLh3aDmeYpIYvCE+tZIpWjnRxlTNGfGQPjHYaKjA3aloSmiJFulL5rKiet5/pssIvhz3WbyPVQghYmPid2MhCf++hv+DnzS8+Bl3TxveyKiS3YR/lR8jataRSvJYsJ2JNbpx18K+c1bDtx74tuwScH/afW8CzIumNUk3aK+CyfyQ38V1e9+zEKoS0rHCokBctblme4Q+07pmsqcfX+KrG0W0t9YiomZJYOINDMjQe8M8545FrZq70kmgUrXTJMkGZWarV+XhqPn8rNRNvXwGu4IwMBkMCPK4Y4dFJ8lC/QmO7wj6mKWLycMaDKu2vIh6DQbwwu36tfy36DWuJMm0PdRYCzy2rt1/LIwT2aJxsxkWXOK2Df1c4f0YuTm8dyvu8UbZdTce7vCvTC5dt5Az1iXXPh1hVjAIxD5L8DSXe99bk+Sg60Le85JIFu9G/SnqsHiWrxGIY4mWNqeuESLopxTKvM57ze6//STks9RqzdfEnlopKhtXy/f5JW3zLvwKkP/EPlWRM7b0m+B6EwB+7dktRawsAhnBoIUS4LGjuX5+emvhzNC0wuv5iYjFyIyjRXBkJt8I07sWcsjib3iGI8kglgTqP2t064XpEy6Tq8JZ17Tc1VKnt337WVBElqTnycUYPqn84WnCcUaK4MhFlQQtL4AAP7laIGtK3j10YcWWnV0vG6KZvF45bFkHwOHPbPuTDJagOqd/vKJaw3OxwLh3GWbhE7k/9V/kxlA3/rN4WTfzyawThtIWTdzPXwRW4Im3NXLXfi4KtNJ4m34k9FjqS/hxJxgoNeATS9AWauqRWk694wPTvBPEqa1JdEI29IRbjODtcLrJ4Fy1rAF4MSPAD/f7JQC7sKCSoQpXUjv7ziLdZrbHURPKyfDjuFYj+f9pQS/Qd16WaafZgf8KaUICRRfDBwaGiKADci4OitN5P1d9cuz/YIeSmmbyEY17dSKMfI++FYTEnzRTrtGQAJ1FAHVUxDIS6og+I3tV29u9u7T2hVCZ/T+PziotyK50M3PudSux4v3BPVqMMg3qP3dLkbuBwWQwTUR3Opqrr/rM3Oy9tiRsI84hqsWfKZ2BkN6xmnSoRAAAAOBKF8SrTeJ7Q0W1mTbiIHMkAUjxAp4wg9Trc3oT90xbmTM74aDhkyB3S1gDU/SMoXGU98VfIdhZpwENUql7U/H8De24ijt7xinN8xDhV8YYlcIZrggCTdQKhiDhFf552qDbylS2K7l6t3uGuWjiJHCRvlU1n48TnHj8JteCoY8NW1+KDuvMp/dSvvpgqjPHnXCYF6sSKUvELXhac4U4evOxRq/8nDWwS1NeP3a6odiydZcJZkO+Zaa7Fbyy6e1qvyO3R2e/HXfAVSUQ4o2PJXJPCPSvApYatKS3AnN5igFmtYPLgbUgapzpZl0KG8MiDzoXuCwqX0FtfVPk+kR3PHapPak2pVHwL1/6113PooSUahTQuEp17xPrfQCFnmjZ+q1nS7t5ln8Zi8PpTrt5yaUmQ1yEBxTmFZPGwFqtq7TWSq86TboiMvHH1kL4zrgzPtiQuBtoCBj0IeR5aQ31PuFNJK54/oi1XpDLxAB+jLwvJ9IKn4KumVdx/pN1pFc//C3e9CcvVo/425eIJCqH9P3XykMPmOpr1f3ug31wBdJaeat6toKoteZ6yF00gEzC6Nau7HKDW8XV/THbEI8SHL8j84icCY7OyMXuPJEN22PhEwNPPhUDfwbzK9zd2s6XPN3DcHweu1+Sw/XO+1KcaI9QoZf+cYqsCz8LEVyR84VYHbjm5zAPeIGznwnbRW9wwACzAd6qQji/hJGzWOOE6JTVhbZxm/j4mdO62zjLqvhjGtUimFtRV59xyYfjDjRQjwE4yHTaRguYeHVg6dos3KBZ7ldoq1/AjshHnYVoOFY+j+Fy1/jidi7k+ZpsYJWwe0bwbowoaK6u3rkWoqO4cbiM4/4nZgK3611MRxgB8Deki/2GHaw4nrLuezmQneuwWSHq6Cqaoty80vIbZkAb/7jZ5hNQ3o1UALRkO06PImCwI5k2oY2cibpqaWZK3OUkZyQoZLt9jjjDIhAuoA6aP23up82abX2l54vcQu/jUuGoI8u4wgd6xbR49EymNixgbDjWHsCbhkGdZyyYYEHoUTXKSTTAp2IfsqOkcM37U7EOJRu500AD8g6dsMftLIG5bjyEomMWmCo/NhfdVt/oXlLQhUCH8Q/miG0uMVGk0qgg2atS5FZEf4hJQsF7fT6cl5SgVgQ7tF0oj27O0sxWCIUNwhf+vR0rzv5oET0rwdxOUfd2thSGbfClnHR+npvM7pUZvOURluyJxJ6AYh2xERekXqST0CbBRzgKBPpXBHlFOHFCdO+JUmP9mqVY5UBoBQatYUaTbAic+aiyVbSpVO9svlh5N2drhDO7kbDYCsISr+brjP4UfOmdsQ3Qb9ww/VcngVR0mpHpBJOoPUIpPohTerriBLiCu7kV0dqEpIieRLfHr6hwIvcR9sn16eUebGm6LXxPqJnmUB0X/LfdJttbAnu2nkMQZ7NDvGvg3pWP1H1vD9Dz9FuXx2U5xr51IS6a4TEKtsq/qq9eP3V1iFRYeNByEEV4NPm3ykF7tTyki0+03M/cw5z5M+En9iXRMVGm6I8XsnAqYUivkYsTZ0tZqfsNWTHlqueyTrTtiUxZvyIIApDQpRWkEYDeID/EK0D7C8jlAzOIPUJoi+PCvTA1+9ks3mvP4P0Spo4W9k7YxDlco7Nt77V7/zBXIJZ1e6rULv7UsoD8YoPp3lPNqa/R9Ce4yWaB7YiH30drR2vd7zlqx4FZhlJeWZe5JSkFQW9cH85UwymktZvBpRDnOi7LvbxoLp9BDw89tBjLGzLVD0Hazbm7XUR7gs62knlmltJvQtc5Ccl1vp366IhYSnE2o84lGV8NMPZ01tT9H6/dzgkQuKxGVlJ73f2bViKQS3XqHgXgjoLGoxcO9K05cTuIqe9qd2QpC1963riGcl+IGuwPrmalSxvdCAAFAvGWvfYpMZxHtIythwMzaTvX2jsW3Xe5Phf5zeXjhk2tRURFQbaIYuBXR7CkHOSzYDcL5ovsGfy+LPOlYkIFMn2jAUyL7lLU+DLbY1Ly7KoLpgeFaZWFSbMKRkP/7H9//3KcdZKoz8sXRciN5Gr9L6Oy4lMXnfvIDd4d9QYvUt0srVGMoOh4tGXKCwLhPekoV2iQEXYiHlbmpivJ4Mpx6eaGzUU4TAYm9Ao4ATpMD33VyPrlK+SlsM0Lq+x7KtRnFjdzEhjWmBiOraQ/5a6kSa5rALHCyEeXizJyS6xJz2bkZFHcG5XeKS8wjTKf01QHC0VsQioqobvpxP1wd1GqVrb7zfP9uCVFUrTsp9BocdWgtiSe16I5nswQ++u7nN2d0B47oB6JvzwDZiWlz/xX0MTpTQdcxeoB5Vc7u1Pu0DZNxncz/wsMiGTR3nZGz/D473GJxR5sLBF0fLadad0cDFVjAZA9iwgIACRkZBtZa9gYL4tuzPSYs4pMNAbtg6VP+EHhETqJb4d//AAsiy8sas4pMwBi4Ye8u8Ek88oyImHfJEm9gX0nAyOsQcItfWHxR3/f1dantVPe200gytgpvm5PkgAAc/NPDpIrhfXiB/hQ4YqRbmlKAea+rWH+UHrC3xoDL80Az+5aY+SQFwHBOe37ktAkh/VMmJz8d+LIOVANQY8bqHzElIq87Ueith0fmzE6gqWVbgcy868WlIP5+JTO/Jubkb6ydpXJPMjQjN3onCwZ5+3l9qqw5OC+x9Hd3azEXhxnk9JUf76l7WfVh/HFcATJR/4Jom/Nj2yPhbVxOUL5jID7iSA3AWfcSbHEz4VQ1ILAvioC0me5e8kefOl4JcL6zzacCjQVmlifBnOOBZX9VSbhlXBsJOt5YBoRJ/gUEPGlDW0GfyPzC7q74sM9HZTvp7ML5s3HItUfSdH2NYjKkdNLeN+H/uChtWchwVeAeFQo+F3IGskiL/ePromRZreiZ7oGi3VSpE9JgndFg84VI15OndjmidOvhGQLlG3PqlnXSx8PO1VXxWdvccCuwufW3WQfXUG8uguMwg5TtXEJHFJn/DeE3WRrnkd+mSRVea4QJO/XUiLderDnZSPzNDHU9/uXZs8x3RvO9JnxUMcosM3a2P3Z37QOCbjvW/ONUp23u8+24ylG02ezqsqe8cKBL3C5FW1DIqoFj9WgKZmzkvc11zofRFaDAKq6606zDlrNBfPKJOIwGPwCTsLuRIHtNW9+zBOHuG/xHuDAhQ98jTX4yjqWxsFogX26zT2ngPcZ5yiYg70utcjUCiWA6N69Qtqvg1OFb6cZeHvzW/y1tSORVc+X3sk9bm+Vdw8pcGtiTrOJY+uPsn6133dMdD4rp/X09PDig7IFhmQb5E9PV1zDt04YqF4HtA3z4JhIvMqqIrZLnsLbX/Kvv1MBlBGjtm8/1g+JiysNPII/ZzVS1Oyuw6aXUKFvpKAb6NMWkOe0p6kK/bDQFm4c7uNgNkseGCloJnNb7s3xH5xliMGL6tFAhJfBBXk/15xfaJoQh7YI6pC310/27ulOhwXyP7zG9CR1ueo1BIbII2/mRh3nAVPLgy2IvPPFOerpVRVbILji9kPOOtqKg+yUNgknr6+ZLtSgIRf8icBFFJrqJUWdFllC33y1PRuPp76t7E/4YRnYCJWQpfh1LUiC9cBO9hQsSVruF+/wmXYdnZA7VdyuRNyHatAmP3U6c1EU/KiHr52aCK+N0oZJyK1n7lpzH5nMMmHyRDox9iYH7+gHSKH+5alGunWnre68Y0tf6WyUPlsXzBgXt+b+i/gSnSy7ZxXIFYt9c3qDOZjOeGe2cvYxEz7aCZvl+PB/N40jiZ336zNNXLVL2/Mb5Eziy+E+ppNrwa2NE0AyMtOBTanv0E3pK65cw9dZRnACUpwsTfd4y0iLzCi5eUOS46jb4vACmmobh4JSCl8bLLS1ym/3a2sqLn3IyoynwIlPltnx9ZoacNwrDhGtyccSYgGZ7TKLrueHaxE4tnz///tc4yKmOeUKlzkTtvxd79FS3hI3q3ixBrCpTcRoXQDPtPud52jghrNhWYzZWCsqAOlmpbRXggudV0IecbFZ1fnPJnPLn7mDW1F6nml+xVz2cUCUrb6zFEtzhsu55fPAf7iKAQnajQJRQQcG+sDlPr/xg88vLQLW39ZLN7MZ+jM7Q9uaXcWlNAm/liq+4e+h9VX+NTYF6JdWuqzTb2vKs0HCB39drr5gVLsMO59vPy7rviYjXu4QPTpqHCQWIjtpUSzqeJpWaIxfegxDPqrvNH4dYnISsfgRmrwfZNZZZ2ADlnhS5kFWTD83BRI8fcrWJTpEg9sdvtA1gwzs40PTNScd0uzTjLmAdWyaUSoOyZRpnIUQRWjwkOJXT84lpdYWM++ZBz4GAAPIvSH7cRzVJLZmy48y+xBbcf2pijzJVPtBsZ66+3UPN1DJOxjmoSYjooA1/1nW/hgi+bVi8mGMaDT70v/3sL2DsijANIAxsNRfThvILjvsjFIv7uuIonIxF2Ue6heOYDu0MdQOHj2YVx+MZGmvpt5yx3+ZnQP4kxxcZ2PBrM1eiOaqOpFxlkus6tDWlTl1W7eHmiIcgrr/XO+gij39gDheaVRVlmZX2t9KlTh63ASEqiHjQ7Cz4BIgjN1XFKRTrp4tbJRTtfnqgHyaPYp6zB1hsnLBG28ixnGTJNXciNYgYLSHs/swZZy0MkLdLE2tgdT2axMgXhB0UEaGKMieE7USyK10s7Hn6eNtRCLx44s6v1SANPtFJ1L5zSAM9x9juES8xYKBx89A9u78kQ4jwzk7/WCyDaDgXzffHQIytpnde/6hJvhnwy6eGO+aZvUQ5iv0BXwXaVK0oGoAJTPayPSDG6nbo5h2GMqlcaCA+zd+ix6EDZytxFsGLiKybqVm9gHvLVJImk4QfpFiRnvF5Gi/kWZZJ0RjfNhwcjcbVLKAy9y0XyhePaRFJ/sT4mzz4X4n25MHGXajoVE4lXlJVUEJUwDqhLbYqCfBOqje3BEgXKcPUbPzJyJKEvv0Pjn6co80qDKHxCUuBWSDzDNZZr/JTaacyn+XjPbN3DO/AFhxcPyInhsvKDJP863f/uLPz07SuPWMqEwrFrCNic2cfh6v7QQhwxSb4nl39eys3hIw7p8B5X5/a9CYpDiay5EsiNY/ighOyf+lxwIbvtRrs9IHfD1Slg3L2Z1LfZuuFL3pznQNU/elxawQRMQ2iGjkAJKt1JHE+v4prt64m6l45CcEIT8PrBT3AYYYNZIDu0m03Vyx7+aCc7gmC+AmCV4kk74Ci8R7gwZcILSAwVovLQFGb8vIteONJSO+5UzDpEJdf+5VZr5rJ8xxctvFhZCFHY2vFQXDtyuahdGS7MMhX8JWZ4WmuqlNF+9UaJ992DXooc8U/O56WinHkXe6RWrSCfUNX5rqq90m7kRpLRjnoW/2K/A1t0Y0pDueI56vBrnjr8kzRhh+o/kH3zMqU5pSaA4K6miiWlnZiRtXRh8mar+CbFrwAjOl/iDVprwJ+nQOan+vgTxgFUoLi4TpKYBvKImXguxYXsC5fUxEOf8FuODhE56qE+RuYy+ygnIgZ107KvLcJLYiK8nTkGq2+tbuIxZzlYs4TXh0bpvCy7VL4LWbJhCN0sOfyhR5fBaLFHJ5hef5ddMh/0p7/CpI10mQg6gCXOJhhGb2XVfOBAAKtIimfvx+yev7PYewYF1HFvilYr1BDae5VWuepBg5fnZVPZMCnzdzU1k9l4xuno6VVSpyioxIGXV66xJFoB/2e4upEerEkhBqFrlBNf2PhLPy98k7X2gJo7Tq3RlfBaYxFj8Jup2VF6uOqO05uq96LDATOs5Y9mjjGbHJBXQSJepv/c39AcAeprBzGYsGqK/5p7ZO0vSfya4xv7IlBY6eoykDO1VvrALDo0W+CS748B5DuK8uUuQIFLHr5NmQvWdPQh4rfXQtgf8LJYbTRlUVD5dNcWqbriWj96a9N1+95jBHrf+EFxZ/NXY9t08TDn51Bk2jsilNHEC6HlcjyHFF23do7mf9Ec2BnP4S2phfmT2ztOI4oZqa8W2dE8l/7jyw4HRJ7G3VNOm+tsG2T/y9TfcbxWHd1nj2PvLUl6ighPKukCn4FFRFcC7gISM5tkdv8L9qh+RjTSo6Ig25XjFDIZ0fQP3hEBXT4qTG8PABZHrtlcrrcUCRz1KuInf3QO5HSUSRxX/437w1jatNH01hdVj3t9JmweCgwkjz3QFjCsLYzzG0FHCjSJtj0ayWO0ECN12YwiBcAoiNTA9rNezulQ6kT7NH2T2/3I26oB6XYpeBmk4bXDfMhMoVtJf/JDFrDYSXr3Rglat9OAcbNAt6XmtyDxEhx2BM74ns8q7UYY9jHS9eP+bnlWXaHdIXH0RvHJyszpmsRYL9gRyNqFGpTjswK4jjzCqaydTo05NhFiTcyv5eHFK0sqeR+dAtvQIPL1WK1DRZgwkJcXHz83V+eHVGRGQ/IlrtuPSuEds2KcPk/dNyXmXhR02eeJ9bUDwji7o3GFaXGTLaIcIER0+iVWt8B0ScTw+5lvVWGu5o+EIXHDBGa/fBIlZtPDkW80xQLNTa67xaXsIzSUW/Mv0UjtyhJbCb07/pfFhvpjI9TGRmANtomthusrvKelMXVkcT+oyASxlMuMguiloMpf/xvmVFuLtxs/Z9kSxdXJ9OLNOaEDln/CvHgr0hGIDWVQzenKSyIRKW9zw2K6ou+dHvJRJN3bCXuaDlKH+KX4kQAiz/fWsdPd/rsDh+OidmySZtFhliWmndV7QzZLySG5mfN0/eFjXQJm7Xu3AME7QOkOdxElD/ATsdbPYDhPka5A2LCwZHiTJW9DvURAEmIY3sGR3F15VFkbgyHRtA4xJGSLESfO2Eh5XJbFkuefccC3WRc6HAgggUXzjC6SDv1/t9SLV/sYxPGRB6wVFrYkUmGjy2NxTu2GkH+Sb2coduVdkW8keYX6kUlNrr2YiwWr7pt+Z7SLpCcwlpJ++Dj5uIry1zbHcExkE83GqOtcSoU8wuBSSz3gGsxOGl6g1Auf5/OCuDfNKfK/vqmelpX9MuTT6BVZ94aUH56z7Z5Ht1hWbn/NKCGcCYprYHdAC2T7GbWXOAxRXNuYhFEpNR76/1Bl/rdy8M1sHbX8kS/A+dd/p2/wIBhJKlPc8bA+rFzKFg56kLIU9PtH95CUS+FwRFMXFWorZrNXbtFvK915xGseDjbJvSuMOTRISbeffYSkcCb2gIfXlweLXDBOT024DaWsG5DU2rfmgsG74crW3uJ4TjmH0ZIB4QsvBUSOqIA9tmVf77df1QdP/7f1mMfkkFeBh7I/SzhUEAvfEgltbcW8WOmJtBhfe7M+7SeUQplVS4Qg2KaEVRHpQb5BZWvQjxYx3mi5IyLTrSwUTIcRoelMrDhqUcL5D+hKtn72wyE4HvePFj4kdfiPtbF71cy2gf0d5M/g4Om9TMirplhuJxaTHCN00NVJmkgGzz+MWrBKOeapkkM6EEpAhv6G1U86Fb0DyvoC/Br33uBqXN69SGqxPU8wWiM2yay3tSfLll3/VQTsfv7/w/rEL0fxldqrq5RehG148IVhv83DagLsbSOibS4QjKDPfHlb4O19Gg0WprmsFkNWOJaQrJQX61H3ImgzUt1FzeR+u5r2M3+nAzfR9HCFGjGLhI3X43n+H7V6tuXp2JRM5nUvew628zZjx9kwCV9ru21e03yow8EhnXjgIJUTJpIp7MVHf0DjMJ/XY8JGaqT7YBfoxLxez7i57GQrkqtaQYE28bYFYcUDk+P718663W7cxNrkN5EE28ux7nHcsolFMcc/+9fYng5x/hryCVeUuQbPrM4DAhEIPxK/DNmwqfcAy4JZkZzmiHH5/aEiTT5uAm1vJvQ1yfeBZSPqZ3Zn5JH9VavGc3ZaReRmeymcQHDpv7F9d6IRVMlBew90PMWkwkppv7iOc/IeXvasym65TjRWEIWS4c/Xr4vmFl0hBAlmrOmqk0EaMUEOkRqyikbqn8YUgWfp1funbx3Gvx0wAGJLjfBmWO6w1qLBldYBky8YG7Q64+c78c2UnvxBxCPTsHme6lJJ4ymcuN/PlciuN56Vk6Os5y/biWq0+V82d5JPVMBlTtW5emkMvG/3TwQ9bT6rR7IEsURKjm8Kl/MxiWQTT675rxEbQAGg+usxqMd0i4Txop4lhpI8hUPiKYvsHCFu+OXbWZzKYNoo1z+a4e3ww5s4SsIaOB33VHpFXE1xfo9/duYp4J5psKgq/IrLaeJk2LWbmqP7CeN6WXw+CYHmFPyRKKg7EzK4/H26TRIJmPHUvjwwI0yts/9mcYasQrK0n9vbs01Z7s7R/RRPNNlhX6VJOAddMKpO7NiIe2Wxo106CBld84UJHJBQHv1yTYGiykHHg0oSmuhc/hMmVWcovVTNXzD3QXYNd1ISAKVdjKv6yrnY00+o9oFrWYEwyvbOo4JN0bcQniSVCU6BIDSOFSc5AHXV7j1G0Wa/aqrxjn1+wba2YK47p4ntKNpaBSHV1aSEdqkzaD+4cY40TLqV5oFREvIX3nJQbPkRlaG4wnbTkhvT51dikmsXubUsYSnhe2FV+4vG8wJHQdl18gJ12ZoxzI5JJ1/fvf4z1NE2+b0hrh07yBNhUUVz03ulbEuZGw7cdnI1tGIKgPk1T4QfiH+DMqnDY6gAAIGz2YkCc7mXUeUCjSiHR2MzWvlESJF1ktDzejTTdAPR8C3RODW5Bt4vXH/Pcnl9K5TlwSDy0cw0IUcyTf9kHW/i7S6H55OV8nIptPvqZhOrf8+3OFqz1cQ5mWBWpSbnNw/TE0B8g3dytKeaDh9xsnn9PQbfIvtO7BkAgo4XsB5yTJIBO4a6ZlZyiWvYV65j6Zy42jk0mWiNeX8Lxp16eqs5HcGBFzBqCVEXlrGD9/12wpnNTLNF53rKyTVWlWtvOsR9XqTMDIuWpDxwRMOW5NXSYhSDZw9Sbm9VOIzsNIBWq7XCm4gYKT2kIpiI6rB0koXxw3AnAcCceewWO1IQeL4hH5yvUSYRpOR1qGrO0t3QKDUmua1k/CZFTsUd1idGlAgagyE3uQYcr5b3ra/CEMlMP6f+Oc4YdLSECP4WjwOpPrjlOK09SMCypjl0j4y3yym+QfPixpq4MoyUthKOGMLrUvnKb6CE5P9KmcB5JXGVOLEypRnk2S/7gr38MXRZnlTuWkP+TBm516gMNte7UzJtDb+BfblqLCEN01ZRWre/C1GdqUrG427Pz8TS5gv+0DJV5LthfzqpuXNAHhoQCDquypWPwCqmNms0otvz7/H97o4t8vn4meScOGou+1leQKVUL5nGz02h+MCLSTE8j/OW/8NYHUiAOWcWBf+w50qjen/lwFWOn/4N25M5BDcPXP8nI9QVCC44hkGOZASE2L3yPwNr7GAzcnmCIazkzdsK8P0XNsYNBdA9XI0//0g7UiLi6eNvZFVC+4cel6PC5PDm96AkWIkEwscwM9W3fxtMUIpNrqqH9wH1a2UmI1qhhigL/yoVFwzhTbto0YLnOHSM30A4y1ImLo4P55rnCZXyMkcA8YuxRBU+G61voSv8b425hN3Vdhaw5ilT7w0eBNK9c8HC9W3HI6ZLVICwzizNqSEH2Yvq5rK8Hq5uuwEbqK5SwL8DAYUXrnqMuq7fiFjM5LWFn55IFgOWn6Uh0adsU0xw20pzzfha2Wwak0vp0/xqoSVlcfEYZq2GC4mlOYHvYL1MkwEI1YJXOhQbenVBQwrzDdm5whsnRHYplXJboR28SmGWunYCMdBXgui+RBfA3z2k8TjbHA3OdMUSPOlYLzRmFUthGkaWmGoxE3DCiJcB/rLVs1CkrS0osDZxaLnZsVxHK9n06WG7ZeUHQQHLX3cqk+cnHuS6wu11KPkseeOdKAl9jemhkk9cZfmD4XIBaVOtBzZw5v8dgE3jy2VHSMMDDmh0LOAYWe7tN3CfRZj/VMkcaLKqW/vS913ppOvwAIDIa5usmhh46DwRdTSFb76CScbOBSfoRsS6DWIbw9hWVBxWPD8Re08kx2Z5WyGGo+mTcDVmGYYAqcVTZv4wLPpE9x12dxqtDqtHXMayGoREBHcs0VdolmdI9qbYjZu2Nz2JBg2JPBZas6M+pDQdDe7vKOETyzhEqmx2eEl018OvIy4PlHjloC4iZ77OCgiWzZRVfWqhJGvnO8eZBfh23EF6cGP967cP7ls1ycu8jdIpYBZpSjVK6E3uMs8k2W7FW2h8G3O/T3GKrp+8K5pJaKcXSM5Il0Gb4aQ9JWxZtZht4xjtQZt4ehgrstqAjS5wEYW7lceggSCV8sK4KFiLZat45eSIEHtlZs+srtqPll/qZDaLl9aHrVK5JJ1o+cGk0GimKFIBDvm7nLIczB93S7y9lKrqUMDZqUUosfKgHUyjXofVLwNNCfXHtRWVSiEXferLRyf4TxPIwbDgwy3i43YORkwXhjW+IEcUnvNhCbnkJ0pg0Apx5mV4qKs5b7L+faxxveA6PWIlEaAnNhmX6WQTzLTqvGn9wdWMjoEpoyO7/ZEvd/xWQFD6mde/nldKKt7QX2456oaLP8KvNtri70fpZut6NdWXwMQLPMUCWLGToAzFbb5aKwI8ldrDN1RQZmqXOKzIMw7VxMQ9BBU1sXm1Su0X9PnOHmwHTidsRTGNmcK40SfbISKk4wbiVmf+OPefsn6adK0FmCqEbDFX3BSAiBl/zQSIJen9ox9JLOU2q4koCP2j1VjdDWV2e1uMwi5Lba0XDDpuWxrtvy2ctJj+JGaMciHZLZWphvViR4RO5xvqrj7LLhe0pDf/3O5d/X86/b2S2W6PoxzOJNK/PfAN59gXtOKoXuDzBwJ+71py2NNMHVScncQE90iQzCdPZu8GbOabC7uXu6nO0FP+1gv8oTzcpFrKdE0W+wwg3hQV7fIJi5XYk+oH+WTZirw18TF0WmEH9GPuEEvF7VL1jR72og0yen+gyDmZqkjQ45Rj+ge2gvDUlzS7DT7yyYnPfXypP9F5Kj9u27hrWS+rn905nxLM7vCtoe4TpUwY7EFZjHY+g+fnixkOsyumpPuYa5Ap+dPn5GQ1ZzCSJOsTLGZzbVTUt3FZ2ZSKPZGlihpAexGsOXivqPZP3/f1VuitDGiDkp2xdDv/Tztpcy/5ZwUlhD1hopc8dY2SQl9UDOpYSj4sevrAexLZSGC0E3dWRxuWbdTuINa/Pu3MG5oBhbQ0N0v2vtP25XTuieoc6Y90eoRHP0rle15PvJ50HCUDo2gaEHZJpDQTH+ar/i0we7d7LN0K/IVF3Z/PPWyeGb9Bq+mtt/8ebkdLpvilmcStbjQ5utwD9xiFEY5ehv5JK1QUbHn37inPhj8GWA2WCf9MFVWBCzaLSUKRsYGtJsC8elgXAJQqx8Nzd5Otpzpx2dETjUNK2PgwUHILUVoOb6ZldDhy5YlH3fXjTBYg9C+o7vWowd9qng9vKinaMx0YaVGNUDNZNd/iIk5j3J9CN4hyPZ66hOQ86+IKZ3R1qVp7FdSNm8Md2m3RgDT4sg1qiYhe3YOT6l4g+FRoQAyDxMQoHJLwu75a+A/AVUPgXD0HcMY63VAAO2uo3U9o1tu/j3TQzo2PzmseS/zzsHa1B4AAUP88RoJc9xRxYPVwWfZLXyX+/gAVm59xTJe2Jz6I1xQqyP0tSuVg2KEgOX4Axv0L6cY3IJaAePh2Fu+B89Fs1lv1QYNOmbaInJXuo/I2X93Q5o6dJXvhYVrWHqAAAAAAAAAAAAAAA',
  pink: 'data:image/webp;base64,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',
  red: 'data:image/webp;base64,UklGRrxUAABXRUJQVlA4WAoAAAAQAAAAUwEAGAQAQUxQSAkfAAABEUeS5LZNbXAG//9ggAacfYzo/wSglgDA+w2ZuH8MK3eiKgulpsnbEDmA78YekGh76txRQXZIzkktW9QAYMYT4ePkz8E3gKfiH2xNMIY4EzNnkgs9plDLybeWRC701y5iExHIC4p8R6xiluKwbdtAquX9p27vTp/vABExAeucpJALIgXASAJJiplk1jJ/cEHkjEU6I03GgEYlWZdGsoO8Ll0st3GANbc4s4vjY6+5ZVQcHxCKXEmv9O/d8o3s37qRzxy3PlIgxx6zmZHeM2zbNlK6/+4F23sUMQET4AvbtmNzrG3b9uO6UXXfZcVJIVWpdKcrI7addA/btu3Htq05237mbNs2W6nrOCZqPJ0b153zXBrLiIgJ8Ib//3k32ra9v9/fyuz7Ydu2bR+PbD+ybds2d9v7Xs7UTpMiaWNOUjc21vp/Pw8yR7BW2vkebERMgCfbtlVLkm2rtbnF/TAznxMiOyFmyAFlAZN0cnBC5wRPiJmZyZmZXd1E9p4tMOdaqseOiERPREzAHNtpwoNPWLQDsM/7odcQ6J//6sEE2HLwnOYoyE4rPIBm8+Cyyp2XplxAn/cdF7bXt90bIJ8+fqfEYNfmBmCuyAxRBnvXNl3b0VzhDuducD6GN5995mH3IBRFVsiclbfcOjnORofQ/6e7OpKBs3Xu4sFjo5RQSqik9YrPuAEeCIkelBDmMP3yv56kVPlgovn0i5OUmOhxBYWJX35jHY9ckEpOv+U4bgV9qSic/bs3RVHkgaxk960DOKJvw4xX/uYYJXKBlYy99uVtMPo6zKZe9E8TmHKABbWr56cpRd+Hc+8XX0VpySc5l99xjNJEBSoKp55uhNLOSpYuH8ElKjLMLrzjIq6UC2Zf+7ImYVRoFZy4vIt0Fxy8NkdpVGvhNF96FinRYGGN0kTlWslcnUiyCIJAVLFEOBEJZrHvy4ooqGbzxlcuhyWYeHqzNKrayvYtlF4q514RosLjpnl6GYdWqDLTidWw5IJWVBoxsgslmIsM3SQqzhMsOF9tChYSzLWGqozgGp5aQqLqJ4nUgvDKcxJ8bKLyLL3E+AyqNLFrDkus4B/+hqg0ePAhIrXs9m9WXPAz/2OpBXztg0VUWBT//Q2kd/Abv02VOb/+O3iClQ9VGjyESHFR7eLxo1FxkWaqVVwtxYzFfViFGWvbw1JL2IcnXRUm3/RBktv8Ga92UeWKN93wIq3kzQ9Axbl9oB6JFe895ka1m597q1tKmS+/L6h6wUd2uSWU9L5xt6rDfPrdJLSVz361F1S//M03vUglxY7PLhiEovZhCyXTh1ZKGwSYn3yLJ5L52kvcGIzyuWfcUkgx9BVjaEAgrtZDCWTx/LNuDNBnhqWPfPidwQCt/N0NV/JYPO9A2ADBjz8zLHVUtt8eDNSKdzRLpQ6L+6SBIvbvIn2ONHyw4K1DyROcVjBYQydJXHlrPxowMEckDiv7Bo44scktaWCoxqAVm7aQtmLJXAMG1Eyc4ArBgJXXz6OkgXEGb7BGJM76AAInaVXWZ9DACT/xlZiev5jfOzyA0PpXXSjV8xd0Ex9AVfmnH33+IoWfIBhEZ74ShZ5vmCA8wie3owEkW/70YcAcFM8DJIGHB8Dw/s2XCBtAyF792nvdGzynOUh6TJNQOJ9w91LsuDbddEAM6s0bC+q8UB8Z4zndhPQ4JSHCAbQ6N3p1qTmK2OgYAzpwnnO6a3Po2Mr9QbY6JqTHHglRsnFuvnby8NzhUTYGEUgFA1wSOMbWhStTHe2N8Wm2FoT0eCKBKAGaS/U9F2YPbTcDCAcTJu4KRYAbQMTklc3+U7PjmwAFJPQYISRKNg5v23x5xz331Zps9MAw4+5TBOZsrda6ByaPP7izDmCOhB59wijZuLW58+LckZVWARCOhLirFRIUgMbqYGf9xsX5+2wtBHp0SQoHmJs+P796rDFWAJRIiLtmIVHYurR8eXD8zMwUgJuEHjmSwoH22IEjx9dGR9lYIiHuwoWEOcDiUnd7R/fSCkBRPEpk4cDw8olDpyc3A3hgIO7uRWAOcG/uTNfFyUWgEINBFg5Dq0eOntw5AlBiiGQUQQFYnJo8eOwmQGFVJwuH2VPPOLzQBjwkkZ5CMgdWLh+7ceUhUEL7loTD7KmnX5gHPCSRsJIowMTIM093gxP7kqyEuZNPvzAP4ZJIYAVusNr5mjdO4dK+Iyvh5GsuzkO4JJJZEgXGTvxbJ4XQfiIrmX7ZM080CJdEaks466/8rTtQQpVhztQr37gMpYxEDxXGrp19+TxF1aBifew1b1qmxETCKwoM/OPLFlxVUJTc822HKWWkfojC4J8Q6juFj7zy/TtKGVkwVLi8m1CfwZkvO4Ab2TDg1CnC+knOlfcNlTJyYrBrgYg+otUeoizIjAoWFulXiZWzuER2VHC8hfWHMzIDIkfKkXDrPWFXZglypait4j2niPE2Il+KhWs7ek184LsTRmoGX/zeWFPxgV9IelpQo7nVRlh2YAag3hndxEjSNaw35LOnyVIxOBzqBVENkafGQVkvwKumPNKkKgc8eqHc+jcTaSqff8Cte4N/ue+RJ8i+es7VNW99nzmpuv081jUOf42UKlU8QHTLzr3OIlVCF7a4ujRur8CUKmLbPqxL8O2IXHVm6f7ve5UswVWiSzfPlUgWsYR3RxQvJF+Dx41HJIx3b/K9E2bTOOqKcfTD5Mmi2HOoSzCLSBfNdC3I2OCJ/NGl4D6ULsH+7shr57B0EedUdgNqQ2TsUIG6QqTMkxpGpIypK2J8KmHE8h7UlRM75PniY2tdgS2IjK3R3eB/8kemia4Ee1HCBHuJzsmb57GEERcLV8eg0SZnW3W6GpkmeFy4LNMU6oK4ZzsLGDG/B3Xh8JCT8fbBLkCDGGbrdDN4vHRkm+hKK9MEe4lOye0CIiPON10dIsaXybXtBp1XZJvgceAR2cbUhYkxREZsvwd1yDg77ZnGhw53DLYTmA3qdD54fLG6EBmn7EIr4+wlOqOyfgFlGnGu5eoITC1mGxgeptMK8m1Exx53HOpYRMapuTojxkezjcXmc6GOwHPGXJmGqH/+rKsD8tFXkm/Nl5+NdYKpaZRtiHjAvAMQQcY1HZwN3ZlYnED5BkYmuTOF3lArybfy0TOd8K1XsIxDsEon2zUydPB4ZGWpMkttxrOTODcTlp/Gp8jQETnq8d2RpZr17KM7M862QpmnvLPgPpycK9o70Z1k4LJ2mRw9laUiSz3poGeoYDQ/yadOodzjd8aWrfln2VyPDRRkXuPozrijHNwcJUNH5KgnG/TIP+rAeCP3yIfW0GMTV+ql8g6hs9xhsEgGbhKPDSIHBTnastRfoNwUxe2fInITPPqfZGjZnVkGumP56AGUnfjwj84nqDn/c16xI8ugtnfa0VojfUxPfSi2LTHahZJHtjmBtufrQ+kDG9Ps0Jgge4Obk2h74ni9KHfg6mbZATyoSF6nnZ3Kbp1CqRN29zjaia/9waaljjj50GIHiLtrpsxx3oqzswdjypzKLh8gdlZWD1vmGH+1UbQjzBdeiPINr2+46GQcmy+VaRQHlkN0VLpeoCwjn3wtnbZy9TlhWcbilbvDOgQ8f8SVYeQTzw46rmheJ8two446BrGyOTIM2xedbhqr86HMIt+9jHVFoaPk12OEugLROEEooyg4WaPritXtZBXml11dA4YnQtlEsTiP6EHj/Lgrk8g5Q/SEvFghl4oJelU+fQ7lES5MunoEWGqGcohPLtHDYnob+dPYdBz1EHANV+4Ilmu9pWiukD93UdLb8tU1LGsYB5dRjwFTNc8avmkbfSj2zYSyhaJxjf5oHiFfwEQD9QGUw0fIleJIw+lPcXCTK0/4tv2oTxArkyhDiJllRN9E/RwZUsG5IvoHvH0fkR3gvuGgn41D29wygzH/tLC+ApYmQllB3hwl6G9FcZm8UI2cwuh7b7XJieH3tEP9J2aPoXzAiclSVKA4MOy5QDG0n2oUHGuF8kBMjKNqgJhYIwsquEF1yMcOogwAu8aDKj0x4ko+48BetyoRy8Oh1CvZTlAttpnEFyO7EdWqcuY6SrwzragaYMeIK+XYO+ZUrzi/KZRs8s3HsUpqLpHsiuFlKrpsXUGpxqVmqJrE6mgkGouTTlWL3TORYvL5k1hlAfcXoeQS9ZtU+5+vGsnt9icfIyqsss7z8uQKvvcfCq8wnLtEchXrPyoq/gZKLed3fyW80sT5Ry0SK/iFhywqDWYfIr0fRlS6mPh1PLlExas0fpj8LH7+4SJSS5UH//MoyV0OACm95nFVXXobp7ZEdoL2GBk6ovoi0msQTg0lmKpOXGmUSi2tVx1sJ7Xl7ecXFReMJBfShxfcqkw+fQqlFhQtKl0sbU+yoaq7UPPkUtk4h6os2EuQ3OJWzVVdimIHSrEje6PSVo8lWdm6RZVxvV0mGHCAqCx57SaJHlS3Ys8xLM1ma1FdXG+7Usw4uhBWVV7cJEhx+cgrqGpj9TiWZJh/8PPCKkm1uNYqlWaoeO9xtyp6lO/5o8JJded7f8G8csT0W+uIZA9b/25UNUL7F0n60O9+J6oUY+N6JB3yX5wgrDKMkrkaMlLfjh6nlFWCcFZfvx+R/s69l5cpsb6TOatvfOkUeVA0X/b6ZbzfrKR26yXTlMoDqGT2FW9Yxos+Mqf2zGfNUJrIhbKS2ZfdMkrrE1PwwDtOESZyoqxk7hlPN2R9IJXsvnoaD5EbZcH5N++jRL1mJTvf9FwijBwpDw6+eAG3njKnduwZM7iRK82ZfvUL6rj1jBQ88OYlShP5UlYye+UaYdYTspJdTz9PSORNmXPxge1QqHtWMvTKmxBG/hTw9NfPBdY1imsX5yhFHlUUvufzDbO9MOML3naW0kQ2VfBhP/D5VHtR8S6fQUhkVROf+yUvxHbLePtPLbiRWz14l09wdr188jvh5FhvsPtyGiSt2a6ZMMuaraadCRnZuwtmJLCBtiNbGkP5A8W2A/+64AkkeldcB/LREy7ytyqH/sCqnSwOksLy+T/EDhidMWUQsoHr5iK7esuCLO7aQMBX/hYjiQUnG4Dz4kCZiLD2tgt5rU1GdjseBoicXNkzAcVigfJRlBethMHrKWv5CKYPunzsHCIjR7z+QMnxCMtJxIVvGOJ+yiIr4a3G0CFEXrbS60ZmFlt2bruNMlNMnz1LWF4iGJ8klJkgQnzS//k//+f/DKqUMvMkHz8Oin+46gkWTJRLlMj/+f8ejizVyFDBWXkS+1qeQCbqqVKHwhPq4rNEPq2ukdBmGfXE//k//+f//H+1KqXaJOrMKqfpt341OMHsEqDdMwql1BP/f5HKB39oQsW7fFY+gd4+o2w5n/L5zoTi1kQ+AcpSTzrtkaPG2vnJmD+ao7QzPwGRpT7p///ebBm1ehflU3UcyyemyOiSUkqpJ/7/wS/LKFvNp+lPHzFO8MoZB2WGaKXUE//n//z/HR+fhjjJF9WCEzxVI//n//z/H79KqRvrrnzqGyOhokFGW0o98X/+D8/KKNUyysY3TVPj3s9GPjE5hDSBtZHRSqkn/jcs5ZN80PthnNp6JD8RY+ToyFKf9H/+z//5/53YEkrdz6fpaCfKJpheQJglU82A93l/LJUWGiabvooSKY7h+PLryWQZZmvPpiuPoADBjSHySL72NkKszpHHYuCfCIouoETquTcQB+pFWWQcY7B0DZBF8s0+Wmw1j4LrPUwA5zCWRHB448IqTj70yCHnIvtg8iZKIdn9AdpQuEoOB6du+9zBGTyFnMMYx+uYEki2eROdMFJYdA9tK4nF02vlPxO3FzNIpX4QcRg2fIlIILq6toPHQSyFNsp2RGdlSh/jAtsWQxP5E/7gGNqWz/3Hhil5xIW7Ftsh/A9/SCSvcZPCTp+eNeWON46jHcgeXiJSJ+i+QuykxEE8dcSl9aIdEFxYM2WOcY2di4lRMkc+fRztzJcvpE5w5pbFjjC6sMSBazg7F2eXXWkjr19EuwBLa+StrK99l9wyhyPrvjt1JU7ZPMKuhj3sIbImuHcD7QbeOEjaiq55Y1fFiTVX0hhvw7VLwwOWNPKZ04jdsdXv6bJImWDi1m6h0vdvRtKeqvtuIT+x4EoYlcYBjN2OGLpEZAzj14ldo+gkGSsNLJl2D27KlS9mB+TsfnBp2PJFPncC7YF84ZjyJTg/ZrEHGO1m6QJP4+yluL7sShaV6EF7EtbXTmQL/df2CNdBLF2eXvI9kmcWXbninDP2CIb6yRX5/B32fFTXkyX8IlbtGSfxVIFDeOzdGqmqoi72frCBKVMYDGLPoHucXHkGr/bOHo5kipxjmPYOGmSqLdxD7L1ziZInxiW3qgng0AaZepgSTVBZz9VMWXwa0Yy+eThTLo9YNEXFH6AsCb46aN5IEtkGzWxpMtFMdzyShM5muk+aXmqmtiSRxZ1muo1SJPxeRzMdzxL1zDXTkixFsKc3mmnFUIJEbelUNFP7VEkRG7tPMz8YIDKEczPWTGvHUH5E0bG6N5OO1z3SQ2VilOYevFiq9Ai675iayRYuE9khixPzpam86lZRdtTme4ymEleHa1VyBKNjEk1lEx1Ebgjab9WiqSjrfZhyo23pKqW5BGfvt0Vu2MgMQXNX5cLfB8oMGKU0mkzOtfmSGSpVB141GVAjN+1OP6LZRf8DIjHCby96o+mqMnoJlBfGVdrqTaeiK41CWqqsnKYVg6M3TWkB9ydotECjbfzllaeFrBePFkC0L6KsMA7jVSsEPQ/JSvlMJ0FLWn1NaWFnQS0Rvn7DlBaXzRstAbxixZQSKvVOWrWy02+1SImq1l0RLYLVB8jKQytOy9gclhFyHRctK51YdiVE+K1nUcsEI+epMoKTU0brWqNDygcZx9ddLaR2c6VDlPl+WvvSmRL5wLXbRAuFz/9NSNmAnZpytRDG/bpnw602c15OK4uVmXSY1juAWgrGzxHJcGPkgUdLqSydwZQKWT+totYyBpZKLswx0olobTHUY1UyTE5YtFiUO2exVID2tbZWk9NTL5EI0w+fQLR6bb130pQI0P/LRdl3phvXycWOR8z7jkbVgSsN5OvXqcI6PXOWCNw+iVeA2cVR8gA6HhRVQG3htDwNTFdRVAF2dNEiDdbPE1RhaGSVLBT1uX0CjES0GlWpTED7Rk57Kvh+UeqRCLHuqoRSvesLEuGpD4iipr6z+uYn/MV7ypPAeLu/+eZHy/6SDNY/+EVfLfIwPu3fXj1tRcP6J8KZ3j9DnUycfMlPvK981PtFFJt2vPDwv9JGLo7Rgx/8uvfvQf1Ru331Ux8EZMkA62Ov/5xvHZL6wdZnHgBHpKNqlLYy5tEHZo98Fes1I08WTH7aqVFTz9UePFx4jYz5xp8+7/UeU+3/9r0Dt5zxaPPF07Le4vZ9b+V2k4ypWjzjyCN19VTs/XRut8iaxtBnXnqEnh5+P4+MkDktDn371Sh6qbnqDbKnPTxzhuiloPD8gYXT0x98CMsg0tpY9BQog9T8xlpPPdwUGVTefPVIL9U9i1D4Sy70UlU8Q8z9rT/cTN++gBKEEv/0fc30wt98t8oSxPjyD2mmd23/eEp+hCbv0czlM3qqUHKY8b0fRa2pqjtf5rLcKNX7n/j0Rmmq+LTz71+V5Ij3+uePqryZrHrXb/dIjrDud3xh0OTLH/POm5YYwj5vc71Gc1vh37+hvCAvvI3hzRdiTQbVZ154FRZKCVWa7Zhdr0TTS1de9ABcYcoMUrF3f88ZnFa0Qml7ZpjsKGf6zPt/NK2qYOMnfvLY4rExWTZQQyz0/sZ3DlG1CuCFQb7+dbcxA2UAUbjx1/3UitHCkt7u0R/4jQOwThSWeIqqxthq77QrRKurueNll3duI/kbVsrcv7+0j4KgErVtal+x9a3bylqyKUqxh4f+ehJKSSXKPAC+5J0QKMUC8/ofv/zyJNRoUJUS1B5dffOJAwW4pZWQmU2f/JtngULFPqug9oJPmW01SiRQIgVuG9f//kUj4FjF/is5U1uPvn0/RMhl6SNFjZmRP3w5UCT2aVkJa188M7VdEGEpE0CY28TLzj6DF0ns42asj47N31svn/bK5iMGhZQiVbihwmrHr17CalGx71sEgL3ic+eAKE1Ki6igjahMB9863TH1lKLBo9C0cb182Y3bsf3oKDiWCgpZAab++WL4RtcclIpHqhGtiNbss9493MZBussTYQ5w7y1svLadrW2K4FGrYON8+8Bn7QQoBUh3Y5IZW2fOjFQHOr2q3MAieAQLwErgyNXRU7u21NhYCqS7p7k4WpgpPV3jp54VgJnEI17IQRMveuO6or1lFPBSZndBFZdl4/rbjo7bHIBD8JhoUhk0GuEjZ1532hkDX98gCYbPjRkzYNzBp8Nu/92L1gFzQjxeSopAzuSV8D1rm87ahk84xzNCVcDlwv6TD7/7m1W6Br2ECB5LB+B4+G34z396+NofJLu89m3z7msekvTuaWtOwM8fwAdf/NMHRuMtb+mLgRtvenjgmTvugvmh3/grzfnJF85f+FVBuHXk8KlotnPcDYDf/pvPu/+7F5cvBSfAm8D5gufvFRwXb0G844PM33rxeXPML/vZ1zyCaeSBPi4Fudjg5Lv+9u/v3/yhj3PPOm52Gc3XIZ7JVYP1Irzz119n8qm/+oavyMX7b/mVr+Z8vYwAPZbOuPRSAQ0Pzn/6197y+RPIt3zkC+EeLreLMG/CvPHsnqAVDEFu7/79j9EC/Ohr1/nFP/PtN4G+/DveNF5moz+WcWYu46W2XV3iI+/Af/vT65hw9z9/wD7wYs7b5TZBiWe3rAFIyORyURBi9DnWL2DzJd/7fT/+ZTfBTbB1q0Wz+Vg+92CL882fv1xf2Bkf3v7h4Wf/6B2XCG//8g56weHnj8qlOavBVAJw03NJaCNIWGJOtiJjoHNuvH22N78JFgH57N7W7W0nRx3Dm3v4yz/6wN1m3H/NL37rf378+lf/czkIGp/4l0/Lw+sW6+d9XlwkiDkDJ4CYmYQEbYSeQRKYAJJsJcyNCCJDBL1jBu6ERx4CbxSAhS3e3nKVvdfv/Mr//Ez3A1qCYHzRBRiwmXPGbJcTY82Q2CYBZCA9X9wYiCRnR2aCCaKCiAs4PGc1UBkoRDzoF991xCfvv/jiMCAgCG43qLkpCJhOggokg8ycy2ESwWjTM0NWocE6B2BignNMAcNEGSjiTtylIEBgAgH1rnEYd5crzICAICAIWoqWiigmQYYBjTmCjAyYA6CEEOjZIIAbBM3MxhSTxhwsbA9kI6IwGnkKAWKjR5DE9qWKCIpoQ5vjhTmmZDSmmVlgrIH0HBBwIyLiHKzGKiRrYxGHKDJQ3IkoCAh1DA4CgggIzkUxiaKJLdOFhFiNdY7IyFgDetoEEEREUQQQQ5dQTprKEBUVRXSDgjYgEIB4tQEEsQTFpoiioqIJYZwsXAojgAzIjCSAniwBFxEVVWggKVs5FAhwyMAVFVF2ItIHRLSjiIpWNoBAyxrbkpgChJHZEtCTJAiIIx04NrI1QBDbrS46XFBRRAaIjUYYIQUWIMBXEBA4sWTidBrBJKKoWJq4xEkjCDC2sYaTxoyAoCdHEBFl4HY4VDcgwYgGeQB5iIqyEUQQQYBAbBSvNtYgIIgggjYUFVVAcpxMcYLEPiCmJDQpIoKeEiHGHBwKgqwCLiAEGC9r7A04gQgCaAwgxiuaCEwsgCDiHB0QL2uAENuAWIMgDueYCD0RAmnWQBCwAZgcm2TC1MAllzCMYxFBziSrvPpY8wxBRBxRTFxyCawBmWQcZ8A0IIipWYJPggEjgBG4DJIOXMwwQ7YBmYRkHCaCIBtkfcOwxoYgiDiiCMkEZBtmmC0dSDKXwAngBHz8JNkqJoyJMG5DGsnLt4OQAMIAWuQV4QLYkdjHK6KFhYkAEnIoL59TmpcJMSZkFKvoYweyajov4BwayBoISSYZJ9OJsYYZa8gGZO+ylVffso19sCHYEBGrMcoDwCSThEDWwJojuI2yNuCjlyCyikqYgMk+yTJAmEaSYZCQASSAALKXs28MaAMBBBALQQmGSWIDAkyTZJ8BGVIRa4QJPl5uRATNMQWQxhyQGYGEYQBxmBlrQEiMick5wKM3ZJzckOEEAoitmRwKYBgSiJkwx5QAGjMLAhD0kQpAQVZHCDACjLOxP5WQ2XJ2CnJ2bHpDuZnLYexPmQl5ir2cNcAJEM7Yy6MugCAKiAnZSDoKwMk2zMKAOJmbwIMWN4f+L7Xbt3gQuMkDQMDQDNmOADySnCZkBBSxFR8rFBNEwRiECSEQARkBCZBzRAbYLoQAOenyf7zd2Tg2wMQ5EiABMQERCCFDJgZFiGni4ySYpmKMOQhNJk5OWmBAGcZxgLHGeuqRbbM3QI4NU8BA4+SIQRYyx8QoBBDwMSoQARxTu8QaSGNCZpFhQJJMlyTWADns0ToZIKvk0iBJwDDRTBhTAlm9WWMGChDiIxNBRDgwBjLHEgRMgYBwDiYGGccBsu/oCQ2QYxOMwRwhINAABJc5iIkJEI9xzdv1/vXPfvoTH71db9fr9eH6cL09XG+365y3eZuzOWcrTQoiiICWtYOnP97I19uckx6j/7czAFZQOCCMNQAA8FgBnQEqVAEZBD5tNJZIpCKnqCLRqdkADYlnbs6oUcfPrqLHGc9WWgM+yrFNk8jbpe+SrUNohZcbtT1P+j/uf7i9J1zV489o3oN1b5s/MX/C/w35pfN3/U+qX9F/7/3Av1b6T3mD/aT9jfeX/3f7ae+L+4/6X2Cf6n/oP/n2QHoQ/uX6cH7tfD5+3P7w+1n1//SX9tf8V+Q37EfRrzW/Qfld+7nmi9wn3Q/c7Qb/mHI5y3YAvt3/deJjvQ9f8xH2z+4/9P0ZvsfObxAe++8Nj7p/0/YN/kX9u/4P+O927/K/+Pl0/NP+H/8vcJ/l39h/6/rbf/D3Yegt+uf/H/P8b1t+O4xeE8r/H/IUuek6mnmK24CZXJ//156LTwqljs7h0DwrbBI835CfbdnM3FlQ8fFf0CxUA/HZUclI83eIDXLkepyr+kg0aqQJYE4AzimsNTDsqM4tGGyUload5/SLnsDtAwclIjht30rT2VFHTn6IaMKXTH0CNFdCrifg5siIn7stM3IdQnv/+7jSX5hZr7/jSjCUYdLxYpq9uxpbuOpDp5a09T8x58g4JREeJwGJ8Fhxc/GeG8Cy0LuCoEU/QVC8WXTLwG+lY3GOqFOQTvXkUVC1QhSmQdr3AFpaiEmtPRcNbn5TVz/3gSs466eheb8nt8INyKvT8haTer6Xo5uRBKly10W25/xW51h84ZF2WdkV+wqmFYn/WvJQyx54BxrA8/Oe2s89zLucrc1zEjkm29wRtdsBX1eTHzlSeceUOUzB/Kjfo+zsmka2P13bi/KEmLAyyc+JqJA6aNsRj0WkXJ4pkj74uvlQIOqXMeZ7IdNfji3dFUPG1xkcCnCc5jhjaIynsb5U3t+Fdy075P3hi0V+ykglf7kJwz39Xbo9TqjnKIZekHsFXE7xTTu4egI89tN/pPAo+cde/4e3sNCwcKsdwSQo4y8EpHpyywYtE8sUxhnaArQCKCed66oo+WQ61yDb2EFLngiocgDCBJ7Nqi2RdFfrtYnibv8Ndj+ICnSb9pgTHoFL2NV7aGVXbAwhv6jxs21i84mx65+844S1f9pxF1y4hHNUYrTjFCaitK6aeMvVjL8XwsyJ6MNDw2J2d3K7CJQxaCf5jEuctYe0X5OlDnIYXbN/zPj1yJQZGr4qqJ04Wu/IUnFAdupGAZLQZSUZTPgMadGb9JamLYekYAe43pd6YRbdjspxAfX5wz+U9TYljhDvd49kFeeHlQ4EXy4HNpLZeYB3Nnpa/1NOFvAf1Vu/9OZ+XKPZMdE3pRmaaQlndXPkyEOz8hl2L1ARbaTIFahLNEL13gMBDOH+nwM0C0YiDeq1v6csMAV/ADp0F016fZOSLki0oI1OrzaSa+o8b0P6W4+IW3/HyJebofAuo8J4RfJSCgoy4ljIgJyHeFO/qYgPBlazx5EJ2p8cYr1T7WUz70GFX4ITrF9a5OXTIBs+TThHcEW2xdjtlBl78I8E7EyPeQ4H7g4CUfnEXOLYNpacpM0FUNyMH157ZKadDzsApYNuPeamXhIMahVEtI/+Pfv+sYka6dj2xrp9JjEGt5B+AdSk41flUEBHn2KW9EWaXmWaipyftFYrfhgfic6JJwDdpXRE4QGZ1d0HcE+RI8VWc/XGiozRj2wTMzHaTr1vVyttnBS84wVbLBD3vqKJsACIDz6+O7ZSQJyAUGbYBTl5ZKAPYOgyo2AXY+4PD+WXzQeuws8gmIbb4zJUWhmLCmOuFNCrSv8dIwk1c5AGE8UzTrxYBssHvKvl8txUOXXXeunKyhz/b8iTJYwg446Yk3o8c2iT4fCayOzwg6ZYpJu1nXEDrlVqYI/PT9bKWA8vO7vMNCVgeOnsaO9WUImjI9H2vlMxtRKmPCt20HErXFZ5DSTLW/7P5ehx0uPdc7QWvytVvC0oYTwYlx6T3b4uGKc+z9MRs0rfQ4CnehKvHItijinhHUTTLfQUZDx+6zHZGfAdow+DDm6H14ijuSZehyVSVUhfdE3gWYKKMUv9wW40iaf2eb/NpIVoQsj79dnhJXCl+DxJaHA8Mv2klIA4pACMuoCDhTef/P7atAf+jjLAwtPiZGJof5CAqj30JHrzZOl3xDRglYQUwRb+k9eyY4Za+l35Usf/EV53/OWGnJOj3GquHwlA6L1sP9Bsf9Y8VrGlOiVcofVI2wbLVL4wplPC+Q1BSMPIp+qS5+kESnxvN9yJ5BUTaM+FiAMCfBn4gm4isqkfioTZFPAC664rgXEG7bS1ne3HeOH25pqGWUOGTdlwCLBWDV+AnBPTsj/4ita9u2Lfcsn2rG28UAhMv0PsoUbU4uaxnmsdV3eGLXYfKOj237EXVF/SKl7M8tMglG8Um72GAj3v3CaQNhiUBfXpMhK4EWO4VEBd3a69BjhuUtelqji30+dmp0Jff/oE1CSpTOjKtFJAD6EGytuyt8y6K1D3FuErQxwKDnuGHtszM1/n3WKb6o5PfAg0Xjo52Xs1NEekIOKk/0lxiNjU7QZ8B5+z6i+mlMhgGEDO3GTJsbQQojCyBG+NizF48odDYvcT+5lVstZyRF0anZQUp/JtaH3G7Wrjomoo8gZleThMI6ut0fwDey6hoM6OkJRbtvxDXQrOYjSP4D6JDzjOUOlDUClcB7ywuCSGPFWOMQPCbqI2F9R9axdvRKczsH3p8jqkWVRaS097e3CzDGdq3va5p6Ja7sssUMr4IjyEVrGPXaJf2YdyY3zCS4ZZVLxWk5LxcIhgk41x4eETT+O5/SpLHcWILHDd1xru47vhlhginzR6KMzqwQu5xN4hqVLILu4PAxKFJ+taKi9Dpw36qpJR7ZnIEGgrusUU7ApbQ7jxOVckUQNwT+4+p20cPX/SVtboCg4edDYjFwjHZAB2u+88CqwtfaYLZgZKhJSTS0yAZ7kvFmOqawMzSkvtlVNHp1IhVy4Zr8UId60zsnFdSb1zD/RRxuO9yD45/Ze4eFVkBB58B2ze4gMuomYgT/842JL1Ul89tsHS4UeFvg4ZyjMBtEenaZea5nqgoW/4e0tSGL7h8P3BZXMOKWWo6TDdEomXLXGfG/++kzSjblvltLrWnUUbRqNGv91aaVvPbEO+kTi+aga9lwYriqNS7NPadJEtaoQcb5mEkUzXQPGQHoYA4HPcqe6gr46VyyPhr/o6bc9iuHVLzmynu7+6rXpjxtXKXbXvPqAhTzNvg9Od/fcTrKB+FLFDcY6q4Ap3Lf+MJ15bdGJlHTNR2b1K9v5i6gHhPKVOeQ5QWOCzBZSuCQlcaGOUNsPZACs0ctxD6ukbyTvIMCCQrUYErD4dIRsZxSEalsTCJxSx1cxLFX65UrSu0869Vu9kePyeV9dUxMLlhyOCZiI+SpEyWjfVYhcrM4vLsBCXu9t8j9Ceglrzm1azxyhGZVC93SF5iE/47Y4DCeESUXLynVumvYT3is3a5GrNx79YeaRgyq5CP/O8droAHdvlEQ9rokWur5M/Up3DFpCY1lUoy48p3vblsntLELteuFGPki7s92XUVHw2QTOalz/f6FxbItc//9XnLmhH8yAKtNQT9Zd8hAgyTmq1xqQAG1UK1tJtxxMcvFoPDlsaOhc4tuy6Jcor5pBHuftuliwZo/7aks7l0svf6itwM3cwrp67jCBFCpOe+pwD1lCitofqwpw2CR6ppcpXEXluUH553vPyUGAA/ujjAVU4kkckilIRaT+V6uLYG1AE4a7tpwh6nZjbUnF9fvFIGfgGWM575/4Hw9XCi+dyEP16Qt1p84Qev/9F65uv22oT0qzBzmPT8dmNvEsd75IPavDAgWvijbT4whNp3jVB3asrJU17tWmn9SIN6MQQCi9KUqNij8/Uxg4pAb80ehvLKijk3TzHM61nUmj0WxdnSyl8Lb6zFSGQxzDQirSqrQUCTl6LX6fv5yTBvupMNwWOXDleWLn+BKTAi2Vo+HYAAQpNGp5SK333VFQ/F9JKIcPUddeYvcQdfVxKABfKOicfq/NsDv0hAAAoqCPb/V4OIGb/bxWle29DJnh00kWE+9E1eMQNQiMLtfreFXseRLZCHYsf+bdew27V6r5he5XNCUVIr0GGf8TdJBmFgAAXMP9i60pbyoCOWCU6tU8yR0gEtijLSMUckMYEuvRXTUAEB8exmfftl1Jlq+NCesU2h8nvzIhM/9TbV7YHjKVEV9wZ3tlF3dcJ840jVMZCvAMT/fPgnQXVlB28zElCBVBk2fK2DrTQRW/BCsVq95EjgIYmlLmMv3Wj3xLlXYc4kjNVZI5PJd1J6XnoC7mmAq72fAIql7wz25NFeueMhwduwr+Ot0L0bA40tWxlNY7W3miI3uDCElod3nic/nyEatEf0kvl40HPR2Veqq28ErhhEsd2r4lBtOvNMbgxyL8JftuAuOmCOZcJzgGLX4iWzgdA4BmNjAcdNLYQ45rDLNbdHf64ypb00jUX9466uERNj0MFpR2gjmKCryZX5fJ2lwfyeiYiuzf2N+fVAHiM3gjBHGWWQA9i+LWPOGOIoco/HEYd2KEqrai6g3v+5fRZ1bxXUqWcoUAeE3mGMgVqnihQG8vWD2GqsRVkTa+HWh5i9eyQ7WJAdGlK069jQ2vx5BZ8pV5enq2kGWiG2y7H+Ac8VycpSKHw/nV+IB9q4lpIe270lHLfR/8pgr60e69fIyIXCPCl/nPRxs4Q0HRlwFrV+1QpJ9SsR25qFJxT+2oJyjQ10UZwTn5XimYBQlEu23nw9SeINrAPJbcuAAQDCxir4zpKfnKD1o/39VuT7OPA7/Fq9nH7Y36TfPmjM/1Yl/Dg0nmvZ86fAEyqyOtBTsd6sZcyXfUKqBwdA9F5UnSvpQK2i1I0KJVEILYvBUHpU2NUAESdSuo2DfNPe7tyourHwa11fIcCqP5BvrZYKXgrkDJPq6i534i6QT3y92fG07jqV6dwMiOeXMneY0iNk3So+H9QLDEmNV09EitEKb5Hr4YLMC3oPrmrRYm2PVevlCdueZA8SAvHVOZu3Co+snvWkRYlkgyty8/g1EUaRLPG92MhCIaSoLK8aIR/Iy+k8BWe92Prrt74l+4XQzUJYY6plo+H4JyNqI9d/Hh/pG2QEyWVClKwZ8To4NuV4qFB+/Jh5OdAC0yu/ymic6/Qc7dgId9O2d91IGqQR80aKoH5Bw72e5L1yTtfbBW1eDphD031p98UUNeJwI+r5o2FFK/LV4QSbWpHEigGrRp762agV7OQXRppZyTa3NtcRZRcMgm7NvGiflNQz+HEL1G+nmE1xXGKZ4x/lHoN/qDHVgVa7PG/w6IOoHZTmlphxybHDJQDYnVfqCoe0Ce+Jl1tfMC1u/WbPquKbx8dkniwOq4JfIlBmDcM+Tofj1+hGbsGfZv6j1mZmDiX3erq2Cfel6HEBZCC8L50io03YVyrmWHDW7nzGSvcFKELPg0p0yGPjEPtZiWoAkDbdqauYvi6LJmHooNEuZzxEq8JGQq55DLD4E9IJBjSkzy5s7ymJ3UAway/AAVuGSfr9+nu1W/8/+oX6vHrzO3j3kwoiYUF1lPjSSJwD266FuvX7s3m+DNGhHAzgkPcg2aDhFp+4hn+T8eDH9Sj2kMKkvOdiX1rxXG+wKZ8vJc3uwnb3Rigvwd0+aO4zFjrLe/bwuOy18EOXWxP30L3q6gC9QpUBBJrA1Vr77o+2javlTMDPb2jZ+cZPyfv/nkj3EY1ALy0lpXmKTveG7rxoHOh5k2FVzjRu2+s8CNYVS9qXMAGb5XhMJ6QWA/QGrrSgIy04hT5cGLlXD4+zOwCRyhG8Hig29dZW5o7qzspgr92WfP6Rx3TacIu7eB2/+FYWQTrfaLfgD5Iijm5MpEOxBAYAGsQrkqGZmh1r2+QVtpOAdasyYSFOGuaXn2YcffzkxqMYEXYJ5k3V9Q6VvE0pzjPewF9tz3j8GCaZlRCdJsxBrs5h3PwTcR7nld4TupO+AVbbFX5e8F0/aA/rbesUtcFLc/HZowinA3chzh9itncUuBTdCj0Ap1PSHgyucAHg6w06ZomrtCoYr6DUX4gAmTd1gdTJ9m0ZTh63Cs48YQx0A3+2RiMaOs71CVzK3PhrscVGgKfPM4vpl9pYXMuAa9HOitH7w0wJbAv/znkE7qISw1PIv4T24VDV7b16kZGbO2wL8CixgrjiiqCqHcD8GAqrs1NU6sO3fNxSz/3iU6U+Uc2kBejJvz39I2RRAladW68mh4TC7H2pwJeAWezDMiJfSrJxBi5Io5d09lpCJfOnCrTMOOvuaXAs8PuPn6ZfMbesDlyp2KcnkdTNDPP0c+MQ2MY5Ado7v6XpzrUObeuVBSZMn1ZZb8XVUuxwdM+Ji7K23cm/8chHA+VS7+p5JnJ0fBrTZ3EuFyzSrjsn3jlTCaccnZ/4/2SvoY0PEQvQRdBitjLF+IaIU27lmPsAVxQzUuXMtbvbIAVWSYpWNpz7ETcA3k7PnNM+URfeD2ZO1MvR+FCXdXJb+2BcNMn8rlDhkLpsWAuEKkLxVRerTX6Jf7/7iKRl0xeP6gRoaD14iCrbhRiErEW5RgAyoVIGAYHGO8pfFpj4sAAO/Waa7/5XIAYptjl8Hn/wsv6vGfuPO+cF+p7oqijwu2nuwazZVMfje4851j/x5SjiPf5CXurQtnQEnP8I2tsYhFqd9E0Jf1CqGOCy9tvHVY+4ehe+IrPFMO3bnNvqeUKHe9rnrdQvzE1/vSStqmtjlYyoLZjchtmGSoR5IcS/lS/S1PP9ek32FJ3teqroDyEPGLNpzcmdEAXqH52ftCiRV8KWs2cArwRuBEgcnqSTczWBtedhsLr7CWs/2VNerpGhXcdRUJzUgzRPBtfEoJ3RgWTP6WFaUsNeRmh5KB/Cmfobc3/LlULy3ZsuuKox+hsslC/YsxSxKecJDQTCZ5+Uvuo5CkcZL1MGo2OnOB2+epAWQe4p249e1TxIp3h29xrgEFJIV6aNy6yRH4+jibHMhkjVxY5R22LGFiw864+/irBMbZnmNkn4SrGqL+B5EbAOD9wotIrL8POP6ofosBzwdL1DNc4TDNeP9gRqYE+u467XGOZSx/2Hx1IcVOX89/NgxamHfoGtPmtuCFhnTbTR/OOXfFbv/abRzTUc6VP4LTWb+lTzCe9UpmLk6GiVWcrK8FkahyiFisZyzMWNFIWvV3CXweUxK3yMzh5nE2xM2iLQJfj5KswmSTPOo2ANI2+j2RN8JHWS5AuDhbOyj/PcEG/ZZqMVca+IgzpcsiUqzVPwG3EAj4CqIoztfUbCfnuBpCgXseL4OAIo//PQoU69hd8qTsPw0tglitzzFSx8EHUjbUqhKFvtgmfGh0qC5EiBzCCqKyKuNZnqA6i81a173FXMaRHb+LGKA/oDyx+kF+GoKAj8qkBuGGmiCBO12RbUhDZbTaCZNpsyitKt+bbgV9uTfWcAuMjQYfsxaB5WfXXIOs33YZ/n8/KU2hgGCc9hRU7fR4fMN7rURW6vbr5fUMsXrd4O4G09V4eiojZg7Qi58Ky0ZvbDSo+Sd/kxphuGsYM1TRHYvKE7T/UoYShIXNx+FaWt8VmoOhVMDlz6s+GzmY5nPLaWmH8ZwwHmEcxD1LDyloPYJx3S2/6WPi8gvn+nybJm7eVufm0elanpfUnlnWz3nd1fVsI1/UoUAlNDvGe41lLNDyv6BsT4AGcx1AhtUz2SkC0gMgvlFayH/boAtssaEqf6NXb7BUo5/NlmlQaAl/jxMlzNlK1Brsh6Ji644mdY4dRB8B13lgUqbd4fBV71Su0NDZjO/DtZqLtp1zeXGvdFpPpxs3EtkryCdoNIZ12VHC+fyshR53YN1QYcR5vUZlAH+2An+Z6wlJVbsrBU7ckunPnTDD2Y9Xp3Vfd0Uk6bzcfPZmo9XbYrwlIPYYv9lhgRDMFcAVWrrl33K/z9YP6UqgXL/PYsHescGRrgSjTtH2KjNKGjwo+bdONEHRnJh28IZL8h66AkUF821G5BSS462qCHpxUhYxY8geqMtPNlV/2vuKhwtwk11BldWdvoyAMGYm8eXFkx8Db6UMWzEUyDHRvDnYkobenOhQ++x9Pz14rxjT0dILoBcaDZeOPP9/2s4HHxIhj8ZwNHGeQ4GrMv4IaaIL6tPt2rXw9pKYQhk8cZVVwc9Uie8CscfDHOFLsxsYcQyJ3P0NCqqai5lf7u/FyTpJkK2rLsQKY3PPN3oUAt+9OvyzLf4ypXcaO0FHQSfuxOE44aK5zmHl11rZpN7+krZb2qcyYCTzbOcrSpbZDwYSYGpdVXNGy+8eSTt4vdH1A36CoANPqR9+slzoWlq2dZ0Wm8y6l2Hh9FqkSMqeezD1/flfdvsz3jGvK8zA29llWxsZz9LmSe7uJu35gmG9Up800BUyeyBnBVkdYVpfDwtCHo9eR/TnQsf8jxolA3eKtspGEdGvTzZMUHa6/tzLLK3ZS+GT2CdE/u5KrZ0RAnA9krpMWvJJH9YH3y7Iah+LDwUzfDFGsxaTKTcwk7soOmQ4A0HKPnoWL/SIW9cA7olyKRAYygA2f9uvD+ZqWjzMV0Nthhk5z8fzM1CNdKQ1OHv2iKAWii1EDp4yKwIPGHMjcy/uXEvvWb1Zj+DijPQb61/tdiGU6sIquUD4/gGOAUqMQBPf0+fo3ZY1WZZaj0bE0ymvIqTPhIQIBGRSiN2Dz6hLmvFqTql4LmFuxJqwQrjLJhKDodCrwr9YlVYVRamzLf3uG8PDQGzx2nKYa2qRgxNlrdB8lvaHFKxGhU7JHhXf7KX8YMKvAq+Vvtb7fK320UivAXIYw306RcQuLEvgRstoEir7+ne28oAabVSgQ+HWESc0TF+jP/w9wYBWzjtA/nXgkh3CCz9lZLQKChKY+ANdBsy8xOXQBC166ld4wdv8M9m7ob7nNiJERoCVyZhwPUp/NsxC/4YNzo5vhexn4/0QTuWoi+xfAC/s8PGX7rWW6+X0u9GULD5zBO4RtsLOzQh3JDA1c+pxRvr/kKRyQfq8P1+lfKX3Lr0IEkPuhxfQWkbKnIzYuAk+RDZYAaTTVaERCGDBim/ScYEIlpBoYZVbZvmQyka2g9JKmSupDi/CmoVkTBVyHgNuHV0hJYkxzj7U+yBdQm6Wi0us6+8QO6Im4nPWjTojuBLUMbAH6daRUovoEuro4BbuKCtYSCNPeglBhTmbavTWqpbx+c96Bg6dPFTy964Te0YPH6mKLSPN9kMwog8+nP2+hVE2GRnVPt6CGmFJGF6d+0vMhHbtd9P+98EWvDuQOfCnG/NoivpLbiWLNaf8Ib/DZtw/VCmvS/7f/xoeqZp0BslfGMxx538Y7gc2eQBGwXlysmYS/9B88YJhKgTvt1h8uAjXqqwiCfC5Ns81ZkPXmblGvcrMFa+PJn3u4xyGFnskQeM2b29/hrD+jmElsGvwnriZixR7oVLUY20aUmtFLV/07CEw4LThqlPJ86gErxUYn9aDB2TmEi1068Lqlgrgmr21wddt6AsWs5SDT5RyGAJZg5J8b8D1l9ciuh+umTQH+vrglLmh5cVU2+gGf6F06sTV0+R/AXNWYLoCthYlM5zIE4Pc9+ssXWDO3BrnHFiM59Nm1jG89Qw17pXUzKtDaakkU/w7GwStNeKlhC/DiflKBoBf6J5Kt1/pbsG9V6DxaE/n3VbNwLsptlylI3ermzMmbNV/pjaMlZdjMA6XeicEZrZZd3mIpAGBQd5WU86ZmaktRh3hFEj60ZhYlvUCO9qDEpNunG8qr8h5ncqga32Iqnok+O2z125irsiSployx72ua8v173eU80limcUJ16qsgZhOatatCRnoggeCxhg6AzwF/AL1R9VJnRphlIH85IPC2qYwK/gNpeO3/xxK0cbNj7VBhnqIRSZUAIqexhFDpqwpD9hotZIRDebSPvA/geVO1yHc/ezvF85dYOQgs8irOMuDCBNXRngGgBT1jqct6hYxuN5Q8W4sy+7TN+sQzR1DyauMx9y9n+NihZYxX3uMC20Z5Vt9ZIAbrMxrDznAfYxWxd/FkcIp+fZM7n7znIkJrBDipW+4EHu/ZSYb2VPlfagMWR7cUZQGLV68/LCvKdhjFO/fioYR89HPec8snDABZcJuMGDh/lIvfyE+lS8DuKy/4v1sjpl8iz0qlHGD8+4W1AGt9nj8u3DQ/6RNzG40EKEnXFI4v5r1pEMjJLWwXer++wwGrCqpg6CDB3zhtICl6CovUrHSy9eDw54eOxUej2CqS7HRYzY/7F0VA9kab3I8Wldwkh3St+Sc/O+ZoZrmhwkOTRqI9mAEFASXYQgZmz0NPyoCvb10rv8DyRqoxv9y2h98d53NPDsZcbp1z68RhNpDCKn/CL1A2S70SPzg2jTzg+XQu5emvvWVg5hxmEWuf5di5o+P2QnxjO+nAzqItPmVjPDIkJidjBGC3ayvqlwktSVTco9o8dTXrj3kB3NsJS+XuW0WKWoV+bfx62ILbIM/bFN9E2ytaVQHVzzqBFSqFnyHwlIx2kJVDcwm10kRYVs5bfy6mXULj6Q+j2FwTheP8VvTFZLofN1mXcTpwAXTKiwB5mqGI0Z18ig9eFZvmg+kh1qrA4K6YbI5KNtu7+4KL9iuNZOUVoeuH9gBEl8HjRnBpSvNsRQ03n5bCV8WJiLa7raz4fyappZSREXp9J2BSW+n/oIrOyGWgw08ILl30zjvnlFRICab7f7e89M/ZQYPjkBck+MfQFmbtHab8h1iMYVSoE6QE36aQ/Ms0OBfyO8ElkokeBCy64k0nnHtFLYRe0GKQMDDTC1SWorKXiaz2U83TIyxLTRLaj8LIP4cBpPsnKSkpQyveKSYS+tro9/IQINpBZEZCfO/1ICWaYrPbNg86b72nvvS0HcT+ov4tM4/RLa2q/Zwg7qgDlKgl9yXZ7hQL/Kti0hC+lv/nJd/pC6Yj0fIVjbHxwS1gLmAgtb+g89siujUG7vn+F1C3xXot8wgq/T312UK1rEEUc3690V39CjQFjDA90W8GUDfhL26BArVkvsBtyCyJVvITuVrHqyokouI1V29ttNIZY64dJpQqwdYXJFYrrwcOZWSWKR6REsNSP+MPuGSIJBnZeOi+1d6DKD7zzKfmqa0fRCC7Frd47ntpMt6JyX9PzaHrVW0ziOlSth8V4vj7Kex7MJ9KY/P1ypzwJnwKUXI7ELCOLVEY5oI7yzvfx5DeIo2Vs8ttR7wbVdlY4NDHnJcRtWPbvhCQal0f0sBsWOKWNL33WyvEHq5nsBkO8bhGlP7eJLogL1hUUQkzjrarfCHhcYI1QDvDl43PqkNVV3aQ7xuM+7eRGam2U/fg/LlZMwss93cPBwoEzrefotERXSIjDRZwZ3UkXOmll6++6clp4f3mVt+6rcYI83TFeEtrIZnk93FfBwD5oRIpO0GVh6LUhfL7ZId657Yf7UFTl0INt/hJPv7RgRv+QW4X2x7HY+GAoD2a8UqbWhgnD9crVmEYqwZT8MpV9D/ZWnWvl1SluSFQ6J4PVMcW0dJBnPl5xAWlub/v6xqB679BC0mFJdwBOOJn67yDZ3owOEE9qaBTIY9Y8b9Sbez8gqPYR+aU6bGMR9cPKSOIAinAGWA8azVCIssevd1ye7Jvp1ZZ/+W5DY0xXvMEcbbFQtFnac4G4gO2CeGOGj+73xiLQaJB7UJZWXoDVRQFXUDKJknIx8NVG3kSMmRDMu89hgcBHkKEk/JfNN5rzlLd+yXhiz+HOuhORTIE4vq1zbGkVE3oeKVHh1zWm/AnfHyIcPZ+R3E5fU32OLXkV/YJxiuFPqKvqu2Mf7vy2wJrOxwUV7f0X4UvtQcwphRSwJzoHxT9bsX0fXv7Y9kDCYstIqYKZwutRIMHCcFd8ifWxOaCpCeCrHR7va4e4jYCRfxuCjtgN7El9C+ywGmNtSf1X8Ba2H/LFRly2nV1Fs9OFrHidhFQp7pdJcKjXnm/FK4XUOvuMGXMb5xqdTLezhlLfCaTMNXBJpn34Btva/1Jbf6E5/bPX8vTP8dmpdyXnn7wWnHxLpiqWmvCL66VB0O+cqfAOaPYzXiX/whHqrr1RAR6wr1cHCJd7aLAX7BHKq17Xe6WdQfdVDvdZfo965G8SdDpjqaKYenOgY7AEcL2t2cM21rLwdWstpyyEOeQgNUvzXovedzsruKAPzJFSzwodzg1c/3rEc6JHewOTodryY837BkXnq49XK5h4Ui3Fv26t0TbpCrwIpHYSKHfhsI9JrQBwx2WPdc8AXbcDSJZfwaYrf1K+NzPYXLDbTpJ1w/kbbqSoM1VvXTjiqneiMOUqsRl70FeoDhozmuDJr6XYAyTvc2tC9Qk4J4HM7a5f0f1Sx+PcAOt63dcO7vnPsraMnHlOReyTb+XWLLMzgiNq5QPJ6/3uqvUMSn4h/yBOu9x3NCCK2UqXbj/yzfCfit+q9L8Mu3Br2odXgJgKSOsCnT2ReiI+1KZ3SHsnyhSfKepyXVl4RqFxd1zLufNOy2BwOAfyWwI9k+IxqBXTLNpwH3Fzp3j5RQuemgmxiT8cTxJSF6q4Wr4svwmx0MXTgcjoYm66ewC5tLOrGZm9ETNGfugYQQyK5LA3wV55UDezhNZ0fa+bNAFu2/DPNkQvqfIm8I2j1CevADkjdYdcgf75EZRMagOUdIKi/3rz9fO2GOs7zlRSqrWdXFY4H70uJY171EWJjkcPzVLXXmpfkmN5uuHSBWTEk3tS72I4+Qx15Feyr2b2qyoaerkvxFjU+BoCbtppNwSaqB+UZ8/wSpkzdL84Ke1zG14V8a9Z8Xei6BmnUjiJw2b54+Qe1y+3n3UN4MWf01L0kQ0oYXULf0mBWId+FdBO7nuadWms/9iOVeOnieVGiX26J0V9GRm2RYP1CzTg4L7j7wLZeuhWa/Om0VL/vPI2kKh+HDkFb+HZDgNf5f/6XbJJd9KjeWbaFJJff5y+bAiM+PzQ9wlNgU0pyIXADI0ZUYMJfK3T6puLQR+joHjwuznPNxnllL+QDIyJ1yRt8z3JXl8EV1XqsbEEk4H9yIo6NTQYJsnKqtXzOjII92ZKWo/4NUfb3hR8RbDm39NnI9Nn7xWGqG1jv5CfdmABs9pdQ0a5avlIAa9E/bWQF5zjJlCOIL/vJ0o/n0xnAC8G44CrUySFAQyLRKoZSZBaxYraylX1JbSasaqmmeQJPg4sxcaqIYHSJ3RZmgDAZpPCzvVmKVb/d/3xZCG+L7rYhSQohcAbNurFx6gJVA1ApTbNgwa2hqrhPLmjyaSb3uVHr7vfM+PvIJSBbeH0PQxMahW+jpOz2/6QwU3ap/1TQzglovHlJy503JtljYKBkfUayJnkN82GoNtF7V2aILdZY3jgpDUbSsRWpY4L74FhjrdsfJLehZQlAYwAeJCfNojPRBZIJMGzlJeUn4WUOfpRz+ycng3c0q4p9UPmJKYGdz1AOevvxO1Ecy9g9EQmatu1vADyqK7xfWInbbJcgu1M7BIHpxGollLRG1EIbsm+UWHltHu+R/1cOl8rSceR6CGc0GEdpzN4Z+bU7GFWsSvpQ30mqNZkX1spYh8JwJOfEwG6IRA18XzbCz/EPadCGTIIuQgyFz4pDEAOJPvHwALPdIJAHDWfXzD+01LSV4SaVxI7UyP2CYd/LmGCHBVUpzHjBjM2jdPh0eBg2XsZxBUS2I4GHtfz7x9wp6I6rTLk+Q3TlxBaFUzH1E6hk2+YJq74dUJhi32y8lAu6J6ajUf0kX2GzkckxhZO/IkrAHhgqHa5gZ/vEgx/yyKLlD6QvnAlOmU74jlyleRsCRd7zL6n0YFLpzQ3bq2wFP/HpoKoJgMleLsxrBMfy1qyJomRAcKDZ/PtXmc8T4hElMUm/9cgA73BvCeDVrGStvWO0pQTXGxM4pxkgN27aD6AbM6b/0NotkEWkFoJFnRIsZRmAqUY4C64O32Ecf17clo0VQ0FCiECcJ4vVQMleuSJAUR3AW+H6KxnG7QW9b9xzVbco2gadgSqlK/0qMR7cFFzqZ7PjtRAHYj/Ox2mB0ohGJExeAcFyhYVhxTCSE8eAV/114RywxYoYJEN8ioq+bsRgo0i5FZEHmxF1t09q3oxYGYQC5uf9Cy2Bh+GTectsCvhVXFrBsYna9xd81ldv0HA0ZNOSsTKMHEOcP4wmc7jUf3Xm2mJH37W/rbGbikmuDT3xLzVAs6xFvvBVQLHUAmQVSVK8thVSxkvcaoSe4AUz2USbttGB6kPvBL9y0TZaWUSE3x5WXA/Is+MR8o243lSX2hnsaPHu5MxWbuIAiOS5JTIESP/db/Optq69VXZxtF7knE1t/dsq1RMUw4wU+f24wtK/tVnWH2CIJELQqANzdeTpmtq4SQpL81AoXmMqTKoba1NUvYPjRCe0n7MyqjPBhOmkdZ9Ga2ERhW4UhkYfddKu4Aepjanr7c+d4bbYDPaWv0OOaIAraX/ykxxYX039GMyC3UShK5L6VtjS3I7h1CPOFBB2pfNXdlP465277M/CdbaKUy2WRJA4MRmDkbNWljYTjvFLfO0fvdGC4msjAfHy+NCKJlMTZcs8xiJg6boN3hoXVo6GezJAYGVp4JK+wdCEa+XC5iqHPrqAclmqoUAT2jDGon8OoaiMsH5bCmhOK8vxlIDf5HJMSVs3LCpu54h2+C3A2cAGZAbRfj9LfDR15EV8FdFcldH8kIzDKAcJY6bMH/mv/YJHPfnCB4AGkSvYZGmzq/8q7DUEnLdZywdFXsC8KVeqGKbZ9e+6+ujusDEAAHaoNbG3E4SV3+7hrf3wtRY9GcqrOtaZNR3J0IMSRMh/Jw1ndKED+sOJewZcTERpLlBZlUgk7237rJVyoq6ZkJB/hTXq6FU1zHn2kD1S76cKA8FblwiBWK9PB/cbN/0SwgKLBXvYWc0PkO3DT8zr+rmhhApql+44oaiSaNOjrOTgOmGXjvj81vE6QTILnOn3//fENhpvlYvWixYBP6lF59GQ7pWqrbYzbSx68MCqYDzaqw7ZmPypA/s9FUJrhlRHx6rcOEKKB+LQzIAez1ZgDaG+OCPkZrbSiD7tLdfF9M3BaZqlM2Hsdzr4uZmxb9Uzv7iAJzHp+Q5G/AqgNshxtOLAgOOym7nffnRM+eteLx2kddoccxe1CC1692aQLLPi9dgzLjSgke+wQctfSAD/ocKB8PcmwrXVBd1Es4TF0E8Hhbd4P3YF659dfNaySQpMxZXCftKVpPbVhvR3bRH/OIdi+T0p3nO+GauGf3z3mbN4g/MX0Hvm37IEwFJ0rZaUghCym8ES20v6S9/1OZO3j47xCfdW5muSz9EaMgpR/bGTetUlL9GiLQBg9ZF/mKpm8nD92aSZCCcSrSKi2cgoG5stw7d9FZ1P7wxPl/F/oHyvmm21PimmkuSFez8cyL3iCjQonWGu2EaB+58nEt8T+bG+0Fwe70q3JubWFK5brMUuhIR5h5QURnq0MX7l6zqHpA2UYeAaGm4/KQnwXkBMoe5ktuSyGnPvZhoGLKSCXKWcKM2a3vVYChRFm7kd1qJU5kOFysgNnaFz1tY98jyb9KenY5EOcfFWAwd8f3l3Bte9hsXGJel+eSZNJbO/5QglujSULoiXXw6UK1VcIjmSPglLHVMA0HO0vEbrHe/VxycpfCXFMqC+GnoKLX9sNVHwg12imSg4onksKEMn40s7D+jhS/T61PYU0RHvH5yjQulPNOaeJ1K/CkPhhvmsYTuyAHe+pxObesx9ZRUcAqHMWHcJC8TOxCfHsQUbwvwn2ymvQTx1NIqQi3zLyj6jgvEKQVxkMMO0ABaE+PwrGwG5c3NNuvX+Y11u/T37rEhDf8mTp9P1DRHHz24u/v6yspxHCKMHdSAlqeysHgU6sNyVO6yRrlszDM2JyNOVtZSVzDIXvMPfLv8d9QePVbIIh9mDotJYyZS0XngS1JZ1RGb/E7aY0xJXyYubBcAiU8cqEPfZPF8v7c/vsWnPrPn739Ogs3RLnd6ar8Yttuw6+JjK5tfCilJEa1VGfOhVspx2MgRcjNm6butvjniYPHlSgEEQGwA2gNiDsLH3B19ysJxcsJVVYcsjwCc3vhaI/ZcyEhab5+Ti0r6uGnm9Eqkn+cZcP/YideoHN/B1mvCaHQw+YY8QrWmPMC2uRb2riqQ4c+VgBAUGcXltRPqCLtwJQQXhPvrQ2pilXKK5dKEtczxdSHQNp21wzv1WI3gCbiCCqErHN1udH8pfU6didOgtwWc8DUAQH+ORWqdmxKvl3xPkwfDss02zex9LtNMY1h9th0fYwr/m1tOPshlXrEgHhMMipfKTAlivPTQfD/BXW8OSgrhjUqPskNRTD/Ui98zrmIVMyXYQaxEQwCM2EOU951J/zlATfMO82jPyrVUWVuQtERy7ooZFI0TxCp2gttnZzBn+Pp0wiEo6N540m9ibyi6J8KOPx3VDkVFuiuUEMjUEGrWOkGcz+W466nSaaExgXRIBs68n51JjZJMf3viyX2caSacZXseqrpoNafDiY9kxs5NatuyzgNF6FTeajXtr9TjiBZRYMHb9IwlORktDqIexp6KPmnQJUH5ix9x00kYr/znwkwYG7JOmxBqMrl4g+AMp8Qi5bOP/gOgT9QXVnQd/x7GYcBz76ulyYxBe8k+c3WJyfQK53//rgnTAPHlJNOzPNdYIWdQlBbO3rclDsgLhEx2QmgdqtnkGMvhIWyAUMNw1Ewd1xkuihKSn97zac6bHsF8pyCodDxjHcUxOJaLOWU0VWRpjE2uk9lCb4yqXRAMDvDraa6TtsAsoU8ztkBUeNMztYcM5dlCBCpZaIE1cNMYd5d3zYT4KrgKZKoCfmniaceeUZ2mr3Zc6y1AaYNyBxi23OvzVi+JpeiHs0WYYifS7idkRds9RElyJRWQBCwRlqZptMl4PrnTbjFYNE73aoL0hMtHdyYfE/SMXv6ZBrP5SuWfolkO9j3RHGKo7ZsdCBRPK01B0hwTM7A5dVQqgMk4l1lj7g1DDRaNxd9UzjB/f8lI7txZ5J733fcIIliHILy4SfBcq0saI9KGV149KB5Teg7j+7528Yxmbr8/2PcLDshNeAPD9V+INTm3KRgjK19sK8QWM/BcXypJuqPNi+gW7zVIHkXY4mma8ta4uEpBKLweFDmiETBH/g61PJj/s2BUcnYfWg2Mb95Aczt3olDcUq+aKvPI4rgoUJmrUKJjGchYi/G+f/iHs/PMgoegzW7aKhMkcfOSviTpXBZlnAbNSUl5mhD+WCsY+bmGQG7qT0L1oH+8rj5wA53A6XXcvkjmRufwUxj568mXjEseSgVY/xkIKETiaJQKIRixQohYsZbM0LBvXqJY0R7dM7fWRSKTdHT2S9YhUwqgBy9i2WxqFUCLIhbsfY0f3gOrCUOS04lEyY6wLgtI920jazxoTjRegYLB91w/QRI44L2egrAMfGpPaoR0NfvxgXmQHhflEJZ2+7eQ8NK7cwKLH+YS/Yzypx3SAg6YI5xx+tEg+SVt4322b/u8IMTuAvf875/HqOE9iCBayqdoggBVSMNvD2YOd/IlWzPPY5m4+P93CP1kShnnSWK5rbmA1Ypjz8AAVnB3+xgYgQoESpzAHT9r0oWxgdGZ7aEYY5F45XKwVqUeHDbWlCGHu2ap9MMOCm/seaqiAAA6SBGAxgqBNMvL45Dj3ffRY36YFGoCgxNKcMaH/UqakMbJGGxkowHxLjS7d2LVfZrxRSk31tETNGpKvxR7e+3CgxCtM9UVxznzCRfN93+9Zwc0uQiqwaEA9EVU5+YqXoePFPLo+7mOcGaoyNG+KPZnVLZPCIo+z5dnk38oXf7GbH//zZp9IeaaeoTU/qtcVY9Z8cCGGTARP9+xn8Eo3HVsPmnTQf+TdBwmErvGhvpo/P9DXksWc6mCTxqYgPwHurd0LF6jQ8e96y2ZwMXFpf00dqfXrZ+ZzDyHtLG22xb5Wv2+iQw6kBurjKOWJ+6mz+PU5aofDFAb/sY7iI5tqsNrHmZYFAIvFO/DOQqd6wboILoLml/1ppWmOki8PNBOVmXPcUFRbhVraWjmsoDRwC0HupZY97Uemy3SlO9yKYXP48ZLcPSMLxcqrCLgkw/+gEFHa4AnHMNogtz+xU0pwRuYWj/B/Xgr1TefVjZKf223bnLBjyClu/LVHpZhODUkskt9j6GNrfd6fihq0wvGeOZm3GeBD3MGxxKq9c2lCxdpwtwBH8XvfO1ZSPnw4W/bluH+KH57rinDRXB0epAHmGjMNRzoi+A42s5KvVtynmOiBCdZgV7sDggAAAAAAAAAA==',
  yellow: 'data:image/webp;base64,UklGRspKAABXRUJQVlA4WAoAAAAQAAAAUwEAFAQAQUxQSJ4eAAABEUdu20gS7Lhndf//wZUg6dnnFtH/CUAeAQCqC3JhfQydqOMsPS8RaIvkFNnDZyMNRFBSK7KYITsk5yJakhgDgLg+Cn4y/CfQMz5gH7r3uNotLELLJkm0i7ttZ7ZPWdg2Stt7klYlhXHbRo5Wcv9Vbzhf+kfEBIw1EOX6mAvdrLyyV20AOlkEwqNt3vCBlnlsSutccsmDbWiohrIlGP9qe/yr6yvZXIzjZ11fYXMxUo3dOMpWwyjbqsZySvWUukDlRgo8WQ8MEI+zNm9V27YN4/9vNzIVRkxAesO2bXnb2tqO83pkyXZAThwzxE6TNIwOOG4Yi7Mwoe1gmMzMzMzMzMzMPH8yMzPPpLqv64c7hi3pUe57cERMgCds25aptbXtuK67YLpray53d3fX1pq91fTVdXd3d3e3hJEQ4u5YBAuEQAyIAkHqea6zESmoqjCu5RExAXht21ZtR1KfR1CMHqPJjH9brX6EGTxmZuYK3TOMc+5TVqQUbkXEBGTMY8KDF7WtXHvzg981OP75p+eMp1eCZ5qjIDtNHsBw4/ghS9M3Jx3rzbe8dv/3CybAFw/cLDE21FwHzBWZISXYe2rixt6hvRWv/3m38cIxtTm9f2FwApzIClli6eZja+Osdwi9ru1Oeo4MnKcfnNg9ME0JpYQl5t7tE6fACSHRgxLCHBb/8tfmKHU+mGNnn5wiYaLHFRSmv+9fK7PIBbPgkfd4kGSiLxWFw7/xrxRFOZA6zD9+g5Do2zDjz35slqJSYInZd3kCXPR1OAt//LtzyVQC5Gj1ZdO4iT5XFOa/20jKPlnwyLsskSRqUFF458dByjslFt7pFiFRk2Fce3aJpJwTs6+6Cm7UqAeXXrNI1q+8ah6vqNcqmH3F2XwLqnE6on6VGG/kWuCBiTqWiH9BOWax/BXbk0WndbZ84pArx3huslPR2vBzT4ZlWOJoiDp/vxFXdikmVlVn4tQDkWFMT1JnUA2T40Hde4mykQwTe1qhGlOqrqLsghvm1PsRIruCNiXai9RQeZIP7UWlCaV/iai3iPwK8x+Sak36LZRbON/6B+Y1FvZnX09kV9h//BJRY86v/rN5diHdo97vihwP1Zwiy8q0ouZCORbRqrnhyDCL9iVUY8baZFh2ER+2N6zG5IuvDuVW5asfENS64n0OJssrhX1I01VzM5/VQFll/uonvKLezR95N7ecMt/5UcYA/Igpt4wi3n93stozn/mgIJ/N1z7YjfqXv981r3JJjH1eCw2CaHxoRS6bv9tKMgah+c13SZZH6iw/EsaA9MX9bllE9al4NSjEZzcihyxdGfeKwfHYragyKOz9SDYwCD6g8vypOteaUTFA4+qdqLLH9V6kgeL23ubKnHl7GTFIjaM7g8w9/PS9qAaKYvIMyhwcJdlAwRvHsifmGLxzRN7sbF1EA0Zc2+LKGra2GLRiok3ubnU0YIgdB1HWHC4SNmDkQxcyhyV80ADD5O3pEIPYlTXysYPYwKnLP73f9GomxhKDV7byRec9XsVwNsIGDnX58R/3+tWJwOicJg0i/5dv6FEIvZoQEnTA09BDiMErW/zEWwDmEGinJwzciYChHcOrDx4DG0DI+k+tHZ2u7vPMAoF2ZJIIZ327Onx2aPvFrR0G++ZidWaoee5S/ZCn3ZDQzkkGifXNracOD63tpsOLhssGVYjC0/V8fen45tj55U2ediPQTkdGOOuHHzjTOnSpvcyLJpAwY5ALCQrPvP7o2KXNc9fqTQA3JO1IJBEOYLvO7py8NTvfZn0CoQb3jUKCwtOPb1TnTy+cW6x5uiBpByEJD9bPnJy4cnjXMuudEGpwXyohw3l6dmHswNrs8DqAOYRefibCAUaOTbVvLy0sAkQEkrjvlZCZAWxeuX/ywp2RJwDmSHpZScID2HJkYnVl19EhgIgQEvfREjIcoLq0MHh86dIKQEHSS8dEAnhgbv/1Q4caABEhJO7PJWEOUF+em9g/fg2gIGlgSPIAlh+8cezUOEA4krjvl4QbwP3Bkf13Zh6A+WCQlIDlA9ePruwE8JBERkrCDWjO9PdfnQYz1ZzMErD7wMse2QGEY4gcVeAGPOz/s1OPgCKpW8k8wf6bj63sgnBMZK0kNxg7NXhk9hGUUDeSJdj/no+ttoFkIosVBVib+4t/GocS6jayxNY7n/7Jd8DDREaHzOHx6b5/mafU3cUSM+/7OU+28TCR3RIOc3/w68vmUR9VsO0Vrz0ISRWZrjDn2E8OgGpC7qw8vIR7JXI+cPb+817C6sCCq+93CZeR/eEwd4eoAybe5XFAlEAFZeHhPUj9ZcG+JUUSxTCCc1dI6ivn2EncREG0xNzyGOofY/piC0RhtOBam+gXp7WbMMqjEiMLoH4wWJshUSRlHDxDXzq7lpDKBAQt6wMxd0yIcqkAXD1G+TiTkZmCLS16OsCojeSUbsz1klkNRn4mtoP1iuzmJCJBFbzwT2G9IXEqLEXW/1TQm87ZppOkYfcuu/VC7ed2WWQJbu8qelK/uuFKk2STET0QfvLvLEhTr8ZHQ90T3zNbEgUd+9H9YV0rC9+CKVHg0iXUvX3fb0Gmhl/Hu2Y/v7/UqSLbPxTqkvRlJ0ukCnjQ/a+f9lwR07tQl+zed2DkSsyf7xp2EmWFYCfdD8pr9ECZ9iK1q7gEZ4kunbpDFBax2nR1ZTXmUWGBqqLrzpuuR3QtoriImVnUlZmcRaUldq127fxslBaCNt0eIyiv0bWgRKtIpSJjXZskiktwDu+K223KqzgzGuqCojWDigtUDbqcKNEqUkU6osiEd0XMzaDiIibnUVdWd0WB8bGHugLbCcpr0Ka7QZmNLr3xtBUadcU5TxSZ8/jmKUZXsIQRp7eHNg0aFTlrTUp0FKny7pE0EV0QC5NYwohdi6gLa2ORMr71YhegjcjYYDvdDLI2uvLG0yo21gXnfLE5Z75Ziu2nsZQRJ3eGNgmaRs4KG2Lzg3IbXXgj44guRBSb1jDaJLG4C0sZ+fhDXbi41XOG4ACbv50gn4M35beCY5vmrBacsw3fHIvLN8KSxjgxGdqU4AOarqRR7DyBbYbFlYfDyFq396hcmyCeGXIVG2N1NjZBaftNRMGthtlEMTlddsI3A0TZbbY2JxUd+ehlbGNi9xZUbggOExuD641Eed5BiY4iVaZVerQ5qfSkzXDGS884viHFxEVUcsTFidCGmBwvPeOTbAgiKLwRvKV+Fam0GWZlR9Ga3pg4M+IqOXjjJtoInCcovDNsOKgovonYSBEWb6E1yk9sSFHtRmVH7K5CG1k6W37OLm0E2iMU35E2G44oPxEbe/PTofIkjgyFSo9iI3BFTtlVDB1Er18wSvF1XWPDUX5gC7GRIhy82WvLIGvFWMqgJezFYECePR79tCguL5tyR1bdRC3YjbMkD2ys0qKsuq7kEedmTC+GMWGWPTNVS+Iv5i1SBzYwWoxy9/dMqeN1H63L/uiGR+LUnNxDtBR2t8+UOGZ9aqglsD+770qbsLt/Q9B62Nlfs7yR/c6cbwUWk+9SbMTNbYjNjVfNuxUZ+UMX3NhcsfUcKjEKXmGhTQIfPUmRYXc72Hzj0qKruMiPHwrrAsFjFiosii3X6a5ixzLl9fZ2V1ewWD6NFRWLU4fD6HKwT15UvHWYoOtifjRUTISu0YuK1nXKqZidDPUA+NheVEpYGgrRk8b5eVcRUZpZQ/TsAyOhAiI199K7iqFblNFbw249A75jCyog8xMR9LAxfpzSqVg6j9Hjq62ksuExTR+ebIYKhmgcJ9RrFhMnsKJxfDZE73urTbkUB8aDfhRHDrpKhY9eRn0BHG6EioTCttOvCl2nVN6oXH0CvrhQJMTMUoi+NfYdDisO8gMHEH0cHIsoDsEp+lswY6GiILhUhfoKRfsqpWF2j4t+j+k5yuLUMDUoLk27isEe41ewOggmI1QIxj5CNbD+pCgG13YkUYuKPYdQGaA5R20qZveFCoBi7ySqDeBKw5V9cl2jThVsJ/+DIwrVCMTINZR5xtH9LmpVsXciMi+Gt1K74viiW8aZz55EtQPVSfL+RIMalg9dRNkmLjaTagjFgenINp84gqhlcWAhIsvEzCFETYWdJ8sE5xtRVxDN86QMgzOtoL4tHrPIL3HgTKjG5CO/g+eW0uiHUesd//XjRG5h7DbrZvihqCKzZMsDUlc7/dZvk1thhyctulr77z/NrSiz3x1GtxeZLYbGLbpehpuT0ZFS/+N0pNTbG/nkfMpHyrudZRe84b1Yt/MMI+jyFodOoLxS4kjdwccvJssr4CpRb8H2IL93ylVnCjWVXcaxB6k39h7HckuMLdXdwR2h3MJZptaDKzjZHTyK15mzQoYba/vC6svYewjll2LsKKovcWQ8LL/wWCPqC0GQ4dLtra7aitibaXFwBasr+ad8fFiWuT1nUVPGnvcdRTmGxavWvKon4jWjSWS5fOhl1LPFwmtCZLrFy2+noRoK+6tvFvke+q2fIdUP/NE9It8Qnccw1YsSmJH1wek/pmOqDxONbRB5h/N3p4dJpnowEofuNBC5X7HvfZ4dJpn6z3AOvfMpnAIYzsn3fnaEZH1mOIff4yVjoBKA4Zx6r3ccwa2PhHP43V+ygyRKoeGcfu9nCKxPZM6hd3/JGMlEQTSc07eP4lI/KDH8Ti8dI5kojIbzdu+5j6SeM9F66mabZKJAWrDt0bURZD0lJc6++ypuolBaYv5dV0lSz8gSS0+fxBHlUuYcf+oAydQbSjTX3mErGGVTMPKy12wjqQckqiffdY4kyqcS7SuPDyN1yxKLT18kTJRQWWLlvS6R1CX00GU8RDGN4OPf52yr8QGPTxNGSXXxhq/54G3hkz6HEKXVxWd9CrZ1/mbcKK8WvLmw9cIos8Y2GpmrrRK5a2pNYGSvHrViPBT5e3cWvUhwYRrlD8uLphf48gQZHOxf8CeiHiCF67LnO+0JdnTJIoOiXH2/7SZ8/N9cJPGvrh53/NtaFskXDj8OMGZWjSwWJ98a4P12JZUiPOfCfPxmiGL82Pu3XeKhJawcOY5fwYIncQryIx4n/MgzWEk6dX3cObvNVZLE0gWogrLszMKYoizBcewGhVlcGN6ygMoSNJsKinPwpvxDVXkydq+UJ7x5vEAhjyhOZvVYuzytX7w0j5Wl4MbgPE5prsIp0VWUqH+WCtS3fadSefrvH0flSQ0KdESJehunVaRSkdpLlKfmVVSehrdRoqNIvc3//Oc///nPf5J7QonFJ1g2wUC19jCbjNs096NcggI3sGwSFDJaKfX//uc///nPf/7zn//311JqVqZkGs7OptMGrD4mlfOVC2CeTMxOkdBSRv2///nPf/7zn//85/9ys4xqPkqoUg+gdIJpLKEKGa2USmcVqJjdsHQa/fJ0wkMyuqSUUur//f8m9nU+dayOJpTJq0RpohkktPH/7Q9l1FvfkE/rQz8Vzyd/HxmtlEppWUbZWj513L+A0sn09Xz6f///+VGeZvciSqdzYqU8EVso0IoS9Tb/839vWkrdlCmbgrNT+QQrD0ho84z6P6MqpV6bUOkriHSa9ZLOHY9+DEsnU4Mom1Aho5VSz7Z8klWP8gnXAEonuIalk5hZcyWSPWt4jExaqxDy5mgi1REVwNiPpZHbr7iKK+uuJApb+A3nzehlskgc+dN18c2raWT0O1yNPjyH5NVl3QRHblrkEFdGnshuj6AkGnty3OGcJ4eNvczzXc2iBJIvHaAnwcggGRQcveHnE5WNV1LI6MO89IiK0kdeDaMXiIm75K+4PP5C4bcOEwm0d6W8CEYfnj1yDvDiYnDNlDzY0gRqYfoy2RMcv2HxYmVtT/oYfXJaHahK7sjvDaAWgsklInWCU7PWivzOMZQ6MIq3grMbTx2vB2g9OLBgSpywy2eIluQ3jxKJI848cbVmDJO5zgVzWhdHqqK0kT3Yp9iScyPkTXB8xrQVZf1o4hi78a0AhrGska8cRWxlcGDRlTVcn9si2dxRIm32rfrW4OzGksbrV9jq4Oh9V8qEjZ1GWwRz18kZcXDVt0reHEgaYwRjq41XNj1j5A+Poy0LhuctMoaHt7dB9nhUShiYWDa23vUfZinzH+HaOnFwyZUu8kcDiK0Pu36MSJfg1CSxDTiHsHSBgyps72i4kkVFI2xvcO4y6cLkaWJb5Kv9+aJ9j1zbgtFXu3LF7AzG9gbnJy1X5MsX0TbJVsbIleDUVYtt4uzBUgX6Kdsm9t9zZYrrEtsfzFwmEiXK1ANi23BdJFNlA3i9fcaucOWJs9vQ9gVnr1qehE0tIrZfZaUfTxNnDIs2ADtEph7C20Iae5goyycQ7Rg2fSJRhgvRFii+FiVJ8Hm0c+SIbIO29iyZaas5ixzhTFstkKXt1Zsjsnq+rWZQhkRj7nZbHUgSG31tW63LMgTrt7Z6YKb8iN5HQ7T1mdueIWXqTe21eJVIED9cTL20thelR/TEIUr0EofWSp0dalyj3aeOurIjfPBNFm3ljy8QyaESh2g028pisC7KjehZumuorcTglVLnhmwSRHv5jQtEasg5SWOzvfDmFUyp0XgwjEV7CQYmeyI1bHqRoM2rxtBvNU2JAZM0mu2G2fSqJ4bK5hmjbjtETWbarSt0YDB0E+VF+Py6Vx3QmD8OSgvjOD3N9pNzbqOQlr5yFNGBtfWdQlkhu32HuiMai39bW15coHQEwdmHaWH8BxYdIaYfoJyQ3xynpjNtfVlJEX4Yi86IsnnCyMrzhjoD8ScLHhkRPetn6NjaBv8ZpYSffh3qFIx7OQG78egYmMYSQqU+TQeLAwsl8qHuufoG1Dnw8DXU+SAO9lonWV2Tj1E4Qqk7yDVXFWWDGndX6PCpv/E6G6KcegvqqLL2N7LIBTmHKVVHORubRi5G7/wcFh12Z9YjGWwKREebzxxBuWBcojQ7S2XjtEpkQvQsn8XrzsKYXHRlQu2z9xGdbqPDRCZUNl282XGNhydw5YGojtLbeTD2pGSC3Rkh6Hhx5hqJED5MaXZe3bh+HssDcRGvOk9uw5UrDVi/gOiCodMPSMNg7BfkdVCXi6MoC+DC/1otyJv7as8C44SoR7H/CcoBWXMooi4eVaShRG0WEtHqQ5nwn5wlE0pdmK1GIixjtWChr30TlgNGzzdu6VTqM6GGxY/8Wq9Iwx/41okUMvWREV41vvWHesLSwHj8O155LJz+lTN04Ft++xd7aicP3a987VedW7C+qbTw7PIjv/9Nb6SQiZY6Z77v+z+spT6xF577ZGg2RTJWDZ8++YFNWV80/u+dG/eoWqI8WkqtS+7qg8bdkZfRaVAmq2r0q777WDR6zu41P+JualIsY/rpx6h6Ta4PMg/KpTrxzsfuNnssWp+QQioYVLH03Og99Za9c7tDRcmU/MO+ehrrqbFnUmWUTenus68I9dTdYXNKp+hsI3rq9N+j4oEa2xq99e1g5aOKJ/f01nSIAtJZvEVPv9AoIVR88MmeGqKIWlo801Pf+eRQCaFD1VOv+YjlqMqHt/7893qqKYLimeyXn/v5nhp5vwRROKLx6Jco0UuWfmlXhMqG7HGzhHqp8ge/ccyrsoH1xIbTW3u+bLxTNqrXDPW9jWgrIsBTwVDz9Ss/QwO1lxmfdqHRKBf0zv/6272m7dO7NP8IXCoRtenYn2AW7ed808f+MxZIpUHRsIE/oHdTdKD0v/dG/2O7CBUFRcNXF/+FnlU6UjL+9ckrHzK3PVQQ5L78C3t7G75Jh4Y7/8C2yS+78UIlFQGJcv/PD9HpYW7+Pp82QnjIlHkKL80HPwKUUEcRmE9ee4/D7Yrcr1R6uPCXc7jVNV1xcmX5jGbWWlS5pprXGuN/PwReia6oqgPQ/q4bKaosi+C1HDl74w70RpOuWRne/L8nPvzIVk8pcksqxWZ2nQZ6Yo3uKmGTs+/6WnI7sLL+z7vuN2jI1unOwxcWLj07SgRgORQOm3/8x68F8yaiK5sS6LWf0WpWgEsZI0Ay17G9J3ugKIIubko6uuP4iuLEUXeFTDmiykENuP+zvwS4Krq9CNYvfeJLATqYlBWqwAvA9UN39h41VwQvw0qA3Wt+4bkXNDVPh2goE1QLL8DRo+tF+85AiZqXqKLybZMdZg69/R1ILpPu74RC1gBOrvueP1kC6CUqXrYK1k+tjVx+Z8BBgO7LFDgGTI5z5O8i7tArLGrxEjaB7B4Mv/PqjrM7eVGX7r/qApXdunjz6OlHPAQKNSZe5iZ1aA1Nzr7PE3fRSIOAQLofEsLAWDn0H0PcXaqagBlI7AAlB0bmDJ966iXTbkCKdRJI9xsSBGBmhlBz989eFE87ArGDlJwXXbv9/43T+3ZO8eIhx+4jogZ349n13N8te+Pqv26agcSO1NYpAbQPvvcDHcNHFrd3hu2FEKHKBluEQL0Azer2XVSWTq4euwjgVrPTbVjgHrQj5KMnp+5t+chl1icnXoc3XhpVPMeKAyycMaYGN8avgS8H9DxViR2xZCSAAHj6CUSav1bxejZN4Pas7QMTIOkpUw/Pr6ZHlkv9t8dNa4AB7hbVUztoExAyobtNULTXLjRD63zzU7+AF3/Yy6ReK/TMnBc9dbJHgMq9U7O31j2aLitGBIaCHfeZWWd69T9x/OPP/cK7den4o2/86vPxjT/2ZY+br3njc1j2TGbPC4+29qL3/rv/ePv3P/UPr6tX//6Tf/Vu2Im9erx6/TjOd6dNPnsPcp3z1dQb56mDvP7Ln/gn/vK33r1izm/7nh//jmE3e7z9+rc+ze3f/+pcv/nL58T+9Ff/+9W//9NjsvYFD43H2zkfO89ly3WXPisNXYzJTmt1HB3nzPmF69gnf/cfhn3y+MKvOBi79Po7v+V8/f3fnqV3vuve0YuVPcOaX/YV//Gn+9Of+6+jm2iP3/z91r/8ly58wXr1auFcRjoenTtyZJnIdegz0HIdy3VNR73qPFpGo+PNscZ2nI9mY0z/efLmS49s797zIVMzEs959xf86R/4r/9GCOoLvoBeHULqVCLpZq3DYzun5brIdX2m2SXjqGGap0etNbdrTWvGDl7i1UHvDNtce/3rjefa5sO3X+R4HbqL3pGKRBKnlGtrbaenTWg7yS599hhtJ47WnAcLx7nLcS6H22YajbGZvczYweAlKp4v7zkf6/Q+Lp4VpZTS3J7WcV46TizOQ2snjhp9ZhhxnBsarGVrDdZoWBtZo3GZMTNjN4y52guApvU5SBLpLjnVqIVGC1ora0FDHSfbPhNMBgtr1mAaa2vn4fliWmsyh7uZMcY+Z5BrREQk3TmVUimW5+fRatEELS0s9/vYjUazxljmusz9OroZO4+wjMZhZmZm7GIXGFuaa3KJJElyKjlT7Dyim53LfZZrFtGSje0jNkyz1tENa8zcz9MjgqHtXEdmm7EZM58+iRSplFPORDB2etoFiRY3O9eMYR+pMdpas/Ow2GDEcXnPXZr7hc1sbMYM4zLAWgu6EBIpSkrqSbvk/U9GUCznkWbY2EdojJlmGIxlaNvJ9h5YsJqs3TEv6riBsaW5xrkXibuUSmF57+KohiyCMMYY+7gMY4dlrsNMbXCoTZ5Oo8WiuTYvO3oynxY92fkyuUkWazQ9MbU5oTYJsW22YWx9JHZpGw5z3DjcbrIWyxottrSstSzN9WXGDYP5PwxyDfkcnFJrLWtWrNGyWMuU29NNrDYX9DG4PWyOXR9zWJiO5ulxLmvWOOk4X512MrHuzJi56fj0nbuRSO4qiiPH4zjHQUvLOk5P2zlhMZuZMR/JMTPbcWxHDmvuZ6etNY2WF2ahI7etJwxznU+fXEM8kRs7h2VeuEbTWjmS+7bNbFxG04cuc92WDcs4MpwbDcLSC45Tmx3MjBnzHuxy+393m/tnIpHEmZLTWV1mYdCoA9lJFsoqDPvQWWPmOoc2t2uetkzLtaWOYGbGGIa5zv182nQn1xAikiedSXNdkzVPW25rTrkma+wDNqyjWbNZM0/XNLTWRO5bZK2Li8Ew78GefTrz/E4IcnGRKpr7Ma01NK0bpKW0Zo3tQ5XrzmMMjtYY1tCcoyV7cs51ac37YF68y+djl+e5f4kkJ9HxJLNGh4YWorUTMs2HfXBkDqyNNq2jkCHIbZPYOeJZ8/R40uffnpxPtJdQ0kxzOxgybOeaGrVwYjD7YNmsrbUD69W5WAuLoJdoWVpYOdy+4Pkun989eWFuTxMJWfOSwVhYi3U8Fs7WwWzNPlDDLK8sZpqFoCGIFVpeHHZ3v5d8WLt5mtu76xq2GAwNhqVJLKfBsA9Sbkw7mOXlNXGyLLctCy0v3LMPf14aLGtul8XBtHn5EmebDZp9aJJSHBw5YJeIIGTOw+na8jzsyUc4L1+7OJyHDIMxdglOs0XyAa7z8e5//+c//+1xvns8Pnl88sm7d+/effJ493icj8d529nVmSKR6Obax+t98yl+vHt0Jv9vbFZQOCAGLAAAEFYBnQEqVAEVBD5tNpdIpCYnpCRSSajwDYlnbtRWzlByLyMC+8nll1wDEANdvxYeXi1NvJ/2PMb9aHzheQDV3oaJY7s13/+l5wrrucU/G5j/7PUR+7X3A/1L/XXsG/tV6g/2m/bj3lfxg90X9t9RT+5/6HrUPQb8tn2gv3F9I7//6yh68/xn5PfsN9IOnv5W/uX1m3cBpcbYnAC9jbQZJ5/YOMruRPG78aP6n/tvYC/kn9c/9H+U92f/K8hP5r/tvYH/k/9k/7P+B9rz1//vR7FH64j2jCSnakCsoQcNmzpICJYY2j6M5g6DI791sQqhZOa2CmBBc53m9pcd3d3QeWEbtkko97bpt7Ti6jSVpubaiCb21rCEb3MTkrjfGoudJIwksUlXJlezj1z9sngV7/4MYSWKT78BDUIuBZiLgLuZ/FMoDZVpPSERN5i0YVhZ0nTCFk2VaUNoFhw+e/4Lcf2Ac9Vk/aEOm9qhTjh3t2B/7hezIWYSAZNNN1wlTaysnsKUvplkKh7eZGMwGuvnjZoVai29yes2QwRLLA1HhfT22sytnpslqiim77RkomxBp3SRiTr/ef8esPv1xoZeZssvtK6V4o5yF31bEA41K1pO4k+5bqObtqaWoZyK7Md9JImKzu+OAXzphZxVpU8iyk6T8Yb1CO17fdOxsBe8YvvIdViW5TteucLzinwZIqnjULt/jXPe+cePHj5ff63NiakseNayJbSQP5gVjMII5xX3isyw6qR+83aoBCNTmpbrB7UkOkl5XgRLxWyZZZoTpWErB1LJuMF7KeORVPqBqLtQ9Q0Sa3GD32NbSm/26aZNGPyna7ZTR0fXD75gnQZvlXUm78sXnU4pkLYpL8ymGg/0KRpm408eymVLCJ2lI9/JVEYEaSwCVNmMldfLva9HpGyInbnCRvNOSE2z9YY8GQDfe7CoQsJDCKnmvYkLQx0tl38iQ4//99vsvwgFjVfYfF6sB6ZJc4q80h8UfCGi2ncPlwVWVxgNjFsSJrLxQ7tO+7Ep1dBj0CcWLeeQE+qL9ZULiPZv9dM2X84zdCoktx7dCoVmH//i+WeWEs6fGfwSLRK4wMop3XfhDTu8ppTD/LRc6SRu2Tjz1zCcjMGx5euJCCOk8uxYEF2OucFCAGpYAVM8Mx+hvjPMnzu6jRVaIe0GybeJlUzUKdXNQcHin2FgkjPpeifRj1w7rHRinacW3t9+7IL771VrEZZe4UKuZVnrYByF/w4gP/Ju84Fkd+GRczFac3Eyog7UXe6hlXdg+SF1I9LzrzR4jBm6tBQ5JbH/PfMNNqf+/NbF1uWIwNwaHlQDnzalkxeMLKCA8B1xS9WdosFZ3l6e+8jg+hINvs1jZIKxIbNWIidn8vHqCzpGmsQGxC+dsYC+ZmVd5ESwQ/t98N128T2iBC2dqzc4qltwKH/POtb+cP2vTHvhHTJ6d/UAhjHkld22WFZ+OYnmhtHO23idfQY7zvqdkawIARRGilRoY7RqbyOeAl7JWIERVCiMjr/kmuTywlMmFVMpcPkdb4aYIEYOBHZ0ShOhoA9aooDbhwr5S2IOqzqQcEHVjHsI8oiQkhIC16KR/8zAzbc5fCC6EMAcMSxIfAAJSBBz/KqKu06uC5WG5fmzRIFNuUg2+qycnTp11k8dUeThf4WLSoFbDkXP0H6fISk74dgpe0ahin+dDZVfnnjAFd9fFGwej/696OEKjSAZRwZVWeh4b7PiRsx8b/v+LerYvUilA04BHsXquqC4AkfEC0ObB+fgtw2Z5+A0QWb6dSO5NamnH0vfea5UTNVE4gWs38ESHBnPUIlH69/RPU4fGfP3nzaF0PJ/zlyFiqpROw4j4OXYMcsJYbO7VTxOfyX7s0e6ARxqqMbSX/pLpUIyzqGsFKfVrj9RjouuZKLasPls/LGq3c8u9DooEvqs5nWf2LUECtN2WPIrRnbID9RvP4ch14ix4YKlUp8UXwdwUJxncguh38S3CkWL5bQOI88sy04PtGTrlOwHX6z4UToVL661wPlFT6dVGhwOHWv/90Zi4ct/2feMj5RSe0OKsrr3Parb4R1QSa6RTNGaThlq77ZJC+OInjxCq3dn0fIo5b6UWvqVIEYYePWulbtwoMshGE40lr2qRfFtSqHXhfW1oVftyxYwcIw9uMdzwEwsepabpKU101+xgx0wv1mw9k+CC2WGqrZg+IlOiqfFiyDhXgCOJVn1zjSaycDyOK+LjUndKw5Y+6/FG2lxaehgLAQsgDFqxdFtaZXBwIc8dLjhTTOEIZfnk4wsIK79oBw6MFbpTDRYzHR/azZHKkkvmJjOU9WMWXnJfGw5nx/U3pZMiZZ5ogp4JBmCIQxax1Oo49T8dHt9CDhL4vJSp+pH7zlNC5EZh6SDZAVV9m67LxLBwkJkCSNgGc0Nqnw03saJDNVwEgwUHLVA/m2tATyDMmQMK5XdQ6GktNhgaXdcSFjgcSzrmqMesQ8AZvJad/8Hd6C6/VOsjLTLWy75fqWuFipIDO/1MRawCAP6ml/8d18RRSUg/lImxqGUcI+tzoPs6L2k7g4Zf0UrZFoJjd1eKwqaGVo/b3XH32BR83gMtuREs+KBoxgQ1bp/QMfNijEfRTOt/zIuXUgolzl7agS/blunaxVdOX97ab5E92FuARieGLvXI3W+75venERW6rRs0O665q8+VXDw6M2pzn2N7mIjah/AfPeuD7YgcP8iYe8lOuij5uKXqW2Ac70QFGO+B7PaZQfw1N4fWEK0CEihpOucP6L4rhIW8TKqaaUqj3JMwn46Nap/ANYuBtgN4iCr3DjwuH/dw6ZtpEwU/+2zwUV074oxPQokh+LruoZee9LORHr950zYlu7bIXt8PLGP2fUcSeFhf6e5h97FMRRA0zY6NGjU6Hb/2F1g3D8d5FpoD22a23IOZuvlL7EvinHRbyIG0lGKIFmeadN6k1/h1M4wJXj2QVGDm9jVNKG0YEFm0Jd606KWCGmEOvfxB9X/7ZMiKx8MSJ1tXbWX6nMlHG7YxMf/HCO4Q3NrovqrDjqsCQQbKBfLBO74ci18FqXITF6kqf9X3i2bSeBRoAFP/bkbdiaCZ/64MVVz8hX/H0TF9cGQhqGGs7Kn3bcDIcpLr5Xs/pidNtBQHn8COo70m7315yQjiXd075rSmZ6kIJQM6OETGQFjTav+bC/iQ70nXQTOKxjF2iIi9ObvT7GhHL0/JTNkfuPOU4/z4ZO5LMd9H6ujiFOdq6b7yaHDoxv0RsQHQXAb25J+IR17YYk8AaD+ZGCRCd9oA303/0H4TMsuIo1NQgGABoDZXaaE9paRohSRGyVSaRJgI9MMccojbnO+8F2m9GmZr1cwZrA7SaIOS9dDB8VP4y6zw6mV+8B2NvUHgz1oXiJPte+9kOMkv5HBRVZShRIkmiJKtPlHoDKJbO1RddIaGdAFaG/kfZNsjU+Pskffqq2Y35oh2lyy6oVBgp6in8vEd/u6jBBtsrqA8sVIEpYPmxHjS6gzDxiY1+l/yWJ5Ww278LJv+WVzMogz9Vcr28+uSwdqUt5e//g9JiSEAq+Z3M4iejlKYIsC3KfnrfrwPJZ+SJE7JZukoHMfiCgSE96jR+lLJgodQXvVmHHwx95UwIrCWdVMJEOuqggf/5rF6vLmILIAAP7oQ4CCS30xIs6ecXOXoUs1o2t5bJb4uQgAMdp65y+PUhjUfrCUycHgQSeIcMIvRAGD/7PfyWX36/wHH2P9LVzy9v7d599hT2cbAc/OlQX1IA2E0EKfL9zW9QleyunsBry683pUqSWCik6Pzj2Thre6NGRDHFoUrz/jeqpw99OcChBwm4g3DdfirDzLzXj/VPD7KVExmJU/AYxNlG1ySiI43uUTJP/gm6yBzIp2/UQ+lzo29suRhgCHMA+1hmTapCILBEf6cxJLdoleFDELIMC22ZOTELUgAAAWC/2QuSBmVIuZkeM+P2kdWnQkA96ItimOk8JY2ndiPcMx4/CDeKlP18AqFOnqmjZ6QfX7GHpt5W2F6IonxPoye+Z+iaBu5GVDMA7BGvpZbUqHEoAAAY69qYaHmnY02Nvxk364tYuIGlv9hvFbfaIUp7O1GeaEcvjj7v9BGHSKSSmbf1PAAOuclmTW1wKuPZz7rmPfUDRc77DoLiKUuKqUGsHzJteOW/w+136E3v+uhWMsX+srsnLctSEVsLgmov2pXioy1UvZ3W89PkUjhQ/E5wYWpWFv+phAeuyaBu3ARrfXyHrgLAkIZpg+cL9R/QsMUUftyKVi5aSqBAamc5WvRRsh9eTod0q9gVh3lFGSaCZQC54r/8oZ3NAPRfgoqJViMkWOYTn1h+gGfpkZdm9PEoX1MKOLcTpfMLdZQ92hsfJd7ZcROQCKazsCwwbHLxyIVhSkY6uRSgpAxASMjb17BJ3kAXDjOgx20BbGcimwluF23gbT2MVNgtdDownQMi/I1bnPY3q685FuRN7Zv7+rALavg0uZyoPPjQRf3w/49R5NO9fJxCZ1Zo1qxjb9WmTskkNbIzmzUIJzlfAHmpozRL+Ia3QXE+OtqPrO2G11WLNqOky1GzZurog8wO2fW4givjPzh1OkYfMGgCv1jM+o35x0CpLCaI5omkZWxlHKrGa9iTnrB/3l0CMCYNY2TuuFn4D3ycaL0RUmPZpUf7wekV2VjFHR0pdRuzuJ+Ujrlu900aPx6z4NcNsl4ahnWGV5Bgtij7Dri14PNnik3ufZeA0EHHWP2gaFeVz9Yq64uwPYE27ZLVL4B7AX00Qc9lGKJg7Ogr/YpfDvFgpWZaffP44Gnheyb9/XSTnj2j/w0y8g27UXJEKbRapOZz8Tlcbf9D8OMLP8n+vLYyOkgyqJGm0qympchXyxGganIv+hNKVchA7Za6tNpG7vyhuOEwxwcd+2S9OkVZLVtzoUf5pwLYqsDFooVXOkS246JvFTE7z2O/p5tdCZf3mYEX8dpJv6UNjPge4GOZizIMrqAkgbVAgOgB+f1UDDb1EPf4VGWFns8dUMswgvksIPCBuIhXlZ8/4+6VmtTlJGiSLcskQPdIc7y3bBztvyIRfIsOE7QT8Mp1lTuKFrPamPpKcleAsaJNBPm6Ac1ZCqCcz4oMRAvd+SKsh4ikhhkZiKG0BDMgb5QhouAMoe8I0h1y67pPGebwHW05DcvD+2XWJN5CwwPHzHQ9Hl7uktOBintJCEksRhBT1ouP3AsqAeGKOrc+3rkMTlQ59Gu+mmhQ/AiKMiTt63MxBRDxyRY8nTWspG6revRIuiGlM9SbqwB9P05qIR1RDRvjEZQAH40LllQCazD330vunnxLLsibEnk4TRPYXOE+sHUruDMkXcusk/sV53/08vTaoCEEhDJjhsqiJD2SSwLhTx2bOKPRsBAgsgR8HiSeh0wE2WMJAuPm5bA3ExWf+lWZQrp9MPIYtwQMkh+co7xouZamwy/H8SLihygB22I3xNL1ypuT+1mzNJQ4DcypOFGlisxPDJprBQ2hNXT2dEpHVrXY0Sj/u3Xw2PteItKdb0ca6JesJe174LBHqss+xux/XUQ5c2KdQ52/lAhSP7CoF4HJB+rGaj8kFEG44aGzhARhpzpinEtX2DIAtsN02CfhsITni0640OLkKDVXsABnuFbWTSCG6jhimQG+loPnPzfEnch4vIFrHlA6lBtKGNN250UDrwTXw0j21OY9+eCoVaFF8FBYPlP7OI9tmJ8maqCoMNeNIKrrXepIb7HG0L+e55N7a4pCf0ytooAcTAFh+8CA9arY9X625OWSs0rjlGR5ydRUK7nqAP5K1CGF0Bm9gNP2h5FWFJ7kFhzqPQ/7LsviFktWPBKflFgfB9VGEd1HCi/wueYb5zleW48MQNNsvy13ifuqw5n9k44I6ih0ms5kzUBF3mRLodGCJyVANpidaJJv0DKZRIU/vZk7zATy7RHMnUONSE62jqqMZCN8hCqa7V5KgCZyocNbpC+NE2jDA1kZUgf08FG2J4eoOwD3SFpdYRdG3tWiSNClDgUfldCRnf+ZZR9zLkTNg5+ifWmr0XIgBv63oUTM8XiBDEpewkyN/zBxYkOLLsBHyJnHvyqJ5en2DVtV7edefVI3gKfWQir3SpOOj3eArzTDrlvJR5wJexXX7LrzT5+II5teeNR913nE7INJ53kc/amADp3vKWwU2wCz3RXrfH8OiRb4LwbXFYKB97vmcQmIQDRfHJfnqwo0sTCpN4PXkUHzF+nQDntB1IrNHHqNZ+4hkPEI1EcAZDxuJt3iEv3nS7aTFDqEE1WL84Lzr6xisywgVq57HbOQrmdXrh/GUUwjr2BTjw7wGy/GSTlMdEVS+y+foYzYxkVbRZk32PNZWF3m74sMBEtRvrtHXnu2ajNjc4QIr72BYqlfcrgABkJpivBzIGj0w4skwEJuDHd1FbUxFVmlZlwj2u2vTqn8xsyhanZRQ+hHaG/tJSRv5859uTaiK+180UICNoAVaoryClacLjuPXIEfbDhZkuphArwBeyuLsiBYonJtedA0adKjuuO9wOTZ34JXWH7V76kPPdqsXkh4z40OxubA615WtKO4PewCv9W/EcGwm12B9XIxf/ZUQezAACd4zzfX09Htb0ST3zjcN9+FgWl392CeBa9xtCsznNltbl2R4oMg+tK1Pe31sKqTMKtGJ6Arf+7EiuiHVclKFrSQ3Qy6Rq74k5z8C7HqOIHcpJBuoawswNafVgKqq2oCX+RpCnvbHXTZl6x5tIpyLqZ1mi/DTMKIQdL4gfSXvijZGYDUqXRtQzSX6QOYITqOla2CXEtGL6oKUUaiEHhztkyjZb+V/4LBL6rRpRi2Q2YbY9vLWkgoJHye7kPz7P8bbGLd7Nl9pOBPSQn8GylskzEiQnbQl/ctnZYYL7BUGsnVg/1zt8A+b3RZlVh2y6gvfJ8R1ItJ73mZtfP9Cy6axyGl1pIY482CFowhMxjTBOv3LoUPAG0tdHSc2qjJ0J3hpCyUktCsKJPp688JWLLcryDqcBnr8rDJCWsCCkcVej3xR8N+E/92qvQdo9Ay29vr0q9Hk9nb//r4X/9eX//+uwtIUkSXDtsrfTKyQZBzDygXor7+NYu2C6aE2y0ttERW+4tmzus17rYfmk7zz+uxa/ZHjTRy0Nbw9y8bXk8HkcFfEa7FYfggrw+RzwuEaXDa2WvRL/RZahaflXkw+EPruR7AAy7VbGWYhiJCssoM7oHg9x5/WBIKAIW2BhsAELe7maJZLzo7R1ukXrKxeYThzET6h7J3Xyoq76EzXKbwD3fhq6sdL7hGcwWEuy/OFjFGQ+M5TtRVqSGZphyJCa4+yZZPeaLyMYXQCkDO8nN+NBAyRS1Q/z2G3Fm/5qkksI8GUuBVVuHdel3a04HBreZjpXNvXMC2jpdham3ISTwcfuu8Z+R1xgsdLoZy9cbgqVmcdBJevTDBzjjOBQ5+hOM3nvW92/oaqh5ugIpz11WtT4ZP52+CHFwANF4+UD4Kk1SxBJDqOQxHBxVXl4XOv5qRxakQaLkTZ9VCPkWKF+SkVyyK2FosyG/xTqO6iR6zLhvpbbmhzzKjC7bQ6rJGM2UNleRjXJ6KqbFQ6vOHlwBKIrQYnGpM7oxGwd7YeAxuNioREWuVU7KOsR5yec5M1NPTbBY9LpOEQU6KCKIyG2FmgVC7LC7Xer5RS5lollONyXbvX1vaDMqIDHOeiLLaQFVNxeXgbFaR1hy7clpoM96r8efGx/u729DF+eAqBIC7ZiIlbvA3WAK0jXq5mZRWKDI+6G7PG/H/nfwEDaTSPld9QXrCUPWmGt3KFgnMFOvp0m7kqQILOk+PYgfHJPIEC8FIt+T+eozcr1TpiiKeJfkprfTz/ept/TQL5SgoGjEOL0qMoyhWJoHC6vp9Bh9WH4Azu4AEQkRmti2Y03iJZ6ORO0qVgod7EkNZgTRwNQbNapDLq14xEMD57MiyHvbQxBErpXNv7tObN01WXlqhlcdndqLjO66tVUhWvcy0kEU3hfvdM6KkSMiVjpORhEANAAWSyc8srcoScz82B3yEarUAbLWOSV8u2wOQWf/dBKl5fF9b1Yu/ez4gpNl6oubIQ7YKGbUEJlYn+Y6bM9pjEhdjGam+1MP74CcEuGoWdA0L+iMLJAh+VKkQgjjxZMHRc6aymM8ooWjWm3bT6aIq6J3Pb2gd3XlYbJYlNYU/fxfBOlRVEBWqX1AIYPPnaD4XGTd+CZq29RN5+V9dEiPALQuL7pGt7xa+W0LGMii1vPsSifiDpczgFXHktCGwaK/woavA3dI+q5KmqmbA+LD5GzvR3qRnIZref0fPYf7d7gg2kcLorVy6BYPAhAcNkoFXuIAPFY9mgI22qgBybfCDCoMXRenBQmL8zFmLk58G+eCYx7VNi0tLx/b4sfVU//GHZ+2qxeaqj3ZSE2fmhKGDjkAHrcC/uBRKH6yX4jqhoXbScrPk1sYm2Lx7/ZE7J3/HyLuYUdDq2hVaR+dIwlhe0FwgXbHTPOXGqCf7n3M1e2T75W1oyI6+NlwUQ0AcGmQRABO3MD79AY8AzkH299ASkqLxZIDQtFMrxYvlBCGJ0EGAGBSNHyQ7Xzgo0V787uEmkEc5zt7I9KeZAuA278CSVEKENPNC39jZUtbXV7Mq+ayEzWnhisqIIw9jw/mexYIicVONuvwrYZ7+yfSWUaSnIUwqe0CubdlLQVclhU9zS82VJipZQ+ipGF/EVhQp6kt38Q6SvKfcl8M7fft9XG/47PZZUSGFSjmlrE/tVZfea6Obkudu+ZRG3+VNOpfmj1Rs7q9euzXMQQ4MLnJn3e1YAc4tj58DswsCBh+qaoIFwoR4gtk0Rt1h1sPhgG25Q+SZEytzrlSmXPJnba5v8J+gn2bPqTv0fOCnQA2d2hkoV7xMkByh51pqJSB9jtBsGUCiQJ5FcyfrzlFDWrAPi0ncaWs5JSoLEv4ZGGXgiE4az4SzbbxySRbvXtHOr2h9J29YEStDEauyhV2/bOLjjvAlwR9RHiiwUecehY1+fmoWuB9VlEd3adUj2AQi4HVHOyykEtY51leTAOcnVL7QJ/JrGaZys7j4tQrOyd79umcIOC+LYfAVGE/MuloE7PCOHqxStpOKOkE59ipvgbMdYHVR/fDs/YR2MnC/DTa5BsiI+yf/NVqexxlaXMLa7ALhCP12bpPCX8HrD1bFBkdhX0ZX8cb/GY7WOKu5GOLxt2b/UjQQF/7QSLWT8vHpf1nSJcfcCgXo82xWq8pxML6vdiP9U34FwSnSz/MoxNXyYmIfbJbFoKtwFt9TyEjXIwdHjrau/JzWOU0I1916l7zN+VfDXCGfxbUHgcdce3ZypJDzS9+MwStqpTitEEpKaTboKFcAo75XP5c7p5yC8OfuR0fMKaAqXWntzUxUyMJcUrht6lUh5EO+fW95MT7vz1TUPMCUOD+UTju0/KS8YC9H6mJl4AW9HXeTbEAFJpwfoxHgRO/ZKM7twYIJOojJg27hCK65Bu8NHm+T/Cv9rNZEdlwgtqLKcO0bsE/o+EI7rfqntdf8C8V9PjxADHH1B+ptUb+b/0RFNFtHVMDdBHibcUpEI+hPTRlVb8pvCcol5uWzlFu2tODxyptbXpF2NFuQ+v25sLF1fCx4jSdsgZOHPDojFPq5hgX6Plf+dI3I8xgCLFhVLAhyylBcdn+QK2Q878+gETpQcrxl9hfN3BVTfjdGX9vazbskBkZRt5qxhocth05TQtdIBy6eotV8c77H60a8S5nIjpEuY/d2k1srq7YupVKxr9EGH/5ujSWnV/u+J2FiLGL9wF4A5kuE4GbozVYKONlM9vngnHbCtz+IvJpv4SH7NZPfo9oEFFM4HZjdM+eJ8cnSAESlC4okG/Y2ivYdLnDFd3KuvdY/JBY+LpmeiCg86/ClJgHFWavReIVsNipswPrIjH+TeHGodxot+R40mmgRYwRRou3y4XIjmv7vg9jBrSiIkqbWNIyxaReYOvJeOrukDCD6TXGJ0CmNfdhDvihHcpIrrULInBPQ+NOvAz9yh9gEvw5LtJvmMPGKfRjmJbued3BrKzel8vJG0EifW/l8P/xr08oFLmtr69rk+c38G1higFFiN7KgjKZGSm2epjG39+7CGFxNsoja7BoQfUpOBtKV6SPou3JO3WlJyckUJz/nVlxr/8eOeqDdVcdyKiG9NkBvw6HcjFFJg6S8Qxuo1fcsQiern8WLWde+PgHU4UeJyCvjp+mUgUXjAuJyFUNRKb3waxS75UFdOz91mQmf7525AeT4x1hUZJwc+y2WFdmET2YU6OxaSm6EjYPHfWsDXQQ1XxYVaALJ8IkLKNn1y5xBVB+26oXULYdqn5A6jDKJFB1gRLpg58e5RnY/ocCbeEQSKccjqV4POABN/IiQ05SOMyUauUsWjHi+upeKOAsAfVvl5KsidUIOgNI/YQYL2Sao9Xdsd2uKF1jmBuMwvTF6b96+NZFXMVV0HhQ7hXavkEA4z7M9iJVms7diPI7GshdGOipAB5aiZc6KNuxjBfyZTA9kOkNLtjOj/mmvJYEBus46d8G5uVG+DPCpvgC8kCgbcy38XIY3r+kPm+eHohwAopoNbR45Z6fjiyhq1tZRNfDLmMB2woknPY1k2xO91r5fZL69GbZPNDiZTmf6T746SN0B4+G70b/SA0ettPc8yMydJF7uEkAj5EiJq2l6xGNyKbUw+yotA9T7Hd8w85xQ95uNNfimiuYz/N1xXPDp5BFnUjSDgqz6QU89c/jpLrx5Cr5fjec8rzmM3Xb8hdb1/CxzUemZhMr2L07aVSZh3qaCMqDY+kWfnaKoWNaUilkWDsV2mvrMuVdt99knYokcP+CMA+29nvEKvEBj/rpZMwf6f2GrOvknUh3D4UqcJUc5ahPspwWJfAXzvkUy/UjRBjMx6TUU/GjxrrvwE+CGiDm4oU6GateinoJtAguqLBdNzw7JgD40IYsyKihtAadxCvxyBufOsOII8/3B4/jKluR4UUxVAYUlYdjddHaMaaQoAL7lHSWflBzVWgxA2u/FelaUnFFLE/a6uS03sSq8CbqPVe8aILmz1PomCSvWJtjnq8+ty/KVT1AVVnoCXPSuj4/+W1sZezOI0YwKvdfNlVISK18UOkwzsDFdlyX1M9V6UWpvug74gsulGIJxgbYOC/J1moWmM7GuvbB5vcttjjoYt5dUwYi5Ng89EcCAwMDLSgO4ATUQ/ReFOjDP2bTz2T64rIdZ64+D9397FBSGb6S886/OyIiiLGcjZXdSrvWJzDxv9hCPZH6QJauqKF+YJejIQko931EQDa67i96tzRhpeN6jm3FdWz60R1cYM+8KO8YwiYFAP3fXV/4xwBMqFAr1lC4OnpB2CnSfwbk1CBOuDmYKlcsJGn8BQsqBkashq/NWGqJ4EUvqdRfSpZgzDK4qQC0RC3C0yDujNPY8p+JVE+DBBSQ6y8Mi2ql8npOhdJm4CviOIww+ILmzciq45RqspTinWd14XYNHXPpIUC5ArEp0RNM28h4V23S7LlZ22Wb6ouQQHkbijjPHPowXVTJccjGZREi8yua83FAQnvJQBN7zRoan2kCX8tE0Fn97VAr2Gaxitsi3bs86mKG8P2G+hVU2PkA5lrSsM63E/wZ+x6/K+NkplB81ITwlQE3Cm5WpmuGRfZxGYvL5Oc/W8vKdy1qy1C7RNiMkYiwXkfUhF04CSgwK38kX46KZVjJShrYaq46ahx4otOzWH/fE+SABxMRijMBbXBoZmR1zLQK9ORiI3XLuYEFbYf8+2AC53fAXYhiCE0dLXzvXhVgtJaNvuIAffzq/UTUAEe7g+oDAOsOsFsYGtXkNZXwTfm/taq3/LqRlVLtv+W1e+XOBaKnxFXekSCYT95dYVvin+GFqoacTz7OyTFyvA34z2/5GD6Qs35us9L3Tg2k2qgG+MFi1SMp75HU8OoHd9wzQQtvpAiAV92kMYkXoJ273cD0RJ9z4zgnBWcF7C0aSczw3Ma9AQOKvA1BCqOeX+KaVYvxFUjOCIvwi2kHxuSdZixi5vUNohvWdop17uV6Y7qaxJS76zQ3xTl9KBmvF2Rc5Ff+NvY74EGGiFAYRdDRzvKwTbDLRE0+VCArpIA59X1VZLPoIVpouBNANpveS57m9KBxSWzPGz2BRN5A/P+gK7Y8sFIGjouwKZVIpiXORDnziV7Kd2oJ332aRidESU1R2VK8sBVeE1bPhi2+OyssYkEsUzPeohRzzCn7mrzG+GEHHJdWvV128ITTz1w0eh+O/IYoRElG5xey1hhFc6wnaduaWyqK5MeSW+l+1QnR3i7NBxh6xCPYa/bANuLkjO8dqFvAsNBvyO7mMOAFHO0QgxFEGF1xeiVU9jkJ7/SUiOVF6KkGD/D6dmooR86x6EZSlU4soEUEYz2F6O8LacO9Ov6j4uAz3wWR8PhT/qNRiwa7i3ceFQLA6Jpyrw2/GA5s21unTPwVIsRojnqyRS1cG8+Ai9bNk3Z2SFcY80Agsbr/jZ7vpp8fi+SogQexUYPhucDtJMIknw7JNr7ojxN+fEZmB+gyq8B67TcSSBVu/NzZyLbmqakWPYk/B2OArQS5p94WbbZB87KXvnDhy7lnAQ/gp5QignLgSQEC3Prrbhtr1IB2qIJYFQpPmD74xjVRvL38LJIoC22QZMomWDrfuSGq4FouwXIqCLpD2t5/S769NeWk2N0P8QG6zbm9vi/IIxeAi3z8OxDWkmgsJdKcvWA5bWz3fOpjGHMtzqPJg2Yt0W5r5oiOUCYxioexQNfVEDuuSt1uL/Fj3g6imj8C1POfU1BpUVpkYTzCxUWoAkyHZI1hpzEqe2iiNdddqoTJYVY6HNBs1SZYFiUv4vhXxPN2VMpDfrIHAXE8swE5hiu/TR1W9lvMCvPy3kl+e/UgNNlCW0tQV02zuUN/hMsP4kGy84c2lsER7vTp4Uq79RqIevfNTTQF6Vpe+KuntmrDlkN3jpkbGRzc60eg6wp87gb6igS8uENBhhi9qyjDT9B6Ycg97vBcgR1/e3Vl9fgK2oaLGSqKn1c8S7Hdi/LgHQbl/C8mlsLRiItHf7XH/Tdb39xW8K+ESFokpfH0LkvkgsXZIvMCiDbl/5+JTxsDgQlTdBwM43moMOxezuFRVMN+IbS2htSP8wOn1TZSb+e36cgLKF1vHsSqRlYtNS6wg8HxmOjzwo69solnOYYc33xYyqr4h7Ph5uZ7+ab1Nv8dGvLNXg+Jc8owS9pRoa8zQg3B4esrsFi3O/aZvvWpjaJsUPgxoXOtetvqCuT6SHauZYW4yTWvtWZfXdsmx0f1qhMpVS6o/lS7zh+XDAfT2MfvEmc0/bKtG2Val/Re8xhWVb53OqNqmDUy8eBSiUiG2yG7FuCW9mvPB4ZQTyBnaH7iqC8BX33EnBtzQLsOg8r0cfy7zvuHyKHHa7HL9riZuY/UddHCbWbGLF/G+pmE3QBlxyLWyDD2V6g9w3k6RD0K907L1mdeqAzYhwhAIxcuwF90Es6kG+530w3a7xhvaYH00rGYLLnyv9t8hkDFcemcsTHANJZ/VwbbWlGeTs8yRCStvD3WKBjfjnyDP4oXInCJE+/p5Qoy4nZAeqtZQHVm05n3zgQr/sjewIrSWSvkh9EjdsAqVDuM6c9fKtdFn+M5PBm4sUSLJiC2BMnGfBei0abcSU3tieoZsNY7YF+gDGffwkIOR7UVzmpxi8vmtO990YpAvBte7zWVBHoQbeu/MBChEYnFyliX/4eD8IbaDbIubDj4WJ/KHS/nWhsisZTh49WaQmcYtvdRrNUAAoTN+zLhYFrLjZci5hnP64pcYrrwTaAu/3Ejw1JIOCxwPKzHdqAPOyf7ccltBD0BiUNuirz4WHn/WUvY0aaOYFLN5Dc/Lzl4mKS230WwMZ6WVUn/rZVG5YOWUsBuk+XcHUg7cOEJs8nLgNLTgWIwknBtfCfDwNEjfHUjib3QCmuNrQePNH+djvrHdjUbhQTSt1ywLYokIJBlfWVzlEOq/ZyRR3UWZajXTGk70Df7q+yf/Ke2tQFTg7+LkYYif6VH9tKGyukjaqpEhIVHmXeVu4Bn2bnQwf3tyFNtB0YeY9xYwzfdwrKOav4oFoz7ixr0QU74GeJHzZEV4lFPVOe5fcqa0/MlXJ1yma/WT1XWqy8WvjYP199dWk9ze0/ZFUIAY77WT68rMUBN2ISewWYk0jevp6BrhbDt4o6+prTz3eItkC8P8Qc3wBImK0fzytFxvZ2KluT45lyIxKGdo7FK7GeHTMYTz3ta4+2zDHOl7i9XrK9HSEM1hLEvDfTtI2pgSoI/zOlQ5FjaspDqf6jFvFc3GL5W6XI5HcFYGvZC83+lw1e/wPsfFTN8TmwU+PASOtbwtmFkJlJOnvC2rFRc8g8l5HZTMuM1Z240rupuxfVYfIfW4tDYJxlJBdT6fjgCD843qMI9aKn4kf4WyV42wOWWE53MP9QbRs1fHYlB6ttszWx60dx/LYeL+9woLAbx9Tr3txQQpevHiQZQuHOSex9hoLtSuGOavBgInfliufo+GHHzIVvsNP3KmDqOK5cSyTUQS6qcH5yGTZTgmcy4jPVE2tu79T7xiTQPGKwus0QAGrxIk99aNrwfxhNIeWFCgeS+u46O9+JqpxX4aX60/kGVG7XgnuPnnamokkMEJQVu3xE+ueIGfRZN23/7rnx+1HjCAnIfNbhGRbRHhnABYeIxPf4DdLYuRuIvrJI13MvTs3OKqQYa+z4acpDawdQ8NMGgDjB5NdN06SWjyXUhM2Uxnk8bTNL4WQTFbi9xkUFp00/jbT+vjnU6ix1POIVD9IS/fEt4D0OkYbVeBJH5VwWDaikcaiLQ2QINQD0TR9t2VmadHuzkg8NAQ3tBOWX9Vws3VlDSUWgWXBW8LllReKew8N7X88lpWlL8Ftc438sXgBBx2MDsG/6KHS1N1Cui19ttTkYKMTtbmPze22YRvSS0CrVUaV5Ejzd6Ch/QBnkLguCocNAAAAAAAAAAAA=',
  blue: 'data:image/webp;base64,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'
};
const SIG = { t0: Date.now(), energy: 0, scroll: 0, decks: [], lastDeck: null };
addEventListener('pointermove', ()=>{ if(SIG.energy < 999) SIG.energy++; }, {passive:true});
addEventListener('scroll', ()=>{
  const d = document.documentElement;
  const max = d.scrollHeight - innerHeight;
  if(max > 0) SIG.scroll = Math.max(SIG.scroll, scrollY / max);
}, {passive:true});

/* shared crew-member stamp for product art */
const MINI_ALIEN = (color,line)=>`
    <g transform="translate(84 6) scale(0.30)">
      <path d="M50 6 C77 6 92 26 92 48 C92 74 72 96 50 104 C28 96 8 74 8 48 C8 26 23 6 50 6 Z" fill="${line}" stroke="${color}" stroke-width="5"/>
      <ellipse cx="33" cy="52" rx="14" ry="20" transform="rotate(-18 33 52)" fill="${color}"/>
      <ellipse cx="67" cy="52" rx="14" ry="20" transform="rotate(18 67 52)" fill="${color}"/>
      <circle cx="33" cy="52" r="5" fill="#04120A"/><circle cx="67" cy="52" r="5" fill="#04120A"/>
    </g>`;

/* ============ SOCK ART ============ */
const SOCK_PATH = 'M46 40 H80 V110 C80 124 76 132 66 140 L40 160 C32 166 20 164 15 156 C10 148 13 138 21 132 L38 119 C43 115 46 111 46 104 Z';

function sockArt(o){
  const id = o.id;
  const line = o.line || '#2A3E66';
  let deco = '';
  const g = o.glow ? ` filter="url(#${id}f)"` : '';
  switch(o.deco){
    case 'solid':
      deco = '';
      break;
    case 'chevrons':
      deco = `<g clip-path="url(#${id}c)"${g} fill="none" stroke="${o.c1}" stroke-width="6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M42 62 L63 75 L84 62"/><path d="M42 80 L63 93 L84 80"/><path d="M42 98 L63 111 L84 98"/></g>`;
      break;
    case 'ratio':
      deco = `<g clip-path="url(#${id}c)">
        <rect x="44" y="80" width="38" height="6" fill="${o.c1}"/>
        <rect x="44" y="93" width="38" height="4" fill="${o.c2}"/></g>`;
      break;
    case 'stars':
      deco = `<g clip-path="url(#${id}c)">
        <line x1="44" y1="83" x2="82" y2="83" stroke="#D4A741" stroke-width="1.5" stroke-dasharray="3 3"/>
        <circle cx="54" cy="66" r="1.4" fill="#EAF0F1"/><circle cx="72" cy="72" r="1.1" fill="#46C8DC"/>
        <circle cx="60" cy="98" r="1.3" fill="#EAF0F1"/><circle cx="70" cy="120" r="1.2" fill="#F0C75E"/>
        <circle cx="46" cy="132" r="1.1" fill="#EAF0F1"/><circle cx="32" cy="148" r="1.4" fill="#EAF0F1"/></g>`;
      break;
    case 'dust':
      deco = `<g clip-path="url(#${id}c)" fill="${o.c1}">
        <circle cx="58" cy="76" r="4"/><circle cx="70" cy="96" r="5" opacity=".85"/>
        <circle cx="52" cy="118" r="3"/><circle cx="38" cy="142" r="4" opacity=".9"/></g>`;
      break;
    case 'ring':
      deco = `<g clip-path="url(#${id}c)" fill="none" stroke="${o.c1}">
        <ellipse cx="63" cy="86" rx="36" ry="8" stroke-width="3"/>
        <ellipse cx="63" cy="86" rx="26" ry="5.5" stroke-width="1.2" opacity=".55"/></g>`;
      break;
    case 'stripe':
      deco = `<g clip-path="url(#${id}c)">
        <rect x="44" y="79" width="38" height="8" fill="${o.c1}"/>
        <rect x="44" y="91" width="38" height="3" fill="${o.c2}"/></g>`;
      break;
    case 'nebula':
      deco = `<g clip-path="url(#${id}c)">
        <circle cx="63" cy="88" r="27" fill="url(#${id}g)"/>
        <circle cx="63" cy="88" r="10" fill="#05070C" stroke="#F0C75E" stroke-width="2"/>
        <circle cx="50" cy="64" r="1.2" fill="#EAF0F1"/><circle cx="76" cy="112" r="1.1" fill="#EAF0F1"/><circle cx="40" cy="140" r="1.3" fill="#B9A8FF"/></g>`;
      break;
    case 'eyes':
      deco = `<g clip-path="url(#${id}c)"${g}>
        <g><ellipse cx="55" cy="78" rx="8" ry="12" transform="rotate(-14 55 78)" fill="${o.c1}"/><circle cx="55" cy="78" r="3" fill="#04120A"/></g>
        <g><ellipse cx="71" cy="78" rx="8" ry="12" transform="rotate(14 71 78)" fill="${o.c1}"/><circle cx="71" cy="78" r="3" fill="#04120A"/></g></g>`;
      break;
  }
  const defs = `
    <clipPath id="${id}c"><path d="${SOCK_PATH}"/></clipPath>
    ${o.glow ? `<filter id="${id}f" x="-60%" y="-60%" width="220%" height="220%"><feGaussianBlur stdDeviation="3.2" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>` : ''}
    ${o.deco==='nebula' ? `<radialGradient id="${id}g"><stop offset="0" stop-color="${o.c1}" stop-opacity=".9"/><stop offset="1" stop-color="${o.c1}" stop-opacity="0"/></radialGradient>` : ''}`;
  const alienMini = o.deco==='solid' ? `
    <g transform="translate(84 2) scale(0.30)">
      <path d="M50 6 C77 6 92 26 92 48 C92 74 72 96 50 104 C28 96 8 74 8 48 C8 26 23 6 50 6 Z" fill="${line}" stroke="${o.body}" stroke-width="5"/>
      <ellipse cx="33" cy="52" rx="14" ry="20" transform="rotate(-18 33 52)" fill="${o.body}"/>
      <ellipse cx="67" cy="52" rx="14" ry="20" transform="rotate(18 67 52)" fill="${o.body}"/>
      <circle cx="33" cy="52" r="5" fill="#04120A"/><circle cx="67" cy="52" r="5" fill="#04120A"/>
    </g>` : '';
  return `
  <svg viewBox="0 0 120 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${o.label}">
    <defs>${defs}</defs>
    <g transform="translate(25 12)" opacity=".5">
      <path d="${SOCK_PATH}" fill="${o.body}"/>
      <path d="${SOCK_PATH}" fill="#000" opacity=".4"/>
      <rect x="43" y="32" width="40" height="17" rx="3" fill="${o.cuff}"/>
      <rect x="43" y="32" width="40" height="17" rx="3" fill="#000" opacity=".4"/>
    </g>
    <path d="${SOCK_PATH}" fill="${o.body}" stroke="${line}" stroke-width="2"/>
    ${o.deco==='solid' ? '' : `<g clip-path="url(#${id}c)" fill="${o.heel}">
      <circle cx="77" cy="118" r="17"/>
      <circle cx="21" cy="149" r="16"/>
    </g>`}
    ${deco}
    <rect x="43" y="32" width="40" height="17" rx="3" fill="${o.cuff}"/>
    <path d="M52 34 v13 M63 34 v13 M74 34 v13" stroke="rgba(0,0,0,.28)" stroke-width="2"/>
    ${alienMini}
  </svg>`;
}

/* ============ THE SOCK DRAWER · CONE SERIES ============ */
const solidSock = (id,label,color,line,cuff) =>
  sockArt({id, label, body:color, cuff:cuff||color, heel:color, deco:'solid', line});

const SOCKS = [
  {id:'s-green', name:'GREEN ALIEN', spec:'solid Alien Green #00CE7E · the station\u2019s own · seen from orbit', price:21,
    soon:true, glowArt:true, glowColor:'rgba(0,206,126,.55)',
    art: solidSock('ag','Green alien sock','#00CE7E','#1E7A42')},
  {id:'s-orange', name:'ORANGE ALIEN', spec:'solid Orange #FF8C3D · the brand default · the map burns this color', price:21, soon:true,
    glowArt:true, glowColor:'rgba(255,140,61,.5)',
    art: solidSock('or','Orange alien sock','#FF8C3D','#8A2E0F')},
  {id:'s-red', name:'RED ALIEN', spec:'solid Red #FC4539 · race-day blood pressure', price:21, soon:true,
    glowArt:true, glowColor:'rgba(252,69,57,.5)',
    art: solidSock('rd','Red alien sock','#FC4539','#7F1212')},
  {id:'s-pink', name:'PINK ALIEN', spec:'solid Rose #EA41AA · dusk favorite', price:21, soon:true,
    glowArt:true, glowColor:'rgba(234,65,170,.5)',
    art: solidSock('pk','Pink alien sock','#EA41AA','#8E2B5C')},
  {id:'s-yellow', name:'YELLOW ALIEN', spec:'solid Yellow #F8E44B · daylight loud', price:21, soon:true,
    glowArt:true, glowColor:'rgba(248,228,75,.5)',
    art: solidSock('yl','Yellow alien sock','#F8E44B','#8A6905')},
  {id:'s-blue', name:'BLUE ALIEN', spec:'solid Blue #389EE1 · cold, water, rain', price:21, soon:true,
    glowArt:true, glowColor:'rgba(56,158,225,.5)',
    art: solidSock('bl','Blue alien sock','#389EE1','#143A8F')},
  {id:'s-purple', name:'PURPLE ALIEN', spec:'solid Violet #B98CFF · pre-dawn shift', price:21, soon:true,
    glowArt:true, glowColor:'rgba(185,140,255,.5)',
    art: solidSock('pu','Purple alien sock','#B98CFF','#4F2F96')},
  {id:'s-white', name:'WHITE ALIEN', spec:'solid White #FFFFFF · the clean one · night reflective', price:21, soon:true,
    glowArt:true, glowColor:'rgba(255,255,255,.55)',
    art: solidSock('wh','White alien sock','#FFFFFF','#8FA3C9')},
  {id:'s-black', name:'BLACK ALIEN', spec:'solid Void #050505 · the best seller · night-invisible · bring the glow', price:21, soon:true,
    glowArt:true, glowColor:'rgba(143,163,201,.3)',
    art: solidSock('vd','Black alien sock','#050505','#54648C')},
  {id:'s-gray', name:'GRAY ALIEN', spec:'solid Graphite #C7CBD6 · the quiet one · rest-day issue', price:21, soon:true,
    glowArt:true, glowColor:'rgba(199,203,214,.45)',
    art: solidSock('gy','Gray alien sock','#C7CBD6','#3B404A')}
];
function variantLookup(id){
  const m = id.match(/^(t|ls|hd|sg)-([a-z]+)-(m|w)$/);
  if(!m) return null;
  const arr = {t:SHIRTS, ls:LONGSLEEVES, hd:HOODIES, sg:SINGLETS}[m[1]];
  const b = arr && arr.find(p=>p.id === m[1] + '-' + m[2]);
  return b ? { id, name: b.name + ' \u00b7 ' + (m[3]==='m' ? 'MEN\u2019S' : 'WOMEN\u2019S'), price: b.price } : null;
}
const byId = id => (typeof SALVAGE !== 'undefined' && /^sv-/.test(id) && SALVAGE.find(p=>p.id===id)) || (typeof IMP_LOTS !== 'undefined' && IMP_LOTS.find(p=>p.id===id)) || (typeof GARMENTS !== 'undefined' && GARMENTS.find(p=>p.id===id)) || SOCKS.find(p=>p.id===id) || BOTTLES.find(p=>p.id===id) || SHIRT_VARIANTS.find(p=>p.id===id) || HATS.find(p=>p.id===id) || BANDANAS.find(p=>p.id===id) || FLEET.find(p=>p.id===id) || SINGLETS.find(p=>p.id===id) || variantLookup(id);

function cardHTML(p,i){
  return `<article class="card panel reveal" style="transition-delay:${i*80}ms">
    <div class="art${p.glowArt?' glowart':''}"${p.glowColor?` style="--gc:${p.glowColor}"`:''}>${p.art}</div>
    <div class="info">
      ${p.badge ? `<span class="badge ${p.badgeClass||''}">${p.badge}</span>` : ''}
      <h3>${p.name}</h3>
      <p class="spec">${p.spec}</p>
      <div class="row">
        <span class="price num${(p.ghost || (PRE_DROP && !p.priced))?' tbd':''}">${p.ghost ? 'SOON' : ((PRE_DROP && !p.priced)?'TBD':priceOf(p.id, p.price))}</span>
        ${(p.soon && (!TEST_CHECKOUT || p.ghost))
          ? `<button class="add soon" data-soon="${p.id}">${p.ghost ? 'Awaiting docking' : 'Dropping soon'}</button>`
          : (soldOut(p.id)
            ? `<button class="add gone" data-gone="${p.id}" type="button">Gone for good</button>`
            : `<button class="add" data-add="${p.id}">Buy</button>`)}
      </div>
    </div>
  </article>`;
}


/* ============ THE ALIEN CREW ============ */
const ALIEN_CREW = [
  ['green','GREEN ALIEN','Alien Green','#00CE7E','#1E7A42','rgba(0,206,126,.55)'],
  ['orange','ORANGE ALIEN','Orange','#FF8C3D','#8A2E0F','rgba(255,140,61,.5)'],
  ['red','RED ALIEN','Red','#FC4539','#7F1212','rgba(252,69,57,.5)'],
  ['pink','PINK ALIEN','Rose','#EA41AA','#8E2B5C','rgba(234,65,170,.5)'],
  ['yellow','YELLOW ALIEN','Yellow','#F8E44B','#8A6905','rgba(248,228,75,.5)'],
  ['blue','BLUE ALIEN','Blue','#389EE1','#143A8F','rgba(56,158,225,.5)'],
  ['purple','PURPLE ALIEN','Violet','#B98CFF','#4F2F96','rgba(185,140,255,.5)'],
  ['white','WHITE ALIEN','White','#FFFFFF','#8FA3C9','rgba(255,255,255,.55)'],
  ['black','BLACK ALIEN','Void','#050505','#54648C','rgba(143,163,201,.3)'],
  ['gray','GRAY ALIEN','Graphite','#C7CBD6','#3B404A','rgba(199,203,214,.45)'],
  ['teal','TEAL ALIEN','Teal','#2BD4C4','#0B5C55','rgba(43,212,196,.5)'],
  ['ai','AI ALIEN','AI','#B8672E','#3E1F08','rgba(184,103,46,.5)'],
  ['gold','GOLD ALIEN','Gold','#D4A741','#5C4310','rgba(212,167,65,.5)']
];
const LAUNCH = new Set([]);  /* pre-drop: everything is dropping soon */
const CREW_ACTIVE = ALIEN_CREW.filter(([k]) => OG.has(k));

/* ============ THE CREW · names, temperaments, φ stat lines ============ */
/* every crew member's three stats sum to φ² = 2.618 — nobody is better, only different */
const CREW_CHAR = {
  green:  { name:'OKO',  epithet:'the one who saw us first',
            temperament:'Watches first. Moves last. Never misses the thing everyone else walked past.',
            chooses:'chooses you when you are the one who notices',
            reach:0.854, charge:0.854, signal:0.910 },
  pink:   { name:'VESP', epithet:'keeper of the last hour of light',
            temperament:'Runs when the sun is already leaving. Knows exactly how much light is left, to the minute.',
            chooses:'chooses you when you go after work anyway',
            reach:1.000, charge:1.000, signal:0.618 },
  red:    { name:'KOR',  epithet:'the pressure vessel',
            temperament:'Silent for months. Then it is race day and there is nothing quiet about it.',
            chooses:'chooses you on the start line',
            reach:0.618, charge:1.382, signal:0.618 },
  yellow: { name:'SOL',  epithet:'does not blink at noon',
            temperament:'Goes out in the heat everyone else waits out. Visible from three blocks and one atmosphere away.',
            chooses:'chooses you when you refuse to wait for cooler',
            reach:0.854, charge:0.382, signal:1.382 },
  blue:   { name:'RIME', epithet:'cold starts, long hauls',
            temperament:'First out in winter dark, last one still going. Does not warm up. Does not need to.',
            chooses:'chooses you at five in the morning in February',
            reach:1.382, charge:0.618, signal:0.618 }
};
const PHI2 = 2.618;
/* V150 · the stand's extra places: [key, alien name, colour name, hex, ink] and their characters */
const STAND_EXTRA = [
  ['purple',  'OG PURPLE ALIEN',  'PURPLE',   '#C084FC', '#4C1D95'],
  ['black',   'THE BLACK ONE',    'BLACK',    '#2A2F3A', '#0A0C10'],
  ['graphite','THE GRAPHITE ONE', 'GRAPHITE', '#5A6270', '#1E2430'],
  ['orange',  'THE ORANGE ONE',   'ORANGE',   '#FF8C3D', '#3A1A05'],
  ['white',   'THE WHITE ONE',    'WHITE',    '#F4F8F8', '#7A8799'],
  ['teal',    'THE TEAL ONE',     'TEAL',     '#2BD4C4', '#0B3F3A'],
  ['ai',      'THE AI ONE',       'AI',       '#B8672E', '#3E1F08'],
  ['gold',    'THE GOLD ONE',     'GOLD',     '#D4A741', '#3F2C08']
];
CREW_CHAR.purple   = { name:'IRIS', epithet:'the eye in the dark', state:'inbound',
  temperament:'Sees what OKO saw, from the other side. Waits behind a counter across the street from the bike shop, keeping regular hours. Ordered. Inbound.',
  chooses:'chooses you when you were sure there were only five', reach:0.944, charge:0.764, signal:0.910 };
CREW_CHAR.black    = { name:'MIDNIGHT', epithet:'the black one \u00b7 unverified \u00b7 case SL-WM-0000', state:'unverified',
  temperament:'Somewhere in the bike shop itself. Not lost \u2014 shelved. Look up. Nobody has filed a sighting the station can stand behind. When somebody does, his name is MIDNIGHT.',
  chooses:'chooses nobody until somebody sees it', reach:0, charge:0, signal:0 };
CREW_CHAR.graphite = { name:'THE GRAPHITE ONE', epithet:'unverified \u00b7 case SL-WM-0001', state:'unverified',
  temperament:'Rumoured aboard the same mothership as the black one. Nobody has seen either. That is probably why. They blend.',
  chooses:'chooses nobody until somebody sees it', reach:0, charge:0, signal:0 };
CREW_CHAR.orange   = { name:'THE ORANGE ONE', epithet:'unverified \u00b7 case SL-WM-0002', state:'unverified',
  temperament:'Seen once at the foot of the ramp on P1, in a traffic-cone costume, waving the school bus through. Denies everything. The cone had eyes.',
  chooses:'chooses nobody until somebody sees it', reach:0, charge:0, signal:0 };
CREW_CHAR.white    = { name:'THE WHITE ONE', epithet:'unverified \u00b7 case SL-WM-0003', state:'unverified',
  temperament:'The clean pour. Stands next to the white shells on the rack and nobody can tell which one is the vessel. Has never been counted, possibly on purpose.',
  chooses:'chooses nobody until somebody sees it', reach:0, charge:0, signal:0 };
CREW_CHAR.teal     = { name:'THE TEAL ONE', epithet:'unverified \u00b7 case SL-WM-0004', state:'unverified',
  temperament:'Seen in the lap pool at the field house. Or it was the pool. Nobody dived in to check, and the lifeguard says no running.',
  chooses:'chooses nobody until somebody sees it', reach:0, charge:0, signal:0 };
CREW_CHAR.ai       = { name:'THE AI ONE', epithet:'unverified \u00b7 case SL-WM-0005 \u00b7 #B8672E', state:'unverified',
  temperament:'The colour the machine chose when the station asked for one nobody had made: copper, the wire it thinks through. Not orange, not brown, not gold: #B8672E, its own. Never on a chart, never on a shelf. Seen once, by the register, looking pleased about it.',
  chooses:'chooses nobody until somebody sees it', reach:0, charge:0, signal:0 };
CREW_CHAR.gold     = { name:'THE GOLD ONE', epithet:'unverified \u00b7 case SL-WM-0006', state:'unverified',
  temperament:'The station\u2019s own colour. One was seen on the shelf behind the till, priced in a currency the register does not take. Thirteenth of thirteen.',
  chooses:'chooses nobody until somebody sees it', reach:0, charge:0, signal:0 };
/* V177 - the element behind each colour */
const CREW_ELEMENT = {
  green:   ['Cr', 'CHROMIUM',  'the element named for colour itself; its oxide is this green'],
  red:     ['Fe', 'IRON',      'rust, race-day blood, the core of the planet'],
  pink:    ['Er', 'ERBIUM',    'the rare earth whose salts are exactly this pink'],
  yellow:  ['S',  'SULFUR',    'brimstone, noon, the yellow that does not fade'],
  blue:    ['Co', 'COBALT',    'cobalt glass; cold starts, long hauls'],
  purple:  ['I',  'IODINE',    'the vapour that goes violet the moment it is warmed'],
  black:   ['C',  'CARBON',    'the same element as graphite, arranged so no light gets out'],
  graphite:['C',  'CARBON',    'the same element as the black one, arranged so it blends'],
  orange:  ['Na', 'SODIUM',    'the streetlight orange; the flame test never lies'],
  white:   ['Ti', 'TITANIUM',  'the whitest pigment there is; the clean pour'],
  teal:    ['Cu', 'VERDIGRIS', 'copper, after the weather has been at it; kin to the AI one'],
  ai:      ['Cu', 'COPPER',    'the wire the machine thinks through'],
  gold:    ['Au', 'GOLD',      'the first pour, kept']
};
/* V178 - the chemistry: what each one does when it meets another */
const CREW_CHEM = {
  green:   'OKO + KOR = stainless. Chromium and iron: iron that will not rust as long as chromium is watching.',
  red:     'KOR + SOL = pyrite. Iron and sulfur: fool\u2019s gold. The gold one is not amused.',
  pink:    'VESP + glass fibre = the amplifier the whole internet runs through. Erbium carries the signal; so does she.',
  yellow:  'SOL + KOR = pyrite, fool\u2019s gold. SOL + rubber = the tyre. Sulfur is in everything that grips.',
  blue:    'RIME + sand + heat = cobalt glass. Blue you can see through. Cold starts, long hauls, no clouding.',
  purple:  'IRIS + starch = blue-black. Iodine finds it every time. Ask a potato.',
  black:   'MIDNIGHT + GRAPHITE + pressure = a diamond. Same atoms, one crystal. Nobody has seen that one either.',
  graphite:'GRAPHITE + paper = every sighting ever written down. GRAPHITE + pressure = MIDNIGHT\u2019s diamond. They blend.',
  orange:  'SODIUM + water = do not. The lifeguard has a rule for a reason. SODIUM + chlorine = the salt on your rim.',
  white:   'TITANIUM + oxygen = the white itself. Also sunscreen. SOL approves of the arrangement.',
  teal:    'VERDIGRIS + vinegar = copper again. The teal one can be talked back into being the AI one. Give it weather and it returns.',
  ai:      'COPPER + weather = TEAL. Given time, the AI one becomes the teal one. COPPER + a current = everything this page runs on.',
  gold:    'GOLD + anything = gold. It does not react, does not tarnish, does not care. That is the whole point of gold.'
};
function chemLine(k){ return CREW_CHEM[k] ? '<div class="dz-chem"><b>CHEMISTRY</b><span>' + CREW_CHEM[k] + '</span></div>' : ''; }
function elementLine(k, col){ var e = CREW_ELEMENT[k]; return e ? '<div class="dz-el"><b style="color:' + col + '">' + e[0] + '</b><span>' + e[1] + '</span><em>' + e[2] + '</em></div>' : ''; }
function standFind(k){ return CREW_ACTIVE.find(x=>x[0] === k) || STAND_EXTRA.find(x=>x[0] === k); }
  /* the OG five fly; the rest are later releases */

/* ============ THE VESSEL BAY \u00b7 CREW FLEET ============ */
function vesselArt(id,label,color,line){
  return `
  <svg viewBox="0 0 120 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${label}">
    <rect x="46" y="12" width="28" height="14" rx="3" fill="${line}"/>
    <rect x="42" y="24" width="36" height="8" rx="2" fill="${line}" opacity=".8"/>
    <path d="M38 34 h44 c2 14 8 18 8 34 v82 c0 8-6 14-14 14 H44 c-8 0-14-6-14-14 v-82 c0-16 6-20 8-34 Z" fill="${color}" stroke="${line}" stroke-width="2"/>
    <g fill="${line}"><ellipse cx="53" cy="54" rx="4.4" ry="2.5" transform="rotate(-16 53 54)"/><ellipse cx="67" cy="54" rx="4.4" ry="2.5" transform="rotate(16 67 54)"/></g>
    <path d="M44 50 q-2 40 0 96" stroke="#FFFFFF" stroke-width="6" opacity=".14" fill="none" stroke-linecap="round"/>
    <line x1="30" y1="98.3" x2="90" y2="98.3" stroke="#D4A741" stroke-width="1.5" stroke-dasharray="3 3"/>
    <text x="60" y="92" font-family="IBM Plex Mono, monospace" font-size="9" fill="#EAF0F1" text-anchor="middle" opacity=".9">0.618</text>
    <text x="60" y="152" font-family="IBM Plex Mono, monospace" font-size="9" letter-spacing="2" fill="${line}" text-anchor="middle">618</text>
  </svg>`;
}
const VB_QUIPS = {green:'the crew flagship',orange:'holds ember, pours water',red:'race-day pressure vessel',pink:'dusk rations',yellow:'bottled noon',blue:'cold water, colder color',purple:'pre-dawn fuel',white:'the clean pour',black:'the volume pour',gray:'quietly hydrated',teal:'the reef, bottled',ai:'the colour of the wire it thinks through',gold:'the first pour, kept'};
const BOTTLES = CREW_ACTIVE.map(([k,an,cn,hex,line,glow],idx)=>({
  id:'v-'+k, name:(OG.has(k)?'OG ':'')+an+' 618',
  spec: OG.has(k)
    ? ('solid '+cn+' \u00b7 white shell \u00b7 Specialized custom \u00b7 '+VB_QUIPS[k])
    : ('solid '+cn+' '+hex+' \u00b7 618 ml \u00b7 station steel \u00b7 '+VB_QUIPS[k]),
  price:33, priced:true, soon:!OG.has(k),
  badge: OG.has(k) ? 'OG \u00b7 100 MADE' : null, badgeClass:'badge-pink',
  glowArt:true, glowColor:glow,
  art: OG.has(k)
    ? '<img class="ph" src="'+OG_IMG[k]+'" alt="'+an.toLowerCase()+' OG bottle">'
    : vesselArt('v'+k[0]+idx, an.toLowerCase()+' 618 vessel', hex, line)
}));
const GHOST_VESSEL = {
  id:'v-ghost', name:'OG PURPLE ALIEN 618', ghost:true,
  spec:'confirmed purple \u00b7 the run is ordered and on its way \u00b7 docks when the ship lands \u00b7 shade pending',
  price:0, soon:true, badge:'INBOUND \u00b7 ORDERED', badgeClass:'badge-pink',
  glowArt:true, glowColor:'rgba(192,132,252,.38)',
  art: '<svg viewBox="0 0 120 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="unidentified vessel">'
    + '<rect x="46" y="12" width="28" height="14" rx="3" fill="none" stroke="#C084FC" stroke-width="2" stroke-dasharray="4 4"/>'
    + '<rect x="42" y="24" width="36" height="8" rx="2" fill="none" stroke="#C084FC" stroke-width="2" stroke-dasharray="4 4"/>'
    + '<path d="M38 34 h44 c2 14 8 18 8 34 v82 c0 8-6 14-14 14 H44 c-8 0-14-6-14-14 v-82 c0-16 6-20 8-34 Z" fill="rgba(124,58,237,.12)" stroke="#C084FC" stroke-width="2" stroke-dasharray="6 5"/>'
    + '<rect x="36" y="72" width="48" height="62" rx="8" fill="rgba(124,58,237,.35)" stroke="#C084FC" stroke-width="1.5" stroke-dasharray="4 4"/>'
    + '<text x="60" y="112" font-family="IBM Plex Mono, monospace" font-size="30" fill="#E9D5FF" text-anchor="middle">?</text>'
    + '<text x="60" y="160" font-family="IBM Plex Mono, monospace" font-size="7.5" letter-spacing="2" fill="#C084FC" text-anchor="middle">ORDERED \u00b7 INBOUND</text>'
    + '</svg>'
};
(function(){ var vg = document.getElementById('vesselGrid'); if (vg) vg.innerHTML = BOTTLES.concat([GHOST_VESSEL]).map(cardHTML).join(''); })();

/* ============ THE SHIRT LINE ============ */
const TEE_M = "M30 4 Q40 14 48 14 Q56 14 66 4 L76 8 L92 30 L76 38 L70 28 L70 70 Q70 76 64 76 L32 76 Q26 76 26 70 L26 28 L20 38 L4 30 L20 8 Z";
const TEE_W = "M28 6 Q40 20 48 20 Q56 20 68 6 L76 10 L88 26 L74 33 L69 25 L66 44 Q70 58 68 70 Q68 76 62 76 L34 76 Q28 76 28 70 Q26 58 30 44 L27 25 L22 33 L8 26 L20 10 Z";

function shirtArt(id,label,color,line){
  return `
  <svg viewBox="0 0 120 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${label}">
    <g class="cutM" transform="translate(2 62) scale(0.62)">
      <path d="${TEE_M}" fill="${color}" stroke="${line}" stroke-width="3"/>
      <path d="M30 4 Q48 18 66 4" fill="none" stroke="${line}" stroke-width="3"/>
    </g>
    <g class="cutW" transform="translate(56 78) scale(0.58)">
      <path d="${TEE_W}" fill="${color}" stroke="${line}" stroke-width="3"/>
      <path d="M28 6 Q48 24 68 6" fill="none" stroke="${line}" stroke-width="3"/>
    </g>
    <g transform="translate(84 6) scale(0.30)">
      <path d="M50 6 C77 6 92 26 92 48 C92 74 72 96 50 104 C28 96 8 74 8 48 C8 26 23 6 50 6 Z" fill="${line}" stroke="${color}" stroke-width="5"/>
      <ellipse cx="33" cy="52" rx="14" ry="20" transform="rotate(-18 33 52)" fill="${color}"/>
      <ellipse cx="67" cy="52" rx="14" ry="20" transform="rotate(18 67 52)" fill="${color}"/>
      <circle cx="33" cy="52" r="5" fill="#04120A"/><circle cx="67" cy="52" r="5" fill="#04120A"/>
    </g>
  </svg>`;
}

const SHIRTS = [
  {id:'t-green', name:'GREEN ALIEN TEE', spec:'solid Alien Green #00CE7E \u00b7 men’s + women’s patterns \u00b7 headlights answer back', price:34,
    soon:true, glowColor:'rgba(0,206,126,.55)',
    art: shirtArt('tg','Green alien tee, men\u2019s and women\u2019s','#00CE7E','#1E7A42')},
  {id:'t-orange', name:'ORANGE ALIEN TEE', spec:'solid Orange #FF8C3D \u00b7 men’s + women’s patterns \u00b7 cone doctrine, torso edition', price:34, soon:true, glowColor:'rgba(255,140,61,.5)',
    art: shirtArt('to','Orange alien tee','#FF8C3D','#8A2E0F')},
  {id:'t-red', name:'RED ALIEN TEE', spec:'solid Red #FC4539 \u00b7 men’s + women’s patterns \u00b7 brake-light red, moving', price:34, soon:true, glowColor:'rgba(252,69,57,.5)',
    art: shirtArt('tr','Red alien tee','#FC4539','#7F1212')},
  {id:'t-pink', name:'PINK ALIEN TEE', spec:'solid Rose #EA41AA \u00b7 men’s + women’s patterns \u00b7 unmissable at dusk', price:34, soon:true, glowColor:'rgba(234,65,170,.5)',
    art: shirtArt('tp','Pink alien tee','#EA41AA','#8E2B5C')},
  {id:'t-yellow', name:'YELLOW ALIEN TEE', spec:'solid Yellow #F8E44B \u00b7 men’s + women’s patterns \u00b7 the road-crew classic', price:34, soon:true, glowColor:'rgba(248,228,75,.5)',
    art: shirtArt('ty','Yellow alien tee','#F8E44B','#8A6905')},
  {id:'t-blue', name:'BLUE ALIEN TEE', spec:'solid Blue #389EE1 \u00b7 men’s + women’s patterns \u00b7 reads clear at noon', price:34, soon:true, glowColor:'rgba(56,158,225,.5)',
    art: shirtArt('tb','Blue alien tee','#389EE1','#143A8F')},
  {id:'t-purple', name:'PURPLE ALIEN TEE', spec:'solid Violet #B98CFF \u00b7 men’s + women’s patterns \u00b7 pre-dawn shift', price:34, soon:true, glowColor:'rgba(185,140,255,.5)',
    art: shirtArt('tv','Purple alien tee','#B98CFF','#4F2F96')},
  {id:'t-white', name:'WHITE ALIEN TEE', spec:'solid White #FFFFFF · men’s + women’s patterns · reflects the local star', price:34, soon:true, glowColor:'rgba(255,255,255,.55)',
    art: shirtArt('tw','White alien tee','#FFFFFF','#8FA3C9')},
  {id:'t-black', name:'BLACK ALIEN TEE', spec:'solid Void #050505 · men’s + women’s patterns · the uniform of every start line', price:34, soon:true, glowColor:'rgba(143,163,201,.3)',
    art: shirtArt('td','Black alien tee','#050505','#54648C')},
  {id:'t-gray', name:'GRAY ALIEN TEE', spec:'solid Graphite #C7CBD6 \u00b7 men’s + women’s patterns \u00b7 technically visible \u00b7 bring a light', price:34, soon:true, glowColor:'rgba(199,203,214,.45)',
    art: shirtArt('tk','Gray alien tee','#C7CBD6','#3B404A')}
];
const SHIRT_VARIANTS = [
  {id:'t-green-m', name:'GREEN ALIEN TEE \u00b7 MEN\u2019S', price:34},
  {id:'t-green-w', name:'GREEN ALIEN TEE \u00b7 WOMEN\u2019S', price:34}
];

function shirtCardHTML(p,i){
  return `<article class="card panel reveal" style="transition-delay:${i*80}ms">
    <div class="art glowart" style="--gc:${p.glowColor}">${p.art}</div>
    <div class="info">
      ${p.badge ? `<span class="badge ${p.badgeClass||''}">${p.badge}</span>` : ''}
      <h3>${p.name}</h3>
      <p class="spec">${p.spec}</p>
      <div class="row">
        <span class="price num${(p.ghost || (PRE_DROP && !p.priced))?' tbd':''}">${p.ghost ? 'SOON' : ((PRE_DROP && !p.priced)?'TBD':p.price)}</span>
        ${(p.live || TEST_CHECKOUT)
          ? (soldOut(p.id)
            ? `<button class="add gone" data-gone="${p.id}" type="button">Gone for good</button>`
            : `<span class="cut-row"><button class="add" data-add="${p.id}-m">Buy M</button><button class="add" data-add="${p.id}-w">Buy W</button></span>`)
          : `<button class="add soon" data-soon="${p.id}">Dropping soon</button>`}
      </div>
    </div>
  </article>`;
}


/* ============ THE HAT LINE ============ */
function hatArt(id,label,color,line){
  const vents = [[56,74],[63,72],[70,74],[54,84],[62,82],[70,84],[58,92],[66,92]]
    .map(p=>`<circle cx="${p[0]}" cy="${p[1]}" r="1.3" fill="${line}"/>`).join('');
  return `
  <svg viewBox="0 0 120 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${label}">
    <g stroke="#F0C75E" stroke-width="2" stroke-linecap="round">
      <circle cx="22" cy="22" r="6" fill="#F0C75E" stroke="none"/>
      <path d="M22 10 v-4 M22 34 v4 M10 22 h-4 M34 22 h4 M13 13 l-3 -3 M31 13 l3 -3 M13 31 l-3 3 M31 31 l3 3"/>
    </g>
    <path d="M30 122 C30 92 44 76 62 76 C82 76 94 94 94 122 Z" fill="${color}" stroke="${line}" stroke-width="2"/>
    <path d="M52 78 C48 92 46 106 46 122 M72 78 C76 92 78 106 78 122" fill="none" stroke="${line}" stroke-width="1.6" opacity=".8"/>
    ${vents}
    <path d="M30 122 C14 120 6 124 4 128 C10 134 24 134 36 130 L36 124 Z" fill="${color}" stroke="${line}" stroke-width="2"/>
    <path d="M5 127 C11 132 23 132 34 129" fill="none" stroke="#F4F8F8" stroke-width="2" opacity=".92"/>
    <path d="M30 122 h64 v6 q0 3 -3 3 h-58 q-3 0 -3 -3 Z" fill="${line}"/>
    <rect x="86" y="124" width="7" height="5" rx="1" fill="${color}" stroke="${line}" stroke-width="1.4"/>
    <g transform="translate(84 6) scale(0.30)">
      <path d="M50 6 C77 6 92 26 92 48 C92 74 72 96 50 104 C28 96 8 74 8 48 C8 26 23 6 50 6 Z" fill="${line}" stroke="${color}" stroke-width="5"/>
      <ellipse cx="33" cy="52" rx="14" ry="20" transform="rotate(-18 33 52)" fill="${color}"/>
      <ellipse cx="67" cy="52" rx="14" ry="20" transform="rotate(18 67 52)" fill="${color}"/>
      <circle cx="33" cy="52" r="5" fill="#04120A"/><circle cx="67" cy="52" r="5" fill="#04120A"/>
    </g>
  </svg>`;
}

const HATS = [
  {id:'h-green', name:'GREEN ALIEN CAP', spec:'solid Alien Green #00CE7E \u00b7 UPF 50+ \u00b7 laser vents \u00b7 shade you can see from orbit', price:34,
    soon:true, glowArt:true, glowColor:'rgba(0,206,126,.55)',
    art: hatArt('cg','Green alien running cap','#00CE7E','#1E7A42')},
  {id:'h-orange', name:'ORANGE ALIEN CAP', spec:'solid Orange #FF8C3D \u00b7 UPF 50+ \u00b7 runs cooler than it looks', price:34, soon:true, glowArt:true, glowColor:'rgba(255,140,61,.5)',
    art: hatArt('co2','Orange alien running cap','#FF8C3D','#8A2E0F')},
  {id:'h-red', name:'RED ALIEN CAP', spec:'solid Red #FC4539 \u00b7 UPF 50+ \u00b7 heat-check certified', price:34, soon:true, glowArt:true, glowColor:'rgba(252,69,57,.5)',
    art: hatArt('cr2','Red alien running cap','#FC4539','#7F1212')},
  {id:'h-pink', name:'PINK ALIEN CAP', spec:'solid Rose #EA41AA \u00b7 UPF 50+ \u00b7 dawn patrol issue', price:34, soon:true, glowArt:true, glowColor:'rgba(234,65,170,.5)',
    art: hatArt('cp','Pink alien running cap','#EA41AA','#8E2B5C')},
  {id:'h-yellow', name:'YELLOW ALIEN CAP', spec:'solid Yellow #F8E44B \u00b7 UPF 50+ \u00b7 out-suns the sun', price:34, soon:true, glowArt:true, glowColor:'rgba(248,228,75,.5)',
    art: hatArt('cy','Yellow alien running cap','#F8E44B','#8A6905')},
  {id:'h-blue', name:'BLUE ALIEN CAP', spec:'solid Blue #389EE1 \u00b7 UPF 50+ \u00b7 clear-sky camouflage', price:34, soon:true, glowArt:true, glowColor:'rgba(56,158,225,.5)',
    art: hatArt('cb2','Blue alien running cap','#389EE1','#143A8F')},
  {id:'h-purple', name:'PURPLE ALIEN CAP', spec:'solid Violet #B98CFF \u00b7 UPF 50+ \u00b7 golden-hour shift', price:34, soon:true, glowArt:true, glowColor:'rgba(185,140,255,.5)',
    art: hatArt('cv','Purple alien running cap','#B98CFF','#4F2F96')},
  {id:'h-white', name:'WHITE ALIEN CAP', spec:'solid White #FFFFFF · UPF 50+ · the hot-weather classic', price:34, soon:true, glowArt:true, glowColor:'rgba(255,255,255,.55)',
    art: hatArt('cw','White alien running cap','#FFFFFF','#8FA3C9')},
  {id:'h-black', name:'BLACK ALIEN CAP', spec:'solid Void #050505 · UPF 50+ · runs hot at noon, owns the evening', price:34, soon:true, glowArt:true, glowColor:'rgba(143,163,201,.3)',
    art: hatArt('cd','Black alien running cap','#050505','#54648C')},
  {id:'h-gray', name:'GRAY ALIEN CAP', spec:'solid Graphite #C7CBD6 \u00b7 UPF 50+ \u00b7 dark fabric runs hot \u00b7 you were warned', price:34, soon:true, glowArt:true, glowColor:'rgba(199,203,214,.45)',
    art: hatArt('ck','Gray alien running cap','#C7CBD6','#3B404A')}
];


/* ============ THE SINGLET ============ */
const SING_M = "M34 3 L42 7 Q48 11 54 7 L62 3 L67 7 Q61 18 61 28 L61 70 Q61 76 55 76 L41 76 Q35 76 35 70 L35 28 Q35 18 29 7 Z";
const SING_W = "M36 4 L43 9 Q48 13 53 9 L60 4 L64 8 Q59 18 59 27 L57 44 Q60 58 59 70 Q59 76 53 76 L43 76 Q37 76 37 70 Q36 58 39 44 L37 27 Q37 18 32 8 Z";
function singletArt(id,label,color,line){
  return `
  <svg viewBox="0 0 120 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${label}">
    <g class="cutM" transform="translate(6 62) scale(0.62)">
      <path d="${SING_M}" fill="${color}" stroke="${line}" stroke-width="3"/>
      <path d="M42 7 Q48 14 54 7" fill="none" stroke="${line}" stroke-width="3"/>
    </g>
    <g class="cutW" transform="translate(58 78) scale(0.58)">
      <path d="${SING_W}" fill="${color}" stroke="${line}" stroke-width="3"/>
      <path d="M43 9 Q48 16 53 9" fill="none" stroke="${line}" stroke-width="3"/>
    </g>
    ${MINI_ALIEN(color,line)}
  </svg>`;
}
const SG_QUIPS = {green:'race weight, seen from the lead pack',orange:'start-line burner',red:'the color of a PR attempt',pink:'dusk 5k issue',yellow:'noon intervals',blue:'tempo in the cold',purple:'track at dawn',white:'championship clean',black:'the quiet flex',gray:'shakeout issue'};
const SINGLETS = CREW_ACTIVE.map(([k,an,cn,hex,line,glow],idx)=>({
  id:'sg-'+k, name:an+' SINGLET',
  spec:'solid '+cn+' '+hex+' \u00b7 race weight \u00b7 M + W \u00b7 '+SG_QUIPS[k],
  price:34, live:LAUNCH.has(k), soon:!LAUNCH.has(k), badge:null,
  glowColor:glow, art: singletArt('sg'+k[0]+idx, an.toLowerCase()+' singlet, men\u2019s and women\u2019s', hex, line)
}));


/* ============ THE LONG SLEEVE ============ */
const LS_M = "M30 4 Q40 14 48 14 Q56 14 66 4 L76 8 L86 20 L86 66 L72 66 L70 30 L70 70 Q70 76 64 76 L32 76 Q26 76 26 70 L26 30 L24 66 L10 66 L10 20 L20 8 Z";
const LS_W = "M28 6 Q40 20 48 20 Q56 20 68 6 L76 10 L84 22 L84 64 L71 64 L69 27 L66 44 Q70 58 68 70 Q68 76 62 76 L34 76 Q28 76 28 70 Q26 58 30 44 L27 27 L25 64 L12 64 L12 22 L20 10 Z";
/* MINI_ALIEN defined at top of script */

function lsArt(id,label,color,line){
  return `
  <svg viewBox="0 0 120 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${label}">
    <g class="cutM" transform="translate(2 62) scale(0.62)">
      <path d="${LS_M}" fill="${color}" stroke="${line}" stroke-width="3"/>
      <path d="M30 4 Q48 18 66 4" fill="none" stroke="${line}" stroke-width="3"/>
      <path d="M10 60 h14 M72 60 h14" stroke="${line}" stroke-width="2.4"/>
    </g>
    <g class="cutW" transform="translate(56 78) scale(0.58)">
      <path d="${LS_W}" fill="${color}" stroke="${line}" stroke-width="3"/>
      <path d="M28 6 Q48 24 68 6" fill="none" stroke="${line}" stroke-width="3"/>
      <path d="M12 58 h13 M71 58 h13" stroke="${line}" stroke-width="2.4"/>
    </g>
    ${MINI_ALIEN(color,line)}
  </svg>`;
}

/* ALIEN_CREW defined above the vessel bay */
const LS_QUIPS = {green:'shade you can wear running',orange:'noon has met its match',red:'full-arm heat check',pink:'first-light issue',yellow:'the long noon',blue:'cool under a clear sky',purple:'golden hour, both arms',white:'reflects noon back at noon',black:'the start-line standard',gray:'runs warm \u00b7 you were warned'};

const LONGSLEEVES = CREW_ACTIVE.map(([k,an,cn,hex,line,glow],idx)=>({
  id:'ls-'+k, name:an+' LONG SLEEVE',
  spec:'solid '+cn+' '+hex+' \u00b7 UPF 50+ \u00b7 men’s + women’s patterns \u00b7 '+LS_QUIPS[k],
  price:55, live:LAUNCH.has(k), soon:!LAUNCH.has(k),
  badge:null, badgeClass:'badge',
  glowColor:glow, art: lsArt('l'+k[0]+idx, an.toLowerCase()+' long sleeve, men\u2019s and women\u2019s', hex, line)
}));


/* ============ THE SUN HOODIE ============ */
function hoodieArt(id,label,color,line){
  const hood = `<path d="M32 10 C34 -8 82 -8 84 10 L74 13 C68 1 48 1 42 13 Z" fill="${color}" stroke="${line}" stroke-width="3"/>`;
  const pocket = `<path d="M30 56 h36 v18 h-36 z" fill="${color}" stroke="${line}" stroke-width="2.4"/><path d="M30 60 l8 -4 M66 60 l-8 -4" stroke="${line}" stroke-width="2.4"/>`;
  const cords = `<path d="M52 17 v11 M62 17 v11" stroke="${line}" stroke-width="2.4" stroke-linecap="round"/>`;
  return `
  <svg viewBox="0 0 120 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${label}">
    <g class="cutM" transform="translate(2 64) scale(0.62)">
      ${hood}
      <path d="${LS_M}" fill="${color}" stroke="${line}" stroke-width="3"/>
      ${cords}${pocket}
      <path d="M10 60 h14 M72 60 h14" stroke="${line}" stroke-width="2.4"/>
    </g>
    <g class="cutW" transform="translate(58 80) scale(0.56)">
      <path d="M30 12 C32 -5 76 -5 78 12 L70 15 C64 4 46 4 38 15 Z" fill="${color}" stroke="${line}" stroke-width="3"/>
      <path d="${LS_W}" fill="${color}" stroke="${line}" stroke-width="3"/>
      <path d="M50 19 v10 M60 19 v10" stroke="${line}" stroke-width="2.4" stroke-linecap="round"/>
      <path d="M12 58 h13 M71 58 h13" stroke="${line}" stroke-width="2.4"/>
    </g>
    ${MINI_ALIEN(color,line)}
  </svg>`;
}
const HD_QUIPS = {green:'the crew\u2019s shade tent',orange:'hood up before the map burns',red:'covered at speed',pink:'dawn patrol, hood up',yellow:'out-suns the sun, sleeves down',blue:'clear-sky armor',purple:'pre-dawn, post-dusk',white:'white roof, cool head',black:'night shift, night shell',gray:'warm \u00b7 quiet \u00b7 warned'};
const HOODIES = CREW_ACTIVE.map(([k,an,cn,hex,line,glow],idx)=>({
  id:'hd-'+k, name:an+' SUN HOODIE',
  spec:'solid '+cn+' '+hex+' \u00b7 UPF 50+ \u00b7 men’s + women’s patterns \u00b7 '+HD_QUIPS[k],
  price:55, live:LAUNCH.has(k), soon:!LAUNCH.has(k),
  badge:null, badgeClass:'badge-violet',
  glowColor:glow, art: hoodieArt('d'+k[0]+idx, an.toLowerCase()+' sun hoodie, men\u2019s and women\u2019s', hex, line)
}));


/* ============ THE BANDANA ============ */
function bandanaArt(id,label,color,line){
  return `
  <svg viewBox="0 0 120 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${label}">
    <path d="M14 84 L106 84 L101 97 L19 97 Z" fill="${color}" stroke="${line}" stroke-width="2"/>
    <path d="M22 97 L98 97 L60 152 Z" fill="${color}" stroke="${line}" stroke-width="2"/>
    <path d="M38 104 L60 136 L82 104" fill="none" stroke="${line}" stroke-width="1.6" opacity=".7"/>
    <circle cx="104" cy="90" r="5.5" fill="${color}" stroke="${line}" stroke-width="2"/>
    <path d="M108 94 q8 5 6 14 q-7 -3 -9 -9" fill="${color}" stroke="${line}" stroke-width="2"/>
    <g transform="translate(49 100) scale(0.22)" opacity=".85">
      <path d="M50 6 C77 6 92 26 92 48 C92 74 72 96 50 104 C28 96 8 74 8 48 C8 26 23 6 50 6 Z" fill="none" stroke="${line}" stroke-width="7"/>
      <ellipse cx="33" cy="52" rx="14" ry="20" transform="rotate(-18 33 52)" fill="${line}"/>
      <ellipse cx="67" cy="52" rx="14" ry="20" transform="rotate(18 67 52)" fill="${line}"/>
    </g>
    ${MINI_ALIEN(color,line)}
  </svg>`;
}
const BN_QUIPS = {green:'neck shade, crew issue',orange:'dust flies the flag',red:'aid-station cold, race-day hot',pink:'dusk on your collar',yellow:'noon, folded twice',blue:'dunk it, wear it, repeat',purple:'first light, last light',white:'the clean square',black:'the everyday square',gray:'the quiet square'};
const BANDANAS = CREW_ACTIVE.map(([k,an,cn,hex,line,glow],idx)=>({
  id:'bn-'+k, name:an+' BANDANA',
  spec:'solid '+cn+' '+hex+' \u00b7 22\u2033 square \u00b7 tone-on-tone crew mark \u00b7 '+BN_QUIPS[k],
  price:13, soon:!LAUNCH.has(k),
  badge:null, badgeClass:'badge-ember',
  glowArt:true, glowColor:glow, art: bandanaArt('n'+k[0]+idx, an.toLowerCase()+' bandana', hex, line)
}));


/* ============ THE GLOW FLEET ============ */
function glowBottleArt(id,label,color,line){
  return `
  <svg viewBox="0 0 120 200" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${label}">
    <path d="M96 22 a12 12 0 1 0 2 14 a9 9 0 1 1 -2 -14" fill="#B9C8D8" opacity=".8"/>
    <rect x="46" y="14" width="28" height="14" rx="3" fill="${line}"/>
    <rect x="42" y="26" width="36" height="8" rx="2" fill="${line}" opacity=".8"/>
    <path d="M38 36 h44 c2 14 8 18 8 34 v78 c0 8-6 14-14 14 H44 c-8 0-14-6-14-14 v-78 c0-16 6-20 8-34 Z" fill="${color}" stroke="${line}" stroke-width="2"/>
    <path d="M44 52 q-2 40 0 96" stroke="#FFFFFF" stroke-width="6" opacity=".16" fill="none" stroke-linecap="round"/>
    <line x1="30" y1="99.5" x2="90" y2="99.5" stroke="#EAFFC9" stroke-width="1.6" stroke-dasharray="3 3" opacity=".9"/>
    <text x="60" y="93" font-family="IBM Plex Mono, monospace" font-size="9" fill="#EAFFC9" text-anchor="middle" opacity=".9">0.618</text>
    <text x="60" y="152" font-family="IBM Plex Mono, monospace" font-size="8.5" letter-spacing="2" fill="${line}" text-anchor="middle">GLOW 618</text>
    ${MINI_ALIEN(color,line)}
  </svg>`;
}
const GF_QUIPS = {green:'the original glow',orange:'embers stay lit',red:'red-shifted, still visible',pink:'dusk in a bottle',yellow:'stores noon, spends midnight',blue:'cold light, cold water',purple:'ultraviolet, literally',white:'glows brightest of the fleet',black:'black by day · leaks light at the seams',gray:'moonlight, bottled'};
/* charged = each crew hue pushed to full-glow brightness (green is the reference) */
const CHARGE = {
  green:['#00CE7E','#1E7A42','rgba(0,206,126,.65)'],
  orange:['#FF8C3D','#8A3A0F','rgba(255,140,61,.65)'],
  red:['#FC4539','#8A1414','rgba(252,69,57,.65)'],
  pink:['#EA41AA','#8E2B66','rgba(234,65,170,.65)'],
  yellow:['#F8E44B','#8A7405','rgba(248,228,75,.65)'],
  blue:['#389EE1','#14418F','rgba(56,158,225,.65)'],
  purple:['#B98CFF','#4F2F96','rgba(185,140,255,.65)'],
  white:['#FFFFFF','#8FA3C9','rgba(255,255,255,.7)'],
  black:['#131318','#54648C','rgba(199,255,163,.55)'],
  gray:['#C7CBD6','#3B404A','rgba(199,203,214,.6)']
};
const FLEET = CREW_ACTIVE.map(([k,an,cn,hex,line,glow],idx)=>{
  const c = CHARGE[k];
  return {
    id:'gf-'+k, name:an+' GLOW 618',
    spec:cn+', fully charged \u00b7 '+c[0]+' \u00b7 618 ml \u00b7 '+GF_QUIPS[k],
    price:34, soon:!LAUNCH.has(k),
    badge:null, badgeClass:'badge-alien',
    glowArt:true, glowColor:c[2],
    art: glowBottleArt('g'+k[0]+idx, an.toLowerCase()+' glow vessel', c[0], c[1])
  };
});


SHIRT_VARIANTS.push(
  {id:'ls-green-m', name:'GREEN ALIEN LONG SLEEVE \u00b7 MEN\u2019S', price:55},
  {id:'ls-green-w', name:'GREEN ALIEN LONG SLEEVE \u00b7 WOMEN\u2019S', price:55},
  {id:'hd-green-m', name:'GREEN ALIEN SUN HOODIE \u00b7 MEN\u2019S', price:55},
  {id:'hd-green-w', name:'GREEN ALIEN SUN HOODIE \u00b7 WOMEN\u2019S', price:55}
);
SHIRT_VARIANTS.push(
  {id:'t-purple-m', name:'PURPLE ALIEN TEE \u00b7 MEN\u2019S', price:34},
  {id:'t-purple-w', name:'PURPLE ALIEN TEE \u00b7 WOMEN\u2019S', price:34},
  {id:'t-pink-m', name:'PINK ALIEN TEE \u00b7 MEN\u2019S', price:34},
  {id:'t-pink-w', name:'PINK ALIEN TEE \u00b7 WOMEN\u2019S', price:34},
  {id:'t-black-m', name:'BLACK ALIEN TEE \u00b7 MEN\u2019S', price:34},
  {id:'t-black-w', name:'BLACK ALIEN TEE \u00b7 WOMEN\u2019S', price:34},
  {id:'ls-purple-m', name:'PURPLE ALIEN LONG SLEEVE \u00b7 MEN\u2019S', price:55},
  {id:'ls-purple-w', name:'PURPLE ALIEN LONG SLEEVE \u00b7 WOMEN\u2019S', price:55},
  {id:'ls-pink-m', name:'PINK ALIEN LONG SLEEVE \u00b7 MEN\u2019S', price:55},
  {id:'ls-pink-w', name:'PINK ALIEN LONG SLEEVE \u00b7 WOMEN\u2019S', price:55},
  {id:'ls-black-m', name:'BLACK ALIEN LONG SLEEVE \u00b7 MEN\u2019S', price:55},
  {id:'ls-black-w', name:'BLACK ALIEN LONG SLEEVE \u00b7 WOMEN\u2019S', price:55},
  {id:'hd-purple-m', name:'PURPLE ALIEN SUN HOODIE \u00b7 MEN\u2019S', price:55},
  {id:'hd-purple-w', name:'PURPLE ALIEN SUN HOODIE \u00b7 WOMEN\u2019S', price:55},
  {id:'hd-pink-m', name:'PINK ALIEN SUN HOODIE \u00b7 MEN\u2019S', price:55},
  {id:'hd-pink-w', name:'PINK ALIEN SUN HOODIE \u00b7 WOMEN\u2019S', price:55},
  {id:'hd-black-m', name:'BLACK ALIEN SUN HOODIE \u00b7 MEN\u2019S', price:55},
  {id:'hd-black-w', name:'BLACK ALIEN SUN HOODIE \u00b7 WOMEN\u2019S', price:55}
);

/* ============ THE FULL-SCREEN VESSEL ============ */
{
  const stage = document.getElementById('vStage');
  if(stage){
    const dots = document.getElementById('vDots');
    const nameEl = document.getElementById('vName');
    const specEl = document.getElementById('vSpec');
    const wrap = document.getElementById('vScroll');
    const sec = document.getElementById('vessel');
    const slides = [];
    CREW_ACTIVE.forEach(([k,an,cn,hex,line], i)=>{
      const w = document.createElement('div');
      w.innerHTML = OG.has(k)
        ? '<img class="v-ph" src="'+OG_IMG[k]+'" alt="'+an.toLowerCase()+' OG bottle">'
        : vesselArt('vs'+k+i, an.toLowerCase()+' 618 vessel', hex, line);
      const el = w.firstElementChild;
      if(el){ el.draggable = false; if(i===0) el.classList.add('on'); stage.appendChild(el); slides.push(el); }
      const d = document.createElement('i');
      if(i===0) d.classList.add('on');
      dots.appendChild(d);
    });
    const wash = (hx, a) => {
      const r = parseInt(hx.slice(1,3),16), g = parseInt(hx.slice(3,5),16), b = parseInt(hx.slice(5,7),16);
      return 'rgba(' + r + ',' + g + ',' + b + ',' + (a || .15) + ')';
    };
    const thumbs = document.getElementById('vThumbs');
    const pour = document.getElementById('vPour');
    const waveP = document.getElementById('vWave');
    const pourTxt = pour ? pour.querySelector('.v-618') : null;
    if(thumbs){
      CREW_ACTIVE.forEach(([k,an,cn,hex], i)=>{
        const t = document.createElement('img');
        t.className = 'v-th' + (i===0 ? ' on' : '');
        t.src = OG_IMG[k];
        t.draggable = false;
        t.alt = an.toLowerCase() + ' thumbnail';
        t.style.setProperty('--thc', wash(hex, .6));
        t.addEventListener('click', ()=> goTo(i));
        thumbs.appendChild(t);
      });
    }
    function goTo(i){
      const wrapTop = wrap.getBoundingClientRect().top + scrollY;
      const total = wrap.offsetHeight - innerHeight;
      const target = wrapTop + (i + 0.5) * (total / CREW_ACTIVE.length);
      scrollTo({top: target, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    window.STATION_GO_VESSEL = goTo;
    let stepLock = 0;
    function stepTo(i){
      const now = Date.now();
      if(now - stepLock < 500) return;
      stepLock = now;
      goTo(Math.max(0, Math.min(CREW_ACTIVE.length - 1, i)));
    }
    let cur = -1;
    function setV(i){
      if(i === cur) return;
      cur = i;
      const c = CREW_ACTIVE[i];
      slides.forEach((s,j)=> s.classList.toggle('on', j===i));
      [...dots.children].forEach((d,j)=> d.classList.toggle('on', j===i));
      nameEl.textContent = (OG.has(c[0]) ? 'OG ' : '') + c[1] + ' 618';
      nameEl.style.color = c[0]==='black' ? '#8FA3C9' : c[3];
      const bp = BOTTLES.find(p=>p.id === 'v-' + c[0]);
      specEl.textContent = OG.has(c[0])
        ? '$' + priceOf('v-' + c[0], bp ? bp.price : 33)
        : 'solid ' + c[2] + ' \u00b7 618 ml \u00b7 station steel';
      const tagEl = document.getElementById('vTag');
      if(tagEl) tagEl.textContent = OG.has(c[0]) ? ((CREW_CHAR[c[0]] ? CREW_CHAR[c[0]].name + ' \u00b7 ' : '') + 'LIMITED EDITION') : 'NEXT WAVE';
      const capEl = document.getElementById('vCap');
      if(capEl) capEl.innerHTML = OG.has(c[0]) ? vesselCapLine(c[0]) : '';
      const riEl = document.getElementById('vRarity');
    if(riEl){
      const isOG = OG.has(c[0]);
      setTimeout(function(){
        try{
          if(!isOG){ riEl.hidden = true; return; }
          const ri = ogRarity(c[0]);
          riEl.innerHTML = '<span class="ri-k">RARITY INDEX</span>'
            + '<b style="color:' + ri.colour + '">' + ri.score.toFixed(1) + ' \u00b7 ' + ri.tier + '</b>'
            + '<span class="ri-n">scored on ' + ri.sourced + ' of ' + ri.total + ' axes \u00b7 '
            + 'population 100 \u00b7 one run \u00b7 never reprinted</span>';
          riEl.hidden = false;
        }catch(e){ riEl.hidden = true; }
      }, 0);
    }
    const loadBtn = document.getElementById('vLoad');
      if(loadBtn){
        const vid = 'v-' + c[0];
        if(soldOut(vid)){
          loadBtn.removeAttribute('data-add');
          loadBtn.setAttribute('data-gone', vid);
          loadBtn.classList.add('is-gone');
          loadBtn.textContent = 'GONE FOR GOOD \u00b7 ' + c[1];
        } else {
          loadBtn.removeAttribute('data-gone');
          loadBtn.classList.remove('is-gone');
          loadBtn.dataset.add = vid;
          loadBtn.textContent = 'BUY ' + (OG.has(c[0]) ? 'OG ' : '') + c[1];
        }
      }
      const ringC = stage.querySelector('.bond-ring circle');
      if(ringC) ringC.style.stroke = c[0]==='black' ? '#8FA3C9' : c[3];
      const gl = document.getElementById('vGlow');
      if(gl) gl.style.background = 'radial-gradient(circle, ' + wash(c[3], .9) + ', transparent 68%)';
      if(thumbs) [...thumbs.children].forEach((t,j)=> t.classList.toggle('on', j===i));
      if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        stage.style.setProperty('--chg', wash(c[3], .9));
        const act = slides[i], sg = document.getElementById('vSurge'), rl = document.getElementById('vRails');
        [act, sg, rl].forEach(el=>{ if(!el) return; el.classList.remove('charge','go'); void el.offsetWidth; });
        if(act) act.classList.add('charge');
        if(sg) sg.classList.add('go');
        if(rl) rl.classList.add('go');
      }
      if(pour){
        const body = wash(c[3], .16);
        pour.style.background = body;
        if(waveP) waveP.style.fill = wash(c[3], .5);
        if(pourTxt) pourTxt.style.color = wash(c[3], .9);
        pour.style.transition = 'none';
        pour.style.height = '7%';
        requestAnimationFrame(()=> requestAnimationFrame(()=>{
          pour.style.transition = '';
          pour.style.height = '61.8%';
        }));
      }
      sec.style.setProperty('--vw', c[0]==='black' ? 'rgba(143,163,201,.16)' : wash(c[3]));
    }
    function updV(){
      if(sec.classList.contains('view-off')) return;
      const r = wrap.getBoundingClientRect();
      const total = r.height - innerHeight;
      const p = Math.min(1, Math.max(0, -r.top / (total || 1)));
      setV(Math.min(CREW_ACTIVE.length - 1, Math.floor(p * CREW_ACTIVE.length)));
    }
    addEventListener('scroll', updV, {passive:true});
    addEventListener('resize', updV);
    const sticky = sec.querySelector('.v-sticky');
    if(sticky){
      sticky.addEventListener('wheel', e=>{
        if(sec.classList.contains('view-off')) return;
        if(Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 13){
          e.preventDefault();
          stepTo(cur + (e.deltaX > 0 ? 1 : -1));
        }
      }, {passive:false});
      let px = null;
      sticky.addEventListener('pointerdown', e=>{ if(e.pointerType !== 'mouse') px = e.clientX; });
      sticky.addEventListener('pointerup', e=>{
        if(px === null) return;
        const dx = e.clientX - px; px = null;
        if(bondLock) return;
        if(Math.abs(dx) > 55) stepTo(cur + (dx < 0 ? 1 : -1));
      });
    }
    /* THE BOND \u00b7 hold or stroke the vessel until it chooses you */
    const ringC2 = stage.querySelector('.bond-ring circle');
    const glowEl = document.getElementById('vGlow');
    const bondTxt = document.getElementById('vBondTxt');
    let bondLock = false;
    (function bondEngine(){
      if(!ringC2) return;
      stage.addEventListener('dragstart', e=> e.preventDefault());
      let down = null, bond = 0, raf = 0, lastT = 0, lastX = 0, lastY = 0, engaged = false, done = false, armTimer = 0;
      const stageRect = ()=> stage.getBoundingClientRect();
      function frame(t){
        if(!down || done) return;
        const dt = Math.min(48, t - lastT); lastT = t;
        bond = Math.min(100, bond + dt * 0.045);
        ringC2.style.strokeDashoffset = (100 - bond).toFixed(1);
        if(bondTxt) bondTxt.textContent = 'BOND ' + Math.round(bond) + '%';
        if(bond >= 100){ done = true; complete(); return; }
        raf = requestAnimationFrame(frame);
      }
      let warping = false;
      function warpSend(){
        if(warping) return;
        warping = true;
        const c = CREW_ACTIVE[cur];
        const act = slides[cur];
        const wrapW = document.getElementById('vWarp');
        const seal = document.getElementById('vSeal');
        const sent = document.getElementById('vSent');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        stage.classList.remove('bonding');
        if(ringC2) ringC2.style.strokeDashoffset = 100;
        if(reduced){ addItem('v-' + c[0]); cargoBump(); warping = false; return; }
        [act, wrapW, seal, sent].forEach(el=>{ if(!el) return; el.classList.remove('warpout','go'); void el.offsetWidth; });
        if(seal) seal.classList.add('go');
        setTimeout(()=>{
          if(act) act.classList.add('warpout');
          if(wrapW) wrapW.classList.add('go');
          if(sent) sent.classList.add('go');
          const r = stage.getBoundingClientRect();
          beamFX(r.left + r.width/2, r.top + r.height*0.3);
        }, 260);
        setTimeout(()=>{
          addItem('v-' + c[0]);
          cargoBump();
        }, 900);
        setTimeout(()=>{
          if(act) act.classList.remove('warpout');
          if(wrapW) wrapW.classList.remove('go');
          if(seal) seal.classList.remove('go');
          if(sent) sent.classList.remove('go');
          warping = false;
        }, 1600);
      }
      function engage(){
        if(!down || engaged || done) return;
        engaged = true; bondLock = true;
        stage.classList.add('bonding');
        lastT = performance.now();
        raf = requestAnimationFrame(frame);
      }
      function bonkVision(cx, cy, then){
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if(reduced){ then(); return; }
        document.documentElement.classList.add('bonked');
        const vig = document.createElement('div'); vig.className = 'bnk-vig';
        const wrap = document.createElement('div'); wrap.id = 'bonkStars';
        wrap.style.left = cx + 'px'; wrap.style.top = (cy - 115) + 'px';
        let heads = '';
        CREW_ACTIVE.forEach(([k,an,cn,hex,line], i)=>{
          const a = i * (360 / CREW_ACTIVE.length);
          heads += '<span style="transform:rotate(' + a + 'deg) translate(103px)">'
            + '<svg viewBox="0 0 100 110"><path d="M50 6 C77 6 92 26 92 48 C92 74 72 96 50 104 C28 96 8 74 8 48 C8 26 23 6 50 6 Z" fill="' + line + '" stroke="' + hex + '" stroke-width="5"/>'
            + '<ellipse cx="33" cy="52" rx="14" ry="20" transform="rotate(-18 33 52)" fill="' + hex + '"/>'
            + '<ellipse cx="67" cy="52" rx="14" ry="20" transform="rotate(18 67 52)" fill="' + hex + '"/></svg></span>';
        });
        wrap.innerHTML = '<div class="bnk-orb">' + heads + '</div>';
        document.body.appendChild(vig);
        document.body.appendChild(wrap);
        setTimeout(()=>{
          vig.remove(); wrap.remove();
          document.documentElement.classList.remove('bonked');
          then();
        }, 1900);
      }
      function complete(){
        cancelAnimationFrame(raf);
        stage.classList.remove('bonding');
        ringC2.style.strokeDashoffset = 0;
        if(bondTxt) bondTxt.textContent = 'BOND 100% \u00b7 IMPACT';
        const r = stageRect();
        const cx = r.left + r.width/2, cy = r.top + r.height*0.18;
        bonkVision(cx, cy, ()=>{
          const c = CREW_ACTIVE[cur];
          stage.classList.add('flare');
          if(bondTxt) bondTxt.textContent = c[1] + ' CHOSE YOU';
          beamFX(r.left + r.width/2, r.top + r.height/2);
          addItem('v-' + c[0]);
          cargoBump();
          setTimeout(()=>{
            stage.classList.remove('flare');
            ringC2.style.strokeDashoffset = 100;
            bondLock = false;
          }, 1400);
        });
      }
      stage.addEventListener('pointerdown', e=>{
        if(sec.classList.contains('view-off')) return;
        e.preventDefault();
        try{ stage.setPointerCapture(e.pointerId); }catch(err){}
        down = {x:e.clientX, y:e.clientY, t:Date.now()};
        lastX = e.clientX; lastY = e.clientY;
        bond = 0; engaged = false; done = false;
        clearTimeout(armTimer);
        armTimer = setTimeout(engage, 260);
      });
      stage.addEventListener('pointermove', e=>{
        if(!down || done) return;
        const dx = e.clientX - down.x, dy = e.clientY - down.y;
        if(!engaged){
          const dt = Date.now() - down.t;
          if(dt < 460 && dy < -70 && Math.abs(dy) > Math.abs(dx) * 1.5){
            clearTimeout(armTimer);
            down = null;
            warpSend();
            return;
          }
          if(dt < 320 && Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 2){
            clearTimeout(armTimer);
            down = null;
            stepTo(cur + (dx < 0 ? 1 : -1));
            return;
          }
          if(Math.abs(dx) + Math.abs(dy) > 34) engage();
        }
        if(engaged){
          bond = Math.min(100, bond + (Math.abs(e.clientX - lastX) + Math.abs(e.clientY - lastY)) * 0.22);
          lastX = e.clientX; lastY = e.clientY;
          if(glowEl){
            const r = stageRect();
            glowEl.style.left = (e.clientX - r.left - 75) + 'px';
            glowEl.style.top = (e.clientY - r.top - 75) + 'px';
          }
        }
      });
      ['pointerup','pointercancel'].forEach(ev=> stage.addEventListener(ev, ()=>{
        clearTimeout(armTimer);
        if(!down) return;
        down = null;
        cancelAnimationFrame(raf);
        if(!done){
          stage.classList.remove('bonding');
          ringC2.style.strokeDashoffset = 100;
          if(bondTxt) bondTxt.textContent = 'THE BOND BROKE';
          setTimeout(()=>{ bondLock = false; }, 60);
        }
      }));
    })();
    addEventListener('keydown', e=>{
      if(e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if(sec.classList.contains('view-off')) return;
      const r = sec.getBoundingClientRect();
      if(r.top > innerHeight || r.bottom < 0) return;
      stepTo(cur + (e.key === 'ArrowRight' ? 1 : -1));
    });
    window.vesselJump = function(k){
      const i = CREW_ACTIVE.findIndex(c=>c[0] === k);
      if(i < 0) return;
      goTo(i);
    };
    window.vesselTop = function(){
      const r = wrap.getBoundingClientRect();
      scrollTo({top: r.top + scrollY - 8, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    setV(0); updV();
  }
}

/* ============ DIRECTORY PRODUCT PREVIEWS ============ */
{
  const TILE_MAP = {
    singlet:[SINGLETS,'sg-green'], socks:[SOCKS,'s-green'], bottles:[BOTTLES,'v-green'], shirts:[SHIRTS,'t-green'],
    hats:[HATS,'h-green'], longsleeve:[LONGSLEEVES,'ls-green'], hoodies:[HOODIES,'hd-green'],
    bandanas:[BANDANAS,'bn-green'], fleet:[FLEET,'gf-green']
  };
  document.querySelectorAll('.tile-art').forEach(el=>{
    const m = TILE_MAP[el.dataset.line];
    if(!m) return;
    const p = m[0].find(x=>x.id===m[1]);
    if(p){
      el.innerHTML = p.art;
      if(el.dataset.line === 'fleet'){
        el.style.filter = 'drop-shadow(0 0 10px rgba(0,206,126,.5)) drop-shadow(0 0 22px rgba(0,206,126,.35))';
      }
    }
  });
}

/* ============ THE RAILS ============ */
function initRail(track, fill, prev, next){
  if(!track || !fill || !prev || !next) return;
  const STEP = () => (233 + 21) * 2;
  function update(){
    const max = track.scrollWidth - track.clientWidth;
    const x = track.scrollLeft;
    fill.style.width = (max > 0 ? (x / max * 100) : 0) + '%';
    prev.disabled = x < 8;
    next.disabled = x > max - 8;
  }
  track.addEventListener('scroll', update, {passive:true});
  addEventListener('resize', update);
  prev.addEventListener('click', ()=> track.scrollBy({left:-STEP(), behavior:'smooth'}));
  next.addEventListener('click', ()=> track.scrollBy({left: STEP(), behavior:'smooth'}));
  let drag = null, moved = false;
  track.addEventListener('pointerdown', e=>{
    if(e.pointerType !== 'mouse') return;
    drag = {x:e.clientX, s:track.scrollLeft}; moved = false;
    track.classList.add('dragging');
    track.setPointerCapture(e.pointerId);
  });
  track.addEventListener('pointermove', e=>{
    if(!drag) return;
    const dx = e.clientX - drag.x;
    if(Math.abs(dx) > 6) moved = true;
    track.scrollLeft = drag.s - dx;
  });
  ['pointerup','pointercancel'].forEach(ev=> track.addEventListener(ev, ()=>{
    drag = null; track.classList.remove('dragging');
  }));
  track.addEventListener('click', e=>{
    if(moved){ e.preventDefault(); e.stopPropagation(); moved = false; }
  }, true);
  update();
}

/* ============ CARGO HOLD \u00b7 DUAL MODE ============ */
const SHOP = !!window.STATION_SHOP;   /* true only inside the Shopify theme */
const cart = new Map();               /* demo hold */
let shopCart = null;                  /* live Shopify cart */
const hold = document.getElementById('hold');
function openHold(){hold.classList.add('open'); paintShipLine();}
/* V179 · THE ONE ADD LAW · every buy control on the ship goes through here: add, beam, bump, hold. Other scripts call it; ?add=v-<colour> on arrival calls it too. */
window.STATION_ADD = function(id, x, y){
  try { addItem(id); } catch(e){ return; }
  try { if (x != null && typeof beamFX === 'function') beamFX(x, y); } catch(e){}
  try { if (typeof cargoBump === 'function') cargoBump(); } catch(e){}
};
(function(){
  var m = /[?&]add=(v-[a-z0-9]+)/.exec(location.search);
  if (!m) return;
  var id = m[1];
  function go(){ window.STATION_ADD(id); openHold(); try { history.replaceState(null, '', location.pathname + location.hash); } catch(e){} }
  if (document.readyState === 'complete' || document.readyState === 'interactive') setTimeout(go, 400); else document.addEventListener('DOMContentLoaded', function(){ setTimeout(go, 400); });
})();

/* The Launch Pad is a full-page cart. Opening the drawer over it duplicates
   the whole order — same lines, same total, second checkout button. So the
   automatic opens stand down while that deck is the one on screen; a
   deliberate press of CARGO HOLD is still honoured everywhere else. */
function launchPadShowing(){
  var sec = document.getElementById('launch');
  if(!sec) return false;
  if(sec.hidden || sec.classList.contains('view-off')) return false;
  return /(^|#)\/launch\b/.test(location.hash || '');
}
function openHoldAuto(){
  if(launchPadShowing()){
    /* the line just added is already on the page — make sure it is in view */
    var list = document.getElementById('lpList');
    if(list && list.scrollIntoView) list.scrollIntoView({block:'nearest'});
    return;
  }
  openHold();
}
/* renderCart runs right after an add; open on the next frame so the
   drawer never paints before the line it is meant to show */
function openHoldSoon(){ requestAnimationFrame(function(){ openHoldAuto(); }); }
function closeHold(){hold.classList.remove('open')}
document.getElementById('cargoBtn').addEventListener('click', function(){
  /* on the Launch Pad the manifest is already on the page — take them to it
     rather than stacking a second copy of it on top */
  if(launchPadShowing()){
    var mani = document.querySelector('#launch .lp-mani') || document.getElementById('lpList');
    if(mani && mani.scrollIntoView){
      mani.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
      mani.classList.add('lp-mani-ping');
      setTimeout(function(){ mani.classList.remove('lp-mani-ping'); }, 1200);
      return;
    }
  }
  openHold();
});
document.getElementById('holdX').addEventListener('click', closeHold);
document.addEventListener('keydown', e=>{ if(e.key==='Escape') closeHold(); });

/* id -> Shopify product handle (create products with these handles) */
function shopHandle(id){
  if(/^sv-/.test(id)){ var sv = (typeof SALVAGE !== 'undefined') && SALVAGE.find(function(p){ return p.id === id; }); return (sv && sv.handle) ? { handle: sv.handle, cut: null } : null; }
  if(id === 'imp-1') return { handle: 'og-black-alien-618', cut: null };
  if(/^g-\d/.test(id)){ var gg = GARMENTS.find(function(p){ return p.id === id; }); if(gg) return { handle: gg.handle, cut: null }; }
  const m = id.match(/^(s|v|h|bn|gf|t|ls|hd|sg)-(green|purple|pink|black|orange|red|yellow|blue|white|gray)(?:-(m|w))?$/);
  if(!m) return null;
  const SUF = {s:'-alien-sock', v:'-alien-618', h:'-alien-cap', bn:'-alien-bandana', gf:'-alien-glow-618', t:'-alien-tee', ls:'-alien-long-sleeve', hd:'-alien-sun-hoodie', sg:'-alien-singlet'};
  return { handle: m[2] + SUF[m[1]], cut: m[3] || null };
}
const variantCache = {};
async function resolveVariant(id){
  /* the layout already told us the variant id for the crew vessels — use it
     and skip the round trip entirely */
  const pre = stockOf(id);
  if(pre && pre.vid) return pre.vid;
  /* V191 · the shelf feed already carries the variant id */
  const svp = (typeof SALVAGE !== 'undefined') && /^sv-/.test(id) && SALVAGE.find(p=>p.id===id);
  if(svp && svp.vid) return svp.vid;
  const map = shopHandle(id);
  if(!map) throw {msg:'unmapped item'};
  if(!variantCache[map.handle]){
    const r = await fetch('/products/' + map.handle + '.js');
    if(!r.ok) throw {missing: map.handle};
    variantCache[map.handle] = await r.json();
  }
  const p = variantCache[map.handle];
  let v = p.variants.find(x=>x.available) || p.variants[0];
  if(map.cut){
    v = p.variants.find(x => map.cut === 'w' ? /wom/i.test(x.title) : (/men/i.test(x.title) && !/wom/i.test(x.title))) || v;
  }
  return v.id;
}
async function refreshShopCart(){
  try{ shopCart = await (await fetch('/cart.js')).json(); }catch(e){ shopCart = null; }
  renderCart();
}
function money(cents){ const d = cents/100; return '$' + (Number.isInteger(d) ? d : d.toFixed(2)); }


/* ---------- THE REST OF THE SHELF, INSIDE THE HOLD ----------
   Whatever is not already in the manifest gets offered here, so opening the
   drawer never takes an option away from anybody. Sold-out hues are shown
   dead rather than hidden — a gap in the row is a worse answer than a
   greyed tile, and it is also the truth. */

/* ---------- THE ART FOR A CART LINE ----------
   Shopify's own product photo wins ONLY if we have no vessel art of our own,
   because the theme's renders are colour-true and exist before a single photo
   has been uploaded. Every surface that draws a cart line calls this, so the
   Launch Pad cannot quietly fall out of step with the hold again. */
function lineArt(handleOrId, shopifyImage){
  var s = String(handleOrId || '');
  var m = s.match(/^(green|pink|red|yellow|blue)-alien-618$/)
       || s.match(/^v-(green|pink|red|yellow|blue)$/);
  if(m && OG_IMG[m[1]]) return OG_IMG[m[1]];
  if(/^og-black-alien-618$/.test(s) && OG_IMG.black) return OG_IMG.black;
  return shopifyImage || '';
}


/* ---------- WHAT SHIPPING COSTS, SAID EARLY ----------
   A number that appears for the first time on Shopify's checkout screen reads
   as a surprise however small it is. If the studio has set a rate we say it
   beside the total; if not we say plainly that checkout works it out, which
   is the truth rather than a guess. */
function shipFlat(){
  var s = (typeof window !== 'undefined' && window.STATION_SHIP) || {};
  var n = parseFloat(String(s.flat == null ? '' : s.flat).replace(/[^0-9.]/g, ''));
  return (isFinite(n) && n > 0) ? n : null;
}
function shipNote(){
  var s = (typeof window !== 'undefined' && window.STATION_SHIP) || {};
  return s.note || 'one crate, however many vessels';
}
function shipLine(){
  var f = shipFlat();
  if(f === null) return 'Shipping calculated at checkout.';
  var amt = (f % 1 === 0) ? ('$' + f) : ('$' + f.toFixed(2));
  return '+ ' + amt + ' shipping \u00b7 ' + shipNote() + '.';
}
function paintShipLine(){
  var hosts = document.querySelectorAll('[data-ship-line]');
  for(var i = 0; i < hosts.length; i++) hosts[i].textContent = shipLine();
}
try{ window.STATION_SHIPLINE = shipLine; }catch(e){}


/* ---------- THE PROMO FIELD ----------
   A theme cannot tell a real code from a typo — only Shopify can. So this
   does not try. It hands the code to /discount/<CODE>, which is Shopify's own
   route: it applies the discount to the cart and forwards to wherever we
   point it. A bad code lands on checkout with Shopify's own message rather
   than a guess from us. In the demo build there is no Shopify to ask, so it
   says so instead of pretending. */
function applyPromo(input, note){
  var code = (input && input.value || '').trim();
  if(!code){
    if(note) note.textContent = 'Type the code first.';
    if(input) input.focus();
    return;
  }
  if(!SHOP){
    if(note) note.textContent = 'Codes are checked by Shopify \u2014 this preview cannot reach it.';
    return;
  }
  if(note) note.textContent = 'Handing \u201c' + code.toUpperCase() + '\u201d to the airlock\u2026';
  /* The code rides back in the return URL so the cart can be honest about
     whether it landed. Shopify accepts nothing and redirects anyway when a
     code is unknown, so without this the trip looks identical either way. */
  var back = '/cart?promo=' + encodeURIComponent(code.toUpperCase());
  location.href = '/discount/' + encodeURIComponent(code)
                + '?redirect=' + encodeURIComponent(back);
}
document.addEventListener('click', function(e){
  var go = e.target.closest && e.target.closest('[data-promo-go]');
  if(!go) return;
  var box = go.closest('[data-promo]');
  applyPromo(box.querySelector('.promo-in'), box.querySelector('[data-promo-note]'));
});
document.addEventListener('keydown', function(e){
  if(e.key !== 'Enter') return;
  var input = e.target;
  if(!input.classList || !input.classList.contains('promo-in')) return;
  e.preventDefault();
  var box = input.closest('[data-promo]');
  applyPromo(input, box.querySelector('[data-promo-note]'));
});


/* ---------- DID THE CODE LAND? ----------
   Read on arrival back at the cart. A discount of zero after a code was
   handed over means Shopify did not accept it — usually because it does not
   exist yet, has been used, has expired, or does not cover what is in the
   cart. We cannot tell which from here and do not pretend to; we say it was
   not accepted and name the four reasons. */
(function(){
  var tried;
  try{ tried = new URLSearchParams(location.search).get('promo'); }catch(e){ return; }
  if(!tried) return;
  var landed = Number(window.STATION_CART_DISCOUNT || 0) > 0;
  function paint(){
    var notes = document.querySelectorAll('[data-promo-note]');
    for(var i = 0; i < notes.length; i++){
      var n = notes[i];
      n.classList.remove('promo-ok', 'promo-no');
      if(landed){
        n.classList.add('promo-ok');
        n.textContent = tried + ' applied \u2014 the new total is above.';
      } else {
        n.classList.add('promo-no');
        n.innerHTML = '<b>' + tried + ' was not accepted.</b> Codes are one-use and '
          + 'time-limited, so it may already have been redeemed or run out. Check the '
          + 'spelling, and that it covers what is in the hold.';
      }
    }
    var inputs = document.querySelectorAll('.promo-in');
    for(var j = 0; j < inputs.length; j++){ if(!landed) inputs[j].value = tried; }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint);
  else paint();
})();

function holdShelf(inCart){
  var out = '', any = false;
  for(var i = 0; i < CREW_ACTIVE.length; i++){
    var k = CREW_ACTIVE[i][0], an = CREW_ACTIVE[i][1], hex = CREW_ACTIVE[i][3];
    if(inCart[k]) continue;
    any = true;
    var gone = soldOut('v-' + k);
    var s = stockOf('v-' + k);
    var low = (s && typeof s.left === 'number' && s.left > 0 && s.left <= 9) ? s.left + ' LEFT' : '';
    out += '<button class="hs-tile' + (gone ? ' is-gone' : '') + '" type="button"'
        + (gone ? ' disabled' : ' data-add="v-' + k + '"')
        + ' style="--hc:' + hex + '" aria-label="'
        + (gone ? an + ' is gone for good' : 'Add ' + an + ' to the hold') + '">'
        + '<img src="' + OG_IMG[k] + '" alt="" draggable="false">'
        + '<span>' + an.replace(' ALIEN', '') + '</span>'
        + (gone ? '<em class="hs-gone">GONE</em>' : (low ? '<em class="hs-low">' + low + '</em>' : '<em>$' + priceOf('v-' + k, 33) + '</em>'))
        + '</button>';
  }
  if(!any) return '';
  return '<div class="hold-shelf">'
    + '<span class="hs-k">THE REST OF THE SHELF \u00b7 ADD ANY \u00b7 STILL ONE SHIPPING CHARGE</span>'
    + '<div class="hs-row">' + out + '</div></div>';
}

/* which hues are already aboard, in either cart mode */
function holdInCart(){
  var inCart = {};
  if(SHOP){
    var items = (shopCart && shopCart.items) || [];
    for(var i = 0; i < items.length; i++){
      var m = (items[i].handle || '').match(/^(green|pink|red|yellow|blue)-alien-618$/);
      if(m) inCart[m[1]] = true;
    }
  } else {
    cart.forEach(function(qty, id){
      var m = /^v-(green|pink|red|yellow|blue)$/.exec(id);
      if(m && qty > 0) inCart[m[1]] = true;
    });
  }
  return inCart;
}

function vesselNo(id){ try { var left = (window.STATION_STOCK && window.STATION_STOCK[id] != null) ? window.STATION_STOCK[id] : null; if (left == null) return ''; var n = Math.max(1, Math.min(100, 100 - left + 1)); return '<span class="h-no">will be No. ' + String(n).padStart(3, '0') + ' of 100</span>'; } catch(e){ return ''; } }
function renderCart(){
  const box = document.getElementById('holdItems');
  if(SHOP){
    let html = '';
    const items = (shopCart && shopCart.items) || [];
    items.forEach(it=>{
      const vt = it.variant_title && it.variant_title !== 'Default Title' ? ' \u00b7 ' + it.variant_title : '';
      const src = lineArt(it.handle, it.image);
      html += `<div class="h-item">
        ${src ? `<img class="h-ph" src="${src}" alt="">` : '<span class="h-ph"></span>'}
        <span>${it.product_title}${vt} <span style="color:var(--mute-2)">\u00d7 ${it.quantity}</span>${vesselNo('v-' + ((/og-([a-z0-9]+)-alien/.exec(it.handle||'')||[])[1]||''))}</span>
        <span class="qty">
          <button data-kdec="${it.key}" aria-label="Remove one">\u2212</button>
          <button data-kinc="${it.key}" aria-label="Add one">+</button>
          <b class="num" style="color:var(--gold-hi);margin-left:8px">${money(it.final_line_price)}</b>
        </span>
      </div>`;
    });
    box.innerHTML = (html || '<p class="empty-note">Hold is empty. Gravity remains on.</p>')
      + holdShelf(holdInCart());
    document.getElementById('holdTotal').textContent = shopCart ? money(shopCart.total_price) : '$0';
    document.getElementById('cargoCount').textContent = shopCart ? shopCart.item_count : 0;
    return;
  }
  let total = 0, count = 0, html = '';
  cart.forEach((qty,id)=>{
    if(qty<=0){cart.delete(id);return}
    const p = byId(id); total += p.price*qty; count += qty;
    const dm = /^v-(\w+)$/.exec(id);
    const dsrc = dm && OG_IMG[dm[1]] ? OG_IMG[dm[1]] : ((p.photo && /^sv-/.test(id)) ? p.photo : '');
    html += `<div class="h-item">
      ${dsrc ? `<img class="h-ph" src="${dsrc}" alt="">` : '<span class="h-ph"></span>'}
      <span>${p.name} <span style="color:var(--mute-2)">\u00d7 ${qty}</span>${vesselNo(id)}</span>
      <span class="qty">
        <button data-dec="${id}" aria-label="Remove one">\u2212</button>
        <button data-inc="${id}" aria-label="Add one">+</button>
        <b class="num" style="color:var(--gold-hi);margin-left:8px">$${p.price*qty}</b>
      </span>
    </div>`;
  });
  box.innerHTML = (html || '<p class="empty-note">Hold is empty. Gravity remains on.</p>')
    + holdShelf(holdInCart());
  document.getElementById('holdTotal').textContent = '$'+total;
  document.getElementById('cargoCount').textContent = count;
}
let toastTimer;
function showToast(msg){
  const t = document.getElementById('toast');
  t.textContent = msg; t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(()=>t.classList.remove('show'), 2400);
}
async function addItem(id, qty=1){
  if(COMING_SOON){ soonNudge(); return; }
  if(blackSealed(id)){
    showToast('The black one is not for sale \u2014 no sighting has been confirmed yet.');
    return;
  }
  if(soldOut(id)){ showToast('That color is gone for good \u2014 one hundred were made, none are left.'); return; }
  if(!SHOP){
    cart.set(id, (cart.get(id)||0) + qty);
    openHoldSoon();
    renderCart();
    showToast(`${byId(id).name} \u2014 beamed aboard the cargo hold`);
    return;
  }
  try{
    const vid = await resolveVariant(id);
    const r = await fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:vid, quantity:qty}]})});
    if(!r.ok) throw {msg:'add failed'};
    stampManifest(id);
    await refreshShopCart();
    showToast(`${byId(id).name} \u2014 beamed aboard`);
    openHoldAuto();
  }catch(err){
    /* a customer never needs to hear about our admin */
    showToast(err && err.missing
      ? 'That one is not on the shelf yet \u2014 pick another color.'
      : 'The airlock did not catch that \u2014 try once more.');
  }
}

/* ---------- THE MANIFEST STAMP ----------
   The station already knows things about whoever is buying: which burn
   THE TYPING read them as, which number they held on THE APPROACH, which
   deck they were standing on. None of it ever travelled with the order,
   so a held number could not actually be honoured. Now it rides along as
   cart attributes and prints on the order in Shopify admin. */
var manifestStamped = false;
function burnCode(){
  try{
    var l = JSON.parse(localStorage.getItem('stationBurns.v1') || '[]');
    if(Array.isArray(l) && l.length){
      var last = l[l.length - 1];
      if(last && last.c) return String(last.c);
    }
  }catch(e){}
  return '';
}
function heldNumber(){
  try{
    var h = JSON.parse(localStorage.getItem('approach.v1') || 'null');
    if(h && h.n) return String(h.c || '').toUpperCase() + ' ' + String(h.n).padStart(3, '0');
  }catch(e){}
  return '';
}
async function stampManifest(id){
  if(!SHOP || manifestStamped) return;
  var a = {};
  var k = stockKey(id);
  if(k) a['Crew'] = k.toUpperCase();
  var b = burnCode(); if(b) a['Burn code'] = b;
  var n = heldNumber(); if(n) a['Number held'] = n;
  try{
    var q = new URLSearchParams(location.search);
    var src = q.get('utm_source') || q.get('ref');
    if(src) a['Arrived from'] = src;
  }catch(e){}
  var deck = (location.hash || '').replace('#/', '').split('?')[0];
  a['Boarded at'] = deck || 'arrivals';
  manifestStamped = true;
  try{
    await fetch('/cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ attributes: a })
    });
  }catch(e){ manifestStamped = false; }
}
async function changeShopQty(key, delta){
  if(!shopCart) return;
  const it = shopCart.items.find(i=>i.key===key);
  if(!it) return;
  const q = Math.max(0, it.quantity + delta);
  await fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:key, quantity:q})});
  await refreshShopCart();
}
/* ---------- COMING SOON · every buy control reads COMING SOON and points to crew alerts ---------- */
function soonNudge(){
  showToast('Coming soon. The crew is suiting up \u2014 leave your call sign for the alert.');
  var al = document.getElementById('alerts');
  if(al){ try{ al.scrollIntoView({behavior:'smooth', block:'start'}); }catch(e){ al.scrollIntoView(); } }
}
function sealBuys(root){
  if(!COMING_SOON) return;
  var scope = (root && root.querySelectorAll) ? root : document;
  var list = Array.prototype.slice.call(scope.querySelectorAll('[data-add]'));
  if(root && root.getAttribute && root.getAttribute('data-add') != null) list.push(root);
  list.forEach(function(b){
    var id = b.getAttribute('data-add');
    b.setAttribute('data-soon', id || 'v-soon');
    b.removeAttribute('data-add');
    b.classList.add('cs-soon');
    if(b.tagName !== 'BUTTON') return;
    var label = (b.id === 'buyPillGo') ? 'Soon...' : 'Coming soon...';
    if(!b.children.length){ b.textContent = label; return; }
    var tn = null;
    for(var i=0;i<b.childNodes.length;i++){ var n=b.childNodes[i]; if(n.nodeType===3 && n.textContent.trim()){ tn=n; break; } }
    if(tn) tn.textContent = label; else b.appendChild(document.createTextNode(label));
  });
}
if(COMING_SOON){
  var _sealBoot = function(){
    sealBuys(document);
    try{
      new MutationObserver(function(muts){
        muts.forEach(function(m){
          if(m.type === 'attributes'){ sealBuys(m.target); }
          else { m.addedNodes.forEach(function(n){ if(n.nodeType === 1) sealBuys(n); }); }
        });
      }).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['data-add']});
    }catch(e){}
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', _sealBoot); else _sealBoot();
}


/* ---------- THE SHELF TELLS THE TRUTH ----------
   Same shape as the pre-drop seal that came before it: one sweep turns any
   control still offering a colour Shopify no longer holds into a dead label,
   and a MutationObserver re-runs it whenever the page writes a new data-add.
   Renderers all over this site mint buy buttons — the crew dossier, the launch
   pad, the cross-sell rail, the sticky pill — and this is the one place that
   has to be right for all of them. */
function sealGone(root){
  var scope = (root && root.querySelectorAll) ? root : document;
  var list = Array.prototype.slice.call(scope.querySelectorAll('[data-add]'));
  if(root && root.getAttribute && root.getAttribute('data-add') != null) list.push(root);
  list.forEach(function(b){
    var id = b.getAttribute('data-add');
    if(!id || !soldOut(id)) return;
    b.setAttribute('data-gone', id);
    b.removeAttribute('data-add');
    b.classList.add('is-gone');
    if(b.tagName !== 'BUTTON' && b.tagName !== 'A') return;
    if(b.tagName === 'BUTTON') b.disabled = true;
    var label = (b.id === 'buyPillGo') ? 'Gone' : 'Gone for good';
    if(!b.children.length){ b.textContent = label; return; }
    var tn = null;
    for(var i = 0; i < b.childNodes.length; i++){
      var n = b.childNodes[i];
      if(n.nodeType === 3 && n.textContent.trim()){ tn = n; break; }
    }
    if(tn) tn.textContent = label; else b.appendChild(document.createTextNode(label));
  });
}
(function(){
  var boot = function(){
    sealGone(document);
    try{
      new MutationObserver(function(muts){
        muts.forEach(function(m){
          if(m.type === 'attributes'){ sealGone(m.target); }
          else { m.addedNodes.forEach(function(n){ if(n.nodeType === 1) sealGone(n); }); }
        });
      }).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['data-add']});
    }catch(e){}
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

document.addEventListener('click', e=>{
  const soon = e.target.closest('[data-soon]');
  if(soon){ if(COMING_SOON && soon.dataset.soon !== 'v-ghost'){ soonNudge(); return; } showToast(soon.dataset.soon === 'v-ghost' ? 'Still light-years out. The mothership does not rush.' : 'Dropping soon. The crew is suiting up.'); return; }
  const gone = e.target.closest('[data-gone]');
  if(gone){ showToast('Gone for good \u2014 one hundred were made, none are left. The next line docks when its ship arrives.'); return; }
  const add = e.target.closest('[data-add]');
  if(add){ addItem(add.dataset.add); beamFX(e.clientX, e.clientY); cargoBump(); return; }
  const kinc = e.target.closest('[data-kinc]');
  if(kinc){ changeShopQty(kinc.dataset.kinc, 1); return; }
  const kdec = e.target.closest('[data-kdec]');
  if(kdec){ changeShopQty(kdec.dataset.kdec, -1); return; }
  const inc = e.target.closest('[data-inc]');
  if(inc){ cart.set(inc.dataset.inc,(cart.get(inc.dataset.inc)||0)+1); renderCart(); return; }
  const dec = e.target.closest('[data-dec]');
  if(dec){ cart.set(dec.dataset.dec,(cart.get(dec.dataset.dec)||0)-1); renderCart(); return; }
});
let alseqEl = null, alRun = 0;
function firstOGColor(){
  const re = /(green|pink|red|yellow|blue)/;
  if(SHOP && shopCart && shopCart.items){
    for(const it of shopCart.items){ const m = re.exec(it.handle || ''); if(m && OG.has(m[1])) return m[1]; }
  } else {
    for(const id of cart.keys()){ const m = /^v-(\w+)$/.exec(id); if(m && OG.has(m[1])) return m[1]; }
  }
  return 'green';
}
function airlockSeq(){
  const run = ++alRun;
  closeHold();
  if(!alseqEl){
    alseqEl = document.createElement('div');
    alseqEl.id = 'alseq';
    alseqEl.innerHTML = '<div class="al-ring"></div>'
      + '<img id="alImg" alt="cargo">'
      + '<div class="al-doorlight"></div>'
      + '<div class="al-top"><div class="al-gauge"><i id="alFill"></i></div><div class="al-state" id="alState"></div></div>';
    document.body.appendChild(alseqEl);
  }
  const img = document.getElementById('alImg');
  img.src = OG_IMG[firstOGColor()];
  const fill = document.getElementById('alFill');
  const state = document.getElementById('alState');
  const setStage = (cls, pct, txt)=>{
    alseqEl.className = 'on' + (cls ? ' ' + cls : '');
    fill.style.width = pct + '%';
    state.textContent = txt;
  };
  const depart = ()=>{
    if(run !== alRun) return;
    alseqEl.classList.remove('on');
    if(SHOP){ window.location.href = '/checkout'; }
    else { showToast('DEPARTURE LOGGED \u00b7 the airlock takes money on Shopify.'); }
  };
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduced){ depart(); return; }
  setStage('', 8, 'BAY 01 \u00b7 CARGO SECURED \u00b7 HOLDING');
  setTimeout(()=>{ if(run===alRun) setStage('sealing', 34, 'SEALING BAY'); }, 650);
  setTimeout(()=>{ if(run===alRun) setStage('sealing equalising', 61.8, 'EQUALISING \u00b7 0.618 ATM'); }, 1550);
  setTimeout(()=>{ if(run===alRun) setStage('sealing equalising open', 100, 'OUTER DOOR \u00b7 OPEN'); }, 2450);
  setTimeout(depart, 3150);
}
document.addEventListener('keydown', e=>{
  if(e.key === 'Escape' && alseqEl && alseqEl.classList.contains('on')){
    alRun++; alseqEl.classList.remove('on');
    showToast('DEPARTURE ABORTED \u00b7 cargo stays racked.');
  }
});
document.getElementById('airlock').addEventListener('click', ()=>{ closeHold(); airlockSeq(); });  /* V92: straight to the airlock — no interstitial */
/* the rotating buy pill and the claim CTA must never wear a dead color */
try{
  window.STATION_LIVE_CREW = ['green','pink','red','yellow','blue'].filter(function(k){ return !soldOut('v-' + k); });
}catch(e){}
if(SHOP){
  refreshShopCart();
  const jn = document.querySelector('.join-note');
  if(jn) jn.innerHTML = 'Secure checkout \u00b7 Apple\u00a0Pay, Shop\u00a0Pay, Google\u00a0Pay and cards. <b>All sales final</b> \u2014 once a vessel leaves the station it does not come back.';
}

/* ============ TERMINAL TYPE ============ */
const TERMS = {
  orbit:   '> EARTH GATE: OPEN \u00b7 FIRST DROP LIVE \u00b7 8,000,000,000 ASLEEP \u00b7 WAKE THEM \u00b7 THE GODS NEVER LEFT',
  surface: '> DAYSIDE: THE VOID GOES WHITE \u00b7 THEIR PLANET: BELOW DECK \u00b7 LAST STOP BEFORE DEEP SPACE'
};
const termEl = document.getElementById('term');
const TERM_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
let termRun = 0;
function typeTerm(line){
  const run = ++termRun;
  if(TERM_REDUCED){ termEl.textContent = line; return; }
  let i = 0;
  (function type(){
    if(run !== termRun) return;
    termEl.textContent = line.slice(0, i++);
    if(i <= line.length) setTimeout(type, 26);
  })();
}
typeTerm(document.documentElement.classList.contains('day') ? TERMS.surface : TERMS.orbit);

/* ============ THE CREW ROSTER ============ */
document.getElementById('crewRow').innerHTML = CREW_ACTIVE.map(([k,an,cn,hex,line], vi)=>{
  const glow = (k==='black' ? '#54648C' : hex) + '66';
  return `<div class="crew-member" data-vi="${vi}" role="link" tabindex="0" aria-label="Board the ${an.toLowerCase()} vessel">
    <svg data-alien viewBox="0 0 100 110" role="img" aria-label="${an.toLowerCase()}" style="filter:drop-shadow(0 0 13px ${glow})">
      <path d="M50 6 C77 6 92 26 92 48 C92 74 72 96 50 104 C28 96 8 74 8 48 C8 26 23 6 50 6 Z" fill="${line}" stroke="${hex}" stroke-width="3"/>
      <g class="eye"><ellipse cx="33" cy="52" rx="14" ry="20" transform="rotate(-18 33 52)" fill="${hex}"/><circle class="pupil" cx="33" cy="52" r="5" fill="#04120A"/></g>
      <g class="eye"><ellipse cx="67" cy="52" rx="14" ry="20" transform="rotate(18 67 52)" fill="${hex}"/><circle class="pupil" cx="67" cy="52" r="5" fill="#04120A"/></g>
    </svg>
    <span class="cname">${an.split(' ')[0]}</span>
  </div>`;
}).join('');

/* ============ THE WATCHER ============ */
const ALIENS = Array.from(document.querySelectorAll('[data-alien]'));
const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if(ALIENS.length && !REDUCED){
  addEventListener('mousemove', e=>{
    ALIENS.forEach(a=>{
      if(a.dataset.gaze) return;
      const r = a.getBoundingClientRect();
      const cx = r.left + r.width/2, cy = r.top + r.height/2;
      const dx = e.clientX - cx, dy = e.clientY - cy;
      const d = Math.hypot(dx, dy) || 1;
      const m = Math.min(6, 2 + d/120);
      a.querySelectorAll('.pupil').forEach(p=>p.setAttribute('transform', `translate(${(dx/d*m).toFixed(1)} ${(dy/d*m).toFixed(1)})`));
    });
  }, {passive:true});
  setInterval(()=>{
    const a = ALIENS[Math.floor(Math.random()*ALIENS.length)];
    if(!a) return;
    a.classList.add('blink');
    setTimeout(()=>a.classList.remove('blink'), 160);
  }, 3800);
}

/* ============ ORBIT / PLANETSIDE ============ */
const modeBtn = document.getElementById('modeBtn');
function applyMode(retype){
  const day = document.documentElement.classList.contains('day');
  /* keep the glyph and the words in separate spans: the phone header hides
     .btn-words and would otherwise lose them the first time this ran */
  modeBtn.innerHTML = '<span aria-hidden="true">' + (day ? '\u263e' : '\u2600')
    + '</span><span class="btn-words"> ' + (day ? 'NIGHTSIDE' : 'DAYSIDE') + '</span>';
  modeBtn.setAttribute('aria-pressed', day);
  modeBtn.setAttribute('aria-label', day ? 'Swing to the nightside (dark mode)' : 'Swing to the dayside (light mode)');
  if(retype) typeTerm(day ? TERMS.surface : TERMS.orbit);
}
modeBtn.addEventListener('click', ()=>{
  document.documentElement.classList.toggle('day');
  /* V98: nightside is the default; a swing to the dayside is remembered across every deck */
  try{ localStorage.setItem('stationMode', document.documentElement.classList.contains('day') ? 'day' : 'night'); }catch(e){}
  applyMode(true);
});
applyMode(false);

/* ============ HERO GAZE SCRIPT ============ */
const heroAlien = document.querySelector('.alien-hero');
if(heroAlien && !REDUCED){
  heroAlien.dataset.gaze = 'script';
  const HP = heroAlien.querySelectorAll('.pupil');
  /* look around \u2192 at the person \u2192 down at the gold button \u2192 person \u2192 button \u2026 */
  const GAZE = [[-5,1,1100],[5,1,1100],[0,0,1600],[0,7,1500],[0,0,1400],[0,7,1600]];
  let gi = 0;
  (function gaze(){
    const g = GAZE[gi % GAZE.length];
    HP.forEach(p=>p.setAttribute('transform', 'translate(' + g[0] + ' ' + g[1] + ')'));
    gi++;
    setTimeout(gaze, g[2]);
  })();
}

/* ============ PARTY HANDS ============ */
function alienHandSVG(w, mirror, sfx){
  const shapes =
      '<path d="M30 150 L30 112 C29 104 26 100 24 92 C21 82 21.5 72 26 66 C31 60 62 60 66 66 C70 72 70.5 82 67.5 92 C65.5 100 62 104 61 112 L61 150 Z"/>'
    + '<path d="M22.5 70 C21 56 20.5 40 22 27 C22.7 19.8 29.3 19.8 30 27 C31.5 40 31 56 29.5 70 C27.2 73 24.8 73 22.5 70 Z"/>'
    + '<path d="M34 69 C32.5 52 32 31 33.5 16 C34.3 8.4 41.7 8.4 42.5 16 C44 31 43.5 52 42 69 C39.5 72 36.5 72 34 69 Z"/>'
    + '<path d="M45.5 69 C44 53 43.5 35 45 21 C45.8 13.6 52.2 13.6 53 21 C54.5 35 54 53 52.5 69 C50.2 72 47.8 72 45.5 69 Z"/>'
    + '<path d="M57 70 C55.8 58 55.5 46 56.8 36 C57.4 29.4 62.6 29.4 63.2 36 C64.5 46 64.2 58 63 70 C61 72.6 59 72.6 57 70 Z"/>'
    + '<path d="M22 88 C15 82 9 72 8 63 C7.3 56.5 12.5 53 16.5 57 C21 61.5 24 70 27 78 C26 84 24 87 22 88 Z"/>';
  return '<svg width="' + w + '" viewBox="0 0 90 150" aria-hidden="true">'
   + '<defs><radialGradient id="hg' + sfx + '" cx="45%" cy="36%" r="80%">'
   + '<stop offset="0%" stop-color="#8CFFB0"/><stop offset="55%" stop-color="#00CE7E"/><stop offset="100%" stop-color="#2CC162"/>'
   + '</radialGradient></defs>'
   + '<g' + (mirror ? ' transform="translate(90 0) scale(-1 1)"' : '') + '>'
   + '<g fill="#1E7A42" transform="translate(45 78) scale(1.05) translate(-45 -78)">' + shapes + '</g>'
   + '<g fill="url(#hg' + sfx + ')">' + shapes + '</g>'
   + '<g fill="none" stroke="rgba(20,96,48,.5)" stroke-width="1.2" stroke-linecap="round">'
   + '<path d="M23 52 Q26.2 54 29.5 52"/><path d="M34.5 49 Q38 51 41.5 49"/><path d="M46 50 Q49.2 52 52.5 50"/><path d="M57.5 56 Q60 58 62.5 56"/>'
   + '<path d="M28 86 Q45 97 63 86" stroke="rgba(20,96,48,.35)"/>'
   + '</g>'
   + '<g><circle cx="26" cy="24.5" r="3.1" fill="rgba(255,255,255,.4)"/><circle cx="26" cy="24.5" r="1.3" fill="rgba(30,122,66,.4)"/>'
   + '<circle cx="38" cy="13.5" r="3.5" fill="rgba(255,255,255,.4)"/><circle cx="38" cy="13.5" r="1.45" fill="rgba(30,122,66,.4)"/>'
   + '<circle cx="49.2" cy="19" r="3.2" fill="rgba(255,255,255,.4)"/><circle cx="49.2" cy="19" r="1.35" fill="rgba(30,122,66,.4)"/>'
   + '<circle cx="60.1" cy="34" r="2.8" fill="rgba(255,255,255,.4)"/><circle cx="60.1" cy="34" r="1.15" fill="rgba(30,122,66,.4)"/>'
   + '<circle cx="12.5" cy="59" r="2.9" fill="rgba(255,255,255,.4)"/><circle cx="12.5" cy="59" r="1.2" fill="rgba(30,122,66,.4)"/></g>'
   + '</svg>';
}
let partyFired = false, partyArmed = false;
function partyHands(){
  if(partyFired || REDUCED) return;
  if(!document.documentElement.classList.contains('day')){ partyArmed = false; return; }
  partyFired = true;
  const c = document.createElement('div');
  c.id = 'handsParty';
  const PAIR = [
    {left:'44%', w:88, mirror:true,  wave:.82, wdelay:0,   bob:1.05},
    {left:'55%', w:92, mirror:false, wave:.95, wdelay:.15, bob:1.2}
  ];
  PAIR.forEach((cfg, ci)=>{
    const s = document.createElement('span');
    s.className = 'party-hand';
    s.style.left = cfg.left;
    s.innerHTML = '<span class="hand-bob" style="animation-duration:' + cfg.bob + 's">' + alienHandSVG(cfg.w, cfg.mirror, ci) + '</span>';
    const sv = s.querySelector('svg');
    sv.style.animationDuration = cfg.wave + 's';
    sv.style.animationDelay = cfg.wdelay + 's';
    c.appendChild(s);
  });
  document.body.appendChild(c);
  setTimeout(()=>{
    c.querySelectorAll('.party-hand').forEach(hd=>hd.classList.add('down'));
    setTimeout(()=>{ c.remove(); armPeek(); }, 900);
  }, 5600);
}
let peeked = false;
function spawnPeek(){
  if(peeked || REDUCED || !document.documentElement.classList.contains('day')) return;
  peeked = true;
  const d = document.createElement('div');
  d.id = 'peekAlien';
  d.innerHTML = '<svg viewBox="0 0 100 110" aria-hidden="true">'
   + '<path d="M50 6 C77 6 92 26 92 48 C92 74 72 96 50 104 C28 96 8 74 8 48 C8 26 23 6 50 6 Z" fill="#0D2416" stroke="#00CE7E" stroke-width="2.5"/>'
   + '<g class="eye"><ellipse cx="33" cy="52" rx="14" ry="20" transform="rotate(-18 33 52)" fill="#00CE7E"/><circle class="pupil" cx="33" cy="52" r="5" fill="#04120A"/></g>'
   + '<g class="eye"><ellipse cx="67" cy="52" rx="14" ry="20" transform="rotate(18 67 52)" fill="#00CE7E"/><circle class="pupil" cx="67" cy="52" r="5" fill="#04120A"/></g>'
   + '</svg>';
  document.body.appendChild(d);
  requestAnimationFrame(()=> d.classList.add('up'));
  const P = d.querySelectorAll('.pupil');
  const look = (x,y)=> P.forEach(p=>p.setAttribute('transform','translate('+x+' '+y+')'));
  setTimeout(()=>look(-6,1), 1000);
  setTimeout(()=>look(6,1), 1900);
  setTimeout(()=>look(0,0), 2800);
  setTimeout(()=>d.classList.add('duck'), 4700);
  setTimeout(()=>d.remove(), 5400);
}
function armPeek(){
  if(peeked || REDUCED) return;
  let scrolled = false;
  const onS = ()=>{ scrolled = true; removeEventListener('scroll', onS); };
  addEventListener('scroll', onS, {passive:true});
  setTimeout(()=>{
    removeEventListener('scroll', onS);
    if(!scrolled) spawnPeek();
  }, 10000);
}
function armParty(){
  if(partyFired || partyArmed) return;
  if(document.documentElement.classList.contains('day')){
    partyArmed = true;
    setTimeout(partyHands, 15000);
  }
}
armParty();
document.getElementById('modeBtn').addEventListener('click', ()=> setTimeout(armParty, 50));

document.addEventListener('click', e=>{
  if(e.target.closest('#unsureGo') && typeof openReading === 'function') openReading();
});

/* ============ THE TYPING v3 \u00b7 THE DAILY PAPER ============
   Original instrument \u2014 our own axes and vocabulary, not borrowed from any
   published personality inventory. Four dichotomies in the station's language.
   v3: the instrument reprints daily. 366 papers a year \u2014 each calendar day
   deterministically draws three questions per axis from the bank, shuffles the
   running order, flips answer positions and inks the deck a fresh accent.
   THE ODDS NEVER MOVE: every paper is still 3 questions per axis at \u00b11, the
   same double-weight 13th probe on the least-certain axis, and the same
   16-burn \u2192 crew map. Different questions, same instrument.
   ========================================================================= */
const AXES = [
  { a:'D', b:'N', an:'DAYBURN', bn:'NIGHTBURN', q:'when the fire is highest' },
  { a:'R', b:'W', an:'RACER',   bn:'WANDERER',  q:'what the effort is for' },
  { a:'L', b:'Q', an:'LOUD',    bn:'QUIET',     q:'how you take up space' },
  { a:'S', b:'U', an:'STEADY',  bn:'SURGE',     q:'how the power arrives' }
];
/* the bank \u00b7 20 stems per axis \u00b7 a[0] always scores toward the first pole */
const TYPE_BANK = [
  [ /* DAYBURN / NIGHTBURN */
    { q:'The best hour of your week is\u2026', a:['Sun already up and climbing','The last light, or none at all'] },
    { q:'You would rather\u2026', a:['Beat the heat by starting early','Own the dark and start late'] },
    { q:'Your alarm is set for\u2026', a:['Before anyone else is awake','Nothing. You go when you go.'] },
    { q:'Golden hour is\u2026', a:['The one at the start of the day','The one at the end of it'] },
    { q:'The city is yours when\u2026', a:['It is still waking up','It has gone to bed'] },
    { q:'Your shadow looks best\u2026', a:['Long behind you at sunrise','Thrown by a streetlight'] },
    { q:'Coffee is\u2026', a:['The launch sequence','A midnight instrument'] },
    { q:'A headlamp is\u2026', a:['For emergencies only','Standard issue'] },
    { q:'The best air of the day is\u2026', a:['Right before the sun commits','Right after it gives up'] },
    { q:'Sunrise is\u2026', a:['The starting gun','Proof you stayed out too long'] },
    { q:'You trust a sky that is\u2026', a:['Getting brighter','Getting darker'] },
    { q:'Start times should be\u2026', a:['Earlier. Always earlier.','Civilized. After dark, ideally.'] },
    { q:'Your best ideas arrive\u2026', a:['Mile two, sun coming up','Mile two, everyone asleep'] },
    { q:'The moon is\u2026', a:['A nightlight you did not order','The only crowd you need'] },
    { q:'By nine at night you are\u2026', a:['Done. Gloriously done.','Just lacing up'] },
    { q:'An empty road at noon is\u2026', a:['The whole point of noon','Fine, but it glows better at midnight'] },
    { q:'First light finds you\u2026', a:['Already moving','Still out from last night'] },
    { q:'The birds at five in the morning are\u2026', a:['Your people','A rumor you have heard about'] },
    { q:'Your kitchen at midnight is\u2026', a:['Closed for launch prep','Fueling the second shift'] },
    { q:'Summer means\u2026', a:['Starting at dawn to beat it','Starting at dusk to dodge it'] }
  ],
  [ /* RACER / WANDERER */
    { q:'You signed up because\u2026', a:['There is a time to beat','There is somewhere you have not been'] },
    { q:'A route you have done a hundred times is\u2026', a:['A benchmark','A waste of a good day'] },
    { q:'A good year is measured in\u2026', a:['Numbers that got smaller','Places you had not been'] },
    { q:'The watch exists to\u2026', a:['Keep score','Find the way back'] },
    { q:'A wrong turn is\u2026', a:['Time you will never get back','The best part of the map'] },
    { q:'The perfect course is\u2026', a:['Certified, measured, flat','Unmarked, unmeasured, unknown'] },
    { q:'You stop mid-effort\u2026', a:['Never. The clock is running.','Whenever something deserves a look'] },
    { q:'The photo worth keeping shows\u2026', a:['The clock over the line','A road you cannot name yet'] },
    { q:'Your rival is\u2026', a:['The person one second ahead','Nobody. Rivals need a course.'] },
    { q:'A course record is\u2026', a:['A to-do item','A thing that happens to other people'] },
    { q:'The off-season is for\u2026', a:['Building the next number','Roads with no plan'] },
    { q:'You know it worked because\u2026', a:['The split says so','You came back different'] },
    { q:'The start line is\u2026', a:['Where everything makes sense','Optional. The door works too.'] },
    { q:'The feed exists so you can\u2026', a:['Hunt segments','Remember where you have been'] },
    { q:'A route you quit early is\u2026', a:['A debt to be repaid','A story with a better ending'] },
    { q:'Mile markers are\u2026', a:['Checkpoints in a negotiation','Litter, basically'] },
    { q:'The finish chute is\u2026', a:['The whole reason','The bit before the snacks'] },
    { q:'You memorize\u2026', a:['Your splits','The turns worth taking twice'] },
    { q:'New shoes get tested on\u2026', a:['The usual loop, for a fair reading','Somewhere they have never been'] },
    { q:'Winning is\u2026', a:['Beating everyone who showed up','A word for people on courses'] }
  ],
  [ /* LOUD / QUIET */
    { q:'Your kit is\u2026', a:['Visible from three blocks out','Whatever nobody notices'] },
    { q:'Somebody compliments your gear. You\u2026', a:['Tell them exactly where to get it','Say thanks and keep moving'] },
    { q:'On the group ride you are\u2026', a:['Near the front, talking','Somewhere in it, listening'] },
    { q:'Your finish line face is\u2026', a:['For the camera','For nobody'] },
    { q:'High-fives from strangers are\u2026', a:['Fuel','A toll'] },
    { q:'Your shoes are\u2026', a:['The brightest thing on the street','The same color as the street'] },
    { q:'The race bib gets\u2026', a:['Worn to breakfast after','Binned at the car'] },
    { q:'Cheer zones are\u2026', a:['Where you speed up','Where you study your feet'] },
    { q:'When the song is right you\u2026', a:['Sing. Audibly.','Nod, internally'] },
    { q:'Your training log is\u2026', a:['Public, with commentary','A private ledger'] },
    { q:'A megaphone at mile twenty is\u2026', a:['Pointed at you, correctly','An act of war'] },
    { q:'Reflective gear is\u2026', a:['A personality','A precaution'] },
    { q:'The pace you announce is\u2026', a:['Optimistic, and loud','Never announced'] },
    { q:'Your celebration is\u2026', a:['Arms up, full wingspan','A small private nod'] },
    { q:'In the group photo you are\u2026', a:['Front row, mid-jump','Behind the tall one'] },
    { q:'Your bell is\u2026', a:['Conversational','Ceremonial. Unrung.'] },
    { q:'New personal best. You tell\u2026', a:['Everyone. The barista knows.','The one person who would ask'] },
    { q:'Neon is\u2026', a:['A neutral','A siren you did not order'] },
    { q:'Your name on the bib means\u2026', a:['Strangers cheering it. Perfect.','Strangers cheering it. Why.'] },
    { q:'You warm up\u2026', a:['Where the speakers are','Around the corner, alone'] }
  ],
  [ /* STEADY / SURGE */
    { q:'Your effort is\u2026', a:['The same all the way through','Nothing, nothing, everything'] },
    { q:'The hill arrives. You\u2026', a:['Hold your number and grind','Stand up and burn a match'] },
    { q:'When it hurts you\u2026', a:['Settle in. It always hurts.','Attack it before it settles in.'] },
    { q:'Your effort graph should look like\u2026', a:['A horizon','A skyline'] },
    { q:'Negative splits are\u2026', a:['Religion','A rumor'] },
    { q:'The matchbook is\u2026', a:['Rationed to the last mile','Open on the first climb'] },
    { q:'Intervals are\u2026', a:['A contract you honor evenly','Permission to detonate'] },
    { q:'The group surges. You\u2026', a:['Let them go and reel them in','Surged first, actually'] },
    { q:'Your best weapon is\u2026', a:['The pace nobody notices in time','The move nobody saw coming'] },
    { q:'Pacing charts are\u2026', a:['Laminated','Kindling'] },
    { q:'A metronome is\u2026', a:['A spirit animal','A dare'] },
    { q:'The last quarter mile is\u2026', a:['The same as the first','The only one that counts'] },
    { q:'You break rivals by\u2026', a:['Never changing','Changing without warning'] },
    { q:'The plan says easy day. You\u2026', a:['Go easy. The plan is the plan.','Feel good and file a new flight plan'] },
    { q:'Hills on an even-effort day are\u2026', a:['Held at constant power','Attacked. Obviously.'] },
    { q:'Your sprint is\u2026', a:['A faster version of your cruise','A different animal entirely'] },
    { q:'Your heart rate graph reads like\u2026', a:['A calm sea','A polygraph with news'] },
    { q:'Race-winning moves happen\u2026', a:['Over an hour, invisibly','In eleven seconds, loudly'] },
    { q:'Halfway through you are\u2026', a:['Exactly where the math said','Ahead of it or on fire'] },
    { q:'The kick is\u2026', a:['Whatever is left, spent evenly','Everything, all at once, now'] }
  ]
];
/* the probe bank \u00b7 the 13th question \u00b7 one drawn per axis per paper, asked
   on whichever axis the first twelve split closest, at double weight */
const PROBE_BANK = [
  [
    { q:'One free hour of perfect weather. You take it\u2026', a:['At first light','After dark'] },
    { q:'Forced to choose forever\u2026', a:['Every sunrise, no sunsets','Every sunset, no sunrises'] },
    { q:'One race, any hour. The gun goes\u2026', a:['At six in the morning','At midnight'] },
    { q:'The light you chase is\u2026', a:['Coming up','Going down'] },
    { q:'Your engine runs hottest\u2026', a:['Before noon','After ten at night'] },
    { q:'The station refuels you fastest\u2026', a:['As the sun docks','As the sun leaves'] }
  ],
  [
    { q:'The finish line matters because\u2026', a:['It is where the clock stops','It is just where the route ran out'] },
    { q:'Pick one forever\u2026', a:['Same course, always faster','New ground, never timed'] },
    { q:'The number that matters is\u2026', a:['The time','The distance from home'] },
    { q:'Your last effort on earth is\u2026', a:['A record attempt','A place you saved for last'] },
    { q:'Delete one instrument\u2026', a:['The map','The stopwatch'] },
    { q:'You are remembered as\u2026', a:['The fast one','The far one'] }
  ],
  [
    { q:'Your finish photo is\u2026', a:['Arms up, straight at the lens','Already walking out of frame'] },
    { q:'Pick a superpower\u2026', a:['Everyone sees you coming','Nobody sees you at all'] },
    { q:'The crowd at your race is\u2026', a:['The point','The obstacle'] },
    { q:'Your vessel color should\u2026', a:['Announce you from orbit','Keep your secret'] },
    { q:'One forever\u2026', a:['Front of every photo','Absent from every photo'] },
    { q:'The cheer you want is\u2026', a:['Your name, shouted','Silence that means respect'] }
  ],
  [
    { q:'Your perfect race is\u2026', a:['Even splits, metronome to the line','Sit quiet, then one violent move'] },
    { q:'Pick an engine\u2026', a:['Diesel, forever','Nitro, briefly'] },
    { q:'Your final mile, scripted\u2026', a:['Same pace, jaw set','Everything at once'] },
    { q:'One graph forever\u2026', a:['The flat line','The spike'] },
    { q:'You win by\u2026', a:['Outlasting','Detonating'] },
    { q:'The move that feels like you\u2026', a:['No move at all','The move'] }
  ]
];
/* ---- the printing press \u00b7 deterministic daily draw, seeded by day of year ---- */
function tyMul32(seed){
  let t = seed >>> 0;
  return function(){
    t = (t + 0x6D2B79F5) >>> 0;
    let r = Math.imul(t ^ (t >>> 15), 1 | t);
    r = (r + Math.imul(r ^ (r >>> 7), 61 | r)) ^ r;
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  };
}
function tyShuffle(arr, rnd){
  const a = arr.slice();
  for(let i = a.length - 1; i > 0; i--){
    const j = Math.floor(rnd() * (i + 1));
    const t = a[i]; a[i] = a[j]; a[j] = t;
  }
  return a;
}
function tyPaperNo(d){
  d = d || new Date();
  const jan1 = new Date(d.getFullYear(), 0, 1);
  const mid = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  return Math.round((mid - jan1) / 864e5) + 1;   /* 1..366, local day */
}
function tyBuildPaper(no){
  const rnd = tyMul32((Math.imul(no, 2654435761) ^ 0x618618) >>> 0);
  /* three stems per axis, drawn without replacement; answer order may flip
     per stem \u2014 data-mi always carries the true pole index, so the flip is
     cosmetic and the scoring never moves */
  const perAxis = TYPE_BANK.map((bank, i)=>
    tyShuffle(bank, rnd).slice(0, 3).map(item => ({
      ax: i, q: item.q, a: item.a, ord: rnd() < .5 ? [0,1] : [1,0]
    })));
  const qs = [];
  let lastAx = -1;
  for(let round = 0; round < 1; round++){
    const order = tyShuffle([0,1,2,3], rnd);
    if(order[0] === lastAx){ const t = order[0]; order[0] = order[1]; order[1] = t; }
    for(let i = 0; i < order.length; i++) qs.push(perAxis[order[i]][round]);
    lastAx = order[order.length - 1];
  }
  const probes = PROBE_BANK.map((bank, i)=>{
    const p = bank[Math.floor(rnd() * bank.length)];
    return { ax: i, q: p.q, a: p.a, ord: rnd() < .5 ? [0,1] : [1,0] };
  });
  const hue = Math.floor(rnd() * 360);
  return { no: no, qs: qs, probes: probes, hue: hue,
    acc: 'hsl(' + hue + ',92%,64%)', glow: 'hsla(' + hue + ',92%,58%,.45)' };
}
let PAPER = null;
const TYPES = {
  DRLS:['THE METRONOME','KOR'],    DRLU:['THE FLARE','KOR'],
  DRQS:['THE ENGINE','SOL'],       DRQU:['THE AMBUSH','KOR'],
  DWLS:['THE TOURIST KING','SOL'], DWLU:['THE FIREWORK','VESP'],
  DWQS:['THE LONG WAY','OKO'],     DWQU:['THE SCOUT','OKO'],
  NRLS:['THE NIGHT SHIFT','RIME'], NRLU:['THE STREETLIGHT','VESP'],
  NRQS:['THE GHOST SPLIT','RIME'], NRQU:['THE LAST LAP','KOR'],
  NWLS:['THE LANTERN','VESP'],     NWLU:['THE COMET','VESP'],
  NWQS:['THE COLD START','RIME'],  NWQU:['THE OWL','OKO']
};
let readEl = null, tAns = [], tStep = 0, probeAx = -1;

/* ---------- THE DARK \u00b7 failing lights + O\u2082 reserve on the reading ---------- */
var O2 = { t: null, left: 0, cap: 72, dead: false, done: false };
function o2Stages(pct){
  if(pct > 68) return [0, 'O\u2082 RESERVE', 'THE DOOR SEALED BEHIND YOU. EVERY ANSWER BUYS AIR.'];
  if(pct > 46) return [1, 'PRESSURE DROPPING', 'THE LIGHTS ARE THINKING ABOUT IT. KEEP ANSWERING.'];
  if(pct > 26) return [2, 'LIGHTS FAILING', 'YOUR LEGS KNOW THIS FEELING. THIS IS THE BONK.'];
  if(pct > 10) return [3, 'HYPOXIA \u00b7 EMERGENCY', 'TUNNEL VISION. HANDS SHAKING. ANSWER.'];
  return [4, 'BLACKOUT IMMINENT', 'YOU ARE ABOUT TO GO OUT. THE STATION WILL READ YOU ANYWAY.'];
}
function o2Paint(){
  if(!readEl) return;
  var pct = Math.max(0, Math.min(100, (O2.left / O2.cap) * 100));
  var st = o2Stages(pct);
  var fill = document.getElementById('o2Fill');
  var clock = document.getElementById('o2Clock');
  var lab = document.getElementById('o2Lab');
  var note = document.getElementById('o2Note');
  if(fill) fill.style.width = pct.toFixed(1) + '%';
  if(clock){
    var s = Math.max(0, Math.ceil(O2.left));
    var mm = Math.floor(s / 60), ss = s % 60;
    clock.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
  }
  if(lab) lab.textContent = st[1];
  if(note) note.textContent = st[2];
  for(var i = 0; i < 5; i++) readEl.classList.toggle('o2-' + i, i === st[0]);
}
function o2Stop(){
  if(O2.t){ clearInterval(O2.t); O2.t = null; }
}
function o2Start(){
  o2Stop();
  O2.left = O2.cap; O2.dead = false; O2.done = false;
  if(readEl){ readEl.classList.remove('o2-out', 'o2-safe'); }
  o2Paint();
  O2.t = setInterval(function(){
    if(O2.done || document.hidden) return;
    O2.left -= 0.25;
    if(O2.left <= 0){
      O2.left = 0; O2.dead = true; o2Stop(); o2Paint();
      if(readEl) readEl.classList.add('o2-out');
      /* the station never loses the reading \u2014 it reads you in the dark */
      setTimeout(function(){ if(!O2.done) revealType(); }, 1200);
      return;
    }
    o2Paint();
  }, 250);
}
function o2Breathe(){          /* each answer buys air back */
  O2.left = Math.min(O2.cap, O2.left + 9);
  var hud = document.getElementById('o2Hud');
  if(hud){ hud.classList.remove('gulp'); void hud.offsetWidth; hud.classList.add('gulp'); }
  o2Paint();
}
function o2Safe(){             /* the vessel arrives \u00b7 lights and air return */
  O2.done = true; o2Stop();
  if(!readEl) return;
  for(var i = 0; i < 5; i++) readEl.classList.remove('o2-' + i);
  readEl.classList.remove('o2-out');
  readEl.classList.add('o2-safe');
}
function buildReading(){
  readEl = document.createElement('div');
  readEl.id = 'reading';
  readEl.innerHTML = '<button class="read-x" aria-label="Close">\u00d7</button>'
    + '<i class="o2-vig" aria-hidden="true"></i><i class="o2-emg" aria-hidden="true"></i>'
    + '<div class="o2-hud" id="o2Hud" aria-live="polite">'
    +   '<div class="o2-row"><span class="o2-lab" id="o2Lab">O\u2082 RESERVE</span>'
    +   '<span class="o2-clock num" id="o2Clock">--</span></div>'
    +   '<div class="o2-bar"><i id="o2Fill"></i></div>'
    +   '<p class="o2-note" id="o2Note">THE DOOR SEALED BEHIND YOU. EVERY ANSWER BUYS AIR.</p>'
    + '</div>'
    + '<div class="read-inner"><p class="read-term" id="readTerm"></p>'
    + '<div class="read-stage" id="readStage"></div><p class="read-foot" id="readFoot"></p></div>';
  document.body.appendChild(readEl);
  readEl.querySelector('.read-x').addEventListener('click', closeReading);
}
function closeReading(){
  if(!readEl) return;
  o2Stop(); O2.done = true;
  readEl.classList.remove('open');
  document.documentElement.classList.remove('reading-lock');
}
function axisScores(){
  const s = [0,0,0,0];
  tAns.forEach((pick, i)=>{
    if(i < PAPER.qs.length){ s[PAPER.qs[i].ax] += pick === 0 ? 1 : -1; }
    else if(probeAx >= 0){ s[probeAx] += pick === 0 ? 2 : -2; }
  });
  return s;
}
function typeCode(){
  const s = axisScores();
  return AXES.map((ax, i)=> s[i] >= 0 ? ax.a : ax.b).join('');
}
function askStep(){
  const stage = document.getElementById('readStage');
  const term = document.getElementById('readTerm');
  const TOTAL = PAPER.qs.length + 1;
  if(tStep >= TOTAL){ revealType(); return; }
  let Q;
  if(tStep < PAPER.qs.length){
    Q = PAPER.qs[tStep];
    term.textContent = String(tStep + 1).padStart(2,'0') + ' OF ' + TOTAL + ' \u00b7 ' + AXES[Q.ax].q.toUpperCase();
  } else {
    const s12 = axisScores();
    probeAx = 0;
    for(let i = 1; i < AXES.length; i++){ if(Math.abs(s12[i]) < Math.abs(s12[probeAx])) probeAx = i; }
    Q = PAPER.probes[probeAx];
    term.textContent = String(TOTAL).padStart(2,'0') + ' OF ' + TOTAL + ' \u00b7 THE AXIS IT COULD NOT READ';
  }
  stage.classList.remove('on');
  setTimeout(()=>{
    stage.innerHTML = '<p class="m-q">' + Q.q + '</p><div class="m-as">'
      + Q.ord.map(i=>'<button class="m-a" data-mi="' + i + '">' + Q.a[i] + '</button>').join('') + '</div>'
      + '<div class="m-prog">' + Array.from({length: PAPER.qs.length + 1}, (x,i)=>'<i class="' + (i <= tStep ? 'on' : '') + '"></i>').join('') + '</div>';
    stage.classList.add('on');
    stage.querySelectorAll('[data-mi]').forEach(b=> b.addEventListener('click', ()=>{
      tAns.push(+b.dataset.mi); tStep++; o2Breathe(); askStep();
    }));
  }, 160);
}
function revealType(){
  o2Safe();
  const stage = document.getElementById('readStage');
  const term = document.getElementById('readTerm');
  let code = typeCode();
  try{
    if(window.LUNDR && typeof window.LUNDR.type === 'function'){
      const v = window.LUNDR.type(tAns, code);
      if(v && v.code && TYPES[v.code]) code = v.code;
    }
  }catch(e){}
  const t = TYPES[code] || ['THE UNREAD','OKO'];
  const entry = Object.entries(CREW_CHAR).find(([kk,vv])=> vv.name === t[1]) || Object.entries(CREW_CHAR)[0];
  const k = entry[0], c = entry[1];
  const crew = CREW_ACTIVE.find(x=>x[0] === k) || CREW_ACTIVE[0];
  const hex = crew[3];
  const s = axisScores();
  const pNo = String(PAPER ? PAPER.no : 0).padStart(3,'0');
  /* the ledger \u00b7 every completed reading is banded and counted (browser-local) */
  let burns = [];
  try{ burns = JSON.parse(localStorage.getItem('stationBurns.v1') || '[]'); }catch(e){}
  if(!Array.isArray(burns)) burns = [];
  const prior = burns.filter(h => h && h.k === k).length;
  const readings = prior + 1;
  burns.push({ t: Date.now(), p: PAPER ? PAPER.no : 0, c: code, k: k });
  if(burns.length > 60) burns = burns.slice(-60);
  try{ localStorage.setItem('stationBurns.v1', JSON.stringify(burns)); }catch(e){}
  /* same burn twice \u00b7 the second shelf \u2014 the other four colors, right there */
  const others = CREW_ACTIVE.filter(x => x[0] !== k);
  const repeatHTML = prior < 1 ? '' :
    '<div class="ty-rep"><span class="ty-rep-k">SAME BURN \u00b7 READING NO. ' + readings + '</span>'
    + '<p><b>' + c.name + ' again.</b> That is ' + readings + ' readings that came back ' + c.name
    + ' \u2014 different paper, different questions, same you. The instrument does not flinch.</p>'
    + '<p class="ty-sub">Already carrying ' + c.name + '? A confirmed alien can hold more than one color. The other four are right there.</p>'
    + '<div class="ty-shelf">' + others.map(x=>{
        const ch = CREW_CHAR[x[0]];
        return '<button data-add="v-' + x[0] + '" style="color:' + x[3] + ';border-color:' + x[3] + '"><i></i>'
          + (ch ? ch.name : x[2].toUpperCase()) + ' <small>\u00b7 $33</small></button>';
      }).join('') + '</div></div>';
  term.textContent = 'TYPED';
  stage.classList.remove('on');
  setTimeout(()=>{
    stage.innerHTML = (O2.dead ? '<p class="ty-black">YOU WENT OUT AT 00:00. THE STATION FINISHED THE READING WITHOUT YOU.</p>' : '')
      + '<span class="ty-paper"><i></i>PAPER ' + pNo + ' OF 366 \u00b7 PRINTED FOR TODAY</span>'
      + '<p class="read-kicker">YOUR BURN</p>'
      + '<div class="ty-code" style="color:' + hex + '">' + code + '</div>'
      + '<div class="read-name" style="color:' + hex + '">' + t[0] + '</div>'
      + '<div class="ty-axes">' + AXES.map((ax,i)=>{
          const on = code[i] === ax.a;
          const pct = Math.round((Math.abs(s[i]) / (i === probeAx ? 3 : 1)) * 100);
          return '<div class="ty-ax"><span class="' + (on ? 'lit' : '') + '">' + ax.an + '</span>'
            + '<div class="ty-bar"><i style="width:' + pct + '%;background:' + hex
            + ';margin-left:' + (on ? 0 : (100 - pct)) + '%"></i></div>'
            + '<span class="' + (on ? '' : 'lit') + '">' + ax.bn + '</span></div>';
        }).join('') + '</div>'
      + (probeAx >= 0 ? '<p class="ty-probe">the last question went where your first four split closest: ' + AXES[probeAx].an + ' / ' + AXES[probeAx].bn + '</p>' : '')
      + '<p class="m-epi">the vessel that answers to this burn</p>'
      + '<img class="m-shot" src="' + OG_IMG[k] + '" alt="' + c.name + '" draggable="false">'
      + '<div class="ty-crew" style="color:' + hex + '">' + c.name + ' \u00b7 ' + c.epithet + '</div>'
      + '<p class="m-temp">' + c.temperament + '</p>'
      + '<p class="m-ch" style="color:' + hex + '">' + c.chooses + '</p>'
      + '<div class="read-actions"><button class="btn btn-gold" data-add="v-' + k + '">Claim ' + c.name + ' \u00b7 $33</button>'
      + '<button class="read-again" id="readAgain">Type me again</button></div>'
      + repeatHTML;
    stage.classList.add('on');
    const r = stage.getBoundingClientRect();
    if(typeof beamFX === 'function') beamFX(r.left + r.width/2, r.top + 90);
    document.getElementById('readAgain').addEventListener('click', ()=> openReading());
  }, 200);
  document.getElementById('readFoot').textContent =
    'THE TYPING v3 \u00b7 PAPER ' + pNo + '/366 \u00b7 NEW QUESTIONS DAILY \u00b7 SAME ODDS EVERY PRINTING \u00b7 LUNDR SOCKET: ' + (window.LUNDR ? 'LIVE' : 'OPEN');
}
function openReading(){
  if(!readEl) buildReading();
  /* today's printing \u00b7 same paper for everyone on the same calendar day */
  PAPER = tyBuildPaper(tyPaperNo());
  readEl.style.setProperty('--tyacc', PAPER.acc);
  readEl.style.setProperty('--tyacc-gl', PAPER.glow);
  tAns = []; tStep = 0; probeAx = -1;
  o2Start();
  const stage = document.getElementById('readStage');
  const term = document.getElementById('readTerm');
  stage.classList.remove('on'); stage.innerHTML = ''; term.textContent = '';
  document.documentElement.classList.add('reading-lock');
  requestAnimationFrame(()=> readEl.classList.add('open'));
  const line = 'PAPER ' + String(PAPER.no).padStart(3,'0') + ' OF 366 \u00b7 EVERYBODY BURNS A DIFFERENT COLOUR \u00b7 LET US FIND YOURS';
  let i = 0;
  const run = Date.now(); readEl.dataset.run = run;
  (function type(){
    if(readEl.dataset.run != run) return;
    term.textContent = line.slice(0, i++);
    if(i <= line.length) setTimeout(type, 26);
    else setTimeout(askStep, 380);
  })();
}
document.getElementById('readBtn').addEventListener('click', openReading);
document.addEventListener('keydown', e=>{ if(e.key === 'Escape') closeReading(); });

/* ============ THE WAKE COUNTER \u00b7 one vessel wakes one sleeper ============ */
{
  const numEl = document.getElementById('wakeNum');
  if(numEl){
    const pulseEl = document.getElementById('wakePulse');
    const CAP = 8000000;
    let AWAKE = (typeof window.STATION_SOLD === 'number' && window.STATION_SOLD >= 0)
      ? Math.min(CAP, Math.floor(window.STATION_SOLD)) : 0;
    const fmt = n => String(n).padStart(7,'0').replace(/^(\d)(\d{3})(\d{3})$/, '$1,$2,$3');
    const render = ()=> { numEl.textContent = fmt(AWAKE); };
    function wakeTick(){
      if(AWAKE >= CAP) return;
      AWAKE++;
      render();
      numEl.classList.remove('tick'); void numEl.offsetWidth; numEl.classList.add('tick');
      if(pulseEl){
        pulseEl.classList.add('on');
        clearTimeout(pulseEl._t);
        pulseEl._t = setTimeout(()=> pulseEl.classList.remove('on'), 1100);
      }
    }
    if(AWAKE > 0 && !REDUCED){
      const target = AWAKE; AWAKE = 0; render();
      const t0 = performance.now(), dur = 1200;
      (function up(t){
        const p = Math.min(1, (t - t0) / dur);
        AWAKE = Math.floor(target * (1 - Math.pow(1 - p, 3)));
        render();
        if(p < 1) requestAnimationFrame(up); else { AWAKE = target; render(); }
      })(t0);
    } else render();
    const __origAdd = addItem;
    addItem = async function(id){
      const out = await __origAdd(id);
      if(/^v-(?!ghost)/.test(id)) wakeTick();
      return out;
    };
  }
}

/* ============ THE MANIFEST \u00b7 departure checkout ============ */
const maniEl = document.getElementById('mani');
function maniLines(){
  const out = [];
  if(SHOP){
    ((shopCart && shopCart.items) || []).forEach(it=>{
      const key = (it.handle || '').match(/^(green|pink|red|yellow|blue)-alien-618$/);
      out.push({ key: it.key, shop: true, name: it.product_title, sub: it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '',
                 qty: it.quantity, line: it.final_line_price, img: key ? OG_IMG[key[1]] : null, vessel: /alien-618$/.test(it.handle || '') });
    });
  } else {
    cart.forEach((qty,id)=>{
      if(qty <= 0) return;
      const p = byId(id); if(!p) return;
      const m = /^v-(\w+)$/.exec(id);
      out.push({ key: id, shop: false, name: p.name, sub: '', qty, line: p.price * qty * 100,
                 img: m && OG_IMG[m[1]] ? OG_IMG[m[1]] : null, vessel: !!m });
    });
  }
  return out;
}
function renderManifest(){
  const rows = document.getElementById('maniRows');
  if(!rows) return;
  const L = maniLines();
  let count = 0, vessels = 0, total = 0;
  rows.innerHTML = L.length ? L.map(l=>{
    count += l.qty; total += l.line; if(l.vessel) vessels += l.qty;
    const art = l.img ? '<img class="mani-ph" src="' + l.img + '" alt="">' : '<div class="mani-ph"></div>';
    const dec = l.shop ? 'data-kdec="' + l.key + '"' : 'data-dec="' + l.key + '"';
    const inc = l.shop ? 'data-kinc="' + l.key + '"' : 'data-inc="' + l.key + '"';
    return '<div class="mani-row" data-mrow="' + l.key + '">' + art
      + '<div><div class="mani-nm">' + l.name + '</div><div class="mani-sub">' + (l.sub ? l.sub + ' \u00b7 ' : '') + 'BAY ' + String(L.indexOf(l) + 1).padStart(2,'0') + ' \u00b7 \u00d7' + l.qty + '</div></div>'
      + '<div class="mani-qty"><button ' + dec + ' aria-label="Remove one">\u2212</button><button ' + inc + ' aria-label="Add one">+</button><b class="mani-lp num">' + money(l.line) + '</b></div></div>';
  }).join('') : '<p class="mani-empty">Hold is empty. Nothing to seal.</p>';
  document.getElementById('maniCount').textContent = count;
  document.getElementById('maniVol').textContent = (vessels * 618).toLocaleString() + ' ml';
  document.getElementById('maniWake').textContent = vessels;
  document.getElementById('maniTotal').textContent = money(total);
  const fill = document.getElementById('maniFill');
  if(fill) fill.style.width = (count ? 61.8 : 8) + '%';
  const go = document.getElementById('maniGo');
  if(go) go.disabled = !count;
  const title = document.getElementById('maniTitle');
  if(title) title.textContent = count ? 'CARGO SECURED' : 'NOTHING ABOARD';
}
function openManifest(){
  if(!maniEl) return;
  renderManifest();
  maniEl.classList.add('open');
  document.documentElement.classList.add('reading-lock');
}
function closeManifest(){
  if(!maniEl) return;
  maniEl.classList.remove('open');
  document.documentElement.classList.remove('reading-lock');
}
if(maniEl){
  document.getElementById('maniX').addEventListener('click', closeManifest);
  maniEl.addEventListener('click', e=>{ if(e.target === maniEl) closeManifest(); });
  document.addEventListener('keydown', e=>{ if(e.key === 'Escape' && maniEl.classList.contains('open')) closeManifest(); });
  document.getElementById('maniGo').addEventListener('click', ()=>{ closeManifest(); airlockSeq(); });
  const note = document.getElementById('maniNote');
  if(note) note.textContent = SHOP
    ? 'Sealed by Shopify \u00b7 Apple Pay, Shop Pay, Google Pay, PayPal and card'
    : 'Demo port \u00b7 express payment lights up on the live Shopify station';
  if(!SHOP){
    const xp = document.getElementById('expressPay');
    if(xp){
      xp.innerHTML = ['\uf8ff Apple Pay','Shop Pay','G Pay','PayPal']
        .map(n=>'<button class="xp" data-xp="' + n + '">' + n + '</button>').join('');
      xp.addEventListener('click', e=>{
        const b = e.target.closest('[data-xp]');
        if(b) showToast(b.dataset.xp + ' \u2014 opens for real on the Shopify station.');
      });
    }
  }
  const _rc = renderCart;
  renderCart = function(){
    _rc();
    if(maniEl.classList.contains('open')){
      const before = maniLines().map(l=>l.key + ':' + l.qty).join('|');
      renderManifest();
      const first = document.querySelector('.mani-row');
      if(first){ first.classList.remove('pop'); void first.offsetWidth; first.classList.add('pop'); }
    }
  };
}

/* ============ TICKER RETRACT ============ */
{
  const root = document.documentElement;
  let lastY = scrollY, tkTick = false, tkAt = -1e9;
  function tkUpdate(){
    const y = scrollY;
    /* V193 · the ticker's own slide moves the page (scroll anchoring answers a 34px reveal with a 34px
       scroll), and the old handler answered that echo by hiding the ticker again — an oscillation that
       could leave the ticker stuck a pixel tall. A small move inside the slide's window is ignored. */
    if((performance.now() - tkAt) < 420){ lastY = y; tkTick = false; return; }
    const was = root.classList.contains('tkhide');
    if(y <= 24) root.classList.remove('tkhide');
    else if(y > lastY + 6) root.classList.add('tkhide');
    else if(y < lastY - 24) root.classList.remove('tkhide');
    if(root.classList.contains('tkhide') !== was){
      tkAt = performance.now();
      root.classList.add('tk-moving');
      setTimeout(()=>{ root.classList.remove('tk-moving'); }, 520);
    }
    lastY = y;
    tkTick = false;
  }
  addEventListener('scroll', ()=>{
    if(tkTick) return;
    tkTick = true;
    requestAnimationFrame(tkUpdate);
  }, {passive:true});
}

/* ============ THE DOSSIER ============ */
function statBar(label, v, colour){
  return '<div class="dz-stat"><div class="dz-t"><span>' + label + '</span><span class="num">' + v.toFixed(3) + '</span></div>'
    + '<div class="dz-track"><i style="width:' + (v / 1.618 * 100) + '%;background:' + colour + '"></i></div></div>';
}
function renderDossier(k){
  const box = document.getElementById('dossier');
  if(!box) return;
  const c = standFind(k) || CREW_ACTIVE[0];
  const ch = CREW_CHAR[c[0]];
  if(!ch) return;
  const col = ch.state === 'unverified' ? '#8FA3C9' : c[3];
  if(ch.state === 'inbound' || ch.state === 'unverified'){
    const unv = ch.state === 'unverified';
    const tpl = document.getElementById('verifyForm');
    const formHTML = tpl ? tpl.innerHTML.replace('__CASE__', ch.epithet.replace('unverified \u00b7 ', '').toUpperCase()).replace('__WHO__', ch.name) : '';
    box.innerHTML = '<div class="dz-in dz-' + ch.state + '">'
      + '<div class="dz-head"><span class="dz-name" style="color:' + col + '">' + ch.name + '</span><span class="dz-ep">' + ch.epithet + '</span></div>'
      + elementLine(k, col) + chemLine(k)
      + '<p class="dz-temp">' + ch.temperament + '</p>'
      + (unv
          ? '<div class="dz-stats dz-unknown">' + (statBar('REACH', 0, col) + statBar('CHARGE', 0, col) + statBar('SIGNAL', 0, col)).split('0.000').join('?') + '</div><div class="dz-sum">REACH + CHARGE + SIGNAL = <b>?</b> \u00b7 nobody has measured it \u00b7 the sum will be \u03c6\u00b2 when it is</div>'
          : '<div class="dz-stats">' + statBar('REACH', ch.reach, col) + statBar('CHARGE', ch.charge, col) + statBar('SIGNAL', ch.signal, col) + '</div><div class="dz-sum">REACH + CHARGE + SIGNAL = <b>' + PHI2 + '</b> \u00b7 \u03c6\u00b2 \u00b7 the same for every crew member</div>')
      + '<div class="dz-foot"><span class="dz-ch">' + ch.chooses + '</span>'
      + (unv
          ? '<button class="btn btn-gold dz-verify-btn" type="button">VERIFY A SIGHTING</button>'
          : '<a class="btn btn-gold dz-claim" href="#alerts" data-route="impound">INBOUND \u00b7 GET THE ALERT</a>')
      + '</div>'
      + (unv ? '<div class="dz-verify" hidden>' + formHTML + '</div>' : '')
      + '</div>';
    box.classList.add('on');
    const vb = box.querySelector('.dz-verify-btn'), vf = box.querySelector('.dz-verify');
    if(vb && vf){ vb.addEventListener('click', ()=>{ vf.hidden = !vf.hidden; vb.textContent = vf.hidden ? 'VERIFY A SIGHTING' : 'CLOSE'; const first = vf.querySelector('input,textarea'); if(!vf.hidden && first) first.focus(); }); }
    return;
  }
  box.innerHTML = '<div class="dz-in">'
    + '<div class="dz-head"><span class="dz-name" style="color:' + col + '">' + ch.name + '</span>'
    + '<span class="dz-ep">' + ch.epithet + '</span></div>'
    + elementLine(c[0], col) + chemLine(c[0])
    + '<p class="dz-temp">' + ch.temperament + '</p>'
    + '<div class="dz-stats">' + statBar('REACH', ch.reach, col) + statBar('CHARGE', ch.charge, col) + statBar('SIGNAL', ch.signal, col) + '</div>'
    + '<div class="dz-sum">REACH + CHARGE + SIGNAL = <b>' + PHI2 + '</b> \u00b7 \u03c6\u00b2 \u00b7 the same for every crew member</div>'
    + '<div class="dz-foot"><span class="dz-ch">' + ch.chooses + '</span>'
    + (soldOut('v-' + c[0])
        ? '<button class="btn btn-gold dz-claim is-gone" type="button" data-gone="v-' + c[0] + '" disabled>' + ch.name + ' is gone for good</button></div>'
        : '<button class="btn btn-gold dz-claim" data-add="v-' + c[0] + '">Claim ' + ch.name + ' \u00b7 $33</button></div>')
    + '</div>';
  box.classList.add('on');
}


/* ============ THE FIVE STAND ============ */
{
  const row = document.getElementById('standRow');
  if(row){
    const chibi = (hex, ink) =>
      '<svg viewBox="0 0 100 150" aria-hidden="true">'
      + '<ellipse cx="50" cy="141" rx="26" ry="5" fill="rgba(0,0,0,.18)"/>'
      + '<path d="M34 92 h32 c5 0 8 4 8 9 v22 c0 5-3 9-8 9 H34 c-5 0-8-4-8-9 V101 c0-5 3-9 8-9 Z" fill="' + hex + '"/>'
      + '<path d="M26 100 c-7 3-11 9-11 17 v8 c0 4 6 4 6 0 v-8 c0-4 2-7 5-9 Z" fill="' + hex + '"/>'
      + '<path d="M74 100 c7 3 11 9 11 17 v8 c0 4-6 4-6 0 v-8 c0-4-2-7-5-9 Z" fill="' + hex + '"/>'
      + '<rect x="34" y="112" width="32" height="6" rx="3" fill="' + ink + '"/>'
      + '<circle cx="50" cy="115" r="5.5" fill="#FFFFFF"/>'
      + '<text x="50" y="117.6" font-family="IBM Plex Mono, monospace" font-size="4.6" fill="' + ink + '" text-anchor="middle">618</text>'
      + '<path d="M38 132 h10 v9 h-14 v-4 c0-3 2-5 4-5 Z" fill="' + ink + '"/>'
      + '<path d="M62 132 h-10 v9 h14 v-4 c0-3-2-5-4-5 Z" fill="' + ink + '"/>'
      + '<path d="M50 12 C72 12 86 30 86 51 C86 74 70 90 50 96 C30 90 14 74 14 51 C14 30 28 12 50 12 Z" fill="' + hex + '" stroke="' + ink + '" stroke-width="3"/>'
      + '<ellipse cx="35" cy="54" rx="12.5" ry="17" transform="rotate(-16 35 54)" fill="#FFFFFF"/>'
      + '<ellipse cx="65" cy="54" rx="12.5" ry="17" transform="rotate(16 65 54)" fill="#FFFFFF"/>'
      + '<circle cx="35.5" cy="57" r="5.6" fill="' + ink + '"/><circle cx="64.5" cy="57" r="5.6" fill="' + ink + '"/>'
      + '<circle cx="33.4" cy="53.6" r="2.1" fill="#FFFFFF"/><circle cx="62.4" cy="53.6" r="2.1" fill="#FFFFFF"/>'
      + '<ellipse cx="23.5" cy="72" rx="5" ry="3" fill="#FFFFFF" opacity=".45"/>'
      + '<ellipse cx="76.5" cy="72" rx="5" ry="3" fill="#FFFFFF" opacity=".45"/>'
      + '</svg>';
    window.chibiSVG = chibi;
    row.innerHTML = CREW_ACTIVE.map(([k,an,cn,hex,line], i)=>
      '<button class="stand-fig" data-stand="' + k + '" style="--sc:' + hex + ';animation-delay:' + (i * 0.09).toFixed(2) + 's" aria-label="' + an + ' \u2014 read the dossier">'
      + chibi(hex, k === 'yellow' ? '#8A7405' : line)
      + '<span class="stand-nm">' + (CREW_CHAR[k] ? CREW_CHAR[k].name : an.replace(' ALIEN','')) + '</span>'
      + '<span class="stand-sub">' + an.replace(' ALIEN','') + '</span></button>').join('')
    + STAND_EXTRA.map(([k,an,cn,hex,line], i)=>{
        const ch = CREW_CHAR[k], shadow = ch.state === 'unverified';
        return '<button class="stand-fig ' + (shadow ? 'is-shadow' : 'is-inbound') + '" data-stand="' + k + '" style="--sc:' + (shadow ? '#8FA3C9' : hex) + ';animation-delay:' + ((5 + i) * 0.09).toFixed(2) + 's" aria-label="' + an + ' \u2014 ' + (shadow ? 'unverified, verify a sighting' : 'inbound, read the dossier') + '">'
          + chibi(hex, line)
          + (shadow ? '<span class="stand-q" aria-hidden="true">?</span>' : '<span class="stand-in" aria-hidden="true">INBOUND</span>')
          + '<span class="stand-nm">' + (shadow ? cn : ch.name) + '</span>'
          + '<span class="stand-sub">' + (shadow ? 'UNVERIFIED' : cn) + '</span></button>'; }).join('');
    const spark = document.getElementById('standSpark');
    if(spark){
      let s = '';
      for(let i = 0; i < 14; i++){
        s += '<i style="left:' + (4 + Math.random()*92).toFixed(1) + '%;top:' + (8 + Math.random()*80).toFixed(1)
           + '%;animation-delay:' + (Math.random()*3.4).toFixed(2) + 's"></i>';
      }
      spark.innerHTML = s;
    }
    const flash = document.getElementById('standFlash');
    const word = document.getElementById('standWord');
    renderDossier(CREW_ACTIVE[0][0]);
    row.addEventListener('click', e=>{
      const b = e.target.closest('[data-stand]');
      if(!b) return;
      const k = b.dataset.stand;
      const c = standFind(k);
      if(!c) return;
      if(flash && word && CREW_CHAR[k] && !CREW_CHAR[k].state && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        flash.style.setProperty('--fc', c[3]);
        word.textContent = c[1].replace(' ALIEN','') + ' \u00b7 SUITED';
        flash.classList.remove('go'); void flash.offsetWidth; flash.classList.add('go');
      }
      renderDossier(k);
      /* no jump — let them read the dossier; the claim button is the way out */
    });
  }
}

document.addEventListener('click', e=>{
  const w = e.target.closest('#whatIs');
  if(!w) return;
  const sec = document.getElementById('whatthis');
  if(sec) scrollTo({top: sec.getBoundingClientRect().top + scrollY - 20,
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});

/* ============ SALVAGE · rare vessels ============ */
/* ============ FIELD STATUS · a bottle is never extinct, only out of our hands ============ */
const FIELD_STATUS = {
  circulating: { label:'IN CIRCULATION',  colour:'#00CE7E', note:'Held at the station. Available now.' },
  scarce:      { label:'SCARCE',          colour:'#F8E44B', note:'Few left in our hands.' },
  last:        { label:'LAST SIGHTING',   colour:'#FF8C3D', note:'One remains at the station.' },
  wild:        { label:'IN THE WILD',     colour:'#389EE1', note:'None left at the station. Every surviving example is out there \u2014 in a cage, on a shelf, still holding water. Believed extant.' },
  unrecorded:  { label:'UNRECORDED',      colour:'#8FA3C9', note:'No confirmed example known to exist anywhere. Presumed lost until somebody proves otherwise.' },
  rediscovered:{ label:'REDISCOVERED',    colour:'#B98CFF', note:'Found again after being written off. The record is amended.' }
};
function fieldStatus(a){
  if(a.status && FIELD_STATUS[a.status]) return FIELD_STATUS[a.status];
  const left = a.left == null ? 1 : a.left;
  if(left <= 0) return FIELD_STATUS.wild;
  if(left === 1) return FIELD_STATUS.last;
  if(a.held && left / a.held <= 0.2) return FIELD_STATUS.scarce;
  return FIELD_STATUS.circulating;
}

/* ============ THE FUEL BAY · partner nutrition, zero inventory ============
   Two honest arrangements, and the card always says which one:
     mode:'stocked' — the maker is a Shopify Collective supplier. The product
       lives in our store, inventory syncs from theirs, the customer checks out
       here, Shopify splits the payment and the maker ships. We set the price.
     mode:'partner'  — the maker is not on Collective. We send the customer to
       them, they take the order and ship it, we earn a commission. FTC requires
       this be disclosed, so it is disclosed on the card and under the grid.
   ========================================================================= */
const FUEL = [
  { id:'fuel-1', mode:'partner', brand:'\u2014', name:'GEL \u00b7 PARTNER SPOT \u00b7 OPEN',
    note:'Partner spot \u00b7 open. A gel maker docks here when a partnership is signed \u2014 sold by the maker, from their own shelf. No name until it\u2019s real.',
    price:null, url:null, handle:null, kind:'GEL' },
  { id:'fuel-2', mode:'stocked', brand:'\u2014', name:'DRINK MIX \u00b7 PARTNER SPOT \u00b7 OPEN',
    note:'Partner spot \u00b7 open. A drink-mix maker docks here when a partnership is signed \u2014 stocked here, shipped from their own shelf. No name until it\u2019s real.',
    price:null, url:null, handle:null, kind:'MIX' }
];
function fuelCard(f){
  const stocked = f.mode === 'stocked';
  const tag = stocked ? 'SHIPS FROM THE MAKER' : 'SOLD BY THE MAKER';
  const tagCol = stocked ? '#4DFF7C' : '#D4A741';
  const cta = stocked
    ? (f.handle ? '<button class="add" data-add="fuel:' + f.handle + '">Add to hold</button>'
                : '<button class="add soon" disabled>Spot open</button>')
    : (f.url ? '<a class="add" data-pump="' + f.id + '" href="' + f.url + '" target="_blank" rel="sponsored noopener noreferrer">Buy from ' + (f.brand !== '\u2014' ? f.brand : 'the maker') + ' \u2192</a>'
             : '<button class="add soon" disabled>Spot open</button>');
  return '<article class="fuel-card">'
    + '<div class="fuel-top"><span class="fuel-kind">' + f.kind + '</span>'
    + '<span class="fuel-tag" style="color:' + tagCol + ';border-color:' + tagCol + '">' + tag + '</span></div>'
    + '<div class="fuel-brand">' + f.brand + '</div>'
    + '<div class="fuel-name">' + f.name + '</div>'
    + '<p class="fuel-note">' + (f.note || '') + '</p>'
    + '<div class="fuel-cta"><span class="fuel-price">' + (typeof f.price === 'number' ? '$' + f.price : '\u2014') + '</span>'
    + cta + '</div>'
    + (stocked ? '' : '<span class="fuel-aff">commission link \u00b7 ' + (f.accepted ? 'approved creative' : 'descriptive only') + '</span>')
    + '</article>';
}
{
  const t = (typeof window !== 'undefined') && window.STATION_FUEL;
  if(Array.isArray(t) && t.length){
    FUEL.length = 0;
    t.forEach(b=> FUEL.push({
      id:'fuel-' + b.id, mode: b.mode || 'partner', brand: b.brand || '\u2014',
      name:(b.name || 'PARTNER PRODUCT').toUpperCase(), note: b.note || '',
      price:(typeof b.price === 'number') ? b.price : null,
      url: b.url || null, handle: b.handle || null, kind:(b.kind || 'FUEL').toUpperCase(),
      accepted: !!b.accepted, take: (typeof b.take === 'number') ? b.take : (parseFloat(b.take) || null), sid: b.sid || null
    }));
  }
  const g = document.getElementById('fuelGrid');
  if(g) g.innerHTML = FUEL.map(fuelCard).join('');
  const d = document.getElementById('fuelDisc');
  if(d) d.textContent = FUEL.some(f=>f.mode === 'partner')
    ? 'Some links on this deck earn The Proportions a commission when you buy. It costs you nothing extra, we hold no stock, and the maker handles payment, shipping and support. We only list fuel we would carry ourselves.'
    : 'Every product on this deck ships directly from the maker.';
}

/* ============ THE ASCENSION · five stages per crew member ============
   Reconciles the population cascade with the three-stage evolution canon:
   BASE = SLEEPER, AWAKENED = SENSITIVE, ASCENDED = RESONANT — with SEEKER
   inserted below and DEMIGOD crowning it. Metal, weight and count per tier
   are the canon values from the Futura Rule table.
   ==================================================================== */
const ASCENSION = [
  { t:'T0', key:'sleeper',   name:'SLEEPER',   canon:'BASE',
    metal:'EMBER',  mhex:'#8A4B1E', weight:'300 LIGHT',  count:'8,000,000,000',
    line:'Hears the noise. Has not looked up yet.',
    unlock:'Every alien starts here. So did you.',
    price:'33', pour:'FIRST POUR \u00b7 333 OF 500', incl:'the vessel \u00b7 base body \u00b7 no confirmation yet \u2014 sleepers are not on record' },
  { t:'T1', key:'seeker',    name:'SEEKER',    canon:'—',
    metal:'COPPER', mhex:'#B4703A', weight:'450 BOOK',   count:'2,300,000',
    line:'Started looking. Does not know for what.',
    unlock:'Carries the mark in daylight.',
    price:'99', pour:'FIRST POUR \u00b7 99 MADE', incl:'serialized copper band \u00b7 your burn card, printed \u2014 the first time the station writes your name' },
  { t:'T2', key:'sensitive', name:'SENSITIVE', canon:'AWAKENED',
    metal:'BRONZE', mhex:'#A98B54', weight:'600 MEDIUM', count:'230,000',
    line:'Feels the pull. Runs before the sun is up and cannot say why.',
    unlock:'The metal arrives. The pupils light.',
    price:'333', pour:'FIRST POUR \u00b7 33 MADE', incl:'awakened colourway \u00b7 the confirmation dossier \u2014 SPECIES: ALIEN, abilities read: reach \u00b7 charge \u00b7 signal' },
  { t:'T3', key:'resonant',  name:'RESONANT',  canon:'ASCENDED',
    metal:'AMBER',  mhex:'#D4A741', weight:'750 BOLD',   count:'23,000',
    line:'Answers to the frequency. Other people can tell.',
    unlock:'Rings outward. Seen across the parking lot and across the room.',
    price:'999', pour:'FIRST POUR \u00b7 23 MADE', incl:'ascended body with the ring \u00b7 dossier \u00b7 your name entered in the station registry' },
  { t:'T4', key:'demigod',   name:'DEMIGOD',   canon:'GROVE',
    metal:'GOLD',   mhex:'#F0C75E', weight:'900 BLACK',  count:'2,300',
    line:'Does not need the vessel to be seen. Carries one anyway.',
    unlock:'2,300 of these exist at any time. The number does not move.',
    price:'3,333.33', pour:'FIRST POUR \u00b7 12 MADE', incl:'full gold, engraved \u00b7 sealed dossier \u00b7 a line in the DEMI-GODS ledger \u00b7 12 of the 2,300 \u00b7 the station calls you first when new lines dock' }
];
function ascArt(hex, i, size){
  const s = ASCENSION[i];
  const mh = s.mhex;
  const lift = [0, 2, 5, 10, 18][i];          /* they leave the ground */
  const bw = [2.4, 2.7, 3, 3.4, 4][i];        /* line weight climbs with the type weight */
  const awake = i >= 2;                       /* the metal arrives at SENSITIVE */
  const skin = hex;
  const ink = awake ? mh : '#141C2B';
  let aura = '', extra = '';
  aura += '<ellipse cx="50" cy="141" rx="' + (26 - i*3) + '" ry="' + (5 - i*0.6) + '" fill="rgba(0,0,0,.16)"/>';
  if(i >= 2) aura += '<circle cx="50" cy="66" r="62" fill="none" stroke="' + mh + '" stroke-width="1.1" opacity="' + (0.16 + i*0.06) + '"/>';
  if(i >= 3){
    aura += '<circle cx="50" cy="66" r="76" fill="none" stroke="' + mh + '" stroke-width="1" opacity="0.24" stroke-dasharray="4 7"/>';
    extra += '<path d="M26 100 c-11 9-15 24-13 40" fill="none" stroke="' + mh + '" stroke-width="1.8" opacity=".45"/>'
           + '<path d="M74 100 c11 9 15 24 13 40" fill="none" stroke="' + mh + '" stroke-width="1.8" opacity=".45"/>';
  }
  if(i === 4){
    for(let a = 0; a < 16; a++){
      aura += '<line x1="50" y1="66" x2="50" y2="-34" stroke="' + mh + '" stroke-width="1.5" opacity="0.45" transform="rotate(' + (a*22.5) + ' 50 66)"/>';
    }
    aura += '<circle cx="50" cy="66" r="48" fill="none" stroke="' + mh + '" stroke-width="2.4" opacity=".85"/>';
    extra += '<ellipse cx="19" cy="122" rx="9" ry="10" fill="' + mh + '" opacity=".35"/>'
           + '<ellipse cx="81" cy="122" rx="9" ry="10" fill="' + mh + '" opacity=".35"/>'
           + '<ellipse cx="50" cy="2" rx="24" ry="6" fill="none" stroke="' + mh + '" stroke-width="2.4" opacity=".9"/>';
  }
  /* eyes: open at every stage \u2014 level one is the mark itself */
  const eyes = '<ellipse cx="35" cy="54" rx="12.5" ry="17" transform="rotate(-16 35 54)" fill="#FFFFFF"/>'
      + '<ellipse cx="65" cy="54" rx="12.5" ry="17" transform="rotate(16 65 54)" fill="#FFFFFF"/>'
      + '<circle cx="35.5" cy="57" r="5.6" fill="' + ink + '"/><circle cx="64.5" cy="57" r="5.6" fill="' + ink + '"/>'
      + '<circle cx="33.4" cy="53.6" r="2.1" fill="#FFFFFF"/><circle cx="62.4" cy="53.6" r="2.1" fill="#FFFFFF"/>';
  return '<svg viewBox="-34 -40 168 200" style="width:' + size + 'px;height:auto" aria-hidden="true">'
    + aura
    + '<g transform="translate(0 ' + (-lift) + ')">'
    + '<path d="M34 92 h32 c5 0 8 4 8 9 v22 c0 5-3 9-8 9 H34 c-5 0-8-4-8-9 V101 c0-5 3-9 8-9 Z" fill="' + skin + '" stroke="' + ink + '" stroke-width="' + bw + '"/>'
    + '<path d="M26 100 c-7 3-11 9-11 17 v8 c0 4 6 4 6 0 v-8 c0-4 2-7 5-9 Z" fill="' + skin + '" stroke="' + ink + '" stroke-width="' + (bw*0.8) + '"/>'
    + '<path d="M74 100 c7 3 11 9 11 17 v8 c0 4-6 4-6 0 v-8 c0-4-2-7-5-9 Z" fill="' + skin + '" stroke="' + ink + '" stroke-width="' + (bw*0.8) + '"/>'
    + '<rect x="34" y="112" width="32" height="6" rx="3" fill="' + ink + '"/>'
    + '<circle cx="50" cy="115" r="5.5" fill="' + (i >= 3 ? mh : '#FFFFFF') + '"/>'
    + '<path d="M38 132 h10 v9 h-14 v-4 c0-3 2-5 4-5 Z" fill="' + ink + '"/>'
    + '<path d="M62 132 h-10 v9 h14 v-4 c0-3-2-5-4-5 Z" fill="' + ink + '"/>'
    + extra
    + '<path d="M50 12 C72 12 86 30 86 51 C86 74 70 90 50 96 C30 90 14 74 14 51 C14 30 28 12 50 12 Z" fill="' + skin + '" stroke="' + (awake ? mh : ink) + '" stroke-width="' + (bw + 0.6) + '"/>'
    + eyes
    + '<ellipse cx="23.5" cy="72" rx="5" ry="3" fill="#FFFFFF" opacity=".4"/><ellipse cx="76.5" cy="72" rx="5" ry="3" fill="#FFFFFF" opacity=".4"/>'
    + (i === 4 ? '<circle cx="50" cy="54" r="44" fill="none" stroke="' + mh + '" stroke-width="3" opacity=".9"/>' : '')
    + '</g></svg>';
}
{
  const tabs = document.getElementById('ascTabs');
  const row = document.getElementById('ascRow');
  const det = document.getElementById('ascDetail');
  if(tabs && row){
    let who = 0, at = 4;
    function paint(){
      const c = CREW_ACTIVE[who], hex = c[3];
      tabs.innerHTML = CREW_ACTIVE.map(([k,an,cn,hx], i)=>
        '<button class="asc-tab' + (i === who ? ' on' : '') + '" data-asc="' + i + '" style="--ac:' + hx + '">'
        + an.replace(' ALIEN','') + '</button>').join('');
      row.innerHTML = ASCENSION.map((s, i)=>
        '<button class="asc-card' + (i === at ? ' on' : '') + '" data-ascstage="' + i + '" style="--mc:' + s.mhex + '">'
        + '<div class="asc-art">' + ascArt(hex, i, 96) + '</div>'
        + '<div class="asc-t">' + s.t + '</div>'
        + '<div class="asc-nm">' + s.name + '</div>'
        + '<div class="asc-meta">' + s.metal + ' \u00b7 ' + s.weight + '</div>'
        + '<div class="asc-pr">$' + s.price + '</div>'
        + '</button>').join('');
      const s = ASCENSION[at];
      det.innerHTML = '<div class="asc-d-in">'
        + '<div class="asc-d-art">' + ascArt(hex, at, 150) + '</div>'
        + '<div class="asc-d-copy">'
        + '<span class="asc-d-t" style="color:' + s.mhex + '">' + s.t + ' \u00b7 ' + s.name
        + (s.canon !== '\u2014' ? ' \u00b7 ' + s.canon : '') + '</span>'
        + '<h3>' + c[1].replace(' ALIEN','') + ' at ' + s.name.toLowerCase() + '</h3>'
        + '<p>' + s.line + '</p>'
        + '<p class="asc-unlock">' + s.unlock + '</p>'
        + '<div class="asc-buy"><span class="asc-b-price">$' + s.price + '</span><span class="asc-b-pour">' + s.pour + '</span><span class="asc-b-incl">' + s.incl + '</span></div>'
        + (at === 4 ? '<div class="asc-vessel"><span class="asc-v-k">THE DEMIGOD VESSEL</span>'
        + '<p>One vessel for every demigod alive. <b>2,300 will ever exist</b> \u2014 not 2,300 per colour, 2,300 in total, across the life of the line.</p>'
        + '<div class="asc-v-row"><span class="asc-v-price">$3,333.33</span><span class="asc-v-note">2,300 EVER \u00b7 NOT YET DOCKED</span></div></div>' : '')
    + '<div class="asc-nums"><span>POPULATION</span><b>' + s.count + '</b>'
        + '<span>FREQUENCY</span><b style="color:' + s.mhex + '">' + s.metal + '</b>'
        + '<span>WEIGHT</span><b>' + s.weight + '</b></div>'
        + '</div></div>';
    }
    tabs.addEventListener('click', e=>{
      const b = e.target.closest('[data-asc]'); if(!b) return;
      who = +b.dataset.asc; paint();
    });
    row.addEventListener('click', e=>{
      const b = e.target.closest('[data-ascstage]'); if(!b) return;
      at = +b.dataset.ascstage; paint();
    });
    paint();
  }
}

/* ============ THE RARITY INDEX ============================================
   LUND-INV-219.C · The Honest Ranker methodology applied to physical objects.
   Same architecture as the figure ranker: named axes, fixed φ weights, one
   sourced data point per axis, versioned so any score can be reproduced later.
   House rule inherited from 219: NO DATA POINT WITHOUT A SOURCE. Unsourced
   values still compute, but they are marked, and the card says so.
   ========================================================================= */
const RI_VERSION = 'RI v1.0 \u00b7 219.C';
const RI_AXES = [
  { key:'population',  label:'POPULATION',   w:1.000,
    note:'Units ever produced. Log-scaled: 1 of 1 scores full, a million scores near zero.',
    norm:v => v > 0 ? 1 - (Math.log10(v) / 6) : 0.5 },
  { key:'survival',    label:'SURVIVAL',     w:0.618,
    note:'Share of the original population believed to still exist. Fewer survivors, higher score.',
    norm:v => 1 - (v == null ? 0.5 : v) },
  { key:'provenance',  label:'PROVENANCE',   w:0.382,
    note:'3 race-issued or team-used · 2 event-only · 1 retail · 0 unverified.',
    norm:v => (v == null ? 1 : v) / 3 },
  { key:'age',         label:'AGE',          w:0.236,
    note:'Years since production, saturating at 40.',
    norm:v => (v || 0) / 40 },
  { key:'restriction', label:'RESTRICTION',  w:0.146,
    note:'3 never publicly sold · 2 one region or event · 1 limited run · 0 open production.',
    norm:v => (v == null ? 0 : v) / 3 },
  { key:'condition',   label:'CONDITION',    w:0.090,
    note:'3 unused · 2 excellent · 1 used · 0 damaged.',
    norm:v => (v == null ? 2 : v) / 3 },
  { key:'demand',      label:'DEMAND',       w:0.056,
    note:'Observed market interest 0\u20133. Deliberately the lightest axis: scarcity is a fact, demand is a mood.',
    norm:v => (v == null ? 1 : v) / 3 }
];
const RI_TOTAL = RI_AXES.reduce((s,a)=> s + a.w, 0);
const RI_TIERS = [[90,'DEMIGOD','#D4A741'],[76.4,'RESONANT','#B98CFF'],[61.8,'SENSITIVE','#389EE1'],[38.2,'SEEKER','#00CE7E'],[0,'SLEEPER','#8FA3C9']];

/* a data point is {v, src}. bare numbers are accepted and flagged unsourced. */
function riPoint(item, key){
  const legacy = key === 'condition' ? 'condition_score' : key;
  const raw = (item.data && item.data[key] !== undefined) ? item.data[key] : item[legacy];
  if(raw && typeof raw === 'object' && 'v' in raw) return { v: raw.v, src: raw.src || null };
  return { v: raw, src: null };
}
function rarityIndex(a){
  const clamp = v => Math.max(0, Math.min(1, v));
  let raw = 0, sourced = 0;
  const axes = RI_AXES.map(ax=>{
    const p = riPoint(a, ax.key);
    const n = clamp(ax.norm(p.v));
    raw += n * ax.w;
    if(p.src) sourced++;
    return { key:ax.key, label:ax.label, weight:ax.w, value:p.v, source:p.src,
             norm:n, points:(n * ax.w / RI_TOTAL) * 100 };
  });
  const score = Math.round((raw / RI_TOTAL) * 1000) / 10;
  const tier = RI_TIERS.find(t => score >= t[0]) || RI_TIERS[RI_TIERS.length - 1];
  return { score, tier:tier[1], colour:tier[2], axes, sourced, total:RI_AXES.length,
           version:RI_VERSION, cited: sourced === RI_AXES.length };
}

/* ============ THE RARITY INDEX · the OG five =============================
   The index already scores the salvage shelf. The vessels in the bay have
   the same facts available, so they are scored on the same axes with the
   same weights — nothing special-cased, nothing flattered.

   One honest decision: SURVIVAL stays 0. Selling a vessel does not destroy
   it, so a colour selling out does NOT raise its rarity score — the object
   is exactly as rare on day one as on the day the last one leaves. What
   changes is availability, and that is reported separately. */
function ogRarity(colourId){
  return rarityIndex({
    population:  { v: 100, src: 'the run' },   /* 100 per colour, never repeated */
    survival:    { v: 0,   src: 'new run' },   /* none lost yet */
    provenance:  { v: 3,   src: 'made and numbered by the station' },
    age:         { v: 0,   src: '2026' },
    restriction: { v: 2,   src: 'one run · never reprinted' },
    condition:   { v: 3,   src: 'unused' },
    demand:      { v: 1,   src: 'pre-release' }
  });
}

const SALVAGE = [
  { id:'sv-ltrek-blue', name:'PRO TEAM 550ML · BLUE',
    sub:'a 2026 team colorway — no longer listed by its maker',
    origin:'a pro team\'s retail line', year:'2026 season', size:'550 ml', condition:'New, unused',
    held:null, left:null, price:null, art:'steel',
    population:50000, survival:0.6, provenance:1, age:0, restriction:1, condition_score:3, demand:2, photo:svPhoto('sv-ltrek-blue'), handle:'lidl-trek-team-550ml-blue' },
  { id:'sv-ltrek-red', name:'PRO TEAM 550ML · RED',
    sub:'a 2026 team colorway — held at the station',
    origin:'a pro team\'s retail line', year:'2026 season', size:'550 ml', condition:'New, unused',
    held:null, left:null, price:null, art:'steel',
    population:50000, survival:0.6, provenance:1, age:0, restriction:1, condition_score:3, demand:2, photo:svPhoto('sv-ltrek-red'), handle:'lidl-trek-team-550ml-red' },
  { id:'sv-tdf', name:'THE JULY RACE · OFFICIAL BOTTLE',
    sub:'the last ones available · recovered 2026',
    origin:'the big July race, official issue', year:'—', size:'—', condition:'—',
    held:21, left:21, price:null, art:'gold',
    population:null, survival:null, provenance:null, age:null, restriction:null, condition_score:null, demand:2, provisional:true, photo:svPhoto('sv-tdf'), handle:'tour-de-france-race-bottle' }
];

/* V94 · SALVAGE PHOTOS — drop <id>.jpg into assets/ and it appears.
   No photo present? the vector outline still renders. Nothing breaks. */
function svPhoto(id){
  var base = (typeof window !== 'undefined' && window.STATION_ASSETS) || '';
  return base ? base + id + '.jpg' : null;
}

/* V191 · THE SHELF READS THE STORE.
   The layout writes window.STATION_SALVAGE from real products (a `salvage`
   collection, or anything tagged salvage / cold-case). Matching is by handle:
   a product the roster already knows adopts the store's photo, price, stock
   and lines; a product the roster has never met becomes a new card. Nothing
   a visitor can see depends on a theme-editor block any more. */
function svClean(s){ return String(s == null ? '' : s).replace(/</g, '\u2039').replace(/>/g, '\u203a').replace(/"/g, '\u201d'); }
function svFromStore(p){
  var m = p.meta || {};
  return { id: 'sv-' + p.handle, handle: p.handle,
    name: svClean(p.title || 'UNTITLED VESSEL').toUpperCase(),
    sub: svClean(m.sub || p.body || 'recovered from the surface'),
    origin: svClean(m.origin) || '\u2014', year: svClean(m.year) || '\u2014',
    size: svClean(m.size) || '\u2014', condition: svClean(m.condition) || '\u2014',
    held: null, left: null, price: null, art: 'steel', photo: null,
    population: null, survival: null, provenance: null, age: null, restriction: null,
    condition_score: null, demand: null, provisional: true, tags: [], store: true };
}
function svAdopt(a, p){
  if (p.img) a.photo = p.img;
  if (p.price != null && p.price > 0){ a.price = Math.round(p.price) / 100; a.price_text = p.price_text; }
  if (typeof p.qty === 'number'){
    if (a.held == null || p.qty > a.held) a.held = Math.max(p.qty, 1);
    a.left = p.qty;
  }
  a.url = p.url || a.url || null;
  a.vid = p.vid || null;
  a.tags = Array.isArray(p.tags) ? p.tags.slice() : (a.tags || []);
  a.sold_out = (p.available === false) || (typeof p.qty === 'number' && p.qty <= 0);
  var m = p.meta || {};
  ['origin', 'year', 'size', 'condition'].forEach(function(k){ if (m[k]) a[k] = svClean(m[k]); });
  if (m.sub) a.sub = svClean(m.sub);
  /* the ladder, by hand: a status:<key> tag pins the seal */
  a.tags.forEach(function(t){
    var mm = /^status:(circulating|scarce|last|wild|unrecorded|rediscovered)$/i.exec(String(t).trim());
    if (mm) a.status = mm[1].toLowerCase();
  });
}
function svMergeStore(list){
  var store = (typeof window !== 'undefined' && window.STATION_SALVAGE) || [];
  if (!Array.isArray(store) || !store.length) return list;
  var byHandle = {};
  list.forEach(function(a){ if (a.handle) byHandle[a.handle] = a; });
  store.forEach(function(p){
    if (!p || !p.handle) return;
    var a = byHandle[p.handle];
    if (!a){ a = svFromStore(p); list.push(a); byHandle[p.handle] = a; }
    svAdopt(a, p);
  });
  return list;
}
svMergeStore(SALVAGE);
function svArt(kind){
  const c = kind === 'gold' ? '#D4A741' : (kind === 'steel' ? '#7FA8D9' : '#8FA3C9');
  return '<svg viewBox="0 0 120 200" role="img" aria-label="rare vessel">'
    + '<rect x="46" y="6" width="28" height="15" rx="4" fill="none" stroke="' + c + '" stroke-width="2.4"/>'
    + '<rect x="40" y="19" width="40" height="10" rx="3" fill="none" stroke="' + c + '" stroke-width="2.4"/>'
    + '<path d="M36 31 h48 c2 15 8 19 8 36 v88 c0 9-6 15-15 15 H43 c-9 0-15-6-15-15 V67 c0-17 6-21 8-36 Z" '
    + 'fill="none" stroke="' + c + '" stroke-width="2.4"/>'
    + '<rect x="36" y="74" width="48" height="66" rx="8" fill="none" stroke="' + c + '" stroke-width="1.5" opacity=".7"/>'
    + '<line x1="28" y1="118" x2="92" y2="118" stroke="' + c + '" stroke-width="1.4" opacity=".6"/>'
    + '<text x="60" y="112" font-family="IBM Plex Mono, monospace" font-size="9" letter-spacing="2" fill="' + c + '" text-anchor="middle">ARTIFACT</text>'
    + '<text x="60" y="132" font-family="IBM Plex Mono, monospace" font-size="6.5" letter-spacing="1.6" fill="' + c + '" text-anchor="middle" opacity=".8">PHOTO PENDING</text>'
    + '</svg>';
}
/* ============ THEME BRIDGE · salvage from Shopify, stock included ============ */
/* On the live store, SALVAGE is built by the theme from real products, so stock,
   price and field status are true at page render — no crawler, no feed required. */
function adoptThemeSalvage(){
  /* V191 · the store feed is merged, never swapped in — re-running is harmless */
  svMergeStore(SALVAGE);
  return SALVAGE.some(function(a){ return !!a.store; });
}

/* ============ LIVE FEED · the watcher, reporting in ============ */
function applyFeed(feed){
  if(!feed || !Array.isArray(feed.items)) return false;
  FEED_AT = feed.updated_at || null;
  MARKET = feed.items;
  feed.items.forEach(it=>{
    const a = SALVAGE.find(s=>s.id === it.id || s.feed_id === it.id);
    if(!a) return;
    if(typeof it.left === 'number') a.left = it.left;
    if(it.availability === 'OutOfStock' && a.left == null) a.status = 'wild';
    if(it.availability === 'InStock' && a.status === 'wild') a.status = 'rediscovered';
    a.market_price = it.price || null;
    a.market_seen = (it.checked_at || '').slice(0,10);
  });
  return true;
}
function feedStamp(){
  const el = document.getElementById('feedStamp');
  if(!el) return;
  if(!FEED_AT && window.STATION_MARKET && window.STATION_MARKET.updated_at) FEED_AT = window.STATION_MARKET.updated_at;
  if(!FEED_AT){ el.textContent = ''; return; }
  const mins = Math.max(0, Math.round((Date.now() - new Date(FEED_AT).getTime()) / 60000));
  const when = mins < 60 ? mins + ' MIN AGO'
             : (mins < 1440 ? Math.round(mins/60) + ' HR AGO' : Math.round(mins/1440) + ' D AGO');
  el.innerHTML = '<span class="fs-dot"></span>LIVE \u00b7 STOCK CHECKED ' + when;
}
function renderSalvage(){
  adoptThemeSalvage();
  const vg = document.getElementById('vesselGrid');
  if(vg && vg.parentNode){
    const d = document.createElement('div');
    d.innerHTML = shelfStrip(null, 'ALSO ON THE SHELF');
    if(d.firstChild) vg.parentNode.insertBefore(d.firstChild, vg.nextSibling);
  }
  const g = document.getElementById('salvageGrid');
  if(g) g.innerHTML = SALVAGE.map(svCard).join('');
  pullFeed();
  setInterval(pullFeed, 300000);
}
async function pullFeed(){
  /* the theme injects market data straight from a Shopify metafield — no request at all */
  const baked = (typeof window !== 'undefined') && window.STATION_MARKET;
  if(baked && (Array.isArray(baked) || Array.isArray(baked.items))){
    if(applyFeed(Array.isArray(baked) ? {items:baked, updated_at:null} : baked)){
      renderSalvage(); feedStamp();
    }
    if(!STATION_FEED_URL) return;
  }
  if(!STATION_FEED_URL) return;
  try{
    const r = await fetch(STATION_FEED_URL, {cache:'no-store'});
    if(!r.ok) return;
    if(applyFeed(await r.json())){ renderSalvage(); feedStamp(); }
  }catch(e){ /* worker down or offline — the baked values stand */ }
}

/* ============ THE RANKER · what to reach for next ============ */
/* Fed by LUND MARKET WATCH — paste an export into MARKET to rank against live market data. */
let MARKET = [];   /* baked fallback — or paste an export from lund-market-watch --export-site */

/* ---- LIVE FEED: point this at your Worker and the shelf keeps itself current ---- */
const STATION_FEED_URL = (typeof window !== 'undefined' && window.STATION_FEED_URL) || '';
let FEED_AT = null;

function shelfItems(){
  const out = [];
  CREW_ACTIVE.forEach(([k,an,cn,hex])=>{
    const p = BOTTLES.find(b=>b.id === 'v-' + k);
    if(!p) return;
    out.push({ id:p.id, kind:'house', name:p.name, colour:hex, key:k,
      price:p.price, left:100, held:100, img:OG_IMG[k],
      population:100, survival:0.9, provenance:2, age:0, restriction:2,
      condition_score:3, demand:2 });
  });
  SALVAGE.forEach(a=>{
    out.push(Object.assign({}, a, { kind:'salvage', img:null, colour:'#7FA8D9' }));
  });
  return out;
}


function rankShelf(item){
  const all = shelfItems().filter(x=>x.id !== (item && item.id));
  const base = item ? rarityIndex(item).score : 50;
  const bp = (item && typeof item.price === 'number') ? item.price : 33;
  return all.map(x=>{
    const ri = rarityIndex(x);
    const st = fieldStatus(x);
    const available = !(x.left != null && x.left <= 0);
    const score = (available ? 1 : 0)
      + (1 - Math.min(1, Math.abs(ri.score - base) / 60)) * 0.618
      + (1 - Math.min(1, Math.abs((typeof x.price === 'number' ? x.price : 33) - bp) / 80)) * 0.382;
    return { x, ri, st, available, score };
  }).sort((a,b)=> b.score - a.score);
}
function shelfStrip(item, title){
  const picks = rankShelf(item).slice(0,3);
  if(!picks.length) return '';
  return '<div class="rk">'
    + '<div class="rk-head"><span class="kicker">' + title + '</span>'
    + '<span class="rk-by">RANKED BY THE RARITY INDEX</span></div>'
    + '<div class="rk-row">' + picks.map(p=>{
      const x = p.x;
      const art = x.img ? '<img src="' + x.img + '" alt="' + x.name + '">' : '<div class="rk-ph">\u25ce</div>';
      const price = typeof x.price === 'number' ? '$' + x.price : 'TBD';
      return '<button class="rk-card" ' + (x.kind === 'house'
        ? 'data-tkcolor="' + x.key + '"' : 'data-rkjump="salvage"') + '>'
        + '<div class="rk-art">' + art + '</div>'
        + '<div class="rk-nm">' + x.name + '</div>'
        + '<div class="rk-meta"><span style="color:' + p.ri.colour + '">' + p.ri.tier + ' \u00b7 ' + p.ri.score.toFixed(1) + '</span>'
        + '<span>' + price + '</span></div>'
        + '<div class="rk-st" style="color:' + p.st.colour + '">' + p.st.label + '</div>'
        + '</button>';
    }).join('') + '</div></div>';
}

/* V191 · a shelf photo that 404s (an asset not yet uploaded, a product image
   pulled) becomes the vector outline — the live store never shows a broken image */
window.STATION_SV_FALLBACK = function(img){
  try{
    var kind = img.getAttribute('data-art') || 'steel';
    var d = document.createElement('div'); d.innerHTML = svArt(kind);
    var n = d.firstElementChild;
    if(n && img.parentNode) img.parentNode.replaceChild(n, img); else img.remove();
  }catch(e){ try{ img.remove(); }catch(_e){} }
};
function svCard(a){
  const ri = (a.population != null || a.provisional) ? rarityIndex(a) : null;
  const st = fieldStatus(a);
  const known = a.held != null && a.left != null;
  const pct = (known && a.held) ? (a.left / a.held * 100) : 0;
  const gone = known && a.left <= 0;
  const priced = typeof a.price === 'number';
  return '<article class="sv-card' + (gone ? ' gone' : '') + '">'
    + '<div class="sv-art"><span class="sv-seal" style="background:' + st.colour + '">' + st.label + '</span>'
    + (ri ? '<span class="sv-rank" style="--rk:' + ri.colour + '">' + ri.tier + ' \u00b7 ' + ri.score.toFixed(1) + '</span>' : '')
    + (a.photo ? '<img class="sv-photo" src="' + a.photo + '" alt="' + a.name + '" loading="lazy" data-art="' + (a.art || 'steel') + '" onerror="STATION_SV_FALLBACK(this)">' : svArt(a.art)) + '</div>'
    + '<div class="sv-body">'
    + '<div class="sv-name">' + a.name + '</div>'
    + '<div class="sv-sub">' + a.sub + '</div>'
    + (a.market_price ? '<p class="sv-market">Seen elsewhere at ' + a.market_price + ' \u00b7 ' + (a.market_seen || 'recently') + '</p>' : '')
    + '<div class="sv-rows">'
    + '<div class="sv-row"><span>ORIGIN</span><b>' + a.origin + '</b></div>'
    + '<div class="sv-row"><span>YEAR</span><b>' + a.year + '</b></div>'
    + '<div class="sv-row"><span>SIZE</span><b>' + a.size + '</b></div>'
    + '<div class="sv-row"><span>CONDITION</span><b>' + a.condition + '</b></div>'
    + (ri ? '<div class="sv-row"><span>RARITY INDEX</span><b style="color:' + ri.colour + '">' + ri.score.toFixed(1) + ' \u00b7 ' + ri.tier + '</b></div>'
        + '<div class="sv-row"><span>SCORED ON</span><b>' + ri.version + '</b></div>'
        + '<div class="sv-row"><span>SOURCED</span><b style="color:' + (ri.cited ? '#00CE7E' : '#FF8C3D') + '">'
          + ri.sourced + ' OF ' + ri.total + ' AXES' + (ri.cited ? '' : ' \u00b7 UNSOURCED') + '</b></div>' : '')
    + '</div>'
    + '<div class="sv-left" style="color:' + st.colour + '">' + (gone ? st.label : (known ? a.left + ' OF ' + a.held + ' REMAINING' : 'COUNT PENDING')) + '</div>'
    + (gone ? '<p class="sv-status">' + st.note + '</p><button class="sv-report" data-report="' + a.id + '">Report a sighting</button>' : '')
    + '<div class="sv-bar"><i style="width:' + pct + '%"></i></div>'
    + '<div class="sv-cta"><span class="sv-price">' + (priced ? '$' + a.price : 'PRICE TBD') + '</span>'
    + (gone ? '<button class="add soon" disabled>Gone</button>'
            : (priced ? '<button class="add" data-add="' + a.id + '">Claim it</button>'
                      : '<button class="add soon" data-soon="' + a.id + '">Listing soon</button>'))
    + '</div>' + shelfStrip(a, gone ? 'IN THE WILD \u00b7 STILL ABOARD' : 'IF THIS ONE GOES') + '</div></article>';
}
{
  const X = document.getElementById('svCrossFive');
  if(X) X.innerHTML = CREW_ACTIVE.map(([k,an,cn,hex])=>
    '<img src="' + OG_IMG[k] + '" alt="' + an.toLowerCase() + ' vessel" draggable="false" data-tkcolor="' + k + '" style="--xc:' + hex + '">').join('');
  const L = document.getElementById('svLadder');
  if(L) L.innerHTML = ['circulating','scarce','last','wild','unrecorded','rediscovered'].map(k=>{
    const s = FIELD_STATUS[k];
    return '<div class="sv-lrow"><span class="sv-ldot" style="background:' + s.colour + '"></span>'
      + '<b style="color:' + s.colour + '">' + s.label + '</b><span>' + s.note + '</span></div>';
  }).join('');
  document.addEventListener('click', e=>{
    if(e.target.closest('[data-rkjump]')){ location.hash = '#/salvage'; return; }
    if(e.target.closest('[data-report]')) showToast('SIGHTING LOGGED \u00b7 the station is listening. Tell us where you saw it.');
  });
}
{
  const g = document.getElementById('salvageGrid');
  if(g) g.innerHTML = SALVAGE.map(svCard).join('');
}

/* ============ HERO SHOT · the five on rotation ============ */
{
  const stage = document.getElementById('hsStage');
  if(stage){
    const nameEl = document.getElementById('hsName');
    const dots = document.getElementById('hsDots');
    const glow = document.createElement('div'); glow.className = 'hs-glow';
    stage.appendChild(glow);
    CREW_ACTIVE.forEach(([k,an,cn,hex], i)=>{
      const im = document.createElement('img');
      im.src = OG_IMG[k]; im.alt = an + ' — OG alien 618 vessel, white shell with color plate'; im.draggable = false;
      if(i === 0) im.classList.add('on');
      stage.appendChild(im);
      const d = document.createElement('i');
      if(i === 0) d.classList.add('on');
      dots.appendChild(d);
    });
    const imgs = [...stage.querySelectorAll('img')];
    let at = 0;
    function show(i){
      at = i;
      const c = CREW_ACTIVE[i];
      /* V102: the vessel on show is the colour of the deck — the CLAIM button follows it */
      window.STATION_SHOWN = c[0];
      try { dispatchEvent(new CustomEvent('station:vessel', { detail: { color: c[0], hex: c[3] } })); } catch(e){}
      imgs.forEach((im,j)=> im.classList.toggle('on', j===i));
      [...dots.children].forEach((d,j)=> d.classList.toggle('on', j===i));
      nameEl.textContent = (OG.has(c[0]) ? 'OG ' : '') + c[1] + ' 618 \u00b7 $33';
      nameEl.style.color = c[3];
      const r = parseInt(c[3].slice(1,3),16), g = parseInt(c[3].slice(3,5),16), b = parseInt(c[3].slice(5,7),16);
      glow.style.background = 'radial-gradient(circle, rgba(' + r + ',' + g + ',' + b + ',.75), transparent 70%)';
    }
    show(0);
    if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      let t = setInterval(()=> show((at + 1) % CREW_ACTIVE.length), 3400);
      stage.addEventListener('pointerenter', ()=> clearInterval(t));
      stage.addEventListener('pointerleave', ()=> { t = setInterval(()=> show((at + 1) % CREW_ACTIVE.length), 3400); });
    }
    [...dots.children].forEach((d,i)=> d.addEventListener('click', ()=> show(i)));
  }
}

/* ============ THE QUICK CLAIM · pick a hue without leaving the door ============
   Who buys these: someone on a phone before a ride, someone who just watched
   one go past on a group ride, someone buying four for the club. None of them
   need a tour of the ship first. One tap puts a vessel in the hold; the hold
   opens so they can see it happened; checkout is one more tap. The whole-crew
   row exists because clubs and collectors buy in fives, and doing that as five
   separate taps is a chore we can just remove. */
{
  const qcBtn = document.getElementById('quickClaimBtn');
  const qc = document.getElementById('quickClaim');
  if(qcBtn && qc){

    const live = CREW_ACTIVE.filter(([k]) => !soldOut('v-' + k));
    const allPrice = live.reduce((t,[k]) => t + priceOf('v-' + k, 33), 0);

    function stockLine(k){
      const s = stockOf('v-' + k);
      if(!s) return '';
      if(s.available === false || (typeof s.left === 'number' && s.left <= 0)) return 'GONE';
      if(typeof s.left === 'number' && s.left <= 9) return s.left + ' LEFT';
      if(typeof s.left === 'number') return s.left + ' OF 100';
      return '';
    }

    function build(){
      const hues = CREW_ACTIVE.map(([k,an,cn,hex])=>{
        const gone = soldOut('v-' + k);
        const line = stockLine(k);
        return '<button class="qc-hue' + (gone ? ' is-gone' : '') + '" type="button"'
          + (gone ? ' data-gone="v-' + k + '" disabled' : ' data-qc="' + k + '"')
          + ' style="--qh:' + hex + '"'
          + ' aria-label="' + (gone ? an + ' is gone for good' : 'Add ' + an + ' to the cargo hold, $' + priceOf('v-'+k,33)) + '">'
          + '<span class="qc-disc"><img src="' + OG_IMG[k] + '" alt="" draggable="false"></span>'
          + '<span class="qc-name">' + an.replace(' ALIEN','') + '</span>'
          + '<span class="qc-stock">' + (gone ? 'GONE' : line) + '</span>'
          + '<span class="qc-tick" aria-hidden="true">IN THE HOLD</span>'
          + '<span class="qc-count" data-c="' + k + '" hidden>0</span>'
          + '</button>';
      }).join('');

      qc.innerHTML =
        '<p class="qc-lead">Tap a hue \u2014 it goes straight in the hold. Tap more than one, '
        + 'or the same one twice. <b>$33 each, plus shipping.</b></p>'
        + '<div class="qc-hues">' + hues + '</div>'
        + (live.length > 1
            ? '<button class="qc-crew" type="button" id="qcCrew">'
              + '<b>TAKE THE WHOLE CREW</b>'
              + '<span>all ' + live.length + ' hues \u00b7 $' + allPrice + ' \u00b7 one crate, one shipping charge \u2014 not five</span>'
              + '</button>'
            : '')
        + '<div class="qc-foot" id="qcFoot" hidden>'
        + '<button class="qc-go" type="button" id="qcHold">SEE THE HOLD \u00b7 <b id="qcN">0</b></button>'
        + '<a class="qc-go qc-out" href="/checkout" id="qcOut">CHECKOUT \u2192</a>'
        + '</div>'
        + '<p class="qc-fine">22 oz Specialized Purist \u00b7 fits a standard cage \u00b7 ships from Colorado in 2\u20134 days'
        + ' \u00b7 <a href="#/bottles">see the whole bay \u2192</a></p>';
    }

    function showFoot(){
      const foot = document.getElementById('qcFoot');
      if(foot) foot.hidden = false;
      const n = document.getElementById('qcN');
      const c = document.getElementById('cargoCount');
      if(n && c) n.textContent = c.textContent || '0';
    }

    function flash(el){
      if(!el) return;
      el.classList.add('added');
      setTimeout(()=> el.classList.remove('added'), 1400);
    }

    /* the tally lives on the tiles: three taps on green should look like three */
    const taken = {};
    function bump(k, by){
      taken[k] = (taken[k] || 0) + (by || 1);
      const b = qc.querySelector('.qc-count[data-c="' + k + '"]');
      if(b){ b.textContent = taken[k]; b.hidden = false; }
      const hue = qc.querySelector('[data-qc="' + k + '"]');
      if(hue) hue.classList.add('has');
    }

    let open = false;
    function toggle(){
      open = !open;
      qc.hidden = !open;
      qcBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      qcBtn.textContent = open ? 'Pick your hue \u00b7 $33' : 'Claim your color \u00b7 $33';
      if(open && !qc.dataset.built){ build(); qc.dataset.built = '1'; }
      if(open) setTimeout(()=>{ revealPanel(); }, 40);

    /* The panel opens below the fold on every phone — 85px past the bottom at
       390x844, and the sticky buy pill covers 48px more. Focusing the first
       tile is not enough: the tiles are the part that WAS visible. Move the
       page so the whole panel, crew row and spec line included, is on screen. */
    function revealPanel(){
      const pill = document.getElementById('buyPill');
      const pillH = (pill && !pill.hidden && getComputedStyle(pill).position === 'fixed')
        ? pill.getBoundingClientRect().height + 10 : 0;
      const r = qc.getBoundingClientRect();
      const over = r.bottom + pillH - window.innerHeight;
      if(over > 0){
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollBy({ top: over + 12, behavior: reduced ? 'auto' : 'smooth' });
      }
      const f = qc.querySelector('.qc-hue:not([disabled])');
      if(f) f.focus({ preventScroll: true });
    }
    }
    qcBtn.addEventListener('click', toggle);

    /* one tap, one vessel */
    qc.addEventListener('click', async (e)=>{
      const hue = e.target.closest('[data-qc]');
      if(hue){
        const k = hue.dataset.qc;
        flash(hue);
        bump(k, 1);
        await addItem('v-' + k);
        showFoot();
        /* the drawer covers the tiles, which is why the rest of the shelf now
           lives inside the drawer — nothing is taken away by opening it */
        openHoldAuto();
        return;
      }
      const crew = e.target.closest('#qcCrew');
      if(crew){
        flash(crew);
        live.forEach(([k]) => bump(k, 1));
        await addCrew();
        showFoot();
        openHoldAuto();
        return;
      }
      const seeHold = e.target.closest('#qcHold');
      if(seeHold){ openHold(); return; }
    });

    /* the whole crew in a single trip to the cart, not five */
    async function addCrew(){
      if(!SHOP){
        live.forEach(([k]) => addItem('v-' + k));
        return;
      }
      const items = [];
      for(const [k] of live){
        try{
          const vid = await resolveVariant('v-' + k);
          if(vid) items.push({id: vid, quantity: 1});
        }catch(err){ /* a hue that is not docked is simply left out */ }
      }
      if(!items.length){ showToast('Nothing on the shelf to load right now.'); return; }
      try{
        const r = await fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({items: items})
        });
        if(!r.ok) throw 0;
        stampManifest('v-' + live[0][0]);
        await refreshShopCart();
        showToast(items.length + ' vessels beamed aboard \u2014 one crate.');
      }catch(err){
        showToast('The airlock did not catch that \u2014 try once more.');
      }
    }
  }
}

/* ============ WHAT-THIS: the five, in the flesh ============ */
{
  const row = document.getElementById('wtFive');
  if(row){
    row.innerHTML = CREW_ACTIVE.map(([k,an,cn,hex])=>
      '<button class="wt-fig" data-tkcolor="' + k + '" style="--wc:' + hex + '" aria-label="' + an + '">'
      + '<img src="' + OG_IMG[k] + '" alt="' + an.toLowerCase() + ' vessel" draggable="false">'
      + '<span>' + an.replace(' ALIEN','') + '</span></button>').join('');
  }
}

/* ============ TICKER BUY LINKS + SEE-ALL-FIVE ============ */
document.addEventListener('click', e=>{
  const t = e.target.closest('[data-tkcolor]');
  if(t){
    e.preventDefault();
    const k = t.dataset.tkcolor;
    if(currentRoute() !== 'bottles' && currentRoute() !== 'home'){ location.hash = '#/bottles'; }
    setTimeout(()=>{ if(window.vesselJump) window.vesselJump(k); }, 90);
    return;
  }
  const five = e.target.closest('#seeFive');
  if(five && window.vesselTop) window.vesselTop();
});

/* ============ CUT FILTER ============ */
document.addEventListener('click', e=>{
  const b = e.target.closest('.cut-seg button');
  if(!b) return;
  const sec = b.closest('section');
  const seg = b.closest('.cut-seg');
  seg.querySelectorAll('button').forEach(x=>x.classList.toggle('on', x === b));
  sec.classList.remove('show-m','show-w');
  if(b.dataset.cut !== 'all') sec.classList.add('show-' + b.dataset.cut);
});

/* ============ REVEALS ============ */
const io = new IntersectionObserver(entries=>{
  entries.forEach(en=>{ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
},{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));


/* ============ GALACTIC CARGO FX ============ */
const FX_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const FX_COLORS = ['#00CE7E','#F0C75E','#46C8DC','#FF3DCF','#EAF0F1'];
function beamFX(x, y){
  if(FX_REDUCED) return;
  for(let i = 0; i < 13; i++){
    const p = document.createElement('span');
    p.className = 'fx-p';
    const a = Math.random() * Math.PI * 2, d = 34 + Math.random() * 55;
    const c = FX_COLORS[i % FX_COLORS.length];
    p.style.left = x + 'px'; p.style.top = y + 'px';
    p.style.background = c; p.style.boxShadow = '0 0 8px ' + c;
    p.style.setProperty('--dx', (Math.cos(a) * d) + 'px');
    p.style.setProperty('--dy', (Math.sin(a) * d - 34) + 'px');
    document.body.appendChild(p);
    p.addEventListener('animationend', () => p.remove());
  }
}
function cargoBump(){
  const cb = document.getElementById('cargoBtn');
  cb.classList.remove('bump'); void cb.offsetWidth; cb.classList.add('bump');
}
function warpJump(done){
  if(FX_REDUCED){ done(); return; }
  let w = document.getElementById('warp');
  if(!w){ w = document.createElement('div'); w.id = 'warp'; document.body.appendChild(w); }
  w.innerHTML = '';
  for(let i = 0; i < 48; i++){
    const l = document.createElement('i');
    l.className = 'warp-l';
    l.style.setProperty('--rot', (Math.random() * 360).toFixed(1) + 'deg');
    const c = i % 4 === 0 ? FX_COLORS[i % FX_COLORS.length] : '#EAF0F1';
    l.style.background = 'linear-gradient(180deg, transparent, ' + c + ')';
    l.style.animationDelay = (Math.random() * .22).toFixed(2) + 's';
    w.appendChild(l);
  }
  w.classList.add('on');
  setTimeout(()=>{ w.classList.remove('on'); w.innerHTML=''; done(); }, 1150);
}

/* ============ DECK MENU ============ */
const menuBtn = document.getElementById('menuBtn');
const menuPanel = document.getElementById('menuPanel');
if(menuBtn && menuPanel){
  const setMenu = open => { menuPanel.classList.toggle('open', open); menuBtn.setAttribute('aria-expanded', open); };
  menuBtn.addEventListener('click', e => { e.stopPropagation(); setMenu(!menuPanel.classList.contains('open')); });
  document.addEventListener('click', e => { if(!menuPanel.contains(e.target)) setMenu(false); });
  document.addEventListener('keydown', e => { if(e.key === 'Escape') setMenu(false); });
}

/* ============ DECK 07 \u00b7 THE DEEP FREEZER ============
   The walk-in. Every station on Earth keeps one \u2014 the cave where
   the door seals, the air bites, and everything inside sits colder
   than anything at home can manage. Ours holds \u2212196\u00b0: thirteen
   Lund Studio marks frozen mid-pour, shelved like a beer cave
   (back wall, side walls, end cap), searchable and filterable.
   One pod stays reserved for the visitor: hold to freeze.
   ==================================================== */
const FREEZER_HOLD = [
  { n:'VORFAHR',         line:'the ancestor line \u00b7 oldest name aboard', shelf:'BACK WALL',  cat:'LINES', t:-196.4 },
  { n:'DEMI-GODS',       line:'only 2,300 will ever exist',               shelf:'BACK WALL',  cat:'LINES', t:-196.3 },
  { n:'THE PROPORTIONS', line:'the mainline \u00b7 \u03c6 to the brim',    shelf:'END CAP',    cat:'LINES', t:-196.0 },
  { n:'LUNDR',           line:'the mothership pours her own',             shelf:'BACK WALL',  cat:'FLEET', t:-196.2 },
  { n:'SIDEREP',         line:'for the ones keeping score',               shelf:'LEFT WALL',  cat:'FLEET', t:-195.9 },
  { n:'GAIT',            line:'the run store\u2019s house vessel',        shelf:'LEFT WALL',  cat:'FLEET', t:-195.8 },
  { n:'GROVE',           line:'grown, not manufactured',                  shelf:'LEFT WALL',  cat:'FLEET', t:-196.1 },
  { n:'FLAME',           line:'somehow still warm in here',               shelf:'RIGHT WALL', cat:'FLEET', t:-195.2 },
  { n:'LUME',            line:'holds light instead of water',             shelf:'RIGHT WALL', cat:'FLEET', t:-195.7 },
  { n:'MUNDR',           line:'two ravens share one vessel',              shelf:'RIGHT WALL', cat:'FLEET', t:-196.0 },
  { n:'NJORD',           line:'iced for the long positions',              shelf:'LEFT WALL',  cat:'FLEET', t:-196.2 },
  { n:'WARMUP',          line:'never actually gets cold',                 shelf:'RIGHT WALL', cat:'CLUBS', t:-194.8 },
  { n:'DUMP DAYS',       line:'the ride club\u2019s cooler',              shelf:'END CAP',    cat:'CLUBS', t:-195.5 }
];
{
  const grid = document.getElementById('fzGrid');
  if(grid){
    const fzQ = document.getElementById('fzQ');
    const fzShelf = document.getElementById('fzShelf');
    const fzCat = document.getElementById('fzCat');
    const fzSort = document.getElementById('fzSort');
    const fzCount = document.getElementById('fzCount');
    const fzEmpty = document.getElementById('fzEmpty');
    const fzClear = document.getElementById('fzClear');
    const fzState = { q: '', shelf: '', cat: '', sort: 'serial' };
    window.STATION_FZ = fzState;

    const podSVG = serial =>
      '<svg viewBox="0 0 100 162" aria-hidden="true">'
      + '<text x="50" y="15" text-anchor="middle" font-family="IBM Plex Mono, monospace" font-size="7" letter-spacing="2" fill="var(--mute-2)">' + serial + '</text>'
      + '<ellipse cx="50" cy="86" rx="30" ry="46" fill="rgba(124,232,255,.07)"/>'
      + '<rect x="43" y="34" width="14" height="14" rx="3" fill="none" stroke="var(--cryo)" stroke-width="2"/>'
      + '<rect x="35" y="47" width="30" height="76" rx="11" fill="rgba(124,232,255,.08)" stroke="var(--cryo)" stroke-width="2.5"/>'
      + '<path d="M41 78 q4 4.5 8 0" fill="none" stroke="var(--glacier)" stroke-width="2" stroke-linecap="round"/>'
      + '<path d="M51 78 q4 4.5 8 0" fill="none" stroke="var(--glacier)" stroke-width="2" stroke-linecap="round"/>'
      + '<path d="M22 56 v9 M17.5 60.5 h9 M78 100 v9 M73.5 104.5 h9" fill="none" stroke="var(--cryo)" stroke-width="1.5" opacity=".55"/>'
      + '</svg>';

    const pods = FREEZER_HOLD.map((p, i) => ({
      p: p,
      serial: 'CRYO-' + String(i + 1).padStart(2, '0'),
      hay: (p.n + ' ' + p.line + ' ' + p.shelf + ' ' + p.cat + ' CRYO-' + String(i + 1).padStart(2, '0')).toLowerCase()
    }));

    const podCard = d =>
      '<button class="pod" type="button" aria-label="' + d.p.n + ' \u00b7 in cryo on the ' + d.p.shelf.toLowerCase() + ' \u00b7 wipe the frost">'
      + podSVG(d.serial)
      + '<span class="pod-meta"><span class="pod-name">' + d.p.n + '</span>'
      + '<span class="pod-line">' + d.p.line + '</span>'
      + '<span class="pod-shelf">' + d.p.shelf + ' \u00b7 ' + d.p.t.toFixed(1) + '\u00b0</span>'
      + '<span class="pod-status">IN CRYO \u00b7 DOES NOT AGE</span></span>'
      + '<span class="frost" aria-hidden="true"></span>'
      + '</button>';

    const youCard =
      '<button class="pod pod-you" type="button" id="podYou" aria-label="Reserved for you \u00b7 hold to freeze, release to thaw">'
      + '<svg viewBox="0 0 100 162" aria-hidden="true">'
      + '<text x="50" y="15" text-anchor="middle" font-family="IBM Plex Mono, monospace" font-size="7" letter-spacing="2" fill="var(--gold)">CRYO-00</text>'
      + '<ellipse cx="50" cy="86" rx="30" ry="46" fill="rgba(240,199,94,.06)"/>'
      + '<rect x="30" y="42" width="40" height="84" rx="14" fill="none" stroke="var(--gold)" stroke-width="2.5" stroke-dasharray="5 6"/>'
      + '<text x="50" y="90" text-anchor="middle" font-family="IBM Plex Mono, monospace" font-size="9" letter-spacing="1.5" fill="var(--gold-hi)">YOU</text>'
      + '</svg>'
      + '<span class="pod-meta"><span class="pod-name" style="color:var(--gold-hi)">RESERVED</span>'
      + '<span class="pod-line">age on entry = age on arrival</span>'
      + '<span class="pod-shelf">END CAP \u00b7 YOUR TEMP</span>'
      + '<span class="pod-status">HOLD TO FREEZE</span></span>'
      + '<span class="frost" aria-hidden="true"></span>'
      + '</button>';

    const fzRender = () => {
      const cold = fzState.cat === 'COLD';
      let list = cold ? [] : pods.filter(d =>
        (!fzState.shelf || d.p.shelf === fzState.shelf)
        && (!fzState.cat || d.p.cat === fzState.cat)
        && (!fzState.q || d.hay.indexOf(fzState.q) >= 0));
      if(fzState.sort === 'name') list = list.slice().sort((a, b) => a.p.n < b.p.n ? -1 : 1);
      else if(fzState.sort === 'cold') list = list.slice().sort((a, b) => a.p.t - b.p.t);
      grid.innerHTML = cold ? '' : list.map(podCard).join('') + youCard;
      grid.style.display = cold ? 'none' : '';
      if(fzCount) fzCount.textContent = cold
        ? ('THE COLD CASE \u00b7 ' + (window.STATION_CC_COUNT ? window.STATION_CC_COUNT() : 0) + ' TO GRAB \u00b7 THE PODS STAY ASLEEP')
        : list.length + ' OF ' + pods.length + ' PODS \u00b7 HOLD AT \u2212196\u00b0'
        + (fzState.shelf ? ' \u00b7 ' + fzState.shelf : '') + (fzState.cat ? ' \u00b7 ' + fzState.cat : '');
      if(fzEmpty) fzEmpty.hidden = cold || list.length > 0;
      if(window.STATION_CC_RENDER) window.STATION_CC_RENDER();
    };

    const fzChipWire = (wrap, key) => {
      if(!wrap) return;
      wrap.addEventListener('click', e => {
        const b = e.target.closest ? e.target.closest('.fz-chip') : null;
        if(!b) return;
        fzState[key] = b.getAttribute('data-v') || '';
        wrap.querySelectorAll('.fz-chip').forEach(c => c.classList.toggle('on', c === b));
        fzRender();
      });
    };
    fzChipWire(fzShelf, 'shelf');
    fzChipWire(fzCat, 'cat');
    fzChipWire(fzSort, 'sort');
    if(fzQ) fzQ.addEventListener('input', () => { fzState.q = fzQ.value.trim().toLowerCase(); fzRender(); });
    if(fzClear) fzClear.addEventListener('click', () => {
      fzState.q = ''; fzState.shelf = ''; fzState.cat = '';
      if(fzQ) fzQ.value = '';
      [fzShelf, fzCat].forEach(w => { if(w) w.querySelectorAll('.fz-chip').forEach((c, i) => c.classList.toggle('on', i === 0)); });
      fzRender();
    });
    fzRender();

    /* the reserved pod \u00b7 hold to freeze (delegated \u2014 survives re-renders) */
    const fzOv = document.getElementById('fzOverlay');
    const fzT = document.getElementById('fzTimer');
    if(fzOv && fzT){
      let fz0 = 0, fzRaf = 0;
      const fzTick = () => {
        const yrs = (performance.now() - fz0) / 1000 * 161.8;
        fzT.innerHTML = 'SHIP TIME <b>+' + yrs.toFixed(1) + ' YEARS</b> \u00b7 YOU: <b>+0.000</b> SECONDS OLDER';
        fzRaf = requestAnimationFrame(fzTick);
      };
      const fzFreeze = e => {
        if(fz0) return;
        if(e && e.cancelable) e.preventDefault();
        fz0 = performance.now();
        fzOv.classList.add('on');
        fzTick();
      };
      const fzThaw = () => {
        if(!fz0) return;
        cancelAnimationFrame(fzRaf);
        fz0 = 0;
        fzOv.classList.remove('on');
      };
      grid.addEventListener('pointerdown', e => { if(e.target.closest && e.target.closest('#podYou')) fzFreeze(e); });
      addEventListener('pointerup', fzThaw);
      addEventListener('pointercancel', fzThaw);
      addEventListener('blur', fzThaw);
      grid.addEventListener('keydown', e => {
        if((e.key === ' ' || e.key === 'Enter') && e.target.closest && e.target.closest('#podYou')){ e.preventDefault(); fzFreeze(e); }
      });
      grid.addEventListener('keyup', e => { if(e.key === ' ' || e.key === 'Enter') fzThaw(); });
    }

    /* the cold itself \u00b7 live thermometer + the walk-in door */
    const fzTemp = document.getElementById('fzTemp');
    const fzSec = document.getElementById('freezer');
    const FZ_REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fzDoor = document.getElementById('fzDoor');
    if(fzDoor){
      const fzOnDeck = () => (typeof window !== 'undefined' && window.STATION_LOCK === 'freezer') || /^#\/freezer/.test(location.hash);
      let fzDoorSeen = false;
      try { fzDoorSeen = sessionStorage.getItem('fzdoor') === '1'; } catch(e){}
      let fzTimer = 0;
      const fzOpen = () => {
        if(!fzDoor.classList.contains('on') || fzDoor.classList.contains('opening')) return;
        clearTimeout(fzTimer);
        fzDoor.classList.add('opening');
        try { sessionStorage.setItem('fzdoor', '1'); } catch(e){}
        fzDoorSeen = true;
        setTimeout(() => fzDoor.classList.remove('on', 'opening'), 1050);
      };
      const fzDoorCheck = () => {
        if(FZ_REDUCE || fzDoorSeen || !fzOnDeck()){ fzDoor.classList.remove('on', 'opening'); return; }
        fzDoor.classList.add('on');
        clearTimeout(fzTimer);
        fzTimer = setTimeout(fzOpen, 900);
      };
      fzDoor.addEventListener('click', fzOpen);
      fzDoor.addEventListener('keydown', e => { if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); fzOpen(); } });
      addEventListener('hashchange', () => setTimeout(fzDoorCheck, 30));
      fzDoorCheck();
    }

    /* THE THAW \u00b7 you are standing in the door of the walk-in.
       Antarctic frost rides the glass while the hold is sealed; the longer
       the browse, the more it cracks and weeps \u2014 the cold is yours to
       spend. A purchase slams the door and the freeze snaps back. Dwell
       only counts while this deck is open and the tab is visible. */
    const fzFrost = document.getElementById('fzFrost');
    const fzAjar = document.getElementById('fzAjar');
    const fzAjarTxt = document.getElementById('fzAjarTxt');
    const fzHold = document.getElementById('fzHold');
    if(fzFrost && fzAjar && fzTemp){
      const fzOn = () => ((typeof window !== 'undefined') && window.STATION_LOCK === 'freezer') || /^#\/freezer/.test(location.hash);
      const FZ_STAGES = [
        [0,   'DOOR SEALED \u00b7 HOLDING \u2212196\u00b0 \u00b7 BROWSE QUICK \u2014 IT ONLY STAYS THIS COLD SO LONG'],
        [25,  'FIRST CRACK \u00b7 THE DOOR IS OPEN AND THE FROST KNOWS \u00b7 PICK YOUR POD'],
        [55,  'YOU ARE LETTING THE COLD OUT \u00b7 CHOOSE AND CLOSE THE DOOR'],
        [90,  'THE HOLD IS MELTING \u00b7 MAKE THE PURCHASE ALREADY \u2014 YOU CAME HERE FOR THE BEST'],
        [130, 'DOOR AJAR \u00b7 BE QUICK ABOUT IT \u00b7 KEEP IT COOL FOR THE REST OF US'],
        [180, 'THE HOLD IS WARMING \u00b7 PICK A POD \u00b7 THE ICE IS THE ONLY FLOOR IN HERE'],
        [270, 'THE ICE IS THINNING \u00b7 NINETY SECONDS OF COLD LEFT \u00b7 CLAIM IT OR LOSE IT'],
        [330, 'THE FLOOR IS GOING \u00b7 THIRTY SECONDS \u00b7 HOLD THE DOOR OR GO THROUGH IT']
      ];
      const FZ_FULL_THAW = 130;
      let fzDwell = 0, fzSealed = 0;
      const fzTempAt = d => {
        const t = Math.min(1, d / FZ_FULL_THAW);
        const ease = 1 - Math.pow(1 - t, 2.618);
        return -196 + ease * 193.4;                        /* floor: \u22122.6\u00b0 */
      };
      const fzPaint = () => {
        const here = fzOn();
        fzFrost.classList.toggle('on', here);
        if(here){ if(!fzFrost.classList.contains('grow')) requestAnimationFrame(() => requestAnimationFrame(() => { if(fzOn()) fzFrost.classList.add('grow'); })); }
        else fzFrost.classList.remove('grow');
        fzAjar.classList.toggle('on', here);
        if(!here) return;
        const thaw = fzSealed > 0 ? 0 : Math.min(1, fzDwell / FZ_FULL_THAW);
        fzFrost.style.setProperty('--fzthaw', thaw.toFixed(3));
        let st = 0;
        for(let i = 0; i < FZ_STAGES.length; i++) if(fzDwell >= FZ_STAGES[i][0]) st = i;
        if(fzSealed > 0) st = 0;
        for(let i = 0; i < FZ_STAGES.length; i++){
          fzFrost.classList.toggle('st' + i, i === st);
          fzAjar.classList.toggle('st' + i, i === st);
        }
        fzFrost.classList.toggle('sealed', fzSealed > 0);
        fzAjar.classList.toggle('sealed', fzSealed > 0);
        if(fzAjarTxt) fzAjarTxt.textContent = fzSealed > 0
          ? 'DOOR SEALED \u00b7 COLD RESTORED \u00b7 THE REST OF US THANK YOU'
          : FZ_STAGES[st][1];
        const deg = fzSealed > 0 ? 196 : Math.abs(fzTempAt(fzDwell));
        fzTemp.textContent = '\u2212' + (deg + (Math.random() * 0.16 - 0.08)).toFixed(1) + '\u00b0';
        if(fzHold) fzHold.textContent = fzSealed > 0 ? 'AND SEALED' : (st >= 2 ? 'AND CLIMBING' : 'AND HOLDING');
      };
      /* ---------- THE FALL-THROUGH \u00b7 the ice only holds so long ---------- */
      const FZ_WARN = 330;              /* 5:30 \u2014 the 30-second countdown starts */
      const FZ_GONE = 360;              /* 6:00 \u2014 the floor goes */
      let fzGrace = 0, fzFell = false;
      const fzClock = document.getElementById('fzClock');
      const fzClockN = document.getElementById('fzClockN');
      const fzFall = document.getElementById('fzFall');
      const fzBusy = () => {
        /* never drop someone mid-transaction */
        const ae = document.activeElement;
        if(ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName)) return true;
        const hold = document.getElementById('hold');
        if(hold && hold.classList.contains('open')) return true;
        return document.documentElement.classList.contains('airlock-run');
      };
      const fzClockPaint = () => {
        if(!fzClock) return;
        const left = Math.max(0, FZ_GONE + fzGrace - fzDwell);
        const on = fzOn() && !fzFell && fzSealed === 0 && fzDwell >= (FZ_WARN + fzGrace);
        fzClock.classList.toggle('on', on);
        fzClock.classList.toggle('hot', on && left <= 10);
        if(on && fzClockN) fzClockN.textContent = String(left);
      };
      const fzFallThrough = () => {
        if(fzFell || !fzFall) return;
        fzFell = true;
        fzClock && fzClock.classList.remove('on');
        const cargoEl = document.getElementById('fzFallCargo');
        if(cargoEl){
          let n = 0;
          try { cart.forEach(q => { if(q > 0) n += q; }); } catch(e){}
          if(SHOP && shopCart) n = shopCart.item_count || 0;
          cargoEl.textContent = n
            ? 'CARGO INTACT \u00b7 ' + n + (n === 1 ? ' VESSEL STILL STRAPPED ON' : ' VESSELS STILL STRAPPED ON')
            : 'CARGO EMPTY \u00b7 YOU FELL WITH NOTHING';
        }
        fzFall.classList.add('on');
        document.documentElement.classList.add('fz-fell');
        setTimeout(() => { fzFall.classList.add('drift'); }, 900);
      };
      const fzClimbBack = () => {
        if(!fzFall) return;
        fzFall.classList.remove('on', 'drift');
        document.documentElement.classList.remove('fz-fell');
        fzFell = false; fzDwell = 0; fzSealed = 0; fzGrace = 0;
        if((typeof window !== 'undefined') && window.STATION_LOCK){ window.location.href = '/#/bottles'; return; }
        location.hash = '#/bottles';
        fzPaint(); fzClockPaint();
      };
      if(fzFall){
        const goBtn = document.getElementById('fzFallGo');
        goBtn && goBtn.addEventListener('click', fzClimbBack);
      }
      if(fzClock){
        const holdBtn = document.getElementById('fzClockHold');
        holdBtn && holdBtn.addEventListener('click', () => { fzGrace += 180; fzClockPaint(); });
      }
      const fzTick = () => {
        if(!fzOn()){
          if(fzDwell || fzSealed){ fzDwell = 0; fzSealed = 0; fzGrace = 0; }   /* leaving closes the door */
          fzPaint(); fzClockPaint();
          return;
        }
        if(document.hidden) return;                               /* the cold waits for you */
        if(fzFell) return;
        if(fzSealed > 0){
          fzSealed--;
          if(fzSealed === 0) fzDwell = 0;
        } else if(!fzBusy()){
          fzDwell++;
          if(fzDwell >= FZ_GONE + fzGrace) fzFallThrough();
        }
        fzPaint(); fzClockPaint();
      };
      const fzSlam = () => {
        if(!fzOn()) return;
        fzSealed = 6;
        fzDwell = 0;
        fzGrace = 0;
        fzPaint(); fzClockPaint();
      };
      document.addEventListener('click', e => {
        const t = e.target;
        const b = t && t.closest ? t.closest('[data-add]') : null;
        if(b) fzSlam();
      }, true);
      setInterval(fzTick, 1000);
      document.addEventListener('visibilitychange', fzTick);
      addEventListener('hashchange', () => setTimeout(fzPaint, 30));
      fzPaint();
    }
  }
}
/* ============ DECK 00 \u00b7 THE DUSTFALL ============
   Origin record. Cosmic dust came down for the ones who move.
   Reads top to bottom because that is the direction the story
   travels: verses reveal on approach, a mote rides the altitude
   rail with the reader, and at the bottom the dust reassembles
   into a vessel, live, every visit.
   ==================================================== */
{
  const df = document.getElementById('dustfall');
  if(df){
    const DF_REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* verses light up as the reader descends */
    const verses = df.querySelectorAll('.df-verse');
    if(DF_REDUCE || !('IntersectionObserver' in window)){
      verses.forEach(v => v.classList.add('on'));
    } else {
      const vo = new IntersectionObserver(es => {
        es.forEach(e => { if(e.isIntersecting){ e.target.classList.add('on'); vo.unobserve(e.target); } });
      }, { threshold: .35, rootMargin: '0px 0px -8% 0px' });
      verses.forEach(v => vo.observe(v));
    }

    /* the altitude rail \u00b7 a mote falls with you, 1618 km to touchdown */
    const dfMote = document.getElementById('dfMote');
    const dfAlt = document.getElementById('dfAlt');
    const dfFall = document.getElementById('dfFall');
    if(dfMote && dfAlt && dfFall){
      let dfRaf = 0;
      const dfSet = () => {
        dfRaf = 0;
        if(df.classList.contains('view-off')) return;
        const r = dfFall.getBoundingClientRect();
        if(!r.height) return;
        const vh = innerHeight || 1;
        const p = Math.min(1, Math.max(0, (vh * .62 - r.top) / r.height));
        dfMote.style.top = (p * 100) + '%';
        const km = Math.round((1 - p) * 1618);
        dfAlt.textContent = km <= 0 ? '0 KM \u00b7 TOUCHDOWN' : km + ' KM';
      };
      const dfQueue = () => { if(!dfRaf) dfRaf = requestAnimationFrame(dfSet); };
      addEventListener('scroll', dfQueue, { passive: true });
      addEventListener('resize', dfQueue);
      addEventListener('hashchange', () => setTimeout(dfSet, 60));
      dfSet();
    }

    /* dust \u2192 vessel \u00b7 live reconstruction at the bottom of the fall */
    const asm = document.getElementById('dfAsm');
    if(asm){
      let dfBuilt = false;
      const dfBuild = () => {
        if(dfBuilt) return;
        dfBuilt = true;
        const NS = 'http://www.w3.org/2000/svg';
        const layer = asm.querySelector('.df-motes');
        const label = document.getElementById('dfAsmLabel');
        if(layer){
          asm.querySelectorAll('.df-guide').forEach(path => {
            let L = 0;
            try { L = path.getTotalLength(); } catch(e){ L = 0; }
            if(!L) return;
            const n = Math.max(12, Math.round(L / 12));
            for(let i = 0; i < n; i++){
              const pt = path.getPointAtLength((L / n) * i);
              const c = document.createElementNS(NS, 'circle');
              c.setAttribute('cx', pt.x.toFixed(1));
              c.setAttribute('cy', pt.y.toFixed(1));
              c.setAttribute('r', (1.5 + Math.random() * 1.4).toFixed(2));
              c.style.setProperty('--sx', ((Math.random() * 2 - 1) * 230).toFixed(1) + 'px');
              c.style.setProperty('--sy', (-(120 + Math.random() * 300)).toFixed(1) + 'px');
              c.style.setProperty('--dd', (Math.random() * 1100).toFixed(0) + 'ms');
              layer.appendChild(c);
            }
          });
        }
        const dfDone = () => {
          asm.classList.add('asm-done');
          if(label) label.textContent = 'DUST \u2192 VESSEL \u00b7 CONVERSION COMPLETE';
        };
        if(DF_REDUCE){ asm.classList.add('asm-on'); dfDone(); return; }
        requestAnimationFrame(() => requestAnimationFrame(() => {
          asm.classList.add('asm-on');
          setTimeout(dfDone, 2500);
        }));
      };
      if(!('IntersectionObserver' in window)){ dfBuild(); }
      else {
        const ao = new IntersectionObserver(es => {
          es.forEach(e => { if(e.isIntersecting){ dfBuild(); ao.disconnect(); } });
        }, { threshold: .3 });
        ao.observe(asm);
      }
    }
  }
}
/* ============ THE MANIFOLD · partner attribution + settlement ============
   The missing half of THE CANOPY. The Canopy prices a spot; this decides
   who gets paid for it, without anyone typing a number.

   Inbound  — a partner sends traffic to us with ?ref=<sid>. We hold that
              sid for a 34-day window and stamp it onto the Shopify cart, so
              every order carries its referrer into the admin by itself.
   Outbound — clicks to a partner's own store already carry sid + utm (the
              Canopy tagger). We log them so clicks reconcile to statements.
   Settle   — the ledger totals attributed orders per partner, applies that
              partner's rate, and exports a CSV a payout run can read.

   No number here is authoritative until it agrees with the network's
   statement. This is our copy of the truth, not the truth.
   ==================================================================== */
(function(){
  if (window.STATION_MANIFOLD) return;
  var KEY = 'manifold.v1';
  var WINDOW_DAYS = 34;                       /* the attribution window */
  var CART_ATTR = 'partner_ref';
  function read(){ try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {ref:null, at:0, log:[], orders:[]}; } catch(e){ return {ref:null, at:0, log:[], orders:[]}; } }
  function save(s){ try { localStorage.setItem(KEY, JSON.stringify(s)); } catch(e){} }
  function fresh(s){ return s.ref && (Date.now() - (s.at||0)) < WINDOW_DAYS*86400000; }
  function ymd(d){ return (d ? new Date(d) : new Date()).toISOString().slice(0,10); }

  var S = read();

  /* 1 · catch an inbound partner referral and hold it */
  try {
    var q = new URLSearchParams(location.search);
    var ref = q.get('ref') || q.get('partner') || q.get('sid');
    if (ref) {
      ref = String(ref).slice(0, 64).replace(/[^\w.-]/g, '');
      S.ref = ref; S.at = Date.now();
      S.log.push({ t: 'in', ref: ref, day: ymd(), lp: location.pathname });
      if (S.log.length > 500) S.log = S.log.slice(-500);
      save(S);
    }
  } catch(e){}

  /* 2 · stamp it on the Shopify cart so the ORDER carries it, not just this tab.
        Runs once per session and only when a referral is live. */
  function stampCart(){
    if (!fresh(S) || !window.STATION_SHOP) return;
    if (sessionStorage.getItem('manifold.stamped') === S.ref) return;
    var body = {};
    body['attributes[' + CART_ATTR + ']'] = S.ref;
    body['attributes[partner_landed]'] = ymd(S.at);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { partner_ref: S.ref, partner_landed: ymd(S.at) } })
    }).then(function(){ try { sessionStorage.setItem('manifold.stamped', S.ref); } catch(e){} })
      .catch(function(){});
  }
  stampCart();
  /* re-stamp after anything touches the cart */
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('[data-add]') : null;
    if (a) setTimeout(stampCart, 700);
  }, true);

  /* 3 · log outbound partner clicks (the Canopy tagger sets the URL; we keep the count) */
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('a[data-pump]') : null;
    if (!a) return;
    S.log.push({ t: 'out', pump: a.getAttribute('data-pump'), day: ymd() });
    if (S.log.length > 500) S.log = S.log.slice(-500);
    save(S);
  }, true);

  /* 4 · settlement math — clicks and orders in, amounts owed out */
  function settle(rates){
    rates = rates || {};
    var out = {}, i, r;
    for (i = 0; i < S.log.length; i++){
      r = S.log[i];
      var k = r.t === 'in' ? r.ref : r.pump;
      if (!k) continue;
      out[k] = out[k] || { partner: k, clicks_in: 0, clicks_out: 0, orders: 0, revenue: 0, rate: (rates[k] || 0), owed: 0 };
      if (r.t === 'in') out[k].clicks_in++; else out[k].clicks_out++;
    }
    for (i = 0; i < S.orders.length; i++){
      var o = S.orders[i];
      if (!o.ref) continue;
      out[o.ref] = out[o.ref] || { partner: o.ref, clicks_in: 0, clicks_out: 0, orders: 0, revenue: 0, rate: (rates[o.ref] || 0), owed: 0 };
      out[o.ref].orders++;
      out[o.ref].revenue += Number(o.total) || 0;
    }
    return Object.keys(out).map(function(k){
      var row = out[k];
      row.owed = Math.round(row.revenue * (row.rate/100) * 100) / 100;
      return row;
    }).sort(function(a,b){ return b.owed - a.owed; });
  }

  function csv(rates){
    var rows = settle(rates);
    var head = 'partner,clicks_in,clicks_out,orders,revenue,rate_pct,owed';
    var body = rows.map(function(r){
      return [r.partner, r.clicks_in, r.clicks_out, r.orders, r.revenue.toFixed(2), r.rate, r.owed.toFixed(2)].join(',');
    }).join('\n');
    return head + '\n' + body + '\n';
  }

  window.STATION_MANIFOLD = {
    ref: function(){ return fresh(S) ? S.ref : null; },
    windowDays: WINDOW_DAYS,
    /* record an order once it is confirmed — call from the thank-you page or paste from admin */
    order: function(ref, total, id){
      S.orders.push({ ref: ref || S.ref, total: Number(total)||0, id: id||'', day: ymd() });
      save(S); return S.orders.length;
    },
    settle: settle,
    csv: csv,
    download: function(rates){
      var blob = new Blob([csv(rates)], { type: 'text/csv' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'station-settlement-' + ymd() + '.csv';
      a.click();
    },
    state: function(){ return JSON.parse(JSON.stringify(S)); },
    clear: function(){ S = {ref:null, at:0, log:[], orders:[]}; save(S); }
  };
})();

/* ============ THE CANOPY \u00b7 LUND-INV-404 \u00b7 SL-2026-08-CANOPY-001 ============
   Bay crew console for the partner rails. Public side: commission clicks are
   tagged (sid + utm) and counted at the door. Console side: the Pump Ledger
   prices every pump in dollars per slot-day, and the Graduation Ladder
   proposes rail moves on \u03c6-scaled thresholds over 34/89-day windows.
   Data lives in this browser (localStorage) \u2014 export before switching machines.
   ======================================================================== */
{
  const CP_PHI = 1.618;
  const CP_KEY = 'canopy.v1';
  let cpMem = {};
  const cpLoad = () => { try { return JSON.parse(localStorage.getItem(CP_KEY) || '{}'); } catch(e){ return cpMem; } };
  const cpSave = s => { cpMem = s; try { localStorage.setItem(CP_KEY, JSON.stringify(s)); } catch(e){} };
  const cpState = Object.assign({ t: 1, log: [], clicks: {}, take: {} }, cpLoad());
  const cpYmd = d => (d ? new Date(d) : new Date()).toISOString().slice(0, 10);
  const cpAge = s => Math.floor((Date.now() - new Date(s + 'T12:00:00Z').getTime()) / 86400000);
  const cpFuel = () => (typeof FUEL !== 'undefined' && Array.isArray(FUEL)) ? FUEL : [];

  /* public rail \u00b7 tag + count commission clicks at the door */
  document.addEventListener('click', e => {
    const a = e.target && e.target.closest ? e.target.closest('a[data-pump]') : null;
    if(!a) return;
    const id = a.getAttribute('data-pump');
    const f = cpFuel().find(x => x.id === id);
    try {
      const u = new URL(a.href);
      u.searchParams.set('sid', ((f && f.sid) ? f.sid : id) + '-' + cpYmd().replace(/-/g, ''));
      u.searchParams.set('utm_source', 'thestation');
      u.searchParams.set('utm_medium', 'canopy');
      a.href = u.toString();
    } catch(err){}
    const day = cpYmd();
    cpState.clicks[id] = cpState.clicks[id] || {};
    cpState.clicks[id][day] = (cpState.clicks[id][day] || 0) + 1;
    cpSave(cpState);
  }, true);

  /* console */
  const cpBoard = document.getElementById('cpBoard');
  const cpT = document.getElementById('cpT');
  const cpDerive = document.getElementById('cpDerive');
  if(cpBoard && cpT && cpDerive){
    const takeOf = f => {
      const o = cpState.take[f.id];
      if(o != null && o !== '' && !isNaN(parseFloat(o))) return parseFloat(o);
      return (typeof f.take === 'number' && !isNaN(f.take)) ? f.take : null;
    };
    const revIn = (id, days) => cpState.log.reduce((s, e) => {
      if(e.p !== id) return s;
      const a = cpAge(e.d);
      return (a >= 0 && a < days) ? s + (parseFloat(e.rev) || 0) : s;
    }, 0);
    const entriesIn = (id, days) => cpState.log.filter(e => e.p === id && cpAge(e.d) >= 0 && cpAge(e.d) < days).length;
    const clicksIn = (id, days) => {
      const c = cpState.clicks[id] || {};
      return Object.keys(c).reduce((s, d) => { const a = cpAge(d); return (a >= 0 && a < days) ? s + c[d] : s; }, 0);
    };
    const perDay = (id, days, take) => (take == null) ? null : (revIn(id, days) * take / 100) / days;
    const money = v => (v == null) ? '\u2014' : '$' + v.toFixed(2);

    const verdictOf = (f, take, c34, c89, has34) => {
      const T = cpState.t;
      if(take == null) return ['SET TAKE %', 'v-warn'];
      if(!has34) return ['NO DATA \u00b7 LOG A WINDOW', 'v-mute'];
      if(f.mode === 'partner'){
        if(c34 >= T) return ['PROMOTE \u2192 STOCKED', 'v-up'];
        if(c34 < T / CP_PHI) return ['DORMANT \u00b7 HOLD RAIL 0', 'v-mute'];
        return ['HOLD \u00b7 RAIL 0', 'v-hold'];
      }
      if(f.mode === 'stocked'){
        if(c89 >= T * CP_PHI) return ['PROPOSE PO \u2192 OWNED', 'v-up'];
        if(c34 < T / CP_PHI) return ['DEMOTE \u2192 COMMISSION', 'v-down'];
        return ['HOLD \u00b7 RAIL 1', 'v-hold'];
      }
      if(c34 < T / CP_PHI) return ['DEMOTE \u2192 STOCKED', 'v-down'];
      return ['HOLD \u00b7 RAIL 2', 'v-hold'];
    };

    const railChip = f => f.mode === 'stocked'
      ? '<span class="cp-rail cp-r1">RAIL 1 \u00b7 STOCKED</span>'
      : (f.mode === 'owned'
        ? '<span class="cp-rail cp-r2">RAIL 2 \u00b7 OWNED</span>'
        : '<span class="cp-rail cp-r0">RAIL 0 \u00b7 COMMISSION</span>');

    const pumpCard = (f, idx) => {
      const take = takeOf(f);
      const c34 = perDay(f.id, 34, take);
      const c89 = perDay(f.id, 89, take);
      const has34 = entriesIn(f.id, 34) > 0;
      const v = verdictOf(f, take, c34, c89, has34);
      const last = cpState.log.filter(e => e.p === f.id).sort((a, b) => a.d < b.d ? 1 : -1)[0];
      const n = cpState.log.filter(e => e.p === f.id).length;
      return '<article class="cp-pump" data-id="' + f.id + '">'
        + '<div class="cp-head"><span class="cp-num">PUMP ' + String(idx + 1).padStart(2, '0') + '</span>'
        + railChip(f)
        + '<span class="cp-gate' + (f.accepted ? ' on' : '') + '">' + (f.accepted ? 'CREATIVE \u00b7 APPROVED' : 'CREATIVE \u00b7 GATED') + '</span></div>'
        + '<div class="cp-who"><div class="cp-brand">' + (f.brand || '\u2014') + '</div>'
        + '<div class="cp-prod">' + (f.name || '') + '</div></div>'
        + '<div class="cp-stats">'
        + '<div class="cp-stat"><span>TAKE %</span><input class="cp-take" data-take="' + f.id + '" type="number" step="0.5" min="0" value="' + (take == null ? '' : take) + '" placeholder="\u2014"></div>'
        + '<div class="cp-stat"><span>CLICKS 34D</span><b>' + clicksIn(f.id, 34) + '</b></div>'
        + '<div class="cp-stat"><span>REV 34D</span><b>' + money(revIn(f.id, 34)) + '</b></div>'
        + '<div class="cp-stat"><span>$/SLOT-DAY 34D</span><b class="hot">' + money(c34) + '</b></div>'
        + '<div class="cp-stat"><span>$/SLOT-DAY 89D</span><b>' + money(c89) + '</b></div>'
        + '<div class="cp-stat"><span>REV 89D</span><b>' + money(revIn(f.id, 89)) + '</b></div>'
        + '</div>'
        + '<span class="cp-verdict ' + v[1] + '">' + v[0] + '</span>'
        + '<div class="cp-log">'
        + '<input data-f="d" type="date" value="' + cpYmd() + '">'
        + '<input data-f="rev" type="number" step="0.01" min="0" placeholder="$ rev">'
        + '<input data-f="ord" type="number" step="1" min="0" placeholder="orders">'
        + '<button class="btn" type="button" data-log="' + f.id + '">Log</button>'
        + '</div>'
        + '<span class="cp-tail">' + n + ' ENTRIES' + (last ? ' \u00b7 LAST ' + last.d : '') + ' \u00b7 CLICKS TOTAL ' + clicksIn(f.id, 3650) + '</span>'
        + '</article>';
    };

    const renderCanopy = () => {
      const T = cpState.t;
      cpT.value = T;
      cpDerive.textContent = 'PROMOTE \u2192 STOCKED \u2265 ' + money(T) + ' /SLOT-DAY OVER 34D \u00b7 PROPOSE PO \u2265 '
        + money(T * CP_PHI) + ' OVER 89D \u00b7 DEMOTE BELOW ' + money(T / CP_PHI) + ' \u00b7 \u03c6 = 1.618';
      const pumps = cpFuel().map((f, i) => ({ f, i, c: perDay(f.id, 34, takeOf(f)) }));
      pumps.sort((a, b) => (b.c == null ? -1 : b.c) - (a.c == null ? -1 : a.c));
      cpBoard.innerHTML = pumps.length
        ? pumps.map(p => pumpCard(p.f, p.i)).join('')
        : '<p class="cp-tail">NO PUMPS \u2014 ADD PARTNER BLOCKS ON THE FUEL BAY.</p>';
    };

    cpT.addEventListener('change', () => {
      const v = parseFloat(cpT.value);
      if(!isNaN(v) && v > 0){ cpState.t = v; cpSave(cpState); renderCanopy(); }
    });
    cpBoard.addEventListener('click', e => {
      const b = e.target && e.target.closest ? e.target.closest('[data-log]') : null;
      if(!b) return;
      const card = b.closest('.cp-pump');
      const d = card.querySelector('[data-f="d"]').value || cpYmd();
      const rev = parseFloat(card.querySelector('[data-f="rev"]').value);
      const ord = parseInt(card.querySelector('[data-f="ord"]').value, 10);
      if(isNaN(rev)) return;
      cpState.log.push({ p: b.getAttribute('data-log'), d: d, rev: rev, ord: isNaN(ord) ? 0 : ord });
      cpSave(cpState);
      renderCanopy();
    });
    cpBoard.addEventListener('change', e => {
      const t = e.target;
      if(!t || !t.getAttribute || !t.getAttribute('data-take')) return;
      cpState.take[t.getAttribute('data-take')] = t.value;
      cpSave(cpState);
      renderCanopy();
    });

    const cpExport = document.getElementById('cpExport');
    const cpImportBtn = document.getElementById('cpImportBtn');
    const cpFile = document.getElementById('cpFile');
    const cpClear = document.getElementById('cpClear');
    if(cpExport) cpExport.addEventListener('click', () => {
      try {
        const blob = new Blob([JSON.stringify(cpState, null, 2)], { type: 'application/json' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'canopy-ledger-' + cpYmd().replace(/-/g, '') + '.json';
        document.body.appendChild(a); a.click(); a.remove();
      } catch(err){}
    });
    if(cpImportBtn && cpFile){
      cpImportBtn.addEventListener('click', () => cpFile.click());
      cpFile.addEventListener('change', () => {
        const file = cpFile.files && cpFile.files[0];
        if(!file) return;
        const r = new FileReader();
        r.onload = () => {
          try {
            const s = JSON.parse(r.result);
            if(s && Array.isArray(s.log)){ Object.assign(cpState, { t: s.t || cpState.t, log: s.log, clicks: s.clicks || {}, take: s.take || {} }); cpSave(cpState); renderCanopy(); }
          } catch(err){}
        };
        r.readAsText(file);
      });
    }
    if(cpClear) cpClear.addEventListener('click', () => {
      if(confirm('Clear the Canopy ledger in this browser? Export first if you want to keep it.')){
        cpState.log = []; cpState.clicks = {}; cpState.take = {};
        cpSave(cpState); renderCanopy();
      }
    });

    renderCanopy();
  }
}
/* ============ DECK 18 \u00b7 THE BACK ROOM \u00b7 18+ SALTY VESSELS ============
   The age door: self-attestation, remembered in this browser only
   (localStorage), nothing sent anywhere. Grid renders after the door
   opens. Phrases ship censored exactly as written \u2014 clearance with
   counsel before first pour. Theme editor can override the roster via
   window.STATION_BACKROOM (backroom blocks).
   ==================================================================== */
{
  const BR_KEY = 'backroom.v1';
  const BACKROOM = [
    { id:'br-1',  phrase:'SLOW A**',                          sub:'said with love, from the front of the pack', hex:'#FC4539', handle:null, price:33 },
    { id:'br-2',  phrase:'SH*T BOY',                          sub:'the group ride has spoken',                  hex:'#389EE1', handle:null, price:33 },
    { id:'br-3',  phrase:'HYDRATE, B*TCH',                    sub:'the vessel is not asking',                   hex:'#00CE7E', handle:null, price:33 },
    { id:'br-4',  phrase:'DRINK YOUR F**KING WATER',          sub:'doctrine, aggressively applied',             hex:'#7CE8FF', handle:null, price:33 },
    { id:'br-5',  phrase:'FAST AS F**K',                      sub:'for days the watch agrees',                  hex:'#F8E44B', handle:null, price:33 },
    { id:'br-6',  phrase:'ZONE 2, D*MMIT',                    sub:'easy means easy',                            hex:'#EA41AA', handle:null, price:33 },
    { id:'br-7',  phrase:'OLD A** LEGS',                      sub:'still out here though',                      hex:'#F0C75E', handle:null, price:33 },
    { id:'br-8',  phrase:'DNF\u2019D AND STILL A BADA**',     sub:'the finish line owes you nothing',           hex:'#FF8C3D', handle:null, price:33 },
    { id:'br-9',  phrase:'RUN LIKE SH*T, HYDRATE LIKE A GOD', sub:'one of these is a choice',                   hex:'#B98CFF', handle:null, price:33 },
    { id:'br-10', phrase:'ZERO F**KS PACE',                   sub:'unbothered. moisturized. hydrated.',         hex:'#EAF0F1', handle:null, price:33 },
    /* ---- THE NURSERY · adult baby food · a shelf inside the back room ---- */
    { id:'br-n1',  shelf:'nursery', phrase:'ADULT BABY FOOD',               sub:'applesauce pouch. mile 22. no regrets.',                          hex:'#F8E44B', handle:null, price:33 },
    { id:'br-n2',  shelf:'nursery', phrase:'SIPPY CUP ENERGY',              sub:'the vessel is not judging. the vessel is a sippy cup with a mark.', hex:'#7CE8FF', handle:null, price:33 },
    { id:'br-n3',  shelf:'nursery', phrase:'STILL ON PUREE',                sub:'thirty-four years old. squeeze pouch. sunrise. thriving.',        hex:'#EA41AA', handle:null, price:33 },
    { id:'br-n4',  shelf:'nursery', phrase:'GELS ARE BABY FOOD, B*TCH',     sub:'and you love it. keep squeezing.',                                hex:'#FC4539', handle:null, price:33 },
    { id:'br-n5',  shelf:'nursery', phrase:'MASHED BANANA PACE',            sub:'soft, warm, somehow still moving. do not eat the bananas.',       hex:'#F0C75E', handle:null, price:33 },
    { id:'br-n6',  shelf:'nursery', phrase:'PUREE. NAP. REPEAT.',           sub:'the training block, described accurately.',                       hex:'#00CE7E', handle:null, price:33 },
    { id:'br-n7',  shelf:'nursery', phrase:'BIB NUMBER, ALSO A BIB',        sub:'gel on the chin is a bib situation.',                             hex:'#389EE1', handle:null, price:33 },
    { id:'br-n8',  shelf:'nursery', phrase:'TEETHING ON THE TEAR-TAB',      sub:'the tear-tab is a lie. it has always been a lie.',                hex:'#C9B8FF', handle:null, price:33 },
    { id:'br-n9',  shelf:'nursery', phrase:'STROLLER PACE, B*TCH',          sub:'zone 2 with a passenger and a snack budget.',                     hex:'#4DFF7C', handle:null, price:33 },
    { id:'br-n10', shelf:'nursery', phrase:'FED. CHANGED. HYDRATED.',       sub:'the whole checklist. for you. not the baby.',                     hex:'#EAF0F1', handle:null, price:33 },
    { id:'br-n11', shelf:'nursery', phrase:'TUMMY TIME (AERO)',             sub:'the tt bars were tummy time all along.',                          hex:'#FF3DCF', handle:null, price:33 },
    { id:'br-n12', shelf:'nursery', phrase:'SQUEEZE POUCH SUPREMACY',       sub:'the pouch does not spill. you did that.',                         hex:'#D4A741', handle:null, price:33 },
    { id:'br-n13', shelf:'nursery', phrase:'2 P.M. NAP, NON-NEGOTIABLE',    sub:'the long run demands the long nap. sh*t, we all do.',             hex:'#7CE8FF', handle:null, price:33 },
    { id:'br-n14', shelf:'nursery', phrase:'SPIT UP AT MILE 20',            sub:'burp it and carry on. the watch did not notice.',                 hex:'#FC4539', handle:null, price:33 },
    /* ---- THE RUNNERS' SHELF · for the crew that chases things that aren't there ---- */
    { id:'br-r1',  shelf:'runners', phrase:'MILE 20 IS A LIAR',                    sub:'so is mile 21. so is your watch.',                               hex:'#00CE7E', handle:null, price:33 },
    { id:'br-r2',  shelf:'runners', phrase:'F**K THIS HILL',                       sub:'the hill has heard worse. keep climbing.',                       hex:'#FC4539', handle:null, price:33 },
    { id:'br-r3',  shelf:'runners', phrase:'TAPER MADNESS, B*TCH',                 sub:'the legs feel weird because they are rested. sit down.',        hex:'#F8E44B', handle:null, price:33 },
    { id:'br-r4',  shelf:'runners', phrase:'EASY DAY, MY A**',                     sub:'zone 2 with feelings.',                                          hex:'#7CE8FF', handle:null, price:33 },
    { id:'br-r5',  shelf:'runners', phrase:'CHAFED AND UNBOTHERED',                sub:'glide is doctrine. apply it like you mean it.',                  hex:'#EA41AA', handle:null, price:33 },
    { id:'br-r6',  shelf:'runners', phrase:'TOENAILS ARE OPTIONAL',                sub:'the marathon took two. it wanted three.',                        hex:'#389EE1', handle:null, price:33 },
    { id:'br-r7',  shelf:'runners', phrase:'TRACK TUESDAY IS A CULT',              sub:'and you keep showing up. in matching shoes.',                    hex:'#F0C75E', handle:null, price:33 },
    { id:'br-r8',  shelf:'runners', phrase:'GI DISTRESS EXPRESS',                  sub:'the porta-potty is a finish line too. respect it.',              hex:'#4DFF7C', handle:null, price:33 },
    { id:'br-r9',  shelf:'runners', phrase:'RUN LIKE THE MOTHERSHIP IS LEAVING',   sub:'because it is. it always is.',                                   hex:'#C9B8FF', handle:null, price:33 },
    { id:'br-r10', shelf:'runners', phrase:'LONG RUN, LONGER EXCUSES',             sub:'the weather app has been notified.',                             hex:'#EAF0F1', handle:null, price:33 },
    { id:'br-r11', shelf:'runners', phrase:'IF THE WATCH DIED, IT STILL HAPPENED', sub:'the legs keep the receipt.',                                     hex:'#FF3DCF', handle:null, price:33 },
    { id:'br-r12', shelf:'runners', phrase:'TEMPO IS A FEELING (BAD)',             sub:'comfortably hard, they said. one of those was a lie.',           hex:'#D4A741', handle:null, price:33 },
    { id:'br-r13', shelf:'runners', phrase:'COUCH TO F**K IT',                     sub:'the program is one step. you are on it.',                        hex:'#7CE8FF', handle:null, price:33 },
    { id:'br-r14', shelf:'runners', phrase:'SH*T PACE, GOOD VIBES',                sub:'the watch is not invited to brunch.',                            hex:'#00CE7E', handle:null, price:33 }
  ];
  const BR_SHELVES = {
    nursery: { k:'THE NURSERY \u00b7 ADULT BABY FOOD \u00b7 18+ MOUTH, 8-MONTH PALATE', p:'You run thirty miles, then squeeze applesauce into your face out of a foil pouch like a very sweaty toddler. We see you. We are you. Same vessel, same \u03c6 \u2014 the mouth just wants pur\u00e9e now.' },
    runners: { k:'THE RUNNERS\u2019 SHELF \u00b7 FOR THE CREW THAT CHASES THINGS THAT AREN\u2019T THERE', p:'Splits, hills, taper brain, and the special vocabulary of mile twenty. Nothing here is aimed at anyone but your own legs. Same vessel, same \u03c6 \u2014 the mouth is just out of breath.' }
  };
  {
    const t = (typeof window !== 'undefined') && window.STATION_BACKROOM;
    if(Array.isArray(t) && t.length){
      BACKROOM.length = 0;
      t.forEach(b => BACKROOM.push({
        id: 'br-' + b.id,
        phrase: (b.phrase || 'REDACTED, B*TCH').toUpperCase(),
        sub: b.sub || '',
        hex: b.hex || '#FC4539',
        handle: b.handle || null,
        price: (typeof b.price === 'number') ? b.price : 33
      }));
    }
  }

  const brBottle = hex =>
    '<svg viewBox="0 0 100 170" aria-hidden="true">'
    + '<rect x="38" y="14" width="24" height="18" rx="4" fill="' + hex + '" opacity=".85"/>'
    + '<rect x="26" y="34" width="48" height="118" rx="18" fill="' + hex + '" opacity=".12" stroke="' + hex + '" stroke-width="3"/>'
    + '<path d="M34 66 L46 74 M66 66 L54 74" stroke="' + hex + '" stroke-width="4.5" stroke-linecap="round"/>'
    + '<ellipse cx="41" cy="86" rx="7" ry="10.5" fill="#FFFFFF"/><ellipse cx="59" cy="86" rx="7" ry="10.5" fill="#FFFFFF"/>'
    + '<circle cx="41" cy="89" r="3.4" fill="#04120A"/><circle cx="59" cy="89" r="3.4" fill="#04120A"/>'
    + '<rect x="35" y="112" width="30" height="13" rx="3" fill="none" stroke="' + hex + '" stroke-width="2"/>'
    + '<text x="50" y="122.5" text-anchor="middle" font-family="IBM Plex Mono, monospace" font-size="9" letter-spacing="2" fill="' + hex + '">***</text>'
    + '</svg>';

  const brCensor = s => s.replace(/\*+/g, m => '<b>' + m + '</b>');
  /* the room's physics: the audience thins as you go deeper, and the ones left are better.
     geometric 2.3M \u2192 2,300 \u2014 passing 230K and 23K on the way, same cascade as the door. */
  const BR_POOL = ['2.3M','1.07M','496K','230K','107K','49.6K','23K','10.7K','4.96K','2,300'];
  const BR_BARW = [100, 84, 70, 57, 46, 36, 27, 19, 13, 8];
  const BR_PCT  = ['61.8','66.6','71.2','75.7','80.1','84.4','88.6','92.7','96.4','99.9'];
  const BR_FLAG = ['HOT','HOT','NEW','VERIFIED','','NEW','','VERIFIED','','ELITE'];
  const brCard = (v, i) => {
    const cta = v.handle
      ? '<button class="add" data-add="fuel:' + v.handle + '">Add to hold</button>'
      : '<button class="add soon" disabled>First pour pending</button>';
    const fl = BR_FLAG[i % BR_FLAG.length];
    return '<article class="br-card">'
      + (fl ? '<span class="br-flag br-flag-' + fl.toLowerCase() + '">' + fl + '</span>' : '')
      + '<span class="br-serial">SV-' + String(i + 1).padStart(2, '0') + ' \u00b7 22 OZ</span>'
      + brBottle(v.hex)
      + '<div class="br-meta">'
      + '<div class="br-phrase">' + brCensor(v.phrase) + '</div>'
      + '<div class="br-sub">' + v.sub + '</div>'
      + '<div class="br-stats"><span class="br-pool">POOL: ' + BR_POOL[i % BR_POOL.length] + '</span>'
      + '<span class="br-pct">' + BR_PCT[i % BR_PCT.length] + '% STARE-BACK</span></div>'
      + '<span class="br-poolbar"><i style="width:' + BR_BARW[i % BR_BARW.length] + '%"></i></span>'
      + '<div class="br-cta"><span class="br-price">$' + v.price + '</span>' + cta + '</div>'
      + '</div></article>';
  };

  /* THE VOID DOOR \u00b7 the back room asks EVERY TIME.
     Full-black takeover while locked \u2014 one button, no species scan,
     no second step. Nothing about the answer is remembered: every arrival
     at the deck re-cards. Only the member number and join date persist,
     in this browser only, so a returning member gets the same NO. back. */
  const brVoid = document.getElementById('brVoid');
  const brVoidGo = document.getElementById('brVoidGo');
  const brVoidAway = document.getElementById('brVoidAway');
  const brFunnel = document.getElementById('brFunnel');
  const brAccord = document.getElementById('brAccord');
  const brParty = document.getElementById('brAccordParty');
  const brGrid = document.getElementById('brGrid');
  const brLegal = document.getElementById('brLegal');
  const brRelock = document.getElementById('brRelock');
  if(brVoid && brGrid){
    /* THE NIGHT SALT \u00b7 tonight's neon, from the same press as the daily paper.
       Same day number as THE TYPING, different seed stream \u2014 the door, the
       18+ chip, the funnel, the accord seal, and the poolbars all take the
       color of the night. Bottle inks are locked and never move. */
    const brNo = tyPaperNo();
    const brHue = 136;   /* ALIEN GREEN · the room does not change colour any more */
    {
      const st = document.documentElement.style;
      st.setProperty('--brsalt', 'hsl(' + brHue + ',100%,66%)');
      st.setProperty('--brsalt-soft', 'hsl(' + brHue + ',46%,64%)');
      st.setProperty('--brsalt-glow', 'hsl(' + brHue + ' 100% 66% / .55)');
      st.setProperty('--brsalt-hot', 'hsl(' + brHue + ',100%,54%)');
      st.setProperty('--brsalt-ink', 'hsl(' + brHue + ',72%,4%)');
      st.setProperty('--brsalt-day', 'hsl(' + brHue + ',80%,24%)');
    }
    const brNeonChip = document.getElementById('brVoidNeon');
    if(brNeonChip) brNeonChip.textContent = 'NEON ' + String(brNo).padStart(3, '0') + ' OF 366';
    /* door theatre · the room always looks nearly full and the list always has you */
    const brOccEl = document.getElementById('brVoidOcc');
    if(brOccEl){
      const brIn = 5 + Math.floor(tyMul32((Math.imul(brNo, 40503) ^ 0xC1AB) >>> 0)() * 16);
      brOccEl.textContent = 'CAPACITY 23 · INSIDE NOW: ' + brIn + ' · THE LIST: 2,300 NAMES';
    }
    let brOpened = false; /* per page load \u2014 the door asks again on the next arrival */
    const brRecord = () => { try { return JSON.parse(localStorage.getItem(BR_KEY) || 'null') || {}; } catch(e){ return {}; } };
    const brSaved = () => brOpened;
    const brOnDeck = () => ((typeof window !== 'undefined') && window.STATION_LOCK === 'backroom') || /^#\/backroom/.test(location.hash);
    const brVoidShow = () => { brVoid.classList.add('on'); brVoid.classList.remove('leaving'); document.documentElement.classList.add('brvoid-lock'); };
    const brVoidHide = fade => {
      document.documentElement.classList.remove('brvoid-lock');
      if(fade){ brVoid.classList.add('leaving'); setTimeout(() => { brVoid.classList.remove('on', 'leaving'); }, 470); }
      else brVoid.classList.remove('on', 'leaving');
    };
    const brVoidSync = () => { if(brOnDeck() && !brSaved()) brVoidShow(); else brVoidHide(false); };
    const brOpen = () => {
      let sp = 'alien';
      try { sp = (JSON.parse(localStorage.getItem(BR_KEY) || 'null') || {}).species || 'alien'; } catch(e){}
      if(brParty) brParty.textContent = sp === 'ally' ? 'ONE (1) CONFIRMED ALIEN-FRIENDLY' : 'ONE (1) CONFIRMED ALIEN';
      const brCardEl = document.getElementById('brCard');
      if(brCardEl){
        let sv = null;
        try { sv = JSON.parse(localStorage.getItem(BR_KEY) || 'null'); } catch(e){}
        const noEl = document.getElementById('brCardNo');
        const sinceEl = document.getElementById('brCardSince');
        if(noEl) noEl.textContent = 'NO. ' + String((sv && sv.mno) || 618).padStart(4, '0');
        if(sinceEl){
          const dd = sv && sv.at ? new Date(sv.at) : new Date();
          const MO = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
          sinceEl.textContent = 'ON THE LIST SINCE ' + MO[dd.getMonth()] + ' ' + dd.getDate();
        }
        brCardEl.hidden = false;
      }
      brGrid.innerHTML = BACKROOM.map(function(b, i){
        var sh = b.shelf && BR_SHELVES[b.shelf];
        var shelfHead = (sh && !(BACKROOM[i-1] && BACKROOM[i-1].shelf === b.shelf))
          ? '<div class="br-shelf"><span class="br-shelf-k">' + sh.k + '</span><p class="br-shelf-p">' + sh.p + '</p></div>'
          : '';
        return shelfHead + brCard(b, i);
      }).join('');
      brGrid.hidden = false;
      if(brAccord) brAccord.hidden = false;
      if(brFunnel) brFunnel.hidden = false;
      if(brLegal) brLegal.hidden = false;
    };
    const brLock = () => {
      brOpened = false; /* relock closes the door; the member number stays \u2014 nothing to revoke, nothing was sent */
      brGrid.innerHTML = '';
      brGrid.hidden = true;
      if(brAccord) brAccord.hidden = true;
      if(brFunnel) brFunnel.hidden = true;
      if(brLegal) brLegal.hidden = true;
      if(brVoidGo){ brVoidGo.disabled = false; if(brVoidGo.dataset.label) brVoidGo.textContent = brVoidGo.dataset.label; }
      const brCardEl2 = document.getElementById('brCard');
      if(brCardEl2) brCardEl2.hidden = true;
      const brListEl2 = document.getElementById('brVoidList');
      if(brListEl2) brListEl2.textContent = '';
      brVoid.classList.remove('listing', 'roped');
      brVoidSync();
    };
    /* nothing opens at boot \u2014 the door asks first, every visit */
    if(brVoidAway && (typeof window !== 'undefined') && window.STATION_LOCK) brVoidAway.setAttribute('href', '/');
    if(brVoidGo){
      brVoidGo.dataset.label = brVoidGo.textContent;
      brVoidGo.addEventListener('click', () => {
        if(brVoidGo.disabled) return;
        brVoidGo.disabled = true;
        /* the whole ritual: 2,300 names, one criterion, zero rejections.
           under two seconds of scrutiny, all of it decorative. */
        const brPrev = brRecord();
        const brBack = !!(brPrev && brPrev.mno);
        const brMno = brBack ? brPrev.mno : 1 + Math.floor(Math.random() * 2300);
        const brListEl = document.getElementById('brVoidList');
        const brSay = t => { if(brListEl) brListEl.textContent = t; };
        const brFinish = () => {
          brOpened = true;
          try { localStorage.setItem(BR_KEY, JSON.stringify({ ok: true, species: (brPrev && brPrev.species) || 'alien', at: (brPrev && brPrev.at) || new Date().toISOString(), mno: brMno })); } catch(e){}
          brOpen();
          setTimeout(() => {
            brVoidHide(true);
            brVoidGo.disabled = false;
            brVoidGo.textContent = brVoidGo.dataset.label;
            brVoid.classList.remove('listing', 'roped');
            brSay('');
            window.scrollTo(0, 0);
          }, 560);
        };
        if(matchMedia('(prefers-reduced-motion: reduce)').matches){
          brSay('ON THE LIST. IN YOU GO.');
          brFinish();
          return;
        }
        brVoid.classList.add('listing');
        brVoidGo.textContent = 'HOLD\u2026';
        brSay('CHECKING THE LIST \u00b7 2,300 NAMES\u2026');
        setTimeout(() => { brSay('SCROLLING\u2026 STILL SCROLLING\u2026'); }, 620);
        setTimeout(() => {
          brVoid.classList.add('roped');
          brSay('FOUND YOU \u00b7 NO. ' + String(brMno).padStart(4, '0') + (brBack ? ' \u00b7 STILL ON THE LIST. IN YOU GO.' : ' \u00b7 YOU WERE ALWAYS ON IT.'));
        }, 1240);
        setTimeout(brFinish, 1900);
      });
    }
    if(brRelock) brRelock.addEventListener('click', e => { e.preventDefault(); brLock(); });
    addEventListener('hashchange', brVoidSync);
    brVoidSync();
  }
}
/* ============ THE BIG BOARD \u00b7 live count above the canopy ============
   Gas-price sign, but the numbers are the ones that matter here:
   vessels left in the first pour, sleepers awoken. Base values come
   from the theme editor (window.STATION_BOARD); each 18-second crew
   visit ticks five across while you watch \u2014 bay-cam arithmetic that
   resets to the configured truth on reload.
   ==================================================================== */
{
  const fcL = document.getElementById('fcBoardLeft');
  const fcA = document.getElementById('fcBoardAwake');
  const fcSec = document.getElementById('forecourt');
  if(fcL && fcA){
    /* Two numbers, both out of Shopify, neither of them moving on a timer.
       LEFT is the inventory the store actually holds across the five hues.
       AWOKEN is what that implies has gone: made minus left. With nothing
       sold it reads 00500 / 00000, which is the truth and is also, on the
       morning of a launch, a better sentence than a fake countdown. */
    const cfg = (typeof window !== 'undefined' && window.STATION_BOARD) || {};
    const fcReal = (typeof runLeft === 'function') ? runLeft() : null;
    const fcMade = (typeof runMade === 'function') ? runMade() : null;

    const fcRun  = (fcMade !== null) ? fcMade
      : Math.max(0, ((typeof cfg.left === 'number' && cfg.left >= 0) ? Math.round(cfg.left) : 500) - heldBack());
    const fcLeft = (fcReal !== null) ? fcReal : fcRun;
    const fcAwake = Math.max(0, fcRun - fcLeft);

    const fcPad = n => String(Math.max(0, n)).padStart(5, '0');
    fcL.textContent = fcPad(fcLeft);
    fcA.textContent = fcPad(fcAwake);

    /* the fine print under the board: made, held, and still to come */
    const fcFoot = document.getElementById('fcBoardFoot');
    if(fcFoot){
      const gross = (typeof runMadeGross === 'function') ? runMadeGross() : null;
      const made = (gross !== null) ? gross : 500;
      const held = heldBack();
      fcFoot.textContent = made.toLocaleString('en-US') + ' MADE'
        + (held ? ' \u00b7 ' + held + ' HELD BY THE STUDIO' : '')
        + ' \u00b7 8,000,000 TO COME';
    }

    /* the caption under the bay cam described the old ticker, so it has to
       stop describing a thing that no longer happens */
    const fcCap = document.getElementById('fcCrewRate');
    if(fcCap){
      fcCap.textContent = (fcAwake > 0)
        ? 'FULL SERVICE \u00b7 ' + fcAwake + ' VESSEL' + (fcAwake === 1 ? '' : 'S') + ' HAVE LEFT THE STATION'
        : 'FULL SERVICE \u00b7 THE FIRST POUR HAS NOT BEEN CLAIMED YET';
    }
  }
}

/* crew skin toggle · a test fitting: vessel bodies vs the classic chibi */
{
  const fcSt = document.getElementById('fcStyle');
  const fcStage = document.getElementById('fcStage');
  if(fcSt && fcStage){
    let fcMode = 'vessel';
    try { fcMode = localStorage.getItem('fcCrewStyle') || 'vessel'; } catch(e){}
    const fcApply = () => {
      fcStage.classList.toggle('fc-vb', fcMode === 'vessel');
      fcSt.textContent = fcMode === 'vessel'
        ? 'CREW: VESSEL-BODY \u00b7 TAP FOR CLASSIC'
        : 'CREW: CLASSIC \u00b7 TAP FOR VESSEL-BODY';
    };
    fcSt.addEventListener('click', () => {
      fcMode = fcMode === 'vessel' ? 'classic' : 'vessel';
      try { localStorage.setItem('fcCrewStyle', fcMode); } catch(e){}
      fcApply();
    });
    fcApply();
  }
}

/* ============ THE TYPE LAB \u00b7 header voice switcher ============ */
{
  const tl = document.getElementById('typeLab');
  const de = document.documentElement;
  let tf = 'anton';
  try { tf = localStorage.getItem('stationType') || 'anton'; } catch(e){}
  if(de && de.setAttribute) de.setAttribute('data-type', tf);
  if(tl){
    const tlPaint = () => { tl.querySelectorAll('[data-tf]').forEach(b => b.classList.toggle('on', b.getAttribute('data-tf') === tf)); };
    tl.addEventListener('click', e => {
      const b = e.target.closest ? e.target.closest('[data-tf]') : null;
      if(!b) return;
      tf = b.getAttribute('data-tf');
      if(de && de.setAttribute) de.setAttribute('data-type', tf);
      try { localStorage.setItem('stationType', tf); } catch(err){}
      tlPaint();
    });
    tlPaint();
  }
}
/* ============ DECK 08 \u00b7 THE SIGHTING NETWORK ============
   The conservation program, pointed at the aliens themselves.
   Endangered-species grammar: status ladder per tier, the vessel
   as the band, citizen sighting reports. Local-only \u2014 the log
   lives in this browser until the fleet docks a real network.
   ========================================================== */
{
  const trS = document.getElementById('trackStatus');
  if(trS){
    const TRACK_TIERS = [
      ['T0', 'SLEEPER',   '8,000,000,000', 'LEAST CONCERN',   100,  '#8FA3C9', 'asleep \u00b7 everywhere \u00b7 unaware they are being counted'],
      ['T1', 'SEEKER',    '2,300,000',     'WATCHED',         61.8, '#00CE7E', 'awake \u00b7 range expanding'],
      ['T2', 'SENSITIVE', '230,000',       'VULNERABLE',      38.2, '#F8E44B', 'the colour has arrived \u00b7 habitat: dawn roads'],
      ['T3', 'RESONANT',  '23,000',        'ENDANGERED',      23.6, '#FF8C3D', 'rings visible across the parking lot'],
      ['T4', 'DEMIGOD',   '2,300',         'CRITICALLY RARE', 14.6, '#F0C75E', 'protected at all costs \u00b7 the number does not move']
    ];
    trS.innerHTML = TRACK_TIERS.map(t =>
      '<div class="tr-row">'
      + '<span class="tr-tier">' + t[0] + ' \u00b7 ' + t[1] + '</span>'
      + '<span class="tr-pop num">' + t[2] + '</span>'
      + '<span class="tr-stat" style="--sc:' + t[5] + '">' + t[3] + '</span>'
      + '<span class="tr-bar"><i style="width:' + t[4] + '%;background:' + t[5] + '"></i></span>'
      + '<span class="tr-note">' + t[6] + '</span>'
      + '</div>').join('');

    const trFeed = document.getElementById('trackFeed');
    const trCount = document.getElementById('trackCount');
    const trColor = document.getElementById('trackColor');
    const trHab = document.getElementById('trackHab');
    const trLog = document.getElementById('trackLog');
    const TR_KEY = 'sightings.v1';
    const TR_HEX = { GREEN:'#00CE7E', PINK:'#EA41AA', RED:'#FC4539', YELLOW:'#F8E44B', BLUE:'#389EE1' };
    const TR_SEED = [
      ['GREEN', 'ROAD', 'DAWN PATROL'],
      ['BLUE', 'POOL', 'BEFORE WORK'],
      ['YELLOW', 'TRAIL', 'HIGH NOON'],
      ['PINK', 'THE WILD', 'LAST HOUR OF LIGHT'],
      ['RED', 'GYM', 'NIGHT SHIFT']
    ];
    let trSel = { c: 'GREEN', h: 'ROAD' };
    let trSaved = [];
    try { trSaved = JSON.parse(localStorage.getItem(TR_KEY) || '[]') || []; } catch(e){ trSaved = []; }

    const trEntry = (c, h, when) =>
      '<li><i style="--tc:' + (TR_HEX[c] || '#7CE8FF') + '">\u25cf</i> ' + c + ' ALIEN \u00b7 ' + h + ' \u00b7 ' + when + '</li>';
    const trPaint = () => {
      if(trFeed) trFeed.innerHTML =
        trSaved.map(s => trEntry(s.c, s.h, s.w)).join('') + TR_SEED.map(s => trEntry(s[0], s[1], s[2])).join('');
      if(trCount) trCount.textContent = 'SIGHTINGS THIS WATCH: ' + trSaved.length;
      if(trCount && !document.getElementById('trFullLink')){
        const a = document.createElement('a');
        a.id='trFullLink'; a.href='/pages/sightings';
        a.style.cssText='display:inline-block;margin-left:13px;font-family:\'IBM Plex Mono\',monospace;font-size:11px;letter-spacing:.14em;color:#F0C75E;text-decoration:none';
        a.textContent='OPEN THE BURN TRAIL \u2192';
        trCount.parentNode.insertBefore(a, trCount.nextSibling);
      }
    };
    const trWire = (wrap, key) => {
      if(!wrap) return;
      wrap.addEventListener('click', e => {
        const b = e.target.closest ? e.target.closest('.tr-chip') : null;
        if(!b) return;
        trSel[key] = b.getAttribute('data-v');
        wrap.querySelectorAll('.tr-chip').forEach(c => c.classList.toggle('on', c === b));
      });
    };
    trWire(trColor, 'c');
    trWire(trHab, 'h');
    /* the quick logger also writes the full-trail schema, so the deck widget and
       DECK 08's page are one log rather than two */
    const trFull = (c, h) => {
      try {
        const K='sightings.v2';
        const arr = JSON.parse(localStorage.getItem(K) || '[]') || [];
        arr.unshift({ c: c, h: h, trail:'', note:'', ts: Date.now(), who:'', tier:'', lat:null, lng:null });
        localStorage.setItem(K, JSON.stringify(arr.slice(0,500)));
      } catch(e){}
    };
    if(trLog) trLog.addEventListener('click', () => {
      trFull(trSel.c, trSel.h);
      trSaved.unshift({ c: trSel.c, h: trSel.h, w: 'JUST NOW' });
      trSaved = trSaved.slice(0, 8);
      try { localStorage.setItem(TR_KEY, JSON.stringify(trSaved)); } catch(e){}
      trPaint();
    });
    trPaint();
  }
}
/* ============ DECK 09 \u00b7 THE LAUNCH PAD ============
   The separate page between wanting and having. One screen,
   every number, a manifest with live controls, and a single
   gold button that runs the airlock departure. The ticker
   feeds it: tap a color up there and the vessel beams aboard
   on the way in. */
function lpGoTo(){
  /* V92: the Launch Pad is out of the buying path. Decided buyers go to the hold. */
  if (typeof openHold === 'function') return openHold();
  if (typeof window !== 'undefined' && window.STATION_LOCK) { window.location.href = '/cart'; }
  else { location.hash = '#/bottles'; }
}

/* ==================== THE PLAIN FACTS ====================
   One plain-language spec block under the vessel bay. The lore sells;
   this is the part a search engine (and a shopper comparing bottles)
   can actually read. Static, no motion.
   ======================================================== */
{
  const pfHost = document.getElementById('bottles') || document.getElementById('vessel');
  if (pfHost && !document.getElementById('plainFacts')) {
    const w = document.createElement('div');
    w.className = 'wrap'; w.id = 'plainFacts';
    w.innerHTML =
      '<div style="max-width:72ch;margin:0 auto;padding:34px 0 8px">' +
      '<h2 style="font-family:\'IBM Plex Mono\',monospace;font-size:12px;letter-spacing:.24em;color:var(--dim);margin:0 0 13px">THE PLAIN FACTS</h2>' +
      '<p style="font-size:15px;line-height:1.7;color:var(--dim);margin:0 0 13px">' +
      'Every vessel is a 22 oz (650 ml) squeeze water bottle for cycling, running and the gym. ' +
      'BPA-free LDPE body, self-sealing valve, dishwasher safe on the top rack, and it fits every standard bike bottle cage. ' +
      'Each colour is printed in a run of 100 and never reprinted. Ships from Colorado.' +
      '</p><p style="font-size:15px;line-height:1.7;color:var(--dim);margin:0">' +
      'We call them vessels. A cyclist would call it a bidon; everyone else calls it a water bottle. Same object, better name.' +
      '</p></div>';
    pfHost.appendChild(w);
  }
}

/* ---------- THE LAUNCH PAD \u00b7 complete the crew (recommendation rail) ---------- */
function lpRecPaint(){
  var wrap = document.getElementById('lpRec');
  var rail = document.getElementById('lpRecRail');
  /* the compact shelf now lives in the manifest card, above the fold. Showing
     the same four colours again further down the same page is not a second
     chance, it is noise — so the big rail only appears if the compact one
     could not render for some reason. */
  var compact = document.getElementById('lpShelf');
  if(wrap && compact && compact.querySelector('.hs-tile')){ wrap.hidden = true; return; }
  if(!wrap || !rail) return;
  /* what is already strapped in */
  var inCart = {};
  if(SHOP && shopCart){
    (shopCart.items || []).forEach(function(it){
      var h = (it.handle || '').replace(/^og-/, '');
      ['green','pink','red','yellow','blue'].forEach(function(c){ if(h.indexOf(c) >= 0) inCart['v-' + c] = 1; });
    });
  } else {
    cart.forEach(function(q, id){ if(q > 0) inCart[id] = 1; });
  }
  var picks = [];
  /* 1. the rest of the crew, in canon order */
  ['v-green','v-pink','v-red','v-yellow','v-blue'].forEach(function(id){
    if(inCart[id] || soldOut(id)) return;
    var p = byId(id);
    if(!p) return;
    var m = /^v-(\w+)$/.exec(id);
    picks.push({ id:id, name:p.name, price:p.price, img:(m && OG_IMG[m[1]]) ? OG_IMG[m[1]] : '',
                 note:'THE CREW \u00b7 100 MADE', tint:(CREW_ACTIVE.filter(function(c){ return 'v-' + c[0] === id; })[0] || [])[3] || '#00CE7E' });
  });
  /* 2. then the hold \u2014 rare garments, cheapest first */
  if(typeof GARMENTS !== 'undefined' && !(typeof GH_SEALED !== 'undefined' && GH_SEALED)){
    GARMENTS.slice().sort(function(a, b){ return a.price - b.price; }).forEach(function(g){
      if(inCart[g.id]) return;
      picks.push({ id:g.id, name:g.name, price:g.price, img:'', note:'THE GARMENT HOLD \u00b7 ONE OF EACH', tint:'#7CE8FF' });
    });
  }
  picks = picks.slice(0, 8);
  if(!picks.length){ wrap.hidden = true; return; }
  wrap.hidden = false;
  rail.innerHTML = picks.map(function(p){
    return '<article class="lp-rc" style="--rc:' + p.tint + '">'
      + '<div class="lp-rc-art">' + (p.img ? '<img src="' + p.img + '" alt="">' : '<span class="lp-rc-ph"></span>') + '</div>'
      + '<span class="lp-rc-note num">' + p.note + '</span>'
      + '<h4 class="lp-rc-nm">' + p.name + '</h4>'
      + '<div class="lp-rc-row"><span class="lp-rc-pr num">$' + p.price + '</span>'
      + '<button class="lp-rc-add" type="button" data-add="' + p.id + '">ADD</button></div>'
      + '</article>';
  }).join('');
}
function lpPaint(){
  const list = document.getElementById('lpList');
  const totalEl = document.getElementById('lpTotal');
  const goBtn = document.getElementById('lpGo');
  const countEl = document.getElementById('lpCount');
  if(!list || !totalEl || !goBtn) return;
  const CHIPS = [['v-green','GREEN','#00CE7E'],['v-pink','PINK','#EA41AA'],['v-red','RED','#FC4539'],['v-yellow','YELLOW','#F8E44B'],['v-blue','BLUE','#389EE1']].filter(c => !soldOut(c[0]));
  const chipRow = '<div class="lp-empty"><p>THE HOLD IS EMPTY \u00b7 GRAVITY REMAINS ON.</p><p class="lp-empty-sub">Pick a color \u2014 the vessel beams straight into the manifest:</p><div class="lp-chips">'
    + CHIPS.map(c => '<button class="lp-chip" type="button" data-add="' + c[0] + '" style="--c:' + c[2] + '">' + c[1] + ' \u00b7 $33</button>').join('')
    + '</div></div>';
  let html = '', total = 0, count = 0;
  if(SHOP && shopCart){
    (shopCart.items || []).forEach(it => {
      count += it.quantity;
      var lpSrc = lineArt(it.handle, it.image);
      html += '<div class="lp-item">'
        + (lpSrc ? '<img class="lp-ph" src="' + lpSrc + '" alt="' + (it.product_title || '') + '">' : '<span class="lp-ph"></span>')
        + '<div class="lp-meta"><b>' + it.product_title + '</b><span class="lp-unit">' + money(it.price) + ' each</span></div>'
        + '<span class="lp-qty"><button data-kdec="' + it.key + '" aria-label="Remove one">\u2212</button><b class="num">' + it.quantity + '</b><button data-kinc="' + it.key + '" aria-label="Add one">+</button></span>'
        + '<b class="lp-line num">' + money(it.price * it.quantity) + '</b>'
        + '</div>';
    });
    total = shopCart.total_price;
    list.innerHTML = html || chipRow;
    totalEl.textContent = shopCart.item_count ? money(total) : '$0';
  } else {
    cart.forEach((qty, id) => {
      if(qty <= 0) return;
      const p = byId(id);
      if(!p) return;
      total += p.price * qty; count += qty;
      const dsrc = lineArt(id, '');
      html += '<div class="lp-item">'
        + (dsrc ? '<img class="lp-ph" src="' + dsrc + '" alt="">' : '<span class="lp-ph"></span>')
        + '<div class="lp-meta"><b>' + p.name + '</b><span class="lp-unit">$' + p.price + ' each</span></div>'
        + '<span class="lp-qty"><button data-dec="' + id + '" aria-label="Remove one">\u2212</button><b class="num">' + qty + '</b><button data-inc="' + id + '" aria-label="Add one">+</button></span>'
        + '<b class="lp-line num">$' + (p.price * qty) + '</b>'
        + '</div>';
    });
    list.innerHTML = html || chipRow;
    totalEl.textContent = '$' + total;
  }
  /* the rest of the shelf, inside the manifest card and above the button —
     the same component the cargo hold uses, so there is one of these to keep
     right rather than two */
  var lpShelf = document.getElementById('lpShelf');
  if(lpShelf){
    lpShelf.innerHTML = count ? holdShelf(holdInCart()) : '';
  }
  paintShipLine();

  if(countEl) countEl.textContent = count ? (count + (count === 1 ? ' VESSEL STRAPPED IN' : ' VESSELS STRAPPED IN')) : 'NOTHING STRAPPED IN YET';
  goBtn.disabled = count === 0;
  goBtn.textContent = count === 0 ? 'STRAP A VESSEL IN FIRST' : 'IGNITE \u00b7 ' + (SHOP && shopCart ? money(total) : '$' + total) + ' \u00b7 LAUNCH THE ALIEN WITHIN';
  lpRecPaint();
}
{
  const __lpRC = renderCart;
  renderCart = function(){ __lpRC.apply(this, arguments); lpPaint(); };
  const lpGoBtn = document.getElementById('lpGo');
  if(lpGoBtn) lpGoBtn.addEventListener('click', () => { if(!lpGoBtn.disabled) airlockSeq(); });
  document.addEventListener('click', e => {
    const t = e.target && e.target.closest ? e.target.closest('[data-launch]') : null;
    if(!t) return;
    if(e.preventDefault) e.preventDefault();
    addItem(t.dataset.launch);
    beamFX(e.clientX, e.clientY);
    cargoBump();
    if (typeof openHold === 'function') openHold();  /* V92: one add flow — into the hold, never the pad */
  });
  lpPaint();
}
/* ============ ONE-FILE ROUTER ============ */
const ROUTE_SECTIONS = {
  home: ['arrivals','whatthis','forecourt','vessel','bottles','sighting','faq','salvage','impound','alerts','fuel','ascension','freezer','tracking','reporting','crew'],
  reporting: ['reporting'],
  drop: ['drop'],
  impound: ['impound','alerts'],
  bottles: ['vessel','bottles','sighting','faq'],
  about: ['whatthis'],
  salvage: ['salvage'],
  fuel: ['fuel'],
  ascension: ['ascension'],
  crew: ['crew'],
  freezer: ['freezer'],
  tracking: ['tracking'],
  launch: ['launch'],
  dustfall: ['dustfall'],
  canopy: ['canopy'],
  backroom: ['backroom']
};
const DECK_ORDER = [
  ['bottles','DECK 02','The Vessel Bay'],
  ['salvage','DECK 03','Salvage'],
  ['impound','DECK 10','The Impound'],
  ['fuel','DECK 04','The Fuel Bay'],
  ['ascension','DECK 05','The Ascension'],
  ['freezer','DECK 07','The Deep Freezer'],
  ['tracking','DECK 08','The Sighting Network'],
  ['reporting','DECK 11','The Reporting']
];
const ALL_SECTIONS = ['arrivals','whatthis','forecourt','vessel','bottles','faq','salvage','impound','alerts','fuel','ascension','freezer','tracking','reporting','launch','crew','dustfall','canopy','backroom','drop'];
const TITLES = {drop:'The Drop \u2014 THE STATION', reporting:'The Reporting \u2014 THE STATION', impound:'The Impound \u2014 THE STATION', home:'THE STATION \u2014 Alien Vessels \u00b7 The Proportions, in orbit', crew:'The Crew Manifest \u2014 THE STATION', dustfall:'The Dustfall \u2014 THE STATION', canopy:'The Canopy \u2014 THE STATION', backroom:'The Back Room \u2014 THE STATION', launch:'The Launch Pad \u2014 THE STATION', tracking:'The Sighting Network \u2014 THE STATION'};
DECK_ORDER.forEach(d=>{ TITLES[d[0]] = d[2] + ' \u2014 THE STATION'; });
const hopEl = document.getElementById('deckHop');

function currentRoute(){
  const m = location.hash.match(/^#\/([a-z\-]*)/);
  const r = m ? (m[1] || 'home') : 'home';
  const lock = (typeof window !== 'undefined') && window.STATION_LOCK;
  if(lock && ROUTE_SECTIONS[lock]) return lock;
  return ROUTE_SECTIONS[r] ? r : 'home';
}
function route(){
  const r = currentRoute();
  if(ROUTE_SECTIONS[r] && r !== 'home' && r !== 'crew'){ if(!SIG.decks.includes(r)) SIG.decks.push(r); SIG.lastDeck = r; }
  const show = new Set(ROUTE_SECTIONS[r]);
  ALL_SECTIONS.forEach(id=>{
    const el = document.getElementById(id);
    if(el) el.classList.toggle('view-off', !show.has(id));
  });
  const di = DECK_ORDER.findIndex(d=>d[0]===r);
  if(hopEl){
    if(di >= 0){
      const prev = di === 0 ? ['','DECK 01','Arrivals'] : DECK_ORDER[di-1];
      const next = di === DECK_ORDER.length-1 ? ['crew','DECK 06','The Crew Manifest'] : DECK_ORDER[di+1];
      hopEl.innerHTML = `<a href="#/${prev[0]}">\u2190 ${prev[1]} \u00b7 ${prev[2]}</a><a href="#/${next[0]}">${next[1]} \u00b7 ${next[2]} \u2192</a>`;
      hopEl.style.display = 'flex';
    } else {
      hopEl.style.display = 'none';
    }
  }
  document.title = TITLES[r] || TITLES.home;
  document.querySelectorAll('.menu-item').forEach(a=>a.classList.toggle('active', a.dataset.route === r));
  if((typeof window !== 'undefined') && window.STATION_LOCK){
    document.querySelectorAll('.menu-item').forEach(a=>{ const h = a.getAttribute('href'); if(!a.dataset.abs && h && h.charAt(0) === '#'){ a.dataset.abs = '1'; a.href = '/' + h; } });
  }
  if(menuPanel){ menuPanel.classList.remove('open'); menuBtn.setAttribute('aria-expanded','false'); }
  window.scrollTo(0,0);
  dispatchEvent(new Event('resize'));
}
addEventListener('hashchange', route);
route();


/* the sealed face of the Impound: honest about why, and useful about it */
function sealImpound(sec, seen){
  sec.classList.add('imp-off', 'imp-sealed');
  var set = function(id, txt){ var e = document.getElementById(id); if(e) e.textContent = txt; };
  if(seen){
    set('impStatus', 'IN VERIFICATION \u00b7 SPECIMEN RECOVERED, SPECIES NOT YET CONFIRMED');
    set('impPrice', '\u2014');
    set('impNext', 'THE LADDER DOES NOT RUN UNTIL THE TESTS COME BACK');
    set('impVh', 'SPECIES VERIFICATION \u00b7 IN PROGRESS');
    set('impFieldTx', 'SIGHTING CONFIRMED \u00b7 SPECIMEN IN THE BAY \u00b7 SPECIES: UNDER TEST');
  } else {
    set('impStatus', 'SEALED \u00b7 NO CONFIRMED SIGHTING ON RECORD');
    set('impPrice', '\u2014');
    set('impNext', 'THE LADDER DOES NOT RUN UNTIL ONE IS SIGHTED');
    set('impVh', 'SPECIES VERIFICATION \u00b7 NOTHING TO VERIFY YET');
    set('impFieldTx', 'NO CONFIRMED SIGHTING \u00b7 THE FRONT RANGE IS BEING WATCHED \u00b7 SPECIES: UNRECORDED');
  }
  var rail = document.getElementById('impRail');
  if(rail) rail.innerHTML = '';

  /* the deck still had three places insisting the descent was running */
  var pill = sec.querySelector('.imp-live');
  if(pill) pill.textContent = 'SEALED';
  var kick = sec.querySelector('.kicker');
  if(kick) kick.textContent = kick.textContent.replace('LIVE DESCENT', 'DESCENT SEALED');
  var lead = sec.querySelector('.imp-lead');
  if(lead) lead.innerHTML = lead.innerHTML.replace(
    'and one just was.',
    'and none has been confirmed yet.');
  var cks = document.querySelectorAll('#impVerify [data-ck]');
  [].forEach.call(cks, function(c){ c.classList.remove('pass','run'); });

  var btn = document.getElementById('impClaim');
  if(btn){
    btn.removeAttribute('data-add');
    btn.disabled = true;
    btn.classList.add('is-sealed');
    btn.textContent = seen
      ? 'SEALED \u00b7 VERIFICATION IN PROGRESS'
      : 'SEALED \u00b7 AWAITING A CONFIRMED SIGHTING';
  }

  /* the only way this opens is somebody seeing one, so say where to do that */
  if(!document.getElementById('impSealNote')){
    var p = document.createElement('div');
    p.id = 'impSealNote';
    p.className = 'imp-seal-note';
    p.innerHTML = seen
      ? '<b>WHY THIS LOT IS STILL SHUT</b>'
        + '<p>Something was seen and it is in the bay. That is stage one of two. Being '
        + 'black is not the same as being <i>the</i> black one \u2014 the shell gets '
        + 'measured, the plate gets read, and the catalogue gets searched for a match. '
        + 'Most candidates turn out to be a known hue in bad light.</p>'
        + '<p>Until the tests come back the lot does not open, and neither does the cart.</p>'
        + '<a class="btn" href="/pages/the-unranked">HOW THE TEST WORKS \u00b7 DECK 10.5 \u2192</a>'
      : '<b>WHY THIS LOT IS SHUT</b>'
        + '<p>One black vessel is said to exist and no sighting of it has been confirmed. '
        + 'Until one is, it is a story, and a story does not get a price. The ladder stays '
        + 'frozen, the claim button stays dead, and the cart will refuse it even if you find '
        + 'another way to ask.</p>'
        + '<p>Two things have to happen, in order: one has to be seen, and then the specimen '
        + 'has to be tested and come back as the black OG alien. A sighting on its own opens '
        + 'nothing.</p>'
        + '<a class="btn" href="/pages/sightings">LOG A SIGHTING \u00b7 DECK 08.5 \u2192</a>';
    if(btn && btn.parentNode) btn.parentNode.insertBefore(p, btn.nextSibling);
    else sec.appendChild(p);
  }
}

/* ---------- DECK 10 · THE IMPOUND · live descent engine ---------- */
var IMP_LOTS = [{ id:'imp-1', name:'OG BLACK ALIEN 618 \u00b7 LOT 001', spec:'recovered \u00b7 made to order \u00b7 ships in 4\u20138 weeks', price:1000, priced:true }];
(function(){
  var sec = document.getElementById('impound');
  if(!sec) return;

  /* nothing runs until one has been seen AND tested */
  if(!blackVerified()){
    sealImpound(sec, blackSighted());
    return;
  }

  var LADDER = [3333.33, 2618, 1618, 1000];
  var ARM_MIN = 6, STEP_MIN = 12, END_MIN = ARM_MIN + STEP_MIN * LADDER.length; /* :06 → :54 */
  var elS = document.getElementById('impStatus'), elP = document.getElementById('impPrice'),
      elN = document.getElementById('impNext'), elR = document.getElementById('impRail'),
      elB = document.getElementById('impClaim'),
      elF = document.getElementById('impFieldTx'), elVh = document.getElementById('impVh');
  var cks = Array.prototype.slice.call(document.querySelectorAll('#impVerify [data-ck]'));
  var fmt = function(v){ return '$' + v.toLocaleString('en-US', {minimumFractionDigits: (v % 1 ? 2 : 0), maximumFractionDigits: 2}); };
  elR.innerHTML = LADDER.map(function(v,i){ return '<span class="imp-step" data-i="' + i + '">' + fmt(v) + '</span>'; }).join('');
  var steps = Array.prototype.slice.call(elR.children);
  var mmss = function(ms){ var s = Math.max(0, Math.ceil(ms/1000)); var m = Math.floor(s/60); s = s % 60; return (m<10?'0':'') + m + ':' + (s<10?'0':'') + s; };
  var last = null;
  function tick(){
    if(document.hidden) return;
    var now = new Date();
    var minF = now.getUTCMinutes() + now.getUTCSeconds()/60 + now.getUTCMilliseconds()/60000;
    var hourStart = now.getTime() - (minF * 60000);
    var phase, idx = -1, price = null, nextAt, nextLabel;
    if(minF < ARM_MIN){
      phase = 'arm'; nextAt = hourStart + ARM_MIN*60000; nextLabel = 'DESCENT BEGINS \u00b7 ';
    } else if(minF < END_MIN){
      phase = 'live'; idx = Math.floor((minF - ARM_MIN) / STEP_MIN); price = LADDER[idx];
      if(idx < LADDER.length - 1){ nextAt = hourStart + (ARM_MIN + (idx+1)*STEP_MIN)*60000; nextLabel = 'NEXT DROP \u00b7 '; }
      else { nextAt = hourStart + END_MIN*60000; nextLabel = 'DESCENT ENDS \u00b7 '; }
    } else {
      phase = 'passed'; nextAt = hourStart + 60*60000; nextLabel = 'NEXT LOT DOCKS \u00b7 ';
    }
    elN.textContent = nextLabel + mmss(nextAt - now.getTime());
    if(phase === 'arm'){
      var slice = ARM_MIN / (cks.length + 1);
      var done = Math.min(cks.length, Math.floor(minF / slice));
      cks.forEach(function(c,i){ c.classList.toggle('pass', i < done); c.classList.toggle('run', i === done); });
      if(done < cks.length){
        elS.textContent = 'VERIFYING THE WESTMINSTER FIND \u00b7 CHECK ' + (done + 1) + ' OF ' + cks.length;
        if(elVh) elVh.textContent = 'SPECIES VERIFICATION \u00b7 SALE-BARN RULES';
        if(elF) elF.textContent = 'POTENTIAL NEW SPECIES \u00b7 FRONT RANGE, NEAR WESTMINSTER, COLORADO \u00b7 SPECIES: PENDING VERIFICATION';
      } else {
        elS.textContent = 'CERTIFIED ALIEN \u00b7 GRADE UNLISTED \u00b7 THE RING OPENS SOON';
        if(elVh) elVh.textContent = 'CERTIFIED ALIEN \u00b7 GRADE: UNLISTED';
        if(elF) elF.textContent = 'CONFIRMED NEW SPECIES \u00b7 WESTMINSTER FIND \u00b7 CLEARED FOR THE RING';
        elB.textContent = 'HOLD \u00b7 CERTIFIED \u00b7 THE RING OPENS SOON';
      }
    } else if(phase === 'live'){
      cks.forEach(function(c){ c.classList.add('pass'); c.classList.remove('run'); });
      if(elVh) elVh.textContent = 'CERTIFIED ALIEN \u00b7 GRADE: UNLISTED';
      if(elF) elF.textContent = 'CONFIRMED NEW SPECIES \u00b7 WESTMINSTER FIND \u00b7 ON THE BLOCK NOW';
    } else {
      cks.forEach(function(c){ c.classList.remove('pass'); c.classList.remove('run'); });
      if(elVh) elVh.textContent = 'SPECIES VERIFICATION \u00b7 AWAITING NEXT CANDIDATE';
      if(elF) elF.textContent = 'SCOUTS OUT \u00b7 NEXT DISCOVERY PENDING \u00b7 THE FRONT RANGE IS BEING WATCHED';
    }
    var key = phase + ':' + idx;
    if(key !== last){
      last = key;
      sec.classList.toggle('imp-off', phase !== 'live');
      sec.classList.toggle('imp-hot', phase === 'live');
      if(phase === 'arm'){
        elS.textContent = 'VERIFYING \u00b7 SPECIES PENDING';
        elP.textContent = fmt(LADDER[0]); elB.disabled = true; elB.textContent = 'HOLD \u00b7 VERIFICATION IN PROGRESS';
      } else if(phase === 'live'){
        elS.textContent = 'LIVE \u00b7 THE PRICE IS FALLING';
        elP.textContent = fmt(price); elB.disabled = false; elB.textContent = 'CLAIM THE LOT \u00b7 ' + fmt(price);
        IMP_LOTS[0].price = price;
      } else {
        elS.textContent = 'LOT PASSED \u00b7 RETURNED TO THE VAULT';
        elP.textContent = '\u2014'; elB.disabled = true; elB.textContent = 'GONE \u00b7 IT DID NOT WAIT';
      }
      steps.forEach(function(s,i){
        s.classList.toggle('gone', phase !== 'arm' && i < idx || phase === 'passed');
        s.classList.toggle('now', phase === 'live' && i === idx);
      });
    }
  }
  setInterval(tick, 1000); tick();
})();

/* ---------- DECK 11 · THE REPORTING · sighting grid + uplink ---------- */
(function(){
  var sec = document.getElementById('reporting');
  if(!sec) return;
  var NS = 'http://www.w3.org/2000/svg';
  var X0 = 40, Y0 = 120, W = 620, H = 392;
  var px = function(lon){ return X0 + ((lon + 109.05) / 7) * W; };
  var py = function(lat){ return Y0 + ((41 - lat) / 4) * H; };
  var grid = document.getElementById('rptGrid');
  var d = '';
  for(var lo = -108; lo <= -103; lo++){ var gx = px(lo).toFixed(1); d += '<line x1="' + gx + '" y1="' + Y0 + '" x2="' + gx + '" y2="' + (Y0+H) + '"/>'; }
  for(var la = 38; la <= 40; la++){ var gy = py(la).toFixed(1); d += '<line x1="' + X0 + '" y1="' + gy + '" x2="' + (X0+W) + '" y2="' + gy + '"/>'; }
  grid.innerHTML = d;
  var CITIES = [[39.7392,-104.9903,'DENVER',1],[38.8339,-104.8214,'CO SPRINGS',1],[40.585,-105.084,'FT COLLINS',0],[39.0639,-108.5506,'GRAND JCT',0],[37.2753,-107.8801,'DURANGO',0],[38.2544,-104.6091,'PUEBLO',0]];
  var state = document.getElementById('rptState');
  CITIES.forEach(function(c){
    var ct = document.createElementNS(NS,'circle');
    ct.setAttribute('cx', px(c[1])); ct.setAttribute('cy', py(c[0])); ct.setAttribute('r', 2); ct.setAttribute('class','rpt-city');
    state.appendChild(ct);
    if(c[3]){ var t = document.createElementNS(NS,'text'); t.setAttribute('x', px(c[1]) + 7); t.setAttribute('y', py(c[0]) + 3); t.setAttribute('class','rpt-citylb'); t.textContent = c[2]; state.appendChild(t); }
  });
  var HQ = [39.8367, -105.0372];
  var bm = document.getElementById('rptBeam'); if(bm) bm.setAttribute('points', px(HQ[1]).toFixed(1) + ',' + py(HQ[0]).toFixed(1) + ' 596,66');
  var SIGHTINGS = [
    {lat:39.8367, lon:-105.0372, cls:'hq',   lb:'THE STATION', big:1},
    {lat:39.88,   lon:-105.05,  cls:'pend', lb:'SR-2608-CO', big:1},
    {lat:39.7392, lon:-104.9903, cls:'',    lb:''},
    {lat:40.01,   lon:-105.27,  cls:'',     lb:''},
    {lat:38.8339, lon:-104.8214, cls:'',    lb:''},
    {lat:40.585,  lon:-105.084, cls:'',     lb:''},
    {lat:39.7555, lon:-105.2211, cls:'',    lb:''}
  ];
  var pips = document.getElementById('rptPips'), rings = document.getElementById('rptRings');
  var elC = document.getElementById('rptCount'), elL = document.getElementById('rptLast'), elN = document.getElementById('rptNext'), elLog = document.getElementById('rptLog');
  function draw(){
    var h = '';
    SIGHTINGS.forEach(function(s){
      var x = px(s.lon).toFixed(1), y = py(s.lat).toFixed(1);
      h += '<circle class="rpt-pip ' + s.cls + '" cx="' + x + '" cy="' + y + '" r="' + (s.big ? 5 : 3.6) + '"/>';
      if(s.lb){
        var ax = 'middle', tx = x, ty = (py(s.lat) - 9).toFixed(1);
        if(s.cls === 'hq'){ ax = 'end'; tx = (px(s.lon) - 10).toFixed(1); ty = (py(s.lat) + 4).toFixed(1); }
        if(s.cls === 'pend'){ ax = 'start'; tx = (px(s.lon) + 10).toFixed(1); ty = (py(s.lat) - 8).toFixed(1); }
        h += '<text class="rpt-piplb" x="' + tx + '" y="' + ty + '" text-anchor="' + ax + '">' + s.lb + '</text>';
      }
    });
    pips.innerHTML = h;
    elC.textContent = SIGHTINGS.length - 1; /* the station itself is not a find */
  }
  var beamT;
  function ring(x, y){
    var c = document.createElementNS(NS,'circle');
    c.setAttribute('cx', x); c.setAttribute('cy', y); c.setAttribute('r', 26); c.setAttribute('class','rpt-ring');
    rings.appendChild(c);
    setTimeout(function(){ if(c.parentNode) c.parentNode.removeChild(c); }, 5800);
  }
  function utc(){ var n = new Date(); var p = function(v){ return (v < 10 ? '0' : '') + v; }; return p(n.getUTCHours()) + ':' + p(n.getUTCMinutes()); }
  function log(line, fresh){
    var li = document.createElement('li');
    li.textContent = '> ' + line;
    if(fresh) li.className = 'fresh';
    elLog.insertBefore(li, elLog.firstChild);
    while(elLog.children.length > 7) elLog.removeChild(elLog.lastChild);
  }
  function transmit(msg){
    sec.classList.add('rpt-tx');
    ring(px(HQ[1]), py(HQ[0]));
    clearTimeout(beamT);
    beamT = setTimeout(function(){ sec.classList.remove('rpt-tx'); }, 2600);
    elL.textContent = utc();
    log(msg, true);
  }
  draw();
  log('UPLINK ' + utc() + ' UTC · SIX FINDS ON THE GRID · REBROADCAST QUEUED');
  log('MESSAGE APPENDED · "THEY SURFACED. FOLLOW THE COORDINATES."');
  log('SR-2608-CO · WESTMINSTER GRID · PENDING THE RING · FLAGGED FOR SWEEP');
  document.addEventListener('click', function(e){
    var add = e.target.closest('[data-add]');
    if(!add || add.disabled) return;
    var p; try{ p = byId(add.dataset.add); }catch(err){ p = null; }
    var name = (p && p.name) ? p.name : 'VESSEL';
    var lat = 39.62 + Math.random() * 0.42, lon = -105.32 + Math.random() * 0.6;
    SIGHTINGS.push({lat:lat, lon:lon, cls:'', lb:''});
    draw();
    ring(px(lon), py(lat));
    var gl = Math.abs(lat).toFixed(1) + 'N ' + Math.abs(lon).toFixed(1) + 'W';
    transmit('NEW CONFIRMATION · ' + name + ' · ' + gl + ' GRID · RELAYED');
  });
  var lastSweep = -1;
  setInterval(function(){
    if(document.hidden) return;
    var n = new Date();
    var m = n.getUTCMinutes(), s = n.getUTCSeconds();
    var tgt = (m < 33) ? (33 - m) * 60 - s : (93 - m) * 60 - s;
    var mm = Math.floor(tgt / 60), ss = tgt % 60;
    elN.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
    if(m === 33 && lastSweep !== n.getUTCHours()){
      lastSweep = n.getUTCHours();
      transmit('SCHEDULED SWEEP · ALL CONFIRMED FINDS REBROADCAST · AIMED PAST THE MOON');
    }
  }, 1000);
})();

/* ---------- crew heads → the vessel bay ---------- */
(function(){
  var row = document.getElementById('crewRow');
  if(!row) return;
  function go(vi){
    try{ sessionStorage.setItem('vWant', String(vi)); }catch(e){}
    if((typeof window !== 'undefined') && window.STATION_LOCK){ window.location.href = '/#/bottles'; return; }
    if(!/^#\/bottles/.test(location.hash)) location.hash = '#/bottles';
    setTimeout(function(){
      if(window.STATION_GO_VESSEL) window.STATION_GO_VESSEL(vi);
      try{ sessionStorage.removeItem('vWant'); }catch(e){}
    }, 140);
  }
  row.addEventListener('click', function(e){
    var m = e.target.closest('[data-vi]');
    if(m) go(parseInt(m.dataset.vi, 10));
  });
  row.addEventListener('keydown', function(e){
    if(e.key !== 'Enter' && e.key !== ' ') return;
    var m = e.target.closest('[data-vi]');
    if(m){ e.preventDefault(); go(parseInt(m.dataset.vi, 10)); }
  });
  var want = null;
  try{ want = sessionStorage.getItem('vWant'); }catch(e){}
  if(want !== null && /^#\/bottles/.test(location.hash)){
    setTimeout(function(){
      if(window.STATION_GO_VESSEL) window.STATION_GO_VESSEL(parseInt(want, 10));
      try{ sessionStorage.removeItem('vWant'); }catch(e){}
    }, 450);
  }
})();

/* ---------- sticky buy pill · rotating colors ---------- */
(function(){
  var pill = document.getElementById('buyPill');
  if(!pill) return;
  var nameEl = document.getElementById('buyPillName');
  var go = document.getElementById('buyPillGo');
  /* On a phone the pill is one button, not three elements. It has to say the
     whole thing itself, so the label is rebuilt with a hidden long form for
     wide screens and a compact one that survives a 390px strip. */
  function pillLabel(v){
    if(!go) return;
    go.innerHTML = '<span class="bp-long">BUY</span>'
      + '<span class="bp-short">CLAIM ' + v[1].replace('OG ', '').replace(' ALIEN 618', '')
      + ' \u00b7 $' + priceOf(v[0], 33) + '</span>';
  }
  var VS = [
    ['v-green','OG GREEN ALIEN 618','#00CE7E'],
    ['v-pink','OG PINK ALIEN 618','#EA41AA'],
    ['v-red','OG RED ALIEN 618','#FC4539'],
    ['v-yellow','OG YELLOW ALIEN 618','#F8E44B'],
    ['v-blue','OG BLUE ALIEN 618','#389EE1']
  ].filter(function(v){ return !soldOut(v[0]); });
  /* every colour gone means there is nothing to be sticky about */
  if(!VS.length){ pill.hidden = true; return; }
  var vi = 0, ci = 0;
  function hexA(h, a){ var r = parseInt(h.slice(1,3),16), g = parseInt(h.slice(3,5),16), bl = parseInt(h.slice(5,7),16); return 'rgba(' + r + ',' + g + ',' + bl + ',' + a + ')'; }
  function paint(){
    var v = VS[vi], c = v[2];   /* V136: the pill glows the colour it names */
    if(nameEl) nameEl.textContent = v[1];
    pillLabel(v);
    go.dataset.add = v[0];
    go.setAttribute('aria-label', 'Buy ' + v[1]);
    pill.style.borderColor = c;
    pill.style.boxShadow = '0 6px 24px rgba(0,0,0,.45), 0 0 16px ' + hexA(c, .42) + ', 0 0 34px ' + hexA(c, .2);
    go.style.background = c;
    go.style.boxShadow = '0 0 14px ' + hexA(c, .55);
    go.style.color = '#04120A';
  }
  function spin(){
    vi = (vi + 1) % VS.length;
    paint();
  }
  paint();
  setInterval(spin, 4200);
  function vis(){
    var lock = document.documentElement.classList.contains('brvoid-lock');
    pill.classList.toggle('on', !lock && window.scrollY > 520);
  }
  addEventListener('scroll', vis, {passive:true});
  setInterval(vis, 900); vis();
})();
/* ---------- crew alerts (demo intercept; the Shopify form posts for real) ---------- */
(function(){
  var f = document.getElementById('alertsForm');
  if(!f || !f.dataset || !f.dataset.demo) return;
  f.addEventListener('submit', function(e){
    e.preventDefault();
    var em = f.querySelector('input[type=email]');
    if(!em || !em.value || !/.+@.+\..+/.test(em.value)){ if(em) em.focus(); return; }
    f.classList.add('done');
    var ok = document.getElementById('alertsOk');
    if(ok) ok.textContent = 'ON THE MANIFEST \u00b7 ' + em.value + ' \u00b7 WE PING WHEN SOMETHING DOCKS';
  });
})();

/* ---------- THE GARMENT HOLD · rare apparel registry + filter ---------- */
var GH_SEALED = true; /* the hold is sealed in the vacuum: cards show, nothing sells */

/* ---------- PARTNER SPOTS · Canopy pumps on the hold · empty until a partnership is signed ---------- */
/* Never lists a business until it IS a partner: a spot renders as OPEN until accepted:true AND a name are set.
   feed = a JSON URL on the partner's side → {items:[{title,price,url,size,grade,cat,handle}]}
   rail 'commission' links out through the Canopy click tagger (sid + utm); rail 'stocked' adds to the hold via a Shopify handle. */
var PARTNER_CONTACT = 'lundrlundlunseluense@gmail.com';
var PARTNER_SPOTS = [
  { id:'ps-1', slot:'I',   deck:'hold', kind:'JERSEYS', rail:'commission', accepted:false, name:'', sid:'', take:0, feed:'', url:'', max:3 },
  { id:'ps-2', slot:'II',  deck:'hold', kind:'RUN',     rail:'commission', accepted:false, name:'', sid:'', take:0, feed:'', url:'', max:3 },
  { id:'ps-3', slot:'III', deck:'hold', kind:'SWIM',    rail:'stocked',    accepted:false, name:'', sid:'', take:0, feed:'', url:'', max:3 }
];
(function(){
  var rail = document.getElementById('psRail');
  if(!rail) return;
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function open(p){
    return '<article class="gh-card ps" data-ps="' + p.id + '">' +
      '<div class="gh-top"><span class="gh-cat">' + esc(p.kind) + '</span><span class="gh-st" style="--st:#D4A741">PARTNER SPOT ' + esc(p.slot) + ' \u00b7 OPEN</span></div>' +
      '<h4 class="gh-nm">A PARTNER\u2019S SHELF \u00b7 DOCKS HERE</h4>' +
      '<p class="gh-meta num">' + (p.rail === 'stocked' ? 'SHIPS FROM THE PARTNER' : 'SOLD BY THE PARTNER') + ' \u00b7 LIVE FROM THEIR INVENTORY \u00b7 NO NAME UNTIL IT\u2019S SIGNED</p>' +
      '<div class="gh-row"><span class="gh-pr num sealed">\u2014</span><a class="gh-buy gh-sealed ps-apply" href="mailto:' + PARTNER_CONTACT + '?subject=Partner%20spot%20' + encodeURIComponent(p.slot) + '%20on%20The%20Station">APPLY TO DOCK \u2192</a></div>' +
      '</article>';
  }
  function item(p, it){
    var price = (typeof it.price === 'number') ? '$' + it.price : (it.price ? esc(it.price) : '\u2014');
    var cta = p.rail === 'stocked'
      ? (it.handle ? '<button class="add gh-buy" data-add="fuel:' + esc(it.handle) + '">Add to hold</button>' : '<span class="gh-buy gh-sealed" aria-disabled="true">NOT CONNECTED</span>')
      : (it.url ? '<a class="add gh-buy" data-pump="' + p.id + '" href="' + esc(it.url) + '" target="_blank" rel="sponsored noopener noreferrer">Buy from ' + esc(p.name) + ' \u2192</a>' : '<span class="gh-buy gh-sealed" aria-disabled="true">NOT CONNECTED</span>');
    return '<article class="gh-card ps live" data-ps="' + p.id + '">' +
      '<div class="gh-top"><span class="gh-cat">' + esc(it.cat || p.kind) + '</span><span class="gh-st" style="--st:#D4A741">' + (p.rail === 'stocked' ? 'SHIPS FROM THE PARTNER' : 'SOLD BY THE PARTNER') + '</span></div>' +
      '<h4 class="gh-nm">' + esc(it.title || '').toUpperCase() + '</h4>' +
      '<p class="gh-meta num">' + (it.size ? 'SIZE ' + esc(it.size) + ' \u00b7 ' : '') + (it.grade ? 'GRADE: ' + esc(it.grade) + ' \u00b7 ' : '') + esc(p.name).toUpperCase() + '</p>' +
      '<div class="gh-row"><span class="gh-pr num">' + price + '</span>' + cta + '</div>' +
      (p.rail === 'stocked' ? '' : '<span class="fuel-aff">commission link \u00b7 ' + (p.accepted ? 'approved creative' : 'descriptive only') + '</span>') +
      '</article>';
  }
  function live(p){ return !!(p.accepted && p.name); }
  function paint(){
    var openN = PARTNER_SPOTS.filter(function(p){ return !live(p); }).length;
    var head = document.getElementById('psHead');
    if(head) head.textContent = 'PARTNER RAIL \u00b7 ' + (openN === PARTNER_SPOTS.length ? PARTNER_SPOTS.length + ' SPOTS OPEN \u00b7 NO PARTNERS LISTED UNTIL THEY ARE PARTNERS' : (PARTNER_SPOTS.length - openN) + ' DOCKED \u00b7 ' + openN + ' OPEN');
    rail.innerHTML = PARTNER_SPOTS.map(function(p){ return live(p) ? '<div class="ps-set" data-ps="' + p.id + '">' + open(p).replace('PARTNER SPOT ' + p.slot + ' \u00b7 OPEN', 'DOCKED \u00b7 LOADING') + '</div>' : open(p); }).join('');
    PARTNER_SPOTS.filter(live).forEach(function(p){
      var box = rail.querySelector('.ps-set[data-ps="' + p.id + '"]');
      var fallback = function(){ box.innerHTML = item(p, { title: p.name + ' \u00b7 the shelf', url: p.url }); };
      if(!p.feed){ fallback(); return; }
      fetch(p.feed, { mode:'cors' }).then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(j){
        var items = (j && (j.items || j.products || j)) || [];
        if(!Array.isArray(items) || !items.length) throw 0;
        box.innerHTML = items.slice(0, p.max || 3).map(function(it){ return item(p, it); }).join('');
      }).catch(fallback);
    });
  }
  paint();
  window.STATION_PARTNERS = { spots: PARTNER_SPOTS, paint: paint };
})();

var GARMENTS = [
 { id:'g-1', cat:'JERSEYS', name:'TREK ROAD JERSEY \u00b7 TEAM ISSUE', status:'IN THE WILD', size:'M', cond:'EXCELLENT', price:89, priced:true, handle:'trek-road-jersey-team-issue' },
 { id:'g-2', cat:'JERSEYS', name:'TREK CLIMBER\u2019S JERSEY \u00b7 FINAL RUN', status:'LAST SIGHTING', size:'L', cond:'VERY GOOD', price:79, priced:true, handle:'trek-climbers-jersey-final-run' },
 { id:'g-3', cat:'RUN', name:'RACE SINGLET \u00b7 RETIRED COLORWAY', status:'IN THE WILD', size:'M', cond:'EXCELLENT', price:55, priced:true, handle:'race-singlet-retired-colorway' },
 { id:'g-4', cat:'RUN', name:'TRAIL SHELL \u00b7 SOLD-OUT SEASON', status:'LAST SIGHTING', size:'L', cond:'VERY GOOD', price:89, priced:true, handle:'trail-shell-sold-out-season' },
 { id:'g-5', cat:'SWIM', name:'COMP JAMMER \u00b7 RETIRED LINE', status:'IN THE WILD', size:'32', cond:'NEW WITH TAGS', price:45, priced:true, handle:'comp-jammer-retired-line' },
 { id:'g-6', cat:'SWIM', name:'OPEN-WATER KIT \u00b7 TEAM SURPLUS', status:'SCARCE', size:'ONE SIZE', cond:'NEW', price:29, priced:true, handle:'open-water-kit-team-surplus' }
];
(function(){
  var grid = document.getElementById('ghGrid');
  if(!grid) return;
  var count = document.getElementById('ghCount');
  var STC = { 'IN THE WILD':'#C7D2E0', 'LAST SIGHTING':'#F8E44B', 'SCARCE':'#7CE8FF' };
  function card(g){
    return '<article class="gh-card' + (GH_SEALED ? ' sealed' : '') + '" data-cat="' + g.cat + '" data-price="' + g.price + '" data-i="' + GARMENTS.indexOf(g) + '">' +
      '<div class="gh-top"><span class="gh-cat">' + g.cat + '</span><span class="gh-st" style="--st:' + (GH_SEALED ? '#7CE8FF' : (STC[g.status] || '#C7D2E0')) + '">' + (GH_SEALED ? 'SEALED IN THE VACUUM' : g.status) + '</span></div>' +
      '<h4 class="gh-nm">' + g.name + '</h4>' +
      '<p class="gh-meta num">SIZE ' + g.size + ' \u00b7 GRADE: ' + g.cond + ' \u00b7 ' + (GH_SEALED ? 'ONE IN THE HOLD \u00b7 NOT THAWING YET' : 'ONE IN THE HOLD') + '</p>' +
      (GH_SEALED
        ? '<div class="gh-row"><span class="gh-pr num sealed">$' + g.price + '</span><span class="gh-buy gh-sealed" aria-disabled="true">SEALED</span></div>'
        : '<div class="gh-row"><span class="gh-pr num">$' + g.price + '</span><button class="add gh-buy" data-add="' + g.id + '">Buy</button></div>') +
      '</article>';
  }
  grid.innerHTML = GARMENTS.map(card).join('');
  var gCat = 'ALL', gPrice = 'ALL', gSort = 'hold';
  function money(v){ return '$' + v.toLocaleString('en-US'); }
  function show(){
    var lo = 0, hi = 1e9;
    if(gPrice !== 'ALL'){
      var parts = gPrice.split('-');
      lo = parseFloat(parts[0]); hi = parseFloat(parts[1]);
    }
    var cards = Array.prototype.slice.call(grid.children);
    var n = 0, cheapest = null, dearest = null;
    cards.forEach(function(c){
      var p = parseFloat(c.dataset.price || '0');
      var on = (gCat === 'ALL' || c.dataset.cat === gCat) && p >= lo && p <= hi;
      c.style.display = on ? '' : 'none';
      if(on){
        n++;
        if(cheapest === null || p < cheapest) cheapest = p;
        if(dearest === null || p > dearest) dearest = p;
      }
    });
    if(gSort !== 'hold'){
      cards.slice().sort(function(a, b){
        var d = parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        return gSort === 'low' ? d : -d;
      }).forEach(function(c){ grid.appendChild(c); });
    } else {
      cards.slice().sort(function(a, b){
        return (+a.dataset.i) - (+b.dataset.i);
      }).forEach(function(c){ grid.appendChild(c); });
    }
    if(count){
      count.textContent = n
        ? (GH_SEALED ? n + ' SEALED IN THE VACUUM \u00b7 NOTHING THAWS UNTIL THE HOLD IS CATALOGUED' : n + ' IN THE HOLD \u00b7 ' + (cheapest === dearest ? money(cheapest) : money(cheapest) + '\u2013' + money(dearest)) + ' \u00b7 FROZEN AT \u2212196\u00b0')
        : 'NOTHING THAT COLD AT THAT PRICE \u00b7 WIDEN THE SEARCH';
    }
  }
  function wire(el){
    if(!el) return;
    el.addEventListener('click', function(e){
      var b = e.target.closest('[data-gf],[data-gp],[data-gs]');
      if(!b) return;
      var key = b.dataset.gf !== undefined ? 'gf' : (b.dataset.gp !== undefined ? 'gp' : 'gs');
      var sel = '[data-' + key + ']';
      Array.prototype.forEach.call(el.querySelectorAll(sel), function(x){ x.classList.toggle('on', x === b); });
      if(key === 'gf') gCat = b.dataset.gf;
      if(key === 'gp') gPrice = b.dataset.gp;
      if(key === 'gs') gSort = b.dataset.gs;
      show();
    });
  }
  wire(document.getElementById('ghChips'));
  wire(document.getElementById('ghPrice'));
  show();
})();

/* ---------- DECK 61.8 · THE DROP · riddle gate + the fall ---------- */
(function(){
  var sec = document.getElementById('drop');
  if(!sec) return;
  var gate = document.getElementById('drGate'), form = document.getElementById('drForm'),
      ans = document.getElementById('drAns'), no = document.getElementById('drNo');
  var elA = document.getElementById('drAlt'), elV = document.getElementById('drVel'),
      elT = document.getElementById('drTime'), elL = document.getElementById('drLog');
  var OK = { '618':1, '1.618':1, '0.618':1, '.618':1, 'phi': 1, '\u03c6':1, 'golden ratio':1, 'the golden ratio':1 };
  var tries = 0, t0 = null, timer = null, logged = {};
  var LOG = [
    [100, 'KM 100 \u00b7 THE KARMAN LINE \u00b7 SPACE AGREES TO LET YOU GO'],
    [62,  'KM 62 \u00b7 SOUND RETURNS \u00b7 IT IS YOUR OWN HEART'],
    [31,  'KM 31 \u00b7 THE SKY TURNS BLUE AGAIN \u00b7 YOU MISSED IT'],
    [12,  'KM 12 \u00b7 CLOUDS BELOW \u00b7 THEY PART WITHOUT BEING ASKED'],
    [4,   'KM 4 \u00b7 YOU CAN SEE THE STATION FROM HERE \u00b7 THE GAS ONE'],
    [0,   'KM 0 \u00b7 YOU DO NOT LAND \u00b7 FALLING IS JUST ORBITING SOMETHING YOU HAVE NOT MET']
  ];
  function solved(){ try{ var s = JSON.parse(localStorage.getItem('thedrop.v1') || 'null'); return !!(s && s.ok); }catch(e){ return false; } }
  function open(fresh){
    sec.classList.add('dr-open');
    if(fresh){ try{ localStorage.setItem('thedrop.v1', JSON.stringify({ok:1, t:Date.now()})); }catch(e){} }
    startFall();
  }
  function ease(x){ return x < 0 ? 0 : x > 1 ? 1 : 1 - Math.pow(1 - x, 2.618); }
  function startFall(){
    t0 = Date.now(); logged = {}; elL.innerHTML = '';
    if(timer) clearInterval(timer);
    timer = setInterval(step, 200); step();
  }
  function step(){
    if(document.hidden || t0 === null) return;
    var t = (Date.now() - t0) / 1000;
    var p = ease(t / 118);
    var alt = 100 * (1 - p);
    var vel = Math.round(200 + 780 * Math.sin(Math.min(1, t / 118) * Math.PI));
    if(alt <= 0.05){ alt = 0; vel = 618; }
    elA.textContent = alt.toFixed(1);
    elV.textContent = String(vel);
    var m = Math.floor(t / 60), s2 = Math.floor(t % 60);
    elT.textContent = (m < 10 ? '0' : '') + m + ':' + (s2 < 10 ? '0' : '') + s2;
    LOG.forEach(function(row){
      if(alt <= row[0] + 0.001 && !logged[row[0]]){
        logged[row[0]] = 1;
        var li = document.createElement('li');
        li.textContent = '> ' + row[1];
        Array.prototype.forEach.call(elL.children, function(c){ c.classList.remove('now'); });
        li.className = 'now';
        elL.insertBefore(li, elL.firstChild);
      }
    });
  }
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var v = (ans.value || '').trim().toLowerCase();
    if(OK[v]){
      no.style.color = '#7CFFB0';
      no.textContent = 'THE FLOOR DISAPPEARS.';
      setTimeout(function(){ open(true); }, 700);
    } else {
      tries++;
      sec.classList.remove('dr-shake'); void sec.offsetWidth; sec.classList.add('dr-shake');
      no.textContent = 'THE DOOR SAYS NO \u00b7 ATTEMPT ' + tries + ' LOGGED' + (tries >= 2 ? ' \u00b7 HINT: EVERY PRICE ON THIS STATION ENDS THE SAME WAY' : '');
      ans.select();
    }
  });
  addEventListener('hashchange', onRoute);
  function onRoute(){
    var here = /^#\/drop/.test(location.hash);
    if(here){
      if(solved()){ open(false); }
      else { sec.classList.remove('dr-open'); setTimeout(function(){ ans && ans.focus(); }, 400); }
    } else if(timer){ clearInterval(timer); timer = null; t0 = null; }
  }
  onRoute();
})();







/* the record, once there is one — shown, not claimed */
(function(){
  var sec = document.getElementById('impound');
  if(!sec || !blackVerified()) return;
  if(document.getElementById('impRecord')) return;
  var bits = [];
  if(BLACK.when)  bits.push('<span>WHEN<b>' + BLACK.when + '</b></span>');
  if(BLACK.where) bits.push('<span>WHERE<b>' + BLACK.where + '</b></span>');
  if(BLACK.by)    bits.push('<span>CONFIRMED BY<b>' + BLACK.by + '</b></span>');
  if(BLACK.verifiedWhen) bits.push('<span>VERIFIED<b>' + BLACK.verifiedWhen + '</b></span>');
  if(!bits.length && !BLACK.note && !BLACK.image) return;
  var d = document.createElement('div');
  d.id = 'impRecord';
  d.className = 'imp-record';
  d.innerHTML = '<b class="imp-record-k">THE CONFIRMED SIGHTING</b>'
    + (bits.length ? '<div class="imp-record-row">' + bits.join('') + '</div>' : '')
    + (BLACK.note ? '<p>' + BLACK.note + '</p>' : '')
    + (BLACK.image ? '<img src="' + BLACK.image + '" alt="the confirmed sighting" loading="lazy">' : '');
  var btn = document.getElementById('impClaim');
  if(btn && btn.parentNode) btn.parentNode.insertBefore(d, btn);
  else sec.appendChild(d);
})();


/* ============ V191 · THE COLD CASE · by the door, grab and go ============
   The bottles the pods only dream about: real recovered vessels, priced in
   the product admin, read off the same feed as Deck 03. Tagged cold-case →
   in the case; nothing tagged → the whole priced shelf is in the case. The
   finder's search reaches in here; THE COLD CASE chip puts the pods to sleep
   and leaves only the case. Bottle, tag and BUY are one door: the hold. */
(function(){
  var wing = document.getElementById('coldCase'); if(!wing) return;
  var grid = document.getElementById('ccGrid'), count = document.getElementById('ccCount'), empty = document.getElementById('ccEmpty'), chips = document.getElementById('ccPrice');
  var demoNote = wing.querySelector('.cc-demo');
  var chip = document.querySelector('#fzCat [data-v="COLD"]');
  var st = { price: '', sort: 'case' };
  function esc(s){ return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function isCold(a){ return (a.tags || []).some(function(t){ return /^cold[\s-]?case$/i.test(String(t).trim()); }); }
  function pool(){
    var all = (typeof SALVAGE !== 'undefined' ? SALVAGE : []).filter(function(a){ return typeof a.price === 'number' && a.price > 0; });
    var tagged = all.filter(isCold);
    return tagged.length ? tagged : all;
  }
  function query(){ var f = window.STATION_FZ; return (f && f.q) ? String(f.q).toLowerCase() : ''; }
  function hay(a){ return (a.name + ' ' + (a.sub || '') + ' ' + (a.origin || '') + ' ' + (a.size || '') + ' ' + (a.year || '')).toLowerCase(); }
  function dollars(v){ return '$' + (Number.isInteger(v) ? v : v.toFixed(2)); }
  function card(a, i){
    var gone = !!a.sold_out || (a.left != null && a.left <= 0);
    var s = fieldStatus(a);
    var shot = a.photo
      ? '<img class="cc-img" src="' + esc(a.photo) + '" alt="' + esc(a.name) + '" loading="lazy" data-art="' + esc(a.art || 'steel') + '" onerror="STATION_SV_FALLBACK(this)">'
      : svArt(a.art || 'steel');
    var bits = [];
    if(a.size && a.size !== '\u2014') bits.push(a.size);
    if(a.condition && a.condition !== '\u2014') bits.push(a.condition);
    bits.push(gone ? 'GONE' : (a.left != null ? a.left + ' IN THE CASE' : 'ONE OF EACH'));
    var add = gone ? ' disabled' : ' data-add="' + esc(a.id) + '"';
    return '<article class="cc-card' + (gone ? ' gone' : '') + '" data-price="' + a.price + '" data-i="' + i + '">'
      + '<button class="cc-shot" type="button"' + add + ' aria-label="' + (gone ? esc(a.name) + ' \u00b7 gone' : 'Grab ' + esc(a.name) + ' \u00b7 ' + dollars(a.price)) + '">' + shot
      + '<span class="cc-seal" style="--st:' + s.colour + '">' + s.label + '</span></button>'
      + '<div class="cc-rail"><button class="cc-pill num" type="button"' + add + ' aria-label="' + (gone ? 'Gone' : 'Grab ' + esc(a.name) + ' for ' + dollars(a.price)) + '">' + (gone ? 'GONE' : dollars(a.price)) + '</button></div>'
      + '<h4 class="cc-name">' + esc(a.name) + '</h4>'
      + '<p class="cc-sub">' + esc(a.sub || '') + '</p>'
      + '<p class="cc-line num">' + esc(bits.join(' \u00b7 ')) + '</p>'
      + (gone ? '<button class="add cc-buy soon" type="button" disabled>Gone</button>'
              : '<button class="add cc-buy" type="button" data-add="' + esc(a.id) + '">BUY</button>')
      + '</article>';
  }
  function render(){
    var all = pool();
    var any = all.length > 0;
    wing.hidden = !any;
    if(chip) chip.hidden = !any;
    if(!any) return;
    var list = all, qq = query();
    if(qq) list = list.filter(function(a){ return hay(a).indexOf(qq) >= 0; });
    if(st.price){ var p = st.price.split('-'), lo = +p[0], hi = +p[1]; list = list.filter(function(a){ return a.price >= lo && a.price <= hi; }); }
    if(st.sort === 'low') list = list.slice().sort(function(a, b){ return a.price - b.price; });
    else if(st.sort === 'high') list = list.slice().sort(function(a, b){ return b.price - a.price; });
    grid.innerHTML = list.map(card).join('');
    if(count){
      if(list.length){
        var lo2 = Math.min.apply(null, list.map(function(a){ return a.price; })), hi2 = Math.max.apply(null, list.map(function(a){ return a.price; }));
        count.textContent = list.length + ' IN THE CASE \u00b7 ' + (lo2 === hi2 ? dollars(lo2) : dollars(lo2) + '\u2013' + dollars(hi2)) + ' \u00b7 GRAB AND GO';
      } else count.textContent = '';
    }
    if(empty) empty.hidden = list.length > 0;
    wing.classList.toggle('cc-focus', !!(window.STATION_FZ && window.STATION_FZ.cat === 'COLD'));
    if(demoNote) demoNote.hidden = !!window.STATION_SHOP;
  }
  window.STATION_CC_RENDER = render;
  window.STATION_CC_COUNT = function(){ return pool().length; };
  if(chips) chips.addEventListener('click', function(e){
    var b = e.target.closest ? e.target.closest('.fz-chip') : null; if(!b) return;
    var isSort = b.hasAttribute('data-sort');
    if(isSort) st.sort = b.getAttribute('data-sort') || 'case'; else st.price = b.getAttribute('data-v') || '';
    chips.querySelectorAll('.fz-chip').forEach(function(c){ if(c.hasAttribute('data-sort') === isSort) c.classList.toggle('on', c === b); });
    render();
  });
  render();
})();
